(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as Z_, getPartnerDevApiHeaders as eS, WidgetContextProvider as nS, makeExecuteQuery as tS, makeUseLazyQuery as rS, makeUseQuery as iS, makeUseMutation as aS, validateApiHostName as Zk, useTracking as bn, useWidgetContext as un, hasDownstreamApiForbiddenError as km, hasDownstreamApiAuthorizationError as bm, DisplayErrors as Cn, useCopyWithDelay as Jt, defaultDateFormat as gt, displayAttributeValue as Ka, useWidgetSettingsMutations as qr, useWidgetSettingsQuery as Hr, useRenderConditions as Wr, PartnerSettingsWrapper as Kr, handleWidgetSubmit as Gr, MisconfigurationBanner as Yr, OAuthSettings as Hi, WidgetSettingsFormFooter as Qr, useData as xm, PartnerHookFormSecretText as bs, isDownstreamApiNotFoundError as oS, isDownstreamApiAuthorizationError as eb, KlaviyoSubscribeSetting as sS, isDownstreamApiPermissionError as lS, capitalizeFirstCharacter as nb, humanizeKey as cS, hasDownstreamApiTooManyRequestsError as dS, hasDownstreamApiPermissionError as tb, PartnerHookFormBasicAuth as uS, hasDownstreamApiNotFoundError as Xa, getCountryNameFromCountryCode as mS, parseBoolean as pS, parseString as fS, IntegrationModal as rb, useInboundOAuthContext as hS, getWidgetConfigurationByIdQuery as yS, createWidgetConfigurationMutation as gS, updateWidgetConfigurationMutation as vS, trackRenderConditionsSaved as kS, deleteWidgetConfigurationMutation as bS } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import Ae, { useMemo as Bn, useState as se, useEffect as qe, useRef as di, useCallback as at, useReducer as xS, useLayoutEffect as _S, useContext as _m, createContext as ib, isValidElement as SS, createElement as NS, Fragment as jS } from "react";
import { Text as D, FlexBox as b, Spinner as ln, Icon as me, Tooltip as We, List as Ge, Badge as Pn, Button as Kn, IconButton as Kt, Switch as Tu, FieldLabel as wS, FieldWrapper as nn, InputText as pr, InputSelectionList as Ur, FormGrid as rt, FormField as ue, Tag as An, NavigationButton as jt, Select as hr, CollapseCard as rr, Box as Zn, Modal as wt, ModalHead as Ct, ModalBody as It, ModalFoot as Tt, Textarea as $u, TagsInput as xs, Image as Wi, Banner as _s, Divider as Sm, SelectionList as lt, FieldText as ir, FieldTextarea as CS, CopyToClipboardButton as IS, getSelectionListContext as FS, Avatar as Nm, Timestamp as ES, Attachment as TS, EmptyState as ts, Table as Jn, Checkbox as Pp, TextWithHighlight as $S, ErrorBoundaryContext as ab, FieldSwitch as ob } from "@dixa/lib-shared-habla";
import tt from "classnames";
import { ApolloLink as jm, Observable as sb, ApolloClient as DS, InMemoryCache as RS, createHttpLink as OS, ApolloProvider as PS, useApolloClient as AS, ApolloConsumer as LS, NetworkStatus as Wt, isApolloError as lb, ApolloError as cb, gql as Ss, useQuery as VS, useMutation as Ap } from "@apollo/client";
import zS from "cross-fetch";
import { config as Ga } from "lib-shared-backend-config";
import Ln from "moment";
import "moment-timezone";
import { __rest as US, __assign as qs } from "tslib";
import { useLocation as MS } from "react-router-dom";
function wm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var mo = { exports: {} }, ea = {};
var Lp;
function BS() {
  if (Lp) return ea;
  Lp = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ea.Fragment = r, ea.jsx = s, ea.jsxs = s, ea;
}
var na = {};
var Vp;
function qS() {
  return Vp || (Vp = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c, $));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    na.Fragment = i, na.jsx = Rn, na.jsxs = Mn;
  })()), na;
}
var zp;
function HS() {
  return zp || (zp = 1, process.env.NODE_ENV === "production" ? mo.exports = BS() : mo.exports = qS()), mo.exports;
}
var Ve = HS();
function db(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: WS } = Object.prototype, { getPrototypeOf: Ns } = Object, { iterator: js, toStringTag: ub } = Symbol, ws = /* @__PURE__ */ ((e) => (n) => {
  const r = WS.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), yr = (e) => (e = e.toLowerCase(), (n) => ws(n) === e), Cs = (e) => (n) => typeof n === e, { isArray: Ki } = Array, zi = Cs("undefined");
function Za(e) {
  return e !== null && !zi(e) && e.constructor !== null && !zi(e.constructor) && Bt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const mb = yr("ArrayBuffer");
function KS(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && mb(e.buffer), n;
}
const GS = Cs("string"), Bt = Cs("function"), pb = Cs("number"), eo = (e) => e !== null && typeof e == "object", YS = (e) => e === !0 || e === !1, Bo = (e) => {
  if (ws(e) !== "object")
    return !1;
  const n = Ns(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(ub in e) && !(js in e);
}, QS = (e) => {
  if (!eo(e) || Za(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, JS = yr("Date"), XS = yr("File"), ZS = (e) => !!(e && typeof e.uri < "u"), e0 = (e) => e && typeof e.getParts < "u", n0 = yr("Blob"), t0 = yr("FileList"), r0 = (e) => eo(e) && Bt(e.pipe);
function i0() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Up = i0(), Mp = typeof Up.FormData < "u" ? Up.FormData : void 0, a0 = (e) => {
  if (!e) return !1;
  if (Mp && e instanceof Mp) return !0;
  const n = Ns(e);
  if (!n || n === Object.prototype || !Bt(e.append)) return !1;
  const r = ws(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && Bt(e.toString) && e.toString() === "[object FormData]";
}, o0 = yr("URLSearchParams"), [s0, l0, c0, d0] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(yr), u0 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function no(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Ki(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (Za(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function fb(e, n) {
  if (Za(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const si = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, hb = (e) => !zi(e) && e !== si;
function Du() {
  const { caseless: e, skipUndefined: n } = hb(this) && this || {}, r = {}, i = (a, o) => {
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    const s = e && fb(r, o) || o;
    Bo(r[s]) && Bo(a) ? r[s] = Du(r[s], a) : Bo(a) ? r[s] = Du({}, a) : Ki(a) ? r[s] = a.slice() : (!n || !zi(a)) && (r[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && no(arguments[a], i);
  return r;
}
const m0 = (e, n, r, { allOwnKeys: i } = {}) => (no(
  n,
  (a, o) => {
    r && Bt(a) ? Object.defineProperty(e, o, {
      value: db(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), p0 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), f0 = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, h0 = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && Ns(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, y0 = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, g0 = (e) => {
  if (!e) return null;
  if (Ki(e)) return e;
  let n = e.length;
  if (!pb(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, v0 = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Ns(Uint8Array)), k0 = (e, n) => {
  const i = (e && e[js]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, b0 = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, x0 = yr("HTMLFormElement"), _0 = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), Bp = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), S0 = yr("RegExp"), yb = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  no(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, N0 = (e) => {
  yb(e, (n, r) => {
    if (Bt(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = e[r];
    if (Bt(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, j0 = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Ki(e) ? i(e) : i(String(e).split(n)), r;
}, w0 = () => {
}, C0 = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function I0(e) {
  return !!(e && Bt(e.append) && e[ub] === "FormData" && e[js]);
}
const F0 = (e) => {
  const n = new Array(10), r = (i, a) => {
    if (eo(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (Za(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = Ki(i) ? [] : {};
        return no(i, (s, l) => {
          const d = r(s, a + 1);
          !zi(d) && (o[l] = d);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return r(e, 0);
}, E0 = yr("AsyncFunction"), T0 = (e) => e && (eo(e) || Bt(e)) && Bt(e.then) && Bt(e.catch), gb = ((e, n) => e ? setImmediate : n ? ((r, i) => (si.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === si && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), si.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", Bt(si.postMessage)), $0 = typeof queueMicrotask < "u" ? queueMicrotask.bind(si) : typeof process < "u" && process.nextTick || gb, D0 = (e) => e != null && Bt(e[js]), ve = {
  isArray: Ki,
  isArrayBuffer: mb,
  isBuffer: Za,
  isFormData: a0,
  isArrayBufferView: KS,
  isString: GS,
  isNumber: pb,
  isBoolean: YS,
  isObject: eo,
  isPlainObject: Bo,
  isEmptyObject: QS,
  isReadableStream: s0,
  isRequest: l0,
  isResponse: c0,
  isHeaders: d0,
  isUndefined: zi,
  isDate: JS,
  isFile: XS,
  isReactNativeBlob: ZS,
  isReactNative: e0,
  isBlob: n0,
  isRegExp: S0,
  isFunction: Bt,
  isStream: r0,
  isURLSearchParams: o0,
  isTypedArray: v0,
  isFileList: t0,
  forEach: no,
  merge: Du,
  extend: m0,
  trim: u0,
  stripBOM: p0,
  inherits: f0,
  toFlatObject: h0,
  kindOf: ws,
  kindOfTest: yr,
  endsWith: y0,
  toArray: g0,
  forEachEntry: k0,
  matchAll: b0,
  isHTMLForm: x0,
  hasOwnProperty: Bp,
  hasOwnProp: Bp,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: yb,
  freezeMethods: N0,
  toObjectSet: j0,
  toCamelCase: _0,
  noop: w0,
  toFiniteNumber: C0,
  findKey: fb,
  global: si,
  isContextDefined: hb,
  isSpecCompliantForm: I0,
  toJSONObject: F0,
  isAsyncFn: E0,
  isThenable: T0,
  setImmediate: gb,
  asap: $0,
  isIterable: D0
};
let fn = class vb extends Error {
  static from(n, r, i, a, o, s) {
    const l = new vb(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ve.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
fn.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
fn.ERR_BAD_OPTION = "ERR_BAD_OPTION";
fn.ECONNABORTED = "ECONNABORTED";
fn.ETIMEDOUT = "ETIMEDOUT";
fn.ERR_NETWORK = "ERR_NETWORK";
fn.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
fn.ERR_DEPRECATED = "ERR_DEPRECATED";
fn.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
fn.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
fn.ERR_CANCELED = "ERR_CANCELED";
fn.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
fn.ERR_INVALID_URL = "ERR_INVALID_URL";
fn.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const R0 = null;
function Ru(e) {
  return ve.isPlainObject(e) || ve.isArray(e);
}
function kb(e) {
  return ve.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Hs(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = kb(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function O0(e) {
  return ve.isArray(e) && !e.some(Ru);
}
const P0 = ve.toFlatObject(ve, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Is(e, n, r) {
  if (!ve.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ve.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(S, j) {
      return !ve.isUndefined(j[S]);
    }
  );
  const i = r.metaTokens, a = r.visitor || f, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, d = r.maxDepth === void 0 ? 100 : r.maxDepth, m = l && ve.isSpecCompliantForm(n);
  if (!ve.isFunction(a))
    throw new TypeError("visitor must be a function");
  function u(_) {
    if (_ === null) return "";
    if (ve.isDate(_))
      return _.toISOString();
    if (ve.isBoolean(_))
      return _.toString();
    if (!m && ve.isBlob(_))
      throw new fn("Blob is not supported. Use a Buffer instead.");
    return ve.isArrayBuffer(_) || ve.isTypedArray(_) ? m && typeof Blob == "function" ? new Blob([_]) : Buffer.from(_) : _;
  }
  function f(_, S, j) {
    let k = _;
    if (ve.isReactNative(n) && ve.isReactNativeBlob(_))
      return n.append(Hs(j, S, o), u(_)), !1;
    if (_ && !j && typeof _ == "object") {
      if (ve.endsWith(S, "{}"))
        S = i ? S : S.slice(0, -2), _ = JSON.stringify(_);
      else if (ve.isArray(_) && O0(_) || (ve.isFileList(_) || ve.endsWith(S, "[]")) && (k = ve.toArray(_)))
        return S = kb(S), k.forEach(function(E, I) {
          !(ve.isUndefined(E) || E === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Hs([S], I, o) : s === null ? S : S + "[]",
            u(E)
          );
        }), !1;
    }
    return Ru(_) ? !0 : (n.append(Hs(j, S, o), u(_)), !1);
  }
  const h = [], v = Object.assign(P0, {
    defaultVisitor: f,
    convertValue: u,
    isVisitable: Ru
  });
  function C(_, S, j = 0) {
    if (!ve.isUndefined(_)) {
      if (j > d)
        throw new fn(
          "Object is too deeply nested (" + j + " levels). Max depth: " + d,
          fn.ERR_FORM_DATA_DEPTH_EXCEEDED
        );
      if (h.indexOf(_) !== -1)
        throw Error("Circular reference detected in " + S.join("."));
      h.push(_), ve.forEach(_, function(L, E) {
        (!(ve.isUndefined(L) || L === null) && a.call(n, L, ve.isString(E) ? E.trim() : E, S, v)) === !0 && C(L, S ? S.concat(E) : [E], j + 1);
      }), h.pop();
    }
  }
  if (!ve.isObject(e))
    throw new TypeError("data must be an object");
  return C(e), n;
}
function qp(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function Cm(e, n) {
  this._pairs = [], e && Is(e, this, n);
}
const bb = Cm.prototype;
bb.append = function(n, r) {
  this._pairs.push([n, r]);
};
bb.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, qp);
  } : qp;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function A0(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function xb(e, n, r) {
  if (!n)
    return e;
  const i = r && r.encode || A0, a = ve.isFunction(r) ? {
    serialize: r
  } : r, o = a && a.serialize;
  let s;
  if (o ? s = o(n, a) : s = ve.isURLSearchParams(n) ? n.toString() : new Cm(n, a).toString(i), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class Hp {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ve.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Im = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, L0 = typeof URLSearchParams < "u" ? URLSearchParams : Cm, V0 = typeof FormData < "u" ? FormData : null, z0 = typeof Blob < "u" ? Blob : null, U0 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: L0,
    FormData: V0,
    Blob: z0
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Fm = typeof window < "u" && typeof document < "u", Ou = typeof navigator == "object" && navigator || void 0, M0 = Fm && (!Ou || ["ReactNative", "NativeScript", "NS"].indexOf(Ou.product) < 0), B0 = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", q0 = Fm && window.location.href || "http://localhost", H0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Fm,
  hasStandardBrowserEnv: M0,
  hasStandardBrowserWebWorkerEnv: B0,
  navigator: Ou,
  origin: q0
}, Symbol.toStringTag, { value: "Module" })), Ft = {
  ...H0,
  ...U0
};
function W0(e, n) {
  return Is(e, new Ft.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Ft.isNode && ve.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function K0(e) {
  return ve.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function G0(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function _b(e) {
  function n(r, i, a, o) {
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && ve.isArray(a) ? a.length : s, d ? (ve.hasOwnProp(a, s) ? a[s] = ve.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!a[s] || !ve.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ve.isArray(a[s]) && (a[s] = G0(a[s])), !l);
  }
  if (ve.isFormData(e) && ve.isFunction(e.entries)) {
    const r = {};
    return ve.forEachEntry(e, (i, a) => {
      n(K0(i), a, r, 0);
    }), r;
  }
  return null;
}
const xi = (e, n) => e != null && ve.hasOwnProp(e, n) ? e[n] : void 0;
function Y0(e, n, r) {
  if (ve.isString(e))
    try {
      return (n || JSON.parse)(e), ve.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const to = {
  transitional: Im,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ve.isObject(n);
      if (o && ve.isHTMLForm(n) && (n = new FormData(n)), ve.isFormData(n))
        return a ? JSON.stringify(_b(n)) : n;
      if (ve.isArrayBuffer(n) || ve.isBuffer(n) || ve.isStream(n) || ve.isFile(n) || ve.isBlob(n) || ve.isReadableStream(n))
        return n;
      if (ve.isArrayBufferView(n))
        return n.buffer;
      if (ve.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const d = xi(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return W0(n, d).toString();
        if ((l = ve.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const m = xi(this, "env"), u = m && m.FormData;
          return Is(
            l ? { "files[]": n } : n,
            u && new u(),
            d
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), Y0(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = xi(this, "transitional") || to.transitional, i = r && r.forcedJSONParsing, a = xi(this, "responseType"), o = a === "json";
      if (ve.isResponse(n) || ve.isReadableStream(n))
        return n;
      if (n && ve.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, xi(this, "parseReviver"));
        } catch (d) {
          if (l)
            throw d.name === "SyntaxError" ? fn.from(d, fn.ERR_BAD_RESPONSE, this, null, xi(this, "response")) : d;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ft.classes.FormData,
    Blob: Ft.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ve.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  to.headers[e] = {};
});
const Q0 = ve.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), J0 = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && Q0[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
}, Wp = Symbol("internals"), X0 = /[^\x09\x20-\x7E\x80-\xFF]/g;
function Z0(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
function ta(e) {
  return e && String(e).trim().toLowerCase();
}
function eN(e) {
  return Z0(e.replace(X0, ""));
}
function qo(e) {
  return e === !1 || e == null ? e : ve.isArray(e) ? e.map(qo) : eN(String(e));
}
function nN(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const tN = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Ws(e, n, r, i, a) {
  if (ve.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ve.isString(n)) {
    if (ve.isString(i))
      return n.indexOf(i) !== -1;
    if (ve.isRegExp(i))
      return i.test(n);
  }
}
function rN(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function iN(e, n) {
  const r = ve.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let qt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = ta(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = ve.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = qo(l));
    }
    const s = (l, d) => ve.forEach(l, (m, u) => o(m, u, d));
    if (ve.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ve.isString(n) && (n = n.trim()) && !tN(n))
      s(J0(n), r);
    else if (ve.isObject(n) && ve.isIterable(n)) {
      let l = {}, d, m;
      for (const u of n) {
        if (!ve.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = u[0]] = (d = l[m]) ? ve.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = ta(n), n) {
      const i = ve.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return nN(a);
        if (ve.isFunction(r))
          return r.call(this, a, i);
        if (ve.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = ta(n), n) {
      const i = ve.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || Ws(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = ta(s), s) {
        const l = ve.findKey(i, s);
        l && (!r || Ws(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ve.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || Ws(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ve.forEach(this, (a, o) => {
      const s = ve.findKey(i, o);
      if (s) {
        r[s] = qo(a), delete r[o];
        return;
      }
      const l = n ? rN(o) : String(o).trim();
      l !== o && delete r[o], r[l] = qo(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ve.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ve.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[Wp] = this[Wp] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = ta(s);
      i[l] || (iN(a, s), i[l] = !0);
    }
    return ve.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
qt.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
ve.reduceDescriptors(qt.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ve.freezeMethods(qt);
function Ks(e, n) {
  const r = this || to, i = n || r, a = qt.from(i.headers);
  let o = i.data;
  return ve.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function Sb(e) {
  return !!(e && e.__CANCEL__);
}
let ro = class extends fn {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", fn.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Nb(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(
    new fn(
      "Request failed with status code " + r.status,
      [fn.ERR_BAD_REQUEST, fn.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
      r.config,
      r.request,
      r
    )
  );
}
function aN(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function oN(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const v = u && m - u;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function sN(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const rs = (e, n, r = 3) => {
  let i = 0;
  const a = oN(50, 250);
  return sN((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = l != null ? Math.min(s, l) : s, m = Math.max(0, d - i), u = a(m);
    i = Math.max(i, d);
    const f = {
      loaded: d,
      total: l,
      progress: l ? d / l : void 0,
      bytes: m,
      rate: u || void 0,
      estimated: u && l ? (l - d) / u : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, Kp = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, Gp = (e) => (...n) => ve.asap(() => e(...n)), lN = Ft.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Ft.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Ft.origin),
  Ft.navigator && /(msie|trident)/i.test(Ft.navigator.userAgent)
) : () => !0, cN = Ft.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      ve.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), ve.isString(i) && l.push(`path=${i}`), ve.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), ve.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return n ? decodeURIComponent(n[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function dN(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function uN(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function jb(e, n, r) {
  let i = !dN(n);
  return e && (i || r === !1) ? uN(e, n) : n;
}
const Yp = (e) => e instanceof qt ? { ...e } : e;
function hi(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(m, u, f, h) {
    return ve.isPlainObject(m) && ve.isPlainObject(u) ? ve.merge.call({ caseless: h }, m, u) : ve.isPlainObject(u) ? ve.merge({}, u) : ve.isArray(u) ? u.slice() : u;
  }
  function a(m, u, f, h) {
    if (ve.isUndefined(u)) {
      if (!ve.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, u, f, h);
  }
  function o(m, u) {
    if (!ve.isUndefined(u))
      return i(void 0, u);
  }
  function s(m, u) {
    if (ve.isUndefined(u)) {
      if (!ve.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, u);
  }
  function l(m, u, f) {
    if (ve.hasOwnProp(n, f))
      return i(m, u);
    if (ve.hasOwnProp(e, f))
      return i(void 0, m);
  }
  const d = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, u, f) => a(Yp(m), Yp(u), f, !0)
  };
  return ve.forEach(Object.keys({ ...e, ...n }), function(u) {
    if (u === "__proto__" || u === "constructor" || u === "prototype") return;
    const f = ve.hasOwnProp(d, u) ? d[u] : a, h = ve.hasOwnProp(e, u) ? e[u] : void 0, v = ve.hasOwnProp(n, u) ? n[u] : void 0, C = f(h, v, u);
    ve.isUndefined(C) && f !== l || (r[u] = C);
  }), r;
}
const wb = (e) => {
  const n = hi({}, e), r = (h) => ve.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const d = r("auth"), m = r("baseURL"), u = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = qt.from(l), n.url = xb(
    jb(m, f, u),
    e.params,
    e.paramsSerializer
  ), d && l.set(
    "Authorization",
    "Basic " + btoa(
      (d.username || "") + ":" + (d.password ? unescape(encodeURIComponent(d.password)) : "")
    )
  ), ve.isFormData(i)) {
    if (Ft.hasStandardBrowserEnv || Ft.hasStandardBrowserWebWorkerEnv)
      l.setContentType(void 0);
    else if (ve.isFunction(i.getHeaders)) {
      const h = i.getHeaders(), v = ["content-type", "content-length"];
      Object.entries(h).forEach(([C, _]) => {
        v.includes(C.toLowerCase()) && l.set(C, _);
      });
    }
  }
  if (Ft.hasStandardBrowserEnv && (ve.isFunction(a) && (a = a(n)), a === !0 || a == null && lN(n.url))) {
    const v = o && s && cN.read(s);
    v && l.set(o, v);
  }
  return n;
}, mN = typeof XMLHttpRequest < "u", pN = mN && function(e) {
  return new Promise(function(r, i) {
    const a = wb(e);
    let o = a.data;
    const s = qt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, v, C;
    function _() {
      v && v(), C && C(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let S = new XMLHttpRequest();
    S.open(a.method.toUpperCase(), a.url, !0), S.timeout = a.timeout;
    function j() {
      if (!S)
        return;
      const L = qt.from(
        "getAllResponseHeaders" in S && S.getAllResponseHeaders()
      ), I = {
        data: !l || l === "text" || l === "json" ? S.responseText : S.response,
        status: S.status,
        statusText: S.statusText,
        headers: L,
        config: e,
        request: S
      };
      Nb(
        function(A) {
          r(A), _();
        },
        function(A) {
          i(A), _();
        },
        I
      ), S = null;
    }
    "onloadend" in S ? S.onloadend = j : S.onreadystatechange = function() {
      !S || S.readyState !== 4 || S.status === 0 && !(S.responseURL && S.responseURL.indexOf("file:") === 0) || setTimeout(j);
    }, S.onabort = function() {
      S && (i(new fn("Request aborted", fn.ECONNABORTED, e, S)), S = null);
    }, S.onerror = function(E) {
      const I = E && E.message ? E.message : "Network Error", F = new fn(I, fn.ERR_NETWORK, e, S);
      F.event = E || null, i(F), S = null;
    }, S.ontimeout = function() {
      let E = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const I = a.transitional || Im;
      a.timeoutErrorMessage && (E = a.timeoutErrorMessage), i(
        new fn(
          E,
          I.clarifyTimeoutError ? fn.ETIMEDOUT : fn.ECONNABORTED,
          e,
          S
        )
      ), S = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in S && ve.forEach(s.toJSON(), function(E, I) {
      S.setRequestHeader(I, E);
    }), ve.isUndefined(a.withCredentials) || (S.withCredentials = !!a.withCredentials), l && l !== "json" && (S.responseType = a.responseType), m && ([h, C] = rs(m, !0), S.addEventListener("progress", h)), d && S.upload && ([f, v] = rs(d), S.upload.addEventListener("progress", f), S.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (u = (L) => {
      S && (i(!L || L.type ? new ro(null, e, S) : L), S.abort(), S = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const k = aN(a.url);
    if (k && Ft.protocols.indexOf(k) === -1) {
      i(
        new fn(
          "Unsupported protocol " + k + ":",
          fn.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    S.send(o || null);
  });
}, fN = (e, n) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (n || r) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const u = m instanceof Error ? m : this.reason;
        i.abort(
          u instanceof fn ? u : new ro(u instanceof Error ? u.message : u)
        );
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new fn(`timeout of ${n}ms exceeded`, fn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: d } = i;
    return d.unsubscribe = () => ve.asap(l), d;
  }
}, hN = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, yN = async function* (e, n) {
  for await (const r of gN(e))
    yield* hN(r, n);
}, gN = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, Qp = (e, n, r, i) => {
  const a = yN(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream(
    {
      async pull(d) {
        try {
          const { done: m, value: u } = await a.next();
          if (m) {
            l(), d.close();
            return;
          }
          let f = u.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          d.enqueue(new Uint8Array(u));
        } catch (m) {
          throw l(m), m;
        }
      },
      cancel(d) {
        return l(d), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, Jp = 64 * 1024, { isFunction: po } = ve, vN = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ve.global), { ReadableStream: Xp, TextEncoder: Zp } = ve.global, ef = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, kN = (e) => {
  e = ve.merge.call(
    {
      skipUndefined: !0
    },
    vN,
    e
  );
  const { fetch: n, Request: r, Response: i } = e, a = n ? po(n) : typeof fetch == "function", o = po(r), s = po(i);
  if (!a)
    return !1;
  const l = a && po(Xp), d = a && (typeof Zp == "function" ? /* @__PURE__ */ ((C) => (_) => C.encode(_))(new Zp()) : async (C) => new Uint8Array(await new r(C).arrayBuffer())), m = o && l && ef(() => {
    let C = !1;
    const _ = new r(Ft.origin, {
      body: new Xp(),
      method: "POST",
      get duplex() {
        return C = !0, "half";
      }
    }), S = _.headers.has("Content-Type");
    return _.body != null && _.body.cancel(), C && !S;
  }), u = s && l && ef(() => ve.isReadableStream(new i("").body)), f = {
    stream: u && ((C) => C.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((C) => {
    !f[C] && (f[C] = (_, S) => {
      let j = _ && _[C];
      if (j)
        return j.call(_);
      throw new fn(
        `Response type '${C}' is not supported`,
        fn.ERR_NOT_SUPPORT,
        S
      );
    });
  });
  const h = async (C) => {
    if (C == null)
      return 0;
    if (ve.isBlob(C))
      return C.size;
    if (ve.isSpecCompliantForm(C))
      return (await new r(Ft.origin, {
        method: "POST",
        body: C
      }).arrayBuffer()).byteLength;
    if (ve.isArrayBufferView(C) || ve.isArrayBuffer(C))
      return C.byteLength;
    if (ve.isURLSearchParams(C) && (C = C + ""), ve.isString(C))
      return (await d(C)).byteLength;
  }, v = async (C, _) => {
    const S = ve.toFiniteNumber(C.getContentLength());
    return S ?? h(_);
  };
  return async (C) => {
    let {
      url: _,
      method: S,
      data: j,
      signal: k,
      cancelToken: L,
      timeout: E,
      onDownloadProgress: I,
      onUploadProgress: F,
      responseType: A,
      headers: K,
      withCredentials: Y = "same-origin",
      fetchOptions: ie
    } = wb(C), G = n || fetch;
    A = A ? (A + "").toLowerCase() : "text";
    let B = fN(
      [k, L && L.toAbortSignal()],
      E
    ), O = null;
    const z = B && B.unsubscribe && (() => {
      B.unsubscribe();
    });
    let Z;
    try {
      if (F && m && S !== "get" && S !== "head" && (Z = await v(K, j)) !== 0) {
        let Se = new r(_, {
          method: "POST",
          body: j,
          duplex: "half"
        }), Ce;
        if (ve.isFormData(j) && (Ce = Se.headers.get("content-type")) && K.setContentType(Ce), Se.body) {
          const [H, He] = Kp(
            Z,
            rs(Gp(F))
          );
          j = Qp(Se.body, Jp, H, He);
        }
      }
      ve.isString(Y) || (Y = Y ? "include" : "omit");
      const be = o && "credentials" in r.prototype;
      if (ve.isFormData(j)) {
        const Se = K.getContentType();
        Se && /^multipart\/form-data/i.test(Se) && !/boundary=/i.test(Se) && K.delete("content-type");
      }
      const he = {
        ...ie,
        signal: B,
        method: S.toUpperCase(),
        headers: K.normalize().toJSON(),
        body: j,
        duplex: "half",
        credentials: be ? Y : void 0
      };
      O = o && new r(_, he);
      let de = await (o ? G(O, ie) : G(_, he));
      const ye = u && (A === "stream" || A === "response");
      if (u && (I || ye && z)) {
        const Se = {};
        ["status", "statusText", "headers"].forEach((Be) => {
          Se[Be] = de[Be];
        });
        const Ce = ve.toFiniteNumber(de.headers.get("content-length")), [H, He] = I && Kp(
          Ce,
          rs(Gp(I), !0)
        ) || [];
        de = new i(
          Qp(de.body, Jp, H, () => {
            He && He(), z && z();
          }),
          Se
        );
      }
      A = A || "text";
      let q = await f[ve.findKey(f, A) || "text"](
        de,
        C
      );
      return !ye && z && z(), await new Promise((Se, Ce) => {
        Nb(Se, Ce, {
          data: q,
          headers: qt.from(de.headers),
          status: de.status,
          statusText: de.statusText,
          config: C,
          request: O
        });
      });
    } catch (be) {
      throw z && z(), be && be.name === "TypeError" && /Load failed|fetch/i.test(be.message) ? Object.assign(
        new fn(
          "Network Error",
          fn.ERR_NETWORK,
          C,
          O,
          be && be.response
        ),
        {
          cause: be.cause || be
        }
      ) : fn.from(be, be && be.code, C, O, be && be.response);
    }
  };
}, bN = /* @__PURE__ */ new Map(), Cb = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, d, m, u = bN;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : kN(n)), u = m;
  return m;
};
Cb();
const Em = {
  http: R0,
  xhr: pN,
  fetch: {
    get: Cb
  }
};
ve.forEach(Em, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const nf = (e) => `- ${e}`, xN = (e) => ve.isFunction(e) || e === null || e === !1;
function _N(e, n) {
  e = ve.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !xN(i) && (a = Em[(l = String(i)).toLowerCase()], a === void 0))
      throw new fn(`Unknown adapter '${l}'`);
    if (a && (ve.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(nf).join(`
`) : " " + nf(s[0]) : "as no adapter specified";
    throw new fn(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const Ib = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: _N,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Em
};
function Gs(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ro(null, e);
}
function tf(e) {
  return Gs(e), e.headers = qt.from(e.headers), e.data = Ks.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Ib.getAdapter(e.adapter || to.adapter, e)(e).then(
    function(i) {
      return Gs(e), i.data = Ks.call(e, e.transformResponse, i), i.headers = qt.from(i.headers), i;
    },
    function(i) {
      return Sb(i) || (Gs(e), i && i.response && (i.response.data = Ks.call(
        e,
        e.transformResponse,
        i.response
      ), i.response.headers = qt.from(i.response.headers))), Promise.reject(i);
    }
  );
}
const Fb = "1.15.2", Fs = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Fs[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const rf = {};
Fs.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + Fb + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new fn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        fn.ERR_DEPRECATED
      );
    return r && !rf[s] && (rf[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
Fs.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function SN(e, n, r) {
  if (typeof e != "object")
    throw new fn("options must be an object", fn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new fn(
          "option " + o + " must be " + d,
          fn.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new fn("Unknown option " + o, fn.ERR_BAD_OPTION);
  }
}
const Ho = {
  assertOptions: SN,
  validators: Fs
}, Zt = Ho.validators;
let ui = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new Hp(),
      response: new Hp()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), d = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(d) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = hi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Ho.assertOptions(
      i,
      {
        silentJSONParsing: Zt.transitional(Zt.boolean),
        forcedJSONParsing: Zt.transitional(Zt.boolean),
        clarifyTimeoutError: Zt.transitional(Zt.boolean),
        legacyInterceptorReqResOrdering: Zt.transitional(Zt.boolean)
      },
      !1
    ), a != null && (ve.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Ho.assertOptions(
      a,
      {
        encode: Zt.function,
        serialize: Zt.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Ho.assertOptions(
      r,
      {
        baseUrl: Zt.spelling("baseURL"),
        withXsrfToken: Zt.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ve.merge(o.common, o[r.method]);
    o && ve.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (C) => {
      delete o[C];
    }), r.headers = qt.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(_) {
      if (typeof _.runWhen == "function" && _.runWhen(r) === !1)
        return;
      d = d && _.synchronous;
      const S = r.transitional || Im;
      S && S.legacyInterceptorReqResOrdering ? l.unshift(_.fulfilled, _.rejected) : l.push(_.fulfilled, _.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(_) {
      m.push(_.fulfilled, _.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const C = [tf.bind(this), void 0];
      for (C.unshift(...l), C.push(...m), h = C.length, u = Promise.resolve(r); f < h; )
        u = u.then(C[f++], C[f++]);
      return u;
    }
    h = l.length;
    let v = r;
    for (; f < h; ) {
      const C = l[f++], _ = l[f++];
      try {
        v = C(v);
      } catch (S) {
        _.call(this, S);
        break;
      }
    }
    try {
      u = tf.call(this, v);
    } catch (C) {
      return Promise.reject(C);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = hi(this.defaults, n);
    const r = jb(n.baseURL, n.url, n.allowAbsoluteUrls);
    return xb(r, n.params, n.paramsSerializer);
  }
};
ve.forEach(["delete", "get", "head", "options"], function(n) {
  ui.prototype[n] = function(r, i) {
    return this.request(
      hi(i || {}, {
        method: n,
        url: r,
        data: (i || {}).data
      })
    );
  };
});
ve.forEach(["post", "put", "patch"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        hi(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  ui.prototype[n] = r(), ui.prototype[n + "Form"] = r(!0);
});
let NN = class Eb {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new ro(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new Eb(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function jN(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function wN(e) {
  return ve.isObject(e) && e.isAxiosError === !0;
}
const Pu = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Pu).forEach(([e, n]) => {
  Pu[n] = e;
});
function Tb(e) {
  const n = new ui(e), r = db(ui.prototype.request, n);
  return ve.extend(r, ui.prototype, n, { allOwnKeys: !0 }), ve.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return Tb(hi(e, a));
  }, r;
}
const ut = Tb(to);
ut.Axios = ui;
ut.CanceledError = ro;
ut.CancelToken = NN;
ut.isCancel = Sb;
ut.VERSION = Fb;
ut.toFormData = Is;
ut.AxiosError = fn;
ut.Cancel = ut.CanceledError;
ut.all = function(n) {
  return Promise.all(n);
};
ut.spread = jN;
ut.isAxiosError = wN;
ut.mergeConfig = hi;
ut.AxiosHeaders = qt;
ut.formToJSON = (e) => _b(ve.isHTMLForm(e) ? new FormData(e) : e);
ut.getAdapter = Ib.getAdapter;
ut.HttpStatusCode = Pu;
ut.default = ut;
const {
  Axios: p4,
  AxiosError: f4,
  CanceledError: h4,
  isCancel: y4,
  CancelToken: g4,
  VERSION: v4,
  all: k4,
  Cancel: b4,
  isAxiosError: CN,
  spread: x4,
  toFormData: _4,
  AxiosHeaders: S4,
  HttpStatusCode: N4,
  formToJSON: j4,
  getAdapter: w4,
  mergeConfig: C4
} = ut;
class IN {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const af = new IN();
function FN(e, n) {
  return of(e), of(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function of(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const EN = Object.prototype.toString;
function TN(e, n) {
  return EN.call(e) === `[object ${n}]`;
}
function $N(e) {
  return TN(e, "Object");
}
function DN(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Aa = "8.36.0", Or = globalThis;
function Tm(e, n, r) {
  const i = r || Or, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Aa] = a[Aa] || {};
  return o[e] || (o[e] = n());
}
const $b = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, RN = "Sentry Logger ", sf = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], lf = {};
function Db(e) {
  if (!("console" in Or))
    return e();
  const n = Or.console, r = {}, i = Object.keys(lf);
  i.forEach((a) => {
    const o = lf[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function ON() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return $b ? sf.forEach((r) => {
    n[r] = (...i) => {
      e && Db(() => {
        Or.console[r](`${RN}[${r}]:`, ...i);
      });
    };
  }) : sf.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Wo = Tm("logger", ON);
function PN(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    $b && Wo.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const Rb = 1e3;
function $m() {
  return Date.now() / Rb;
}
function AN() {
  const { performance: e } = Or;
  if (!e || !e.now)
    return $m;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / Rb;
}
const LN = AN();
(() => {
  const { performance: e } = Or;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function Oi() {
  const e = Or, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function cf() {
  return {
    traceId: Oi(),
    spanId: Oi().substring(16)
  };
}
function Dm() {
  return Rm(Or), Or;
}
function Rm(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Aa, n[Aa] = n[Aa] || {};
}
function VN(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || LN(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : Oi()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Au = "_sentrySpan";
function df(e, n) {
  n ? PN(e, Au, n) : delete e[Au];
}
function uf(e) {
  return e[Au];
}
const zN = 100;
class Om {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = cf();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Om();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, df(n, uf(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && VN(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof Ui ? [r.getScopeData(), r.getRequestSession()] : $N(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, df(this, void 0), this._attachments = [], this._propagationContext = cf(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : zN;
    if (i <= 0)
      return this;
    const a = {
      timestamp: $m(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: uf(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : Oi();
    if (!this._client)
      return Wo.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : Oi();
    if (!this._client)
      return Wo.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : Oi();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Wo.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const Ui = Om;
function UN() {
  return Tm("defaultCurrentScope", () => new Ui());
}
function MN() {
  return Tm("defaultIsolationScope", () => new Ui());
}
class BN {
  constructor(n, r) {
    let i;
    n ? i = n : i = new Ui();
    let a;
    r ? a = r : a = new Ui(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return DN(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Mi() {
  const e = Dm(), n = Rm(e);
  return n.stack = n.stack || new BN(UN(), MN());
}
function qN(e) {
  return Mi().withScope(e);
}
function HN(e, n) {
  const r = Mi();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function mf(e) {
  return Mi().withScope(() => e(Mi().getIsolationScope()));
}
function WN() {
  return {
    withIsolationScope: mf,
    withScope: qN,
    withSetScope: HN,
    withSetIsolationScope: (e, n) => mf(n),
    getCurrentScope: () => Mi().getScope(),
    getIsolationScope: () => Mi().getIsolationScope()
  };
}
function Ob(e) {
  const n = Rm(e);
  return n.acs ? n.acs : WN();
}
function Pm() {
  const e = Dm();
  return Ob(e).getCurrentScope();
}
function Pb() {
  const e = Dm();
  return Ob(e).getIsolationScope();
}
function KN() {
  return Pm().getClient();
}
function GN(e) {
  if (e)
    return YN(e) ? { captureContext: e } : JN(e) ? {
      captureContext: e
    } : e;
}
function YN(e) {
  return e instanceof Ui || typeof e == "function";
}
const QN = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function JN(e) {
  return Object.keys(e).some((n) => QN.includes(n));
}
function pf(e, n) {
  return Pm().captureException(e, GN(n));
}
function XN(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Pm().captureMessage(e, r, i);
}
function ZN(e, n) {
  Pb().setContext(e, n);
}
const ej = 100;
function ii(e, n) {
  const r = KN(), i = Pb();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = ej } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: $m(), ...e }, d = a ? Db(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var Ya;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Ya || (Ya = {}));
function Pi(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const nj = Ga.backendDomain ? {
  "backend-domain": Ga.backendDomain
} : void 0;
function Ko() {
  const e = new URLSearchParams({
    noToken: "true",
    ...nj
  }).toString();
  document.location.href = `${Ga.url.logIn}?${e}`;
}
const Ys = "authData", Qs = 30, tj = 600, Js = 5;
class rj {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= Js || this.clientServerTimeDiff <= -Js ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + tj, a = Pi(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Js) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(Ys, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(Ys), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(Ys);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - Qs;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = Pi(n), i = r.exp - Qs;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Qs - this.estimatedServerTime()) * 1e3;
  }
}
const kt = new rj();
async function ij(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? Pi(o).exp : "None", l = await Es.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? Pi(m).exp : "None", h = u ? Pi(u).exp : "None", v = typeof s == "number" ? d - s : "Unknown", C = typeof f == "number" ? d - f : "Unknown", _ = typeof h == "number" ? d - h : "Unknown", S = e.response.headers["x-dixa-rid"];
      ZN("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: v,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: C,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: _,
        xDixaRid: S,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    XN("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Ya.Platform,
        domain: n
      }
    });
  }
}
const Xs = /* @__PURE__ */ new Map(), aj = 3;
function oj(e) {
  e.interceptors.response.use((n) => (Xs.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case Lu.Unauthorized:
          if (!Es.isRefreshTokenExpired() && n.config) {
            ii({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = Xs.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= aj)
              return Xs.set(n.config.url, i + 1), e(n.config);
          }
          ij(n), console.error("401 unauthorized interceptor"), Ko();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const Ab = ut.create();
oj(Ab);
const Ir = console.log;
async function ff(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class sj extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function lj(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const cj = 5;
class dj {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      kt.setAuthData(r);
    else {
      const i = kt.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new sj("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = kt.getAccessToken();
    if (!n)
      return {};
    const r = Pi(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return kt.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = kt.getAuthData();
    return r ? kt.isAccessTokenExpired() ? (ii({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && kt.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return kt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return kt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return kt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = kt.getAuthData();
    return n ? kt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!af.isElectron())
      return !0;
    const n = await af.getVersion();
    return FN(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = cj) {
    try {
      return await Ab.post(`${Ga.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Ir("AUTH", "Network connection offline - waiting..."), ii({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await ff(5);
    n && (Ir("AUTH", "Network connection restored"), ii({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = lj(this.retryCount);
    return Ir("AUTH", `Retrying in ${i} seconds`), await ff(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (kt.isRefreshTokenExpired(r))
      return Ir("AUTH", "Refresh token expired"), ii({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), kt.removeAuthData(), Ko(), null;
    if (CN(n)) {
      if (n.message === "timeout exceeded")
        return Ir("AUTH", "Timeout exceeded"), ii({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Ir("AUTH", "Network error"), ii({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Ir("AUTH", "Refresh token invalid (401)"), kt.removeAuthData(), Ko(), null;
      pf(n, {
        level: "error",
        tags: {
          team: Ya.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Ir("AUTH", "Retries exhausted, logging out"), pf(n, {
      level: "error",
      tags: {
        team: Ya.Platform,
        errorSource: "authManager.refresh"
      }
    }), kt.removeAuthData(), Ko(), null) : (Ir("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return kt.accessTokenExpiresInMs();
  }
}
const Es = new dj();
var Lu;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Lu || (Lu = {}));
const uj = new jm((e, n) => new sb((r) => {
  Es.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), mj = new jm(
  (e, n) => new sb((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Es.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...Z_(Ga.url.partnerIntegrations) && d?.access_token && eS(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), pj = new AbortController(), Lb = (e) => new DS({
  queryDeduplication: !1,
  cache: new RS(),
  link: jm.from([
    uj,
    mj,
    OS({
      uri: `${e}/graphql`,
      fetch: zS,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: pj.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), fj = ({
  configuration: e,
  children: n
}) => {
  const r = Bn(
    () => Lb(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Ve.jsx(PS, { client: r, children: n });
};
function hj() {
  try {
    return AS(), !0;
  } catch {
    return !1;
  }
}
const yj = ({
  configuration: e,
  children: n
}) => hj() ? n : /* @__PURE__ */ Ve.jsx(fj, { configuration: e, children: n }), gj = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Ve.jsx(LS, { children: (o) => /* @__PURE__ */ Ve.jsx(
  nS,
  {
    value: {
      useMutation: aS(e, n),
      useQuery: iS(e, n),
      useLazyQuery: rS(e, n),
      executeQuery: tS(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), Vb = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Ve.jsx(yj, { configuration: r, children: s ? /* @__PURE__ */ Ve.jsx(
    gj,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, vj = "_unmatchedHeader_qcj19_1", kj = {
  unmatchedHeader: vj
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Zs = { exports: {} }, ra = {}, hf;
function bj() {
  if (hf) return ra;
  hf = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ra.Fragment = r, ra.jsx = s, ra.jsxs = s, ra;
}
var fo = {}, yf;
function xj() {
  return yf || (yf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    fo.Fragment = i, fo.jsx = Rn, fo.jsxs = Mn;
  })()), fo;
}
var gf;
function _j() {
  return gf || (gf = 1, process.env.NODE_ENV === "production" ? Zs.exports = bj() : Zs.exports = xj()), Zs.exports;
}
var ae = _j();
const Sj = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, Nj = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, jj = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": Sj,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": Nj
};
function zb(e) {
  return jj[e] ?? {};
}
const wj = zb(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), Cj = zb(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), Ij = "_copyIcon_1wjfs_48", Fj = "_list_1wjfs_53", Ej = "_listItem_1wjfs_63", Tj = "_collapsible_1wjfs_72", $j = "_collapsibleIsOpen_1wjfs_80", Dj = "_collapsibleHeader_1wjfs_83", Rj = "_collapsibleIconTrue_1wjfs_86", Oj = "_collapsibleIconFalse_1wjfs_89", On = {
  copyIcon: Ij,
  list: Fj,
  listItem: Ej,
  collapsible: Tj,
  collapsibleIsOpen: $j,
  collapsibleHeader: Dj,
  collapsibleIconTrue: Rj,
  collapsibleIconFalse: Oj
}, Pj = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: tt(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ ae.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(Ge, { className: On.list, children: [
          /* @__PURE__ */ ae.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "5", color: "secondary", children: Ln(d).format(gt) })
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "5", color: "secondary", children: Ln(m).format(gt) })
          ] }) })
        ] })
      ]
    }
  );
}, Aj = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(D.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ ae.jsx(Pn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      D.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx(Pj, { app: r, openByDefault: i === 0 }, i))
  ] });
}, Lj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(D.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ ae.jsx(Ge, { className: On.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ ae.jsx(
      Ge.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", children: i }),
          Ka(a)
        ] })
      },
      o
    )) })
  ] }) });
}, Vj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(D.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ ae.jsx(Ge, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      Ge.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            We,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${Ln(a?.first).format(
                  gt
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${Ln(a?.last).format(
                  gt
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, is = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ ae.jsx(We, { content: n ? null : l(), children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(me, { size: 14, name: o(), color: s() }) }) });
}, zj = "_wrapper_1xucg_1", Uj = "_externalLink_1xucg_7", el = {
  wrapper: zj,
  externalLink: Uj
}, Mj = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Jt(), { isCopied: i, copy: a } = Jt(), { isCopied: o, copy: s } = Jt(), { isCopied: l, copy: d } = Jt(), { isCopied: m, copy: u } = Jt();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: v,
    last_name: C,
    home_city: _,
    country: S,
    email: j,
    phone: k,
    dob: L,
    created_at: E,
    email_subscribe: I,
    push_subscribe: F
  } = e, A = 14, K = `${v || ""} ${C || ""}`.trim() || "A customer has no name", Y = `${_ ? `${_} /` : ""} ${S || ""}`.trim(), ie = L ? Ln(L).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { className: el.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: el.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ ae.jsx(D.Heading, { variant: "heading-2", children: K }),
          ie && /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    E && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", children: Ln(E).format(gt) })
    ] }),
    Y && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: A, name: "map-pin" }),
        /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", children: Y })
      ] }),
      /* @__PURE__ */ ae.jsx(We, { content: "Copy location", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        me,
        {
          size: A,
          name: o ? "done" : "copy",
          onClick: () => s(Y),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    j && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: A, name: "mail" }),
        /* @__PURE__ */ ae.jsx("span", { className: el.externalLink, children: j })
      ] }),
      /* @__PURE__ */ ae.jsx(We, { content: "Copy email", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        me,
        {
          size: A,
          name: n ? "done" : "copy",
          onClick: () => r(j),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    k && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: A, name: "phone" }),
        /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", children: k })
      ] }),
      /* @__PURE__ */ ae.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        me,
        {
          size: A,
          name: i ? "done" : "copy",
          onClick: () => a(k),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: A, name: "user" }),
        /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ ae.jsxs(D.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(We, { content: "Copy Braze ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        me,
        {
          size: A,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: A, name: "tag" }),
        /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ ae.jsxs(D.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ae.jsx(We, { content: "Copy External ID", children: /* @__PURE__ */ ae.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ae.jsx(
        me,
        {
          size: A,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    I && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: A, name: "sync" }),
        /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(is, { state: I })
    ] }),
    F && /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: A, name: "bell" }),
        /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(is, { isPush: !0, state: F })
    ] })
  ] }) });
}, Bj = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ ae.jsxs(
    b,
    {
      className: tt(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ae.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ ae.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ae.jsxs(Ge, { className: On.list, children: [
          /* @__PURE__ */ ae.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ae.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ ae.jsx(
              me,
              {
                size: a,
                className: tt({
                  [On.collapsibleIconTrue]: d,
                  [On.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ ae.jsx(We, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ ae.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(We, { content: "For iOS", children: /* @__PURE__ */ ae.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ae.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, qj = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ae.jsx(D.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ ae.jsx(Pn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ae.jsx(
      D.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ae.jsx(Bj, { device: r, openByDefault: i === 0 }, i))
  ] });
}, ia = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, ho = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = bn(), { useMutation: a } = un(), [o, s] = se(!1), [l] = a(
    Cj,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: ia[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ ae.jsx(We, { content: ia[n].tooltipContent, children: /* @__PURE__ */ ae.jsx(
    Kn,
    {
      variant: "secondary",
      color: ia[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ ae.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(
          is,
          {
            noTooltip: !0,
            state: ia[n].parameter
          }
        ),
        ia[n].label
      ] })
    }
  ) });
}, Hj = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ ae.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(D.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ ae.jsx(Ge, { className: On.list, children: /* @__PURE__ */ ae.jsx(Ge.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ae.jsx(me, { size: 14, name: "sync" }),
        /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ae.jsx(is, { state: a })
    ] }) }) }),
    /* @__PURE__ */ ae.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
        /* @__PURE__ */ ae.jsx(
          ho,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ ae.jsx(
          ho,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ ae.jsx(
        ho,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ ae.jsx(
        ho,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, Wj = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ae.jsx(ae.Fragment, { children: /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ae.jsx(D.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ ae.jsx(Ge, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ ae.jsx(
      Ge.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ ae.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ae.jsx(
            We,
            {
              content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsx(b, { children: `First ${Ln(a?.first).format(
                  gt
                )}` }),
                /* @__PURE__ */ ae.jsx(b, { children: `Last ${Ln(a?.last).format(
                  gt
                )}` })
              ] }),
              children: /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ae.jsx(D.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Kj = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = bn(), { useMutation: i } = un(), [a, o] = se(), [s, l] = se(!1), [d, m] = se(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, C = n.displayCustomAttributes ?? !1, _ = n.displayCustomEvents ?? !1, S = n.displayPuchases ?? !1, j = n.displayDevices ?? !1, k = n.displayApps ?? !1, L = !h && !v && !C && !_ && !S, [E, { error: I }] = i(
    wj,
    {
      onError: () => {
      },
      onCompleted: (A) => {
        const K = A?.Braze?.exportUserDetails?.users?.[0];
        K ? (o(K), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), F = async () => {
    u || f ? await E({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (qe(() => {
    async function A() {
      m(!0), await F();
    }
    A().finally(() => m(!1));
  }, [u, f]), I) {
    const A = I.graphQLErrors;
    return km({ errors: A }) ? /* @__PURE__ */ ae.jsx(
      D.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : bm({ errors: A }) ? /* @__PURE__ */ ae.jsx(
      D.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ae.jsx(Cn, { error: I });
  }
  return d ? /* @__PURE__ */ ae.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ae.jsx(ln, {}) }) : L ? /* @__PURE__ */ ae.jsx(
    D.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ ae.jsx(
    D.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ ae.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ae.jsx(Mj, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ ae.jsx(
          Hj,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await F()
          }
        ),
        C && !!a && /* @__PURE__ */ ae.jsx(Lj, { customerDetails: a }),
        _ && !!a && /* @__PURE__ */ ae.jsx(Vj, { customerDetails: a }),
        S && !!a && /* @__PURE__ */ ae.jsx(Wj, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ ae.jsx(qj, { devices: a?.devices }),
        k && !!a && /* @__PURE__ */ ae.jsx(Aj, { apps: a?.apps })
      ]
    }
  );
}, Gj = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Zk(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function Yj() {
  var e = di(!1), n = at(function() {
    return e.current;
  }, []);
  return qe(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var Qj = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = at(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, Jj = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, vf = function(e) {
  return xS(Jj, e);
}, nl, kf;
function Xj() {
  return kf || (kf = 1, nl = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), nl;
}
var tl, bf;
function Zj() {
  if (bf) return tl;
  bf = 1;
  var e = Xj(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(_) {
        if (_.stopPropagation(), s.format)
          if (_.preventDefault(), typeof _.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var S = n[s.format] || n.default;
            window.clipboardData.setData(S, o);
          } else
            _.clipboardData.clearData(), _.clipboardData.setData(s.format, o);
        s.onCopy && (_.preventDefault(), s.onCopy(_.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var C = document.execCommand("copy");
      if (!C)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (_) {
      l && console.error("unable to copy using execCommand: ", _), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (S) {
        l && console.error("unable to copy using clipboardData: ", S), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return v;
  }
  return tl = a, tl;
}
var ew = Zj();
const nw = /* @__PURE__ */ wm(ew);
var Ub = function() {
  var e = Yj(), n = Qj({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = at(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = nw(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function tw(e, n) {
  n === void 0 && (n = 0);
  var r = di(!1), i = di(), a = di(e), o = at(function() {
    return r.current;
  }, []), s = at(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = at(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return qe(function() {
    a.current = e;
  }, [e]), qe(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function yi(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = tw(e, n), a = i[0], o = i[1], s = i[2];
  return qe(s, r), [a, o];
}
var rw = function(e) {
  qe(e, []);
}, iw = function(e, n) {
  var r = di(function() {
  });
  qe(function() {
    r.current = e;
  }), qe(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, aw = function(e) {
  e === void 0 && (e = {});
  var n = se(e), r = n[0], i = n[1], a = Bn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return qs(qs({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = US(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = qs({ get: at(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, ow = function(e) {
  var n = di(e);
  n.current = e, rw(function() {
    return function() {
      return n.current();
    };
  });
}, io = (e) => e.type === "checkbox", li = (e) => e instanceof Date, At = (e) => e == null;
const Mb = (e) => typeof e == "object";
var ct = (e) => !At(e) && !Array.isArray(e) && Mb(e) && !li(e), Bb = (e) => ct(e) && e.target ? io(e.target) ? e.target.checked : e.target.value : e, sw = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, qb = (e, n) => e.has(sw(n)), lw = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ct(n) && n.hasOwnProperty("isPrototypeOf");
}, Am = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function _t(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Am && (e instanceof Blob || i)) && (r || ct(e)))
    if (n = r ? [] : {}, !r && !lw(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = _t(e[a]));
  else
    return e;
  return n;
}
var Ts = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ot = (e) => e === void 0, Qe = (e, n, r) => {
  if (!n || !ct(e))
    return r;
  const i = Ts(n.split(/[,[\].]+?/)).reduce((a, o) => At(a) ? a : a[o], e);
  return ot(i) || i === e ? ot(e[n]) ? r : e[n] : i;
}, Yt = (e) => typeof e == "boolean", Lm = (e) => /^\w*$/.test(e), Hb = (e) => Ts(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Yn = (e, n, r) => {
  let i = -1;
  const a = Lm(n) ? [n] : Hb(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = ct(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const as = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, cr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Fr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Wb = Ae.createContext(null), wr = () => Ae.useContext(Wb), Vm = (e) => {
  const { children: n, ...r } = e;
  return Ae.createElement(Wb.Provider, { value: r }, n);
};
var Kb = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== cr.all && (n._proxyFormState[s] = !i || cr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function cw(e) {
  const n = wr(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Ae.useState(r._formState), d = Ae.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Ae.useRef(a);
  return m.current = a, Ae.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Ae.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Ae.useMemo(() => Kb(s, r, d.current, !1), [s, r]);
}
var _r = (e) => typeof e == "string", Gb = (e, n, r, i, a) => _r(e) ? (i && n.watch.add(e), Qe(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Qe(r, o))) : (i && (n.watchAll = !0), r);
function La(e) {
  const n = wr(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Ae.useRef(i), d = Ae.useRef(a);
  l.current = i, Ae.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(Gb(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Ae.useState(r._getWatch(i, a));
  return Ae.useEffect(() => r._removeUnmounted()), m;
}
function zm(e) {
  const n = wr(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = qb(a._names.array, r), l = La({
    control: a,
    name: r,
    defaultValue: Qe(a._formValues, r, Qe(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = cw({
    control: a,
    name: r,
    exact: !0
  }), m = Ae.useRef(e), u = Ae.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Yt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Ae.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Qe(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Qe(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Qe(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Qe(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Qe(d.errors, r)
    }
  }), [d, r]), h = Ae.useCallback((S) => u.current.onChange({
    target: {
      value: Bb(S),
      name: r
    },
    type: as.CHANGE
  }), [r]), v = Ae.useCallback(() => u.current.onBlur({
    target: {
      value: Qe(a._formValues, r),
      name: r
    },
    type: as.BLUR
  }), [r, a._formValues]), C = Ae.useCallback((S) => {
    const j = Qe(a._fields, r);
    j && S && (j._f.ref = {
      focus: () => S.focus(),
      select: () => S.select(),
      setCustomValidity: (k) => S.setCustomValidity(k),
      reportValidity: () => S.reportValidity()
    });
  }, [a._fields, r]), _ = Ae.useMemo(() => ({
    name: r,
    value: l,
    ...Yt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: C
  }), [r, i, d.disabled, h, v, C, l]);
  return Ae.useEffect(() => {
    const S = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Yt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const j = (k, L) => {
      const E = Qe(a._fields, k);
      E && E._f && (E._f.mount = L);
    };
    if (j(r, !0), S) {
      const k = _t(Qe(a._options.defaultValues, r));
      Yn(a._defaultValues, r, k), ot(Qe(a._formValues, r)) && Yn(a._formValues, r, k);
    }
    return !s && a.register(r), () => {
      (s ? S && !a._state.action : S) ? a.unregister(r) : j(r, !1);
    };
  }, [r, a, s, o]), Ae.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Ae.useMemo(() => ({
    field: _,
    formState: d,
    fieldState: f
  }), [_, d, f]);
}
const Nt = (e) => e.render(zm(e));
var dw = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Va = (e) => Array.isArray(e) ? e : [e], xf = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Vu = (e) => At(e) || !Mb(e);
function Mr(e, n) {
  if (Vu(e) || Vu(n))
    return e === n;
  if (li(e) && li(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (li(o) && li(s) || ct(o) && ct(s) || Array.isArray(o) && Array.isArray(s) ? !Mr(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Ot = (e) => ct(e) && !Object.keys(e).length, Um = (e) => e.type === "file", dr = (e) => typeof e == "function", os = (e) => {
  if (!Am)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, Yb = (e) => e.type === "select-multiple", Mm = (e) => e.type === "radio", uw = (e) => Mm(e) || io(e), rl = (e) => os(e) && e.isConnected;
function mw(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ot(e) ? i++ : e[n[i++]];
  return e;
}
function pw(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ot(e[n]))
      return !1;
  return !0;
}
function ht(e, n) {
  const r = Array.isArray(n) ? n : Lm(n) ? [n] : Hb(n), i = r.length === 1 ? e : mw(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (ct(i) && Ot(i) || Array.isArray(i) && pw(i)) && ht(e, r.slice(0, -1)), e;
}
var Qb = (e) => {
  for (const n in e)
    if (dr(e[n]))
      return !0;
  return !1;
};
function ss(e, n = {}) {
  const r = Array.isArray(e);
  if (ct(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || ct(e[i]) && !Qb(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, ss(e[i], n[i])) : At(e[i]) || (n[i] = !0);
  return n;
}
function Jb(e, n, r) {
  const i = Array.isArray(e);
  if (ct(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ct(e[a]) && !Qb(e[a]) ? ot(n) || Vu(r[a]) ? r[a] = Array.isArray(e[a]) ? ss(e[a], []) : { ...ss(e[a]) } : Jb(e[a], At(n) ? {} : n[a], r[a]) : r[a] = !Mr(e[a], n[a]);
  return r;
}
var aa = (e, n) => Jb(e, n, ss(n));
const _f = {
  value: !1,
  isValid: !1
}, Sf = { value: !0, isValid: !0 };
var Xb = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ot(e[0].attributes.value) ? ot(e[0].value) || e[0].value === "" ? Sf : { value: e[0].value, isValid: !0 } : Sf
    ) : _f;
  }
  return _f;
}, Zb = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ot(e) ? e : n ? e === "" ? NaN : e && +e : r && _r(e) ? new Date(e) : i ? i(e) : e;
const Nf = {
  isValid: !1,
  value: null
};
var ex = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Nf) : Nf;
function jf(e) {
  const n = e.ref;
  return Um(n) ? n.files : Mm(n) ? ex(e.refs).value : Yb(n) ? [...n.selectedOptions].map(({ value: r }) => r) : io(n) ? Xb(e.refs).value : Zb(ot(n.value) ? e.ref.value : n.value, e);
}
var fw = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Qe(n, o);
    s && Yn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, ls = (e) => e instanceof RegExp, oa = (e) => ot(e) ? e : ls(e) ? e.source : ct(e) ? ls(e.value) ? e.value.source : e.value : e, wf = (e) => ({
  isOnSubmit: !e || e === cr.onSubmit,
  isOnBlur: e === cr.onBlur,
  isOnChange: e === cr.onChange,
  isOnAll: e === cr.all,
  isOnTouch: e === cr.onTouched
});
const Cf = "AsyncFunction";
var hw = (e) => !!e && !!e.validate && !!(dr(e.validate) && e.validate.constructor.name === Cf || ct(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Cf)), yw = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), If = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const za = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Qe(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (za(l, n))
          break;
      } else if (ct(l) && za(l, n))
        break;
    }
  }
};
function Ff(e, n, r) {
  const i = Qe(e, r);
  if (i || Lm(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Qe(n, o), l = Qe(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var gw = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Ot(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || cr.all));
}, vw = (e, n, r) => !e || !n || e === n || Va(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), kw = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, bw = (e, n) => !Ts(Qe(e, n)).length && ht(e, n), xw = (e, n, r) => {
  const i = Va(Qe(e, r));
  return Yn(i, "root", n[r]), Yn(e, r, i), e;
}, Go = (e) => _r(e);
function Ef(e, n, r = "validate") {
  if (Go(e) || Array.isArray(e) && e.every(Go) || Yt(e) && !e)
    return {
      type: r,
      message: Go(e) ? e : "",
      ref: n
    };
}
var _i = (e) => ct(e) && !ls(e) ? e : {
  value: e,
  message: ""
}, Tf = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: C, name: _, valueAsNumber: S, mount: j } = e._f, k = Qe(r, _);
  if (!j || n.has(_))
    return {};
  const L = l ? l[0] : s, E = (B) => {
    a && L.reportValidity && (L.setCustomValidity(Yt(B) ? "" : B || ""), L.reportValidity());
  }, I = {}, F = Mm(s), A = io(s), K = F || A, Y = (S || Um(s)) && ot(s.value) && ot(k) || os(s) && s.value === "" || k === "" || Array.isArray(k) && !k.length, ie = dw.bind(null, _, i, I), G = (B, O, z, Z = Fr.maxLength, be = Fr.minLength) => {
    const he = B ? O : z;
    I[_] = {
      type: B ? Z : be,
      message: he,
      ref: s,
      ...ie(B ? Z : be, he)
    };
  };
  if (o ? !Array.isArray(k) || !k.length : d && (!K && (Y || At(k)) || Yt(k) && !k || A && !Xb(l).isValid || F && !ex(l).isValid)) {
    const { value: B, message: O } = Go(d) ? { value: !!d, message: d } : _i(d);
    if (B && (I[_] = {
      type: Fr.required,
      message: O,
      ref: L,
      ...ie(Fr.required, O)
    }, !i))
      return E(O), I;
  }
  if (!Y && (!At(f) || !At(h))) {
    let B, O;
    const z = _i(h), Z = _i(f);
    if (!At(k) && !isNaN(k)) {
      const be = s.valueAsNumber || k && +k;
      At(z.value) || (B = be > z.value), At(Z.value) || (O = be < Z.value);
    } else {
      const be = s.valueAsDate || new Date(k), he = (q) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + q), de = s.type == "time", ye = s.type == "week";
      _r(z.value) && k && (B = de ? he(k) > he(z.value) : ye ? k > z.value : be > new Date(z.value)), _r(Z.value) && k && (O = de ? he(k) < he(Z.value) : ye ? k < Z.value : be < new Date(Z.value));
    }
    if ((B || O) && (G(!!B, z.message, Z.message, Fr.max, Fr.min), !i))
      return E(I[_].message), I;
  }
  if ((m || u) && !Y && (_r(k) || o && Array.isArray(k))) {
    const B = _i(m), O = _i(u), z = !At(B.value) && k.length > +B.value, Z = !At(O.value) && k.length < +O.value;
    if ((z || Z) && (G(z, B.message, O.message), !i))
      return E(I[_].message), I;
  }
  if (v && !Y && _r(k)) {
    const { value: B, message: O } = _i(v);
    if (ls(B) && !k.match(B) && (I[_] = {
      type: Fr.pattern,
      message: O,
      ref: s,
      ...ie(Fr.pattern, O)
    }, !i))
      return E(O), I;
  }
  if (C) {
    if (dr(C)) {
      const B = await C(k, r), O = Ef(B, L);
      if (O && (I[_] = {
        ...O,
        ...ie(Fr.validate, O.message)
      }, !i))
        return E(O.message), I;
    } else if (ct(C)) {
      let B = {};
      for (const O in C) {
        if (!Ot(B) && !i)
          break;
        const z = Ef(await C[O](k, r), L, O);
        z && (B = {
          ...z,
          ...ie(O, z.message)
        }, E(z.message), i && (I[_] = B));
      }
      if (!Ot(B) && (I[_] = {
        ref: L,
        ...B
      }, !i))
        return I;
    }
  }
  return E(!0), I;
};
const _w = {
  mode: cr.onSubmit,
  reValidateMode: cr.onChange,
  shouldFocusError: !0
};
function Sw(e = {}) {
  let n = {
    ..._w,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: dr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ct(n.defaultValues) || ct(n.values) ? _t(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : _t(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: xf(),
    state: xf()
  }, v = wf(n.mode), C = wf(n.reValidateMode), _ = n.criteriaMode === cr.all, S = (T) => (U) => {
    clearTimeout(m), m = setTimeout(T, U);
  }, j = async (T) => {
    if (!n.disabled && (u.isValid || f.isValid || T)) {
      const U = n.resolver ? Ot((await Y()).errors) : await G(i, !0);
      U !== r.isValid && h.state.next({
        isValid: U
      });
    }
  }, k = (T, U) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((T || Array.from(l.mount)).forEach((X) => {
      X && (U ? Yn(r.validatingFields, X, U) : ht(r.validatingFields, X));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Ot(r.validatingFields)
    }));
  }, L = (T, U = [], X, re, V = !0, W = !0) => {
    if (re && X && !n.disabled) {
      if (s.action = !0, W && Array.isArray(Qe(i, T))) {
        const le = X(Qe(i, T), re.argA, re.argB);
        V && Yn(i, T, le);
      }
      if (W && Array.isArray(Qe(r.errors, T))) {
        const le = X(Qe(r.errors, T), re.argA, re.argB);
        V && Yn(r.errors, T, le), bw(r.errors, T);
      }
      if ((u.touchedFields || f.touchedFields) && W && Array.isArray(Qe(r.touchedFields, T))) {
        const le = X(Qe(r.touchedFields, T), re.argA, re.argB);
        V && Yn(r.touchedFields, T, le);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = aa(a, o)), h.state.next({
        name: T,
        isDirty: O(T, U),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Yn(o, T, U);
  }, E = (T, U) => {
    Yn(r.errors, T, U), h.state.next({
      errors: r.errors
    });
  }, I = (T) => {
    r.errors = T, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, F = (T, U, X, re) => {
    const V = Qe(i, T);
    if (V) {
      const W = Qe(o, T, ot(X) ? Qe(a, T) : X);
      ot(W) || re && re.defaultChecked || U ? Yn(o, T, U ? W : jf(V._f)) : be(T, W), s.mount && j();
    }
  }, A = (T, U, X, re, V) => {
    let W = !1, le = !1;
    const ke = {
      name: T
    };
    if (!n.disabled) {
      if (!X || re) {
        (u.isDirty || f.isDirty) && (le = r.isDirty, r.isDirty = ke.isDirty = O(), W = le !== ke.isDirty);
        const Ie = Mr(Qe(a, T), U);
        le = !!Qe(r.dirtyFields, T), Ie ? ht(r.dirtyFields, T) : Yn(r.dirtyFields, T, !0), ke.dirtyFields = r.dirtyFields, W = W || (u.dirtyFields || f.dirtyFields) && le !== !Ie;
      }
      if (X) {
        const Ie = Qe(r.touchedFields, T);
        Ie || (Yn(r.touchedFields, T, X), ke.touchedFields = r.touchedFields, W = W || (u.touchedFields || f.touchedFields) && Ie !== X);
      }
      W && V && h.state.next(ke);
    }
    return W ? ke : {};
  }, K = (T, U, X, re) => {
    const V = Qe(r.errors, T), W = (u.isValid || f.isValid) && Yt(U) && r.isValid !== U;
    if (n.delayError && X ? (d = S(() => E(T, X)), d(n.delayError)) : (clearTimeout(m), d = null, X ? Yn(r.errors, T, X) : ht(r.errors, T)), (X ? !Mr(V, X) : V) || !Ot(re) || W) {
      const le = {
        ...re,
        ...W && Yt(U) ? { isValid: U } : {},
        errors: r.errors,
        name: T
      };
      r = {
        ...r,
        ...le
      }, h.state.next(le);
    }
  }, Y = async (T) => {
    k(T, !0);
    const U = await n.resolver(o, n.context, fw(T || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return k(T), U;
  }, ie = async (T) => {
    const { errors: U } = await Y(T);
    if (T)
      for (const X of T) {
        const re = Qe(U, X);
        re ? Yn(r.errors, X, re) : ht(r.errors, X);
      }
    else
      r.errors = U;
    return U;
  }, G = async (T, U, X = {
    valid: !0
  }) => {
    for (const re in T) {
      const V = T[re];
      if (V) {
        const { _f: W, ...le } = V;
        if (W) {
          const ke = l.array.has(W.name), Ie = V._f && hw(V._f);
          Ie && u.validatingFields && k([re], !0);
          const en = await Tf(V, l.disabled, o, _, n.shouldUseNativeValidation && !U, ke);
          if (Ie && u.validatingFields && k([re]), en[W.name] && (X.valid = !1, U))
            break;
          !U && (Qe(en, W.name) ? ke ? xw(r.errors, en, W.name) : Yn(r.errors, W.name, en[W.name]) : ht(r.errors, W.name));
        }
        !Ot(le) && await G(le, U, X);
      }
    }
    return X.valid;
  }, B = () => {
    for (const T of l.unMount) {
      const U = Qe(i, T);
      U && (U._f.refs ? U._f.refs.every((X) => !rl(X)) : !rl(U._f.ref)) && Me(T);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (T, U) => !n.disabled && (T && U && Yn(o, T, U), !Mr(Ce(), a)), z = (T, U, X) => Gb(T, l, {
    ...s.mount ? o : ot(U) ? a : _r(T) ? { [T]: U } : U
  }, X, U), Z = (T) => Ts(Qe(s.mount ? o : a, T, n.shouldUnregister ? Qe(a, T, []) : [])), be = (T, U, X = {}) => {
    const re = Qe(i, T);
    let V = U;
    if (re) {
      const W = re._f;
      W && (!W.disabled && Yn(o, T, Zb(U, W)), V = os(W.ref) && At(U) ? "" : U, Yb(W.ref) ? [...W.ref.options].forEach((le) => le.selected = V.includes(le.value)) : W.refs ? io(W.ref) ? W.refs.length > 1 ? W.refs.forEach((le) => (!le.defaultChecked || !le.disabled) && (le.checked = Array.isArray(V) ? !!V.find((ke) => ke === le.value) : V === le.value)) : W.refs[0] && (W.refs[0].checked = !!V) : W.refs.forEach((le) => le.checked = le.value === V) : Um(W.ref) ? W.ref.value = "" : (W.ref.value = V, W.ref.type || h.state.next({
        name: T,
        values: _t(o)
      })));
    }
    (X.shouldDirty || X.shouldTouch) && A(T, V, X.shouldTouch, X.shouldDirty, !0), X.shouldValidate && Se(T);
  }, he = (T, U, X) => {
    for (const re in U) {
      const V = U[re], W = `${T}.${re}`, le = Qe(i, W);
      (l.array.has(T) || ct(V) || le && !le._f) && !li(V) ? he(W, V, X) : be(W, V, X);
    }
  }, de = (T, U, X = {}) => {
    const re = Qe(i, T), V = l.array.has(T), W = _t(U);
    Yn(o, T, W), V ? (h.array.next({
      name: T,
      values: _t(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && X.shouldDirty && h.state.next({
      name: T,
      dirtyFields: aa(a, o),
      isDirty: O(T, W)
    })) : re && !re._f && !At(W) ? he(T, W, X) : be(T, W, X), If(T, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? T : void 0,
      values: _t(o)
    });
  }, ye = async (T) => {
    s.mount = !0;
    const U = T.target;
    let X = U.name, re = !0;
    const V = Qe(i, X), W = (le) => {
      re = Number.isNaN(le) || li(le) && isNaN(le.getTime()) || Mr(le, Qe(o, X, le));
    };
    if (V) {
      let le, ke;
      const Ie = U.type ? jf(V._f) : Bb(T), en = T.type === as.BLUR || T.type === as.FOCUS_OUT, hn = !yw(V._f) && !n.resolver && !Qe(r.errors, X) && !V._f.deps || kw(en, Qe(r.touchedFields, X), r.isSubmitted, C, v), rn = If(X, l, en);
      Yn(o, X, Ie), en ? (V._f.onBlur && V._f.onBlur(T), d && d(0)) : V._f.onChange && V._f.onChange(T);
      const cn = A(X, Ie, en), pn = !Ot(cn) || rn;
      if (!en && h.state.next({
        name: X,
        type: T.type,
        values: _t(o)
      }), hn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? en && j() : en || j()), pn && h.state.next({ name: X, ...rn ? {} : cn });
      if (!en && rn && h.state.next({ ...r }), n.resolver) {
        const { errors: dn } = await Y([X]);
        if (W(Ie), re) {
          const Sn = Ff(r.errors, i, X), Xe = Ff(dn, i, Sn.name || X);
          le = Xe.error, X = Xe.name, ke = Ot(dn);
        }
      } else
        k([X], !0), le = (await Tf(V, l.disabled, o, _, n.shouldUseNativeValidation))[X], k([X]), W(Ie), re && (le ? ke = !1 : (u.isValid || f.isValid) && (ke = await G(i, !0)));
      re && (V._f.deps && Se(V._f.deps), K(X, ke, le, cn));
    }
  }, q = (T, U) => {
    if (Qe(r.errors, U) && T.focus)
      return T.focus(), 1;
  }, Se = async (T, U = {}) => {
    let X, re;
    const V = Va(T);
    if (n.resolver) {
      const W = await ie(ot(T) ? T : V);
      X = Ot(W), re = T ? !V.some((le) => Qe(W, le)) : X;
    } else T ? (re = (await Promise.all(V.map(async (W) => {
      const le = Qe(i, W);
      return await G(le && le._f ? { [W]: le } : le);
    }))).every(Boolean), !(!re && !r.isValid) && j()) : re = X = await G(i);
    return h.state.next({
      ...!_r(T) || (u.isValid || f.isValid) && X !== r.isValid ? {} : { name: T },
      ...n.resolver || !T ? { isValid: X } : {},
      errors: r.errors
    }), U.shouldFocus && !re && za(i, q, T ? V : l.mount), re;
  }, Ce = (T) => {
    const U = {
      ...s.mount ? o : a
    };
    return ot(T) ? U : _r(T) ? Qe(U, T) : T.map((X) => Qe(U, X));
  }, H = (T, U) => ({
    invalid: !!Qe((U || r).errors, T),
    isDirty: !!Qe((U || r).dirtyFields, T),
    error: Qe((U || r).errors, T),
    isValidating: !!Qe(r.validatingFields, T),
    isTouched: !!Qe((U || r).touchedFields, T)
  }), He = (T) => {
    T && Va(T).forEach((U) => ht(r.errors, U)), h.state.next({
      errors: T ? r.errors : {}
    });
  }, Be = (T, U, X) => {
    const re = (Qe(i, T, { _f: {} })._f || {}).ref, V = Qe(r.errors, T) || {}, { ref: W, message: le, type: ke, ...Ie } = V;
    Yn(r.errors, T, {
      ...Ie,
      ...U,
      ref: re
    }), h.state.next({
      name: T,
      errors: r.errors,
      isValid: !1
    }), X && X.shouldFocus && re && re.focus && re.focus();
  }, Re = (T, U) => dr(T) ? h.state.subscribe({
    next: (X) => T(z(void 0, U), X)
  }) : z(T, U, !0), Ue = (T) => h.state.subscribe({
    next: (U) => {
      vw(T.name, U.name, T.exact) && gw(U, T.formState || u, Pe, T.reRenderRoot) && T.callback({
        values: { ...o },
        ...r,
        ...U
      });
    }
  }).unsubscribe, Te = (T) => (s.mount = !0, f = {
    ...f,
    ...T.formState
  }, Ue({
    ...T,
    formState: f
  })), Me = (T, U = {}) => {
    for (const X of T ? Va(T) : l.mount)
      l.mount.delete(X), l.array.delete(X), U.keepValue || (ht(i, X), ht(o, X)), !U.keepError && ht(r.errors, X), !U.keepDirty && ht(r.dirtyFields, X), !U.keepTouched && ht(r.touchedFields, X), !U.keepIsValidating && ht(r.validatingFields, X), !n.shouldUnregister && !U.keepDefaultValue && ht(a, X);
    h.state.next({
      values: _t(o)
    }), h.state.next({
      ...r,
      ...U.keepDirty ? { isDirty: O() } : {}
    }), !U.keepIsValid && j();
  }, De = ({ disabled: T, name: U }) => {
    (Yt(T) && s.mount || T || l.disabled.has(U)) && (T ? l.disabled.add(U) : l.disabled.delete(U));
  }, on = (T, U = {}) => {
    let X = Qe(i, T);
    const re = Yt(U.disabled) || Yt(n.disabled);
    return Yn(i, T, {
      ...X || {},
      _f: {
        ...X && X._f ? X._f : { ref: { name: T } },
        name: T,
        mount: !0,
        ...U
      }
    }), l.mount.add(T), X ? De({
      disabled: Yt(U.disabled) ? U.disabled : n.disabled,
      name: T
    }) : F(T, !0, U.value), {
      ...re ? { disabled: U.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!U.required,
        min: oa(U.min),
        max: oa(U.max),
        minLength: oa(U.minLength),
        maxLength: oa(U.maxLength),
        pattern: oa(U.pattern)
      } : {},
      name: T,
      onChange: ye,
      onBlur: ye,
      ref: (V) => {
        if (V) {
          on(T, U), X = Qe(i, T);
          const W = ot(V.value) && V.querySelectorAll && V.querySelectorAll("input,select,textarea")[0] || V, le = uw(W), ke = X._f.refs || [];
          if (le ? ke.find((Ie) => Ie === W) : W === X._f.ref)
            return;
          Yn(i, T, {
            _f: {
              ...X._f,
              ...le ? {
                refs: [
                  ...ke.filter(rl),
                  W,
                  ...Array.isArray(Qe(a, T)) ? [{}] : []
                ],
                ref: { type: W.type, name: T }
              } : { ref: W }
            }
          }), F(T, !1, void 0, W);
        } else
          X = Qe(i, T, {}), X._f && (X._f.mount = !1), (n.shouldUnregister || U.shouldUnregister) && !(qb(l.array, T) && s.action) && l.unMount.add(T);
      }
    };
  }, Fe = () => n.shouldFocusError && za(i, q, l.mount), Ye = (T) => {
    Yt(T) && (h.state.next({ disabled: T }), za(i, (U, X) => {
      const re = Qe(i, X);
      re && (U.disabled = re._f.disabled || T, Array.isArray(re._f.refs) && re._f.refs.forEach((V) => {
        V.disabled = re._f.disabled || T;
      }));
    }, 0, !1));
  }, Ze = (T, U) => async (X) => {
    let re;
    X && (X.preventDefault && X.preventDefault(), X.persist && X.persist());
    let V = _t(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: W, values: le } = await Y();
      r.errors = W, V = le;
    } else
      await G(i);
    if (l.disabled.size)
      for (const W of l.disabled)
        Yn(V, W, void 0);
    if (ht(r.errors, "root"), Ot(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await T(V, X);
      } catch (W) {
        re = W;
      }
    } else
      U && await U({ ...r.errors }, X), Fe(), setTimeout(Fe);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Ot(r.errors) && !re,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), re)
      throw re;
  }, fe = (T, U = {}) => {
    Qe(i, T) && (ot(U.defaultValue) ? de(T, _t(Qe(a, T))) : (de(T, U.defaultValue), Yn(a, T, _t(U.defaultValue))), U.keepTouched || ht(r.touchedFields, T), U.keepDirty || (ht(r.dirtyFields, T), r.isDirty = U.defaultValue ? O(T, _t(Qe(a, T))) : O()), U.keepError || (ht(r.errors, T), u.isValid && j()), h.state.next({ ...r }));
  }, ge = (T, U = {}) => {
    const X = T ? _t(T) : a, re = _t(X), V = Ot(T), W = V ? a : re;
    if (U.keepDefaultValues || (a = X), !U.keepValues) {
      if (U.keepDirtyValues) {
        const le = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(aa(a, o))
        ]);
        for (const ke of Array.from(le))
          Qe(r.dirtyFields, ke) ? Yn(W, ke, Qe(o, ke)) : de(ke, Qe(W, ke));
      } else {
        if (Am && ot(T))
          for (const le of l.mount) {
            const ke = Qe(i, le);
            if (ke && ke._f) {
              const Ie = Array.isArray(ke._f.refs) ? ke._f.refs[0] : ke._f.ref;
              if (os(Ie)) {
                const en = Ie.closest("form");
                if (en) {
                  en.reset();
                  break;
                }
              }
            }
          }
        for (const le of l.mount)
          de(le, Qe(W, le));
      }
      o = _t(W), h.array.next({
        values: { ...W }
      }), h.state.next({
        values: { ...W }
      });
    }
    l = {
      mount: U.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!U.keepIsValid || !!U.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: U.keepSubmitCount ? r.submitCount : 0,
      isDirty: V ? !1 : U.keepDirty ? r.isDirty : !!(U.keepDefaultValues && !Mr(T, a)),
      isSubmitted: U.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: V ? {} : U.keepDirtyValues ? U.keepDefaultValues && o ? aa(a, o) : r.dirtyFields : U.keepDefaultValues && T ? aa(a, T) : U.keepDirty ? r.dirtyFields : {},
      touchedFields: U.keepTouched ? r.touchedFields : {},
      errors: U.keepErrors ? r.errors : {},
      isSubmitSuccessful: U.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, $e = (T, U) => ge(dr(T) ? T(o) : T, U), Le = (T, U = {}) => {
    const X = Qe(i, T), re = X && X._f;
    if (re) {
      const V = re.refs ? re.refs[0] : re.ref;
      V.focus && (V.focus(), U.shouldSelect && dr(V.select) && V.select());
    }
  }, Pe = (T) => {
    r = {
      ...r,
      ...T
    };
  }, J = {
    control: {
      register: on,
      unregister: Me,
      getFieldState: H,
      handleSubmit: Ze,
      setError: Be,
      _subscribe: Ue,
      _runSchema: Y,
      _getWatch: z,
      _getDirty: O,
      _setValid: j,
      _setFieldArray: L,
      _setDisabledField: De,
      _setErrors: I,
      _getFieldArray: Z,
      _reset: ge,
      _resetDefaultValues: () => dr(n.defaultValues) && n.defaultValues().then((T) => {
        $e(T, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ye,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(T) {
        s = T;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(T) {
        l = T;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(T) {
        n = {
          ...n,
          ...T
        };
      }
    },
    subscribe: Te,
    trigger: Se,
    register: on,
    handleSubmit: Ze,
    watch: Re,
    setValue: de,
    getValues: Ce,
    reset: $e,
    resetField: fe,
    clearErrors: He,
    unregister: Me,
    setError: Be,
    setFocus: Le,
    getFieldState: H
  };
  return {
    ...J,
    formControl: J
  };
}
function mt(e = {}) {
  const n = Ae.useRef(void 0), r = Ae.useRef(void 0), [i, a] = Ae.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: dr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: dr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : Sw(e),
    formState: i
  }, e.formControl && e.defaultValues && !dr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Ae.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Ae.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Ae.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Ae.useEffect(() => {
    e.values && !Mr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Ae.useEffect(() => {
    e.errors && !Ot(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Ae.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Ae.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Kb(i, o), n.current;
}
var yo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function nx(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var il = { exports: {} }, sa = {}, $f;
function Nw() {
  if ($f) return sa;
  $f = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return sa.Fragment = r, sa.jsx = s, sa.jsxs = s, sa;
}
var go = {}, Df;
function jw() {
  return Df || (Df = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    go.Fragment = i, go.jsx = Rn, go.jsxs = Mn;
  })()), go;
}
var Rf;
function ww() {
  return Rf || (Rf = 1, process.env.NODE_ENV === "production" ? il.exports = Nw() : il.exports = jw()), il.exports;
}
var mi = ww();
function Cw(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var al, Of;
function Jr() {
  if (Of) return al;
  Of = 1;
  var e = Array.isArray;
  return al = e, al;
}
var ol, Pf;
function tx() {
  if (Pf) return ol;
  Pf = 1;
  var e = typeof yo == "object" && yo && yo.Object === Object && yo;
  return ol = e, ol;
}
var sl, Af;
function Cr() {
  if (Af) return sl;
  Af = 1;
  var e = tx(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return sl = r, sl;
}
var ll, Lf;
function ao() {
  if (Lf) return ll;
  Lf = 1;
  var e = Cr(), n = e.Symbol;
  return ll = n, ll;
}
var cl, Vf;
function Iw() {
  if (Vf) return cl;
  Vf = 1;
  var e = ao(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return cl = o, cl;
}
var dl, zf;
function Fw() {
  if (zf) return dl;
  zf = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return dl = r, dl;
}
var ul, Uf;
function Gi() {
  if (Uf) return ul;
  Uf = 1;
  var e = ao(), n = Iw(), r = Fw(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return ul = s, ul;
}
var ml, Mf;
function gi() {
  if (Mf) return ml;
  Mf = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return ml = e, ml;
}
var pl, Bf;
function Bm() {
  if (Bf) return pl;
  Bf = 1;
  var e = Gi(), n = gi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return pl = i, pl;
}
var fl, qf;
function Ew() {
  if (qf) return fl;
  qf = 1;
  var e = Jr(), n = Bm(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return fl = a, fl;
}
var hl, Hf;
function Yi() {
  if (Hf) return hl;
  Hf = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return hl = e, hl;
}
var yl, Wf;
function rx() {
  if (Wf) return yl;
  Wf = 1;
  var e = Gi(), n = Yi(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return yl = s, yl;
}
var gl, Kf;
function Tw() {
  if (Kf) return gl;
  Kf = 1;
  var e = Cr(), n = e["__core-js_shared__"];
  return gl = n, gl;
}
var vl, Gf;
function $w() {
  if (Gf) return vl;
  Gf = 1;
  var e = Tw(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return vl = r, vl;
}
var kl, Yf;
function ix() {
  if (Yf) return kl;
  Yf = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return kl = r, kl;
}
var bl, Qf;
function Dw() {
  if (Qf) return bl;
  Qf = 1;
  var e = rx(), n = $w(), r = Yi(), i = ix(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var v = e(h) ? u : o;
    return v.test(i(h));
  }
  return bl = f, bl;
}
var xl, Jf;
function Rw() {
  if (Jf) return xl;
  Jf = 1;
  function e(n, r) {
    return n?.[r];
  }
  return xl = e, xl;
}
var _l, Xf;
function vi() {
  if (Xf) return _l;
  Xf = 1;
  var e = Dw(), n = Rw();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return _l = r, _l;
}
var Sl, Zf;
function $s() {
  if (Zf) return Sl;
  Zf = 1;
  var e = vi(), n = e(Object, "create");
  return Sl = n, Sl;
}
var Nl, eh;
function Ow() {
  if (eh) return Nl;
  eh = 1;
  var e = $s();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Nl = n, Nl;
}
var jl, nh;
function Pw() {
  if (nh) return jl;
  nh = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return jl = e, jl;
}
var wl, th;
function Aw() {
  if (th) return wl;
  th = 1;
  var e = $s(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return wl = a, wl;
}
var Cl, rh;
function Lw() {
  if (rh) return Cl;
  rh = 1;
  var e = $s(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Cl = i, Cl;
}
var Il, ih;
function Vw() {
  if (ih) return Il;
  ih = 1;
  var e = $s(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Il = r, Il;
}
var Fl, ah;
function zw() {
  if (ah) return Fl;
  ah = 1;
  var e = Ow(), n = Pw(), r = Aw(), i = Lw(), a = Vw();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Fl = o, Fl;
}
var El, oh;
function Uw() {
  if (oh) return El;
  oh = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return El = e, El;
}
var Tl, sh;
function ax() {
  if (sh) return Tl;
  sh = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return Tl = e, Tl;
}
var $l, lh;
function Ds() {
  if (lh) return $l;
  lh = 1;
  var e = ax();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return $l = n, $l;
}
var Dl, ch;
function Mw() {
  if (ch) return Dl;
  ch = 1;
  var e = Ds(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return Dl = i, Dl;
}
var Rl, dh;
function Bw() {
  if (dh) return Rl;
  dh = 1;
  var e = Ds();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return Rl = n, Rl;
}
var Ol, uh;
function qw() {
  if (uh) return Ol;
  uh = 1;
  var e = Ds();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return Ol = n, Ol;
}
var Pl, mh;
function Hw() {
  if (mh) return Pl;
  mh = 1;
  var e = Ds();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Pl = n, Pl;
}
var Al, ph;
function Rs() {
  if (ph) return Al;
  ph = 1;
  var e = Uw(), n = Mw(), r = Bw(), i = qw(), a = Hw();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Al = o, Al;
}
var Ll, fh;
function qm() {
  if (fh) return Ll;
  fh = 1;
  var e = vi(), n = Cr(), r = e(n, "Map");
  return Ll = r, Ll;
}
var Vl, hh;
function Ww() {
  if (hh) return Vl;
  hh = 1;
  var e = zw(), n = Rs(), r = qm();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return Vl = i, Vl;
}
var zl, yh;
function Kw() {
  if (yh) return zl;
  yh = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return zl = e, zl;
}
var Ul, gh;
function Os() {
  if (gh) return Ul;
  gh = 1;
  var e = Kw();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return Ul = n, Ul;
}
var Ml, vh;
function Gw() {
  if (vh) return Ml;
  vh = 1;
  var e = Os();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Ml = n, Ml;
}
var Bl, kh;
function Yw() {
  if (kh) return Bl;
  kh = 1;
  var e = Os();
  function n(r) {
    return e(this, r).get(r);
  }
  return Bl = n, Bl;
}
var ql, bh;
function Qw() {
  if (bh) return ql;
  bh = 1;
  var e = Os();
  function n(r) {
    return e(this, r).has(r);
  }
  return ql = n, ql;
}
var Hl, xh;
function Jw() {
  if (xh) return Hl;
  xh = 1;
  var e = Os();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return Hl = n, Hl;
}
var Wl, _h;
function ox() {
  if (_h) return Wl;
  _h = 1;
  var e = Ww(), n = Gw(), r = Yw(), i = Qw(), a = Jw();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Wl = o, Wl;
}
var Kl, Sh;
function Xw() {
  if (Sh) return Kl;
  Sh = 1;
  var e = ox(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Kl = r, Kl;
}
var Gl, Nh;
function Zw() {
  if (Nh) return Gl;
  Nh = 1;
  var e = Xw(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return Gl = r, Gl;
}
var Yl, jh;
function eC() {
  if (jh) return Yl;
  jh = 1;
  var e = Zw(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return Yl = i, Yl;
}
var Ql, wh;
function sx() {
  if (wh) return Ql;
  wh = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Ql = e, Ql;
}
var Jl, Ch;
function nC() {
  if (Ch) return Jl;
  Ch = 1;
  var e = ao(), n = sx(), r = Jr(), i = Bm(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return Jl = s, Jl;
}
var Xl, Ih;
function tC() {
  if (Ih) return Xl;
  Ih = 1;
  var e = nC();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Xl = n, Xl;
}
var Zl, Fh;
function Qi() {
  if (Fh) return Zl;
  Fh = 1;
  var e = Jr(), n = Ew(), r = eC(), i = tC();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Zl = a, Zl;
}
var ec, Eh;
function Ps() {
  if (Eh) return ec;
  Eh = 1;
  var e = Bm();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return ec = n, ec;
}
var nc, Th;
function lx() {
  if (Th) return nc;
  Th = 1;
  var e = Qi(), n = Ps();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return nc = r, nc;
}
var tc, $h;
function cx() {
  if ($h) return tc;
  $h = 1;
  var e = vi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return tc = n, tc;
}
var rc, Dh;
function dx() {
  if (Dh) return rc;
  Dh = 1;
  var e = cx();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return rc = n, rc;
}
var ic, Rh;
function Hm() {
  if (Rh) return ic;
  Rh = 1;
  var e = dx(), n = ax(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return ic = a, ic;
}
var ac, Oh;
function Wm() {
  if (Oh) return ac;
  Oh = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return ac = r, ac;
}
var oc, Ph;
function rC() {
  if (Ph) return oc;
  Ph = 1;
  var e = Hm(), n = Qi(), r = Wm(), i = Yi(), a = Ps();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, v = s; v != null && ++u < f; ) {
      var C = a(l[u]), _ = d;
      if (C === "__proto__" || C === "constructor" || C === "prototype")
        return s;
      if (u != h) {
        var S = v[C];
        _ = m ? m(S, C, v) : void 0, _ === void 0 && (_ = i(S) ? S : r(l[u + 1]) ? [] : {});
      }
      e(v, C, _), v = v[C];
    }
    return s;
  }
  return oc = o, oc;
}
var sc, Ah;
function iC() {
  if (Ah) return sc;
  Ah = 1;
  var e = lx(), n = rC(), r = Qi();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return sc = i, sc;
}
var lc, Lh;
function aC() {
  if (Lh) return lc;
  Lh = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return lc = e, lc;
}
var cc, Vh;
function oC() {
  if (Vh) return cc;
  Vh = 1;
  var e = Gi(), n = gi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return cc = i, cc;
}
var dc, zh;
function Km() {
  if (zh) return dc;
  zh = 1;
  var e = oC(), n = gi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return dc = o, dc;
}
var uc, Uh;
function Gm() {
  if (Uh) return uc;
  Uh = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return uc = n, uc;
}
var mc, Mh;
function sC() {
  if (Mh) return mc;
  Mh = 1;
  var e = Qi(), n = Km(), r = Jr(), i = Wm(), a = Gm(), o = Ps();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var v = o(d[u]);
      if (!(h = l != null && m(l, v)))
        break;
      l = l[v];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (r(l) || n(l)));
  }
  return mc = s, mc;
}
var pc, Bh;
function lC() {
  if (Bh) return pc;
  Bh = 1;
  var e = aC(), n = sC();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return pc = r, pc;
}
var fc, qh;
function cC() {
  if (qh) return fc;
  qh = 1;
  var e = iC(), n = lC();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return fc = r, fc;
}
var hc, Hh;
function Ym() {
  if (Hh) return hc;
  Hh = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return hc = e, hc;
}
var yc, Wh;
function dC() {
  if (Wh) return yc;
  Wh = 1;
  var e = ao(), n = Km(), r = Jr(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return yc = a, yc;
}
var gc, Kh;
function uC() {
  if (Kh) return gc;
  Kh = 1;
  var e = Ym(), n = dC();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return gc = r, gc;
}
var vc, Gh;
function mC() {
  if (Gh) return vc;
  Gh = 1;
  var e = uC();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return vc = n, vc;
}
var kc, Yh;
function pC() {
  if (Yh) return kc;
  Yh = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return kc = e, kc;
}
var bc, Qh;
function fC() {
  if (Qh) return bc;
  Qh = 1;
  var e = pC(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return bc = r, bc;
}
var xc, Jh;
function hC() {
  if (Jh) return xc;
  Jh = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return xc = e, xc;
}
var _c, Xh;
function ux() {
  if (Xh) return _c;
  Xh = 1;
  function e(n) {
    return n;
  }
  return _c = e, _c;
}
var Sc, Zh;
function yC() {
  if (Zh) return Sc;
  Zh = 1;
  var e = hC(), n = cx(), r = ux(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Sc = i, Sc;
}
var Nc, ey;
function gC() {
  if (ey) return Nc;
  ey = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Nc = i, Nc;
}
var jc, ny;
function vC() {
  if (ny) return jc;
  ny = 1;
  var e = yC(), n = gC(), r = n(e);
  return jc = r, jc;
}
var wc, ty;
function mx() {
  if (ty) return wc;
  ty = 1;
  var e = mC(), n = fC(), r = vC();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return wc = i, wc;
}
var Cc, ry;
function kC() {
  if (ry) return Cc;
  ry = 1;
  var e = cC(), n = mx(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Cc = r, Cc;
}
var bC = kC();
const px = /* @__PURE__ */ nx(bC), xC = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function fx(e) {
  const n = px(e, xC);
  return {
    controller: zm(n),
    controllerProps: n
  };
}
const _C = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function hx(e) {
  const { controller: n, controllerProps: r } = fx(e), i = {
    ...px(e, _C),
    required: Cw(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Ic, iy;
function SC() {
  if (iy) return Ic;
  iy = 1;
  var e = Rs();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Ic = n, Ic;
}
var Fc, ay;
function NC() {
  if (ay) return Fc;
  ay = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return Fc = e, Fc;
}
var Ec, oy;
function jC() {
  if (oy) return Ec;
  oy = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Ec = e, Ec;
}
var Tc, sy;
function wC() {
  if (sy) return Tc;
  sy = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return Tc = e, Tc;
}
var $c, ly;
function CC() {
  if (ly) return $c;
  ly = 1;
  var e = Rs(), n = qm(), r = ox(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return $c = a, $c;
}
var Dc, cy;
function IC() {
  if (cy) return Dc;
  cy = 1;
  var e = Rs(), n = SC(), r = NC(), i = jC(), a = wC(), o = CC();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, Dc = s, Dc;
}
var Rc, dy;
function FC() {
  if (dy) return Rc;
  dy = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return Rc = e, Rc;
}
var Oc, uy;
function oo() {
  if (uy) return Oc;
  uy = 1;
  var e = Hm(), n = dx();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return Oc = r, Oc;
}
var Pc, my;
function EC() {
  if (my) return Pc;
  my = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Pc = e, Pc;
}
var Yo = { exports: {} }, Ac, py;
function TC() {
  if (py) return Ac;
  py = 1;
  function e() {
    return !1;
  }
  return Ac = e, Ac;
}
Yo.exports;
var fy;
function yx() {
  return fy || (fy = 1, (function(e, n) {
    var r = Cr(), i = TC(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(Yo, Yo.exports)), Yo.exports;
}
var Lc, hy;
function $C() {
  if (hy) return Lc;
  hy = 1;
  var e = Gi(), n = Gm(), r = gi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", C = "[object String]", _ = "[object WeakMap]", S = "[object ArrayBuffer]", j = "[object DataView]", k = "[object Float32Array]", L = "[object Float64Array]", E = "[object Int8Array]", I = "[object Int16Array]", F = "[object Int32Array]", A = "[object Uint8Array]", K = "[object Uint8ClampedArray]", Y = "[object Uint16Array]", ie = "[object Uint32Array]", G = {};
  G[k] = G[L] = G[E] = G[I] = G[F] = G[A] = G[K] = G[Y] = G[ie] = !0, G[i] = G[a] = G[S] = G[o] = G[j] = G[s] = G[l] = G[d] = G[m] = G[u] = G[f] = G[h] = G[v] = G[C] = G[_] = !1;
  function B(O) {
    return r(O) && n(O.length) && !!G[e(O)];
  }
  return Lc = B, Lc;
}
var Vc, yy;
function Qm() {
  if (yy) return Vc;
  yy = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return Vc = e, Vc;
}
var Qo = { exports: {} };
Qo.exports;
var gy;
function Jm() {
  return gy || (gy = 1, (function(e, n) {
    var r = tx(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(Qo, Qo.exports)), Qo.exports;
}
var zc, vy;
function DC() {
  if (vy) return zc;
  vy = 1;
  var e = $C(), n = Qm(), r = Jm(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return zc = a, zc;
}
var Uc, ky;
function gx() {
  if (ky) return Uc;
  ky = 1;
  var e = EC(), n = Km(), r = Jr(), i = yx(), a = Wm(), o = DC(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), v = !f && !h && i(m), C = !f && !h && !v && o(m), _ = f || h || v || C, S = _ ? e(m.length, String) : [], j = S.length;
    for (var k in m)
      (u || l.call(m, k)) && !(_ && // Safari 9 has enumerable `arguments.length` in strict mode.
      (k == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (k == "offset" || k == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      C && (k == "buffer" || k == "byteLength" || k == "byteOffset") || // Skip index properties.
      a(k, j))) && S.push(k);
    return S;
  }
  return Uc = d, Uc;
}
var Mc, by;
function Xm() {
  if (by) return Mc;
  by = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Mc = n, Mc;
}
var Bc, xy;
function vx() {
  if (xy) return Bc;
  xy = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Bc = e, Bc;
}
var qc, _y;
function RC() {
  if (_y) return qc;
  _y = 1;
  var e = vx(), n = e(Object.keys, Object);
  return qc = n, qc;
}
var Hc, Sy;
function OC() {
  if (Sy) return Hc;
  Sy = 1;
  var e = Xm(), n = RC(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return Hc = a, Hc;
}
var Wc, Ny;
function kx() {
  if (Ny) return Wc;
  Ny = 1;
  var e = rx(), n = Gm();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Wc = r, Wc;
}
var Kc, jy;
function Zm() {
  if (jy) return Kc;
  jy = 1;
  var e = gx(), n = OC(), r = kx();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return Kc = i, Kc;
}
var Gc, wy;
function PC() {
  if (wy) return Gc;
  wy = 1;
  var e = oo(), n = Zm();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Gc = r, Gc;
}
var Yc, Cy;
function AC() {
  if (Cy) return Yc;
  Cy = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return Yc = e, Yc;
}
var Qc, Iy;
function LC() {
  if (Iy) return Qc;
  Iy = 1;
  var e = Yi(), n = Xm(), r = AC(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return Qc = o, Qc;
}
var Jc, Fy;
function ep() {
  if (Fy) return Jc;
  Fy = 1;
  var e = gx(), n = LC(), r = kx();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return Jc = i, Jc;
}
var Xc, Ey;
function VC() {
  if (Ey) return Xc;
  Ey = 1;
  var e = oo(), n = ep();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Xc = r, Xc;
}
var Jo = { exports: {} };
Jo.exports;
var Ty;
function zC() {
  return Ty || (Ty = 1, (function(e, n) {
    var r = Cr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(Jo, Jo.exports)), Jo.exports;
}
var Zc, $y;
function UC() {
  if ($y) return Zc;
  $y = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return Zc = e, Zc;
}
var ed, Dy;
function MC() {
  if (Dy) return ed;
  Dy = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return ed = e, ed;
}
var nd, Ry;
function bx() {
  if (Ry) return nd;
  Ry = 1;
  function e() {
    return [];
  }
  return nd = e, nd;
}
var td, Oy;
function np() {
  if (Oy) return td;
  Oy = 1;
  var e = MC(), n = bx(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return td = o, td;
}
var rd, Py;
function BC() {
  if (Py) return rd;
  Py = 1;
  var e = oo(), n = np();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return rd = r, rd;
}
var id, Ay;
function tp() {
  if (Ay) return id;
  Ay = 1;
  var e = vx(), n = e(Object.getPrototypeOf, Object);
  return id = n, id;
}
var ad, Ly;
function xx() {
  if (Ly) return ad;
  Ly = 1;
  var e = Ym(), n = tp(), r = np(), i = bx(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return ad = o, ad;
}
var od, Vy;
function qC() {
  if (Vy) return od;
  Vy = 1;
  var e = oo(), n = xx();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return od = r, od;
}
var sd, zy;
function _x() {
  if (zy) return sd;
  zy = 1;
  var e = Ym(), n = Jr();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return sd = r, sd;
}
var ld, Uy;
function HC() {
  if (Uy) return ld;
  Uy = 1;
  var e = _x(), n = np(), r = Zm();
  function i(a) {
    return e(a, r, n);
  }
  return ld = i, ld;
}
var cd, My;
function Sx() {
  if (My) return cd;
  My = 1;
  var e = _x(), n = xx(), r = ep();
  function i(a) {
    return e(a, r, n);
  }
  return cd = i, cd;
}
var dd, By;
function WC() {
  if (By) return dd;
  By = 1;
  var e = vi(), n = Cr(), r = e(n, "DataView");
  return dd = r, dd;
}
var ud, qy;
function KC() {
  if (qy) return ud;
  qy = 1;
  var e = vi(), n = Cr(), r = e(n, "Promise");
  return ud = r, ud;
}
var md, Hy;
function GC() {
  if (Hy) return md;
  Hy = 1;
  var e = vi(), n = Cr(), r = e(n, "Set");
  return md = r, md;
}
var pd, Wy;
function YC() {
  if (Wy) return pd;
  Wy = 1;
  var e = vi(), n = Cr(), r = e(n, "WeakMap");
  return pd = r, pd;
}
var fd, Ky;
function rp() {
  if (Ky) return fd;
  Ky = 1;
  var e = WC(), n = qm(), r = KC(), i = GC(), a = YC(), o = Gi(), s = ix(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), C = s(n), _ = s(r), S = s(i), j = s(a), k = o;
  return (e && k(new e(new ArrayBuffer(1))) != h || n && k(new n()) != l || r && k(r.resolve()) != m || i && k(new i()) != u || a && k(new a()) != f) && (k = function(L) {
    var E = o(L), I = E == d ? L.constructor : void 0, F = I ? s(I) : "";
    if (F)
      switch (F) {
        case v:
          return h;
        case C:
          return l;
        case _:
          return m;
        case S:
          return u;
        case j:
          return f;
      }
    return E;
  }), fd = k, fd;
}
var hd, Gy;
function QC() {
  if (Gy) return hd;
  Gy = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return hd = r, hd;
}
var yd, Yy;
function JC() {
  if (Yy) return yd;
  Yy = 1;
  var e = Cr(), n = e.Uint8Array;
  return yd = n, yd;
}
var gd, Qy;
function ip() {
  if (Qy) return gd;
  Qy = 1;
  var e = JC();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return gd = n, gd;
}
var vd, Jy;
function XC() {
  if (Jy) return vd;
  Jy = 1;
  var e = ip();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return vd = n, vd;
}
var kd, Xy;
function ZC() {
  if (Xy) return kd;
  Xy = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return kd = n, kd;
}
var bd, Zy;
function e1() {
  if (Zy) return bd;
  Zy = 1;
  var e = ao(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return bd = i, bd;
}
var xd, eg;
function n1() {
  if (eg) return xd;
  eg = 1;
  var e = ip();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return xd = n, xd;
}
var _d, ng;
function t1() {
  if (ng) return _d;
  ng = 1;
  var e = ip(), n = XC(), r = ZC(), i = e1(), a = n1(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", C = "[object DataView]", _ = "[object Float32Array]", S = "[object Float64Array]", j = "[object Int8Array]", k = "[object Int16Array]", L = "[object Int32Array]", E = "[object Uint8Array]", I = "[object Uint8ClampedArray]", F = "[object Uint16Array]", A = "[object Uint32Array]";
  function K(Y, ie, G) {
    var B = Y.constructor;
    switch (ie) {
      case v:
        return e(Y);
      case o:
      case s:
        return new B(+Y);
      case C:
        return n(Y, G);
      case _:
      case S:
      case j:
      case k:
      case L:
      case E:
      case I:
      case F:
      case A:
        return a(Y, G);
      case l:
        return new B();
      case d:
      case f:
        return new B(Y);
      case m:
        return r(Y);
      case u:
        return new B();
      case h:
        return i(Y);
    }
  }
  return _d = K, _d;
}
var Sd, tg;
function r1() {
  if (tg) return Sd;
  tg = 1;
  var e = Yi(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Sd = r, Sd;
}
var Nd, rg;
function i1() {
  if (rg) return Nd;
  rg = 1;
  var e = r1(), n = tp(), r = Xm();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Nd = i, Nd;
}
var jd, ig;
function a1() {
  if (ig) return jd;
  ig = 1;
  var e = rp(), n = gi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return jd = i, jd;
}
var wd, ag;
function o1() {
  if (ag) return wd;
  ag = 1;
  var e = a1(), n = Qm(), r = Jm(), i = r && r.isMap, a = i ? n(i) : e;
  return wd = a, wd;
}
var Cd, og;
function s1() {
  if (og) return Cd;
  og = 1;
  var e = rp(), n = gi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Cd = i, Cd;
}
var Id, sg;
function l1() {
  if (sg) return Id;
  sg = 1;
  var e = s1(), n = Qm(), r = Jm(), i = r && r.isSet, a = i ? n(i) : e;
  return Id = a, Id;
}
var Fd, lg;
function c1() {
  if (lg) return Fd;
  lg = 1;
  var e = IC(), n = FC(), r = Hm(), i = PC(), a = VC(), o = zC(), s = UC(), l = BC(), d = qC(), m = HC(), u = Sx(), f = rp(), h = QC(), v = t1(), C = i1(), _ = Jr(), S = yx(), j = o1(), k = Yi(), L = l1(), E = Zm(), I = ep(), F = 1, A = 2, K = 4, Y = "[object Arguments]", ie = "[object Array]", G = "[object Boolean]", B = "[object Date]", O = "[object Error]", z = "[object Function]", Z = "[object GeneratorFunction]", be = "[object Map]", he = "[object Number]", de = "[object Object]", ye = "[object RegExp]", q = "[object Set]", Se = "[object String]", Ce = "[object Symbol]", H = "[object WeakMap]", He = "[object ArrayBuffer]", Be = "[object DataView]", Re = "[object Float32Array]", Ue = "[object Float64Array]", Te = "[object Int8Array]", Me = "[object Int16Array]", De = "[object Int32Array]", on = "[object Uint8Array]", Fe = "[object Uint8ClampedArray]", Ye = "[object Uint16Array]", Ze = "[object Uint32Array]", fe = {};
  fe[Y] = fe[ie] = fe[He] = fe[Be] = fe[G] = fe[B] = fe[Re] = fe[Ue] = fe[Te] = fe[Me] = fe[De] = fe[be] = fe[he] = fe[de] = fe[ye] = fe[q] = fe[Se] = fe[Ce] = fe[on] = fe[Fe] = fe[Ye] = fe[Ze] = !0, fe[O] = fe[z] = fe[H] = !1;
  function ge($e, Le, Pe, mn, J, T) {
    var U, X = Le & F, re = Le & A, V = Le & K;
    if (Pe && (U = J ? Pe($e, mn, J, T) : Pe($e)), U !== void 0)
      return U;
    if (!k($e))
      return $e;
    var W = _($e);
    if (W) {
      if (U = h($e), !X)
        return s($e, U);
    } else {
      var le = f($e), ke = le == z || le == Z;
      if (S($e))
        return o($e, X);
      if (le == de || le == Y || ke && !J) {
        if (U = re || ke ? {} : C($e), !X)
          return re ? d($e, a(U, $e)) : l($e, i(U, $e));
      } else {
        if (!fe[le])
          return J ? $e : {};
        U = v($e, le, X);
      }
    }
    T || (T = new e());
    var Ie = T.get($e);
    if (Ie)
      return Ie;
    T.set($e, U), L($e) ? $e.forEach(function(rn) {
      U.add(ge(rn, Le, Pe, rn, $e, T));
    }) : j($e) && $e.forEach(function(rn, cn) {
      U.set(cn, ge(rn, Le, Pe, cn, $e, T));
    });
    var en = V ? re ? u : m : re ? I : E, hn = W ? void 0 : en($e);
    return n(hn || $e, function(rn, cn) {
      hn && (cn = rn, rn = $e[cn]), r(U, cn, ge(rn, Le, Pe, cn, $e, T));
    }), U;
  }
  return Fd = ge, Fd;
}
var Ed, cg;
function d1() {
  if (cg) return Ed;
  cg = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Ed = e, Ed;
}
var Td, dg;
function u1() {
  if (dg) return Td;
  dg = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return Td = e, Td;
}
var $d, ug;
function m1() {
  if (ug) return $d;
  ug = 1;
  var e = lx(), n = u1();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return $d = r, $d;
}
var Dd, mg;
function p1() {
  if (mg) return Dd;
  mg = 1;
  var e = Qi(), n = d1(), r = m1(), i = Ps(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return Dd = s, Dd;
}
var Rd, pg;
function f1() {
  if (pg) return Rd;
  pg = 1;
  var e = Gi(), n = tp(), r = gi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return Rd = m, Rd;
}
var Od, fg;
function h1() {
  if (fg) return Od;
  fg = 1;
  var e = f1();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return Od = n, Od;
}
var Pd, hg;
function y1() {
  if (hg) return Pd;
  hg = 1;
  var e = sx(), n = c1(), r = p1(), i = Qi(), a = oo(), o = h1(), s = mx(), l = Sx(), d = 1, m = 2, u = 4, f = s(function(h, v) {
    var C = {};
    if (h == null)
      return C;
    var _ = !1;
    v = e(v, function(j) {
      return j = i(j, h), _ || (_ = j.length > 1), j;
    }), a(h, l(h), C), _ && (C = n(C, d | m | u, o));
    for (var S = v.length; S--; )
      r(C, v[S]);
    return C;
  });
  return Pd = f, Pd;
}
y1();
const fr = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = hx(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ mi.jsx(nn, { ...a, children: /* @__PURE__ */ mi.jsx(
    Ur,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: nn.getStatus(a.meta),
      children: e
    }
  ) });
};
var g1 = ux();
const v1 = /* @__PURE__ */ nx(g1), $n = ({
  transformValue: e = v1,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = fx(a);
  return /* @__PURE__ */ mi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ mi.jsx(
      Tu,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ mi.jsx(wS, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, Gn = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = hx(e);
  return /* @__PURE__ */ mi.jsx(nn, { ...i, children: /* @__PURE__ */ mi.jsx(
    pr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: nn.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ad = { exports: {} }, la = {}, yg;
function k1() {
  if (yg) return la;
  yg = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return la.Fragment = r, la.jsx = s, la.jsxs = s, la;
}
var vo = {}, gg;
function b1() {
  return gg || (gg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    vo.Fragment = i, vo.jsx = Rn, vo.jsxs = Mn;
  })()), vo;
}
var vg;
function x1() {
  return vg || (vg = 1, process.env.NODE_ENV === "production" ? Ad.exports = k1() : Ad.exports = b1()), Ad.exports;
}
var pe = x1();
const _1 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, S1 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, N1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, j1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, w1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, C1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, I1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, F1 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, E1 = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": N1,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": j1,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": w1,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": _1,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": S1,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": C1,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": I1,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": F1
};
function Ji(e) {
  return E1[e] ?? {};
}
const T1 = Ji(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), $1 = Ji(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), D1 = Ji(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), kg = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, nr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, R1 = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), bg = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, zu = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ pe.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ pe.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ pe.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ pe.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ pe.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ pe.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ pe.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ pe.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ pe.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ pe.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ pe.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ pe.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function O1({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = se(
    []
  ), [o, s] = se([]), [l, d] = se([]), [m, u] = se([]), [f, h] = se(), { showNotification: v, showModal: C, executeQuery: _ } = un(), { track: S } = bn(), {
    loading: j,
    data: k,
    error: L,
    store: E
  } = xm(e ?? null), I = k?.github?.issues || [], F = k?.github?.pullRequests || [], [A, K] = se(!1), [Y, ie] = se();
  qe(
    () => h(L || Y || void 0),
    [L, Y]
  ), qe(
    () => {
      !j && (I?.length || F?.length) ? (a(I), s(F), B(I, F)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [k]
  );
  const G = async (ye, q) => {
    await E(ye).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: q.success.title,
        text: q.success.text
      });
    }).catch((Se) => {
      v({
        title: q.error.title,
        text: `${q.error.text} ${Se.message && " (" + Se.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (ye, q) => {
    if (!ye?.length && !q?.length) {
      d([]), u([]);
      return;
    }
    const Se = (ye || []).map(
      (He) => _($1, {
        owner: He.owner,
        repositoryName: He.repository,
        issueNumber: He.number
      })
    ), Ce = (q || []).map(
      (He) => _(D1, {
        owner: He.owner,
        repositoryName: He.repository,
        prNumber: He.number
      })
    ), H = [...Se, ...Ce];
    K(!0), Promise.all(H).then((He) => {
      const Be = [], Re = [];
      He.forEach((Ue) => {
        const Te = Ue?.data?.GitHub;
        if (!Te) {
          d([]), u([]);
          return;
        }
        Object.keys(Te).forEach((Me) => {
          if (Me.startsWith("repository")) {
            const De = Te[Me];
            Object.keys(De).forEach((on) => {
              const Fe = De[on], Ye = {
                number: Fe?.number,
                owner: Fe?.repository?.owner?.login,
                repository: Fe?.repository?.name
              };
              on.startsWith("issue") && Be.push({
                ...Fe,
                type: "ISSUE",
                key: Ye
              }), on.startsWith("pullRequest") && Re.push({
                ...Fe,
                type: "PR",
                key: Ye
              });
            });
          }
        });
      }), d(Be), u(Re);
    }).catch(ie).finally(() => {
      K(!1);
    });
  }, O = ({ key: ye, type: q }) => {
    S("github:link:issue:clicked", {
      githubOrganization: n
    });
    const Se = k && (I.length || F.length) ? k : r, Ce = q === "ISSUE" ? "issues" : "pullRequests";
    Se.github[Ce] = Array.from(
      new Set(Se.github[Ce]).add(ye)
    ), G(Se, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${nr(
          ye
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${nr(ye)} failed. Please try again.`
      }
    });
  }, z = async ({ key: ye, type: q }) => {
    S("github:link:issue:clicked", {
      githubOrganization: n
    });
    const Se = k && (I.length || F.length) ? k : r, Ce = q === "ISSUE" ? "issues" : "pullRequests";
    Se.github[Ce] = Array.from(
      new Set(Se.github[Ce]).add(ye)
    ), await E(Se).catch((H) => {
      v({
        title: "Linking failed",
        text: `Linking ${ye} failed. Please try again. ${H.message && " (" + H.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, Z = ({ key: ye, type: q }) => {
    S("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const Se = q === "ISSUE" ? "issue" : "pull request";
    C({
      headline: `Unlink ${Se} ${nr(ye)}?`,
      text: `You are about to unlink the ${Se} ${nr(
        ye
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${Se}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Ce = q === "ISSUE" ? "issues" : "pullRequests";
        if (!k)
          return;
        const H = {
          ...k,
          github: {
            ...k?.github,
            [Ce]: k?.github?.[Ce].filter(
              (He) => He.number !== ye.number || He.owner !== ye.owner || He.repository !== ye.repository
            )
          }
        };
        S("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), G(H, {
          success: {
            title: `GitHub ${Se} unlinked`,
            text: `You unlinked the GitHub ${Se} ${nr(
              ye
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${nr(ye)} failed.`
          }
        });
      },
      onCancel: () => {
        S("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, be = () => {
    S("github:unlink:all:clicked", {
      githubOrganization: n
    }), C({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        S("github:unlink:all:confirmed", {
          githubOrganization: n
        }), G(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        S("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, he = I.filter(
    (ye) => !i?.includes(ye)
  ) || [], de = F.filter(
    (ye) => !o?.includes(ye)
  ) || [];
  return {
    linkGithubItem: O,
    linkGithubItemQuietly: z,
    unlinkGithubItem: Z,
    loadGithubItems: B,
    removeDanglingGithubItemLinks: () => {
      const ye = {
        ...k,
        github: {
          ...k?.github,
          issues: I.filter(
            (q) => !he.includes(q)
          ) || [],
          pullRequests: F.filter(
            (q) => !de.includes(q)
          ) || []
        }
      };
      E(ye);
    },
    unlinkAllGithubItems: be,
    isLoadingGithubItemLinks: j,
    danglingIssueLinks: he,
    danglingPullRequestLinks: de,
    isLoadingGithubItems: A,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const P1 = "_contentWrapper_1vx3c_1", A1 = "_contentWrapperHeadline_1vx3c_4", L1 = "_contentWrapperBody_1vx3c_11", V1 = "_contentWrapperAssigneeIcon_1vx3c_15", z1 = "_contentWrapperStatusTag_1vx3c_20", Er = {
  contentWrapper: P1,
  contentWrapperHeadline: A1,
  contentWrapperBody: L1,
  contentWrapperAssigneeIcon: V1,
  contentWrapperStatusTag: z1
}, Nx = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ pe.jsxs(pe.Fragment, { children: [
  e && /* @__PURE__ */ pe.jsxs(Zn, { className: Er.contentWrapper, children: [
    /* @__PURE__ */ pe.jsx(Zn, { className: Er.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ pe.jsx(Zn, { className: Er.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ pe.jsxs(Zn, { className: Er.contentWrapper, children: [
    /* @__PURE__ */ pe.jsx(Zn, { className: Er.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ pe.jsx(Zn, { className: Er.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ pe.jsxs(Zn, { margin: "100 0", children: [
        /* @__PURE__ */ pe.jsx(
          "img",
          {
            className: Er.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ pe.jsx(Zn, { className: Er.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ pe.jsx(
      An,
      {
        className: Er.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), U1 = "_collapse_1bdjy_1", M1 = "_collapseHeader_1bdjy_10", B1 = "_collapseHeaderKey_1bdjy_31", q1 = "_collapseHeaderKeyIcon_1bdjy_36", H1 = "_collapseHeaderKeyLink_1bdjy_41", W1 = "_collapseHeaderIcon_1bdjy_44", K1 = "_collapseHeaderTitle_1bdjy_49", G1 = "_collapseContent_1bdjy_57", Y1 = "_collapseContentButtonSpacer_1bdjy_60", Q1 = "_collapseContentButtonLink_1bdjy_63", gr = {
  collapse: U1,
  collapseHeader: M1,
  collapseHeaderKey: B1,
  collapseHeaderKeyIcon: q1,
  collapseHeaderKeyLink: H1,
  collapseHeaderIcon: W1,
  collapseHeaderTitle: K1,
  collapseContent: G1,
  collapseContentButtonSpacer: Y1,
  collapseContentButtonLink: Q1
}, J1 = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = se(i), { track: s } = bn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ pe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: v,
      repository: C,
      type: _,
      state: S,
      assignees: j,
      labels: k
    } = d, L = a[m];
    return /* @__PURE__ */ pe.jsxs(
      rr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: L,
        className: gr.collapse,
        children: [
          /* @__PURE__ */ pe.jsx(rr.Header, { className: gr.collapseHeader, children: /* @__PURE__ */ pe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ pe.jsx(Zn, { children: /* @__PURE__ */ pe.jsxs(Zn, { as: "span", className: gr.collapseHeaderKey, children: [
                  zu(
                    _,
                    S,
                    gr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ pe.jsxs(
                    "a",
                    {
                      href: kg(f),
                      className: gr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (E) => {
                        E.stopPropagation();
                      },
                      children: [
                        nr(f),
                        /* @__PURE__ */ pe.jsx(
                          me,
                          {
                            className: gr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ pe.jsx(Zn, { className: gr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ pe.jsx(rr.Content, { className: gr.collapseContent, children: /* @__PURE__ */ pe.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ pe.jsx(
              Nx,
              {
                description: v,
                assignees: j,
                labels: k
              }
            ),
            /* @__PURE__ */ pe.jsxs(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: gr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: C?.owner.login,
                    repository: d.repository.name
                  },
                  type: _
                }),
                children: [
                  "Unlink ",
                  bg(_)
                ]
              }
            ),
            /* @__PURE__ */ pe.jsxs(
              jt,
              {
                slotEnd: /* @__PURE__ */ pe.jsx(me, { name: "external-link" }),
                variant: "tertiary",
                className: gr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(kg(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  bg(_),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ pe.jsx(pe.Fragment, {}) });
}, X1 = "_result_1uaom_1", Z1 = "_resultName_1uaom_21", eI = "_resultItemIcon_1uaom_29", nI = "_resultDescription_1uaom_34", tI = "_resultLinkIcon_1uaom_46", rI = "_tooltip_1uaom_55", iI = "_tooltipName_1uaom_61", aI = "_tooltipTag_1uaom_71", Tr = {
  result: X1,
  resultName: Z1,
  resultItemIcon: eI,
  resultDescription: nI,
  resultLinkIcon: tI,
  tooltip: rI,
  tooltipName: iI,
  tooltipTag: aI
}, oI = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = se(!1);
  return /* @__PURE__ */ pe.jsx(
    We,
    {
      className: Tr.tooltip,
      content: /* @__PURE__ */ pe.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ pe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ pe.jsxs(Zn, { as: "span", className: Tr.tooltipName, children: [
                zu(a, o, Tr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ pe.jsx(An, { className: Tr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ pe.jsx(
          Nx,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ pe.jsxs(
        "button",
        {
          className: Tr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ pe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ pe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ pe.jsxs(Zn, { as: "span", className: Tr.resultName, children: [
                    zu(a, o, Tr.resultItemIcon),
                    nr(r)
                  ] }) }),
                  /* @__PURE__ */ pe.jsx(Zn, { className: Tr.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ pe.jsx(
              me,
              {
                className: Tr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, sI = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ pe.jsx(
  jt,
  {
    slotEnd: /* @__PURE__ */ pe.jsx(me, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), cs = "[a-zA-z0-9_.-]+", jx = "[0-9]+", lI = new RegExp(
  `(${cs})/(${cs})/(?:issues|pull)/(${jx})`,
  "i"
), xg = new RegExp(`^${lI.source}$`), _g = new RegExp(
  `https://github.com/(${cs})/(${cs})/(?:issues|pull)/(${jx})`,
  "i"
), cI = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Bn(() => r?.map((F) => F.id) || [], [r]), o = Bn(() => i?.map((F) => F.id) || [], [i]), [s, l] = se([]), { useLazyQuery: d } = un(), [m, u] = se(), [f, { loading: h, error: v, data: C, networkStatus: _ }] = d(T1, {
    notifyOnNetworkStatusChange: !0
  });
  yi(
    () => {
      !h && m && _ === Wt.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), qe(() => {
    let F = C?.GitHub?.issues?.nodes || [], A = C?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (F = F.filter((K) => !a.includes(K.id))), o.length > 0 && (A = A.filter(
      (K) => !o.includes(K.id)
    )), l([
      ...F.map((K) => ({
        ...K,
        type: "ISSUE",
        key: {
          number: K.number,
          owner: K.repository.owner.login,
          repository: K.repository.name
        }
      })),
      ...A.map((K) => ({
        ...K,
        type: "PR",
        key: {
          number: K.number,
          owner: K.repository.owner.login,
          repository: K.repository.name
        }
      }))
    ]);
  }, [C, a, o]);
  function S(F) {
    const A = F?.trim();
    if (xg.test(A)) {
      const [K, Y, ie, G] = A.match(xg) || [];
      return Y !== n ? void 0 : {
        owner: n,
        repository: ie,
        number: parseInt(G)
      };
    }
    if (_g.test(A)) {
      const [K, Y, ie, G] = A.match(_g) || [];
      return Y !== n ? void 0 : {
        owner: n,
        repository: ie,
        number: parseInt(G)
      };
    }
  }
  const j = (F) => {
    e({
      key: R1(F),
      type: F.type
    }), u(void 0);
  }, k = (F) => {
    const A = S(F);
    u(
      A ? `org:${A.owner} repo:${A.repository} ${A.number}` : `org:${n} ${F}`
    );
  }, L = () => {
    u(void 0);
  }, E = ({ className: F, searched: A }) => /* @__PURE__ */ pe.jsx(
    sI,
    {
      className: F,
      searched: A,
      githubOrganization: n
    }
  ), I = ({ item: F, onSelect: A }) => /* @__PURE__ */ pe.jsx(oI, { item: F, onSelect: A });
  return !h && v ? /* @__PURE__ */ pe.jsx(Cn, { error: v }) : /* @__PURE__ */ pe.jsx(
    hr,
    {
      items: s?.map((F) => ({ name: F.title, ...F })),
      loading: h,
      onSearch: k,
      onSelect: j,
      onClear: L,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: E,
      itemComponent: I,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, dI = "_itemButton_3sxfy_1", uI = "_result_3sxfy_6", mI = "_resultName_3sxfy_30", pI = "_resultCheckIcon_3sxfy_38", fI = "_resultAssigneeIcon_3sxfy_41", ca = {
  itemButton: dI,
  result: uI,
  resultName: mI,
  resultCheckIcon: pI,
  resultAssigneeIcon: fI
}, wx = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ pe.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ pe.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: ca.itemButton,
        children: /* @__PURE__ */ pe.jsxs(b, { className: ca.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ pe.jsx(Zn, { margin: "100 0", children: /* @__PURE__ */ pe.jsx(
            "img",
            {
              className: ca.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ pe.jsx(Zn, { className: ca.resultName, children: e.name }),
          n && /* @__PURE__ */ pe.jsx(Zn, { className: ca.resultCheckIcon, children: /* @__PURE__ */ pe.jsx(me, { name: "done" }) })
        ] })
      }
    )
  }
), hI = Ji(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), yI = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = un(), [o, s] = se([]), [l, d] = se(""), m = 2, [u, { loading: f, error: h, data: v, networkStatus: C }] = a(
    hI,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return yi(
    () => {
      !f && l && l.length >= m && C === Wt.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const _ = v?.GitHub?.organization?.teams || { edges: [] }, S = [];
    _?.edges?.forEach((j) => {
      const k = j?.node?.members?.edges;
      (k?.length || 0) > 0 && k?.forEach((L) => {
        const E = L?.node;
        E && (E?.id && S.find((I) => I.id === E.id) || S.push(E));
      });
    }), s(
      S.sort((j, k) => {
        const L = j.name?.toLowerCase() || j.login?.toLowerCase(), E = k.name?.toLowerCase() || k.login?.toLowerCase();
        return L.localeCompare(E, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ pe.jsx(Cn, { error: h }) : /* @__PURE__ */ pe.jsx(
    hr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: _, name: S, login: j, avatarUrl: k }) => ({
        id: _,
        name: S || j,
        iconUrl: k
      })) || [],
      loading: f,
      onSearch: (_) => d(_),
      onChange: (_, S) => {
        const j = _.id;
        i ? (S && !n.find(
          (k) => k.id === j
        ) && n.push(_), S || (n = n.filter(
          (k) => k.id !== j
        ))) : n = S ? [_] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: _, onSelect: S, checked: j }) => /* @__PURE__ */ pe.jsx(
        wx,
        {
          item: _,
          checked: j,
          onSelectItem: S
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, gI = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ pe.jsx(pr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ pe.jsx(
        hr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ pe.jsx(
        xs,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ pe.jsx(pr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ pe.jsx(
        hr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ pe.jsx(pr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ pe.jsx($u, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ pe.jsx(
        yI,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ pe.jsx(pe.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, vI = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ pe.jsx(pe.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ pe.jsx(
  Nt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ pe.jsx(
      nn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: gI({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), kI = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ pe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ pe.jsxs(D.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ pe.jsxs(D.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ pe.jsx(me, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ pe.jsx(nn, { label: "GitHub issue link", children: /* @__PURE__ */ pe.jsx(
          pr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, bI = "_modalBody_1hk1o_1", xI = "_modalBodyFormFields_1hk1o_4", Ld = {
  modalBody: bI,
  modalBodyFormFields: xI
}, _I = Ji(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), SI = Ji(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), NI = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], jI = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = un(), { track: d } = bn(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = mt(), [C, _] = se(""), [S, j] = se([]), [k, L] = se(), [E, I] = se(!1), [F, A] = se(!1), [K, Y] = Ub(), [
    ie,
    {
      loading: G,
      error: B,
      networkStatus: O
    }
  ] = s(_I, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Ce) => {
      j(
        Ce.GitHub.search?.edges?.map((H) => H?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), j([]);
    }
  });
  yi(
    () => {
      !G && C && O === Wt.ready ? ie({
        variables: {
          query: C,
          maxResults: 10
        }
      }) : j([]);
    },
    500,
    [C]
  );
  const [z, { error: Z }] = l(
    SI,
    {
      onError: (Ce) => {
        I(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Ce);
      },
      onCompleted: (Ce) => {
        I(!1);
        const H = Ce.GitHub.createIssue?.issue;
        L(H), o({
          title: "Success",
          text: `GitHub issue '${H.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: H.repository.name,
          number: H.number
        });
      }
    }
  ), be = (Ce) => {
    _(`org:${a} ${Ce}`);
  }, he = (Ce, H) => {
    H(Ce), _("");
  }, de = () => {
    _("");
  }, ye = (Ce) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), I(!0), z({
      variables: {
        input: {
          repositoryId: Ce.repository.id,
          title: Ce.title,
          body: Ce.body,
          assigneeIds: Ce.assignees?.length > 0 ? Ce.assignees.map((H) => H.id) : void 0
        }
      }
    });
  };
  qe(() => {
    const Ce = F ? window.setTimeout(() => A(!1), 2e3) : void 0;
    return () => window.clearTimeout(Ce);
  }, [F]);
  const q = () => {
    _(""), j([]), L(void 0), I(!1), A(!1);
  }, Se = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), q(), h(), n();
  };
  return /* @__PURE__ */ pe.jsxs(
    wt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: Se,
      children: [
        /* @__PURE__ */ pe.jsx(
          Ct,
          {
            title: k ? "Issue creation successful" : "Create new GitHub issue",
            onClose: Se
          }
        ),
        /* @__PURE__ */ pe.jsxs(It, { className: Ld.modalBody, children: [
          !G && B && /* @__PURE__ */ pe.jsx(Cn, { error: B }),
          !E && Z && /* @__PURE__ */ pe.jsx(Cn, { error: Z }),
          k ? /* @__PURE__ */ pe.jsx(
            kI,
            {
              createdIssue: k,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: F,
              setIssueLinkCopied: A,
              copyToClipboard: Y
            }
          ) : /* @__PURE__ */ pe.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(ye),
              children: /* @__PURE__ */ pe.jsxs(rt, { children: [
                /* @__PURE__ */ pe.jsx(ue, { children: /* @__PURE__ */ pe.jsx(nn, { label: "Repository", required: !0, children: /* @__PURE__ */ pe.jsx(
                  Nt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Ce, value: H } }) => /* @__PURE__ */ pe.jsx(
                      hr,
                      {
                        className: Ld.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: G,
                        onSearch: be,
                        onSelect: (He) => he(He, Ce),
                        onClear: de,
                        selectedItems: [H],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: B ? "No repositories found" : "No repositories available",
                        items: S || [],
                        itemComponent: ({ item: He, onSelect: Be, checked: Re }) => /* @__PURE__ */ pe.jsx(
                          wx,
                          {
                            item: He,
                            checked: Re,
                            onSelectItem: Be
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ pe.jsx(ue, { className: Ld.modalBodyFormFields, children: /* @__PURE__ */ pe.jsx(
                  vI,
                  {
                    control: m,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: NI
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ pe.jsx(
          Tt,
          {
            confirmOnClick: k ? Se : u(ye),
            confirmProps: {
              isLoading: E,
              loadingIndicator: /* @__PURE__ */ pe.jsx(ln, { size: 16 })
            },
            confirmName: k ? "Close" : "Save",
            cancelOnClick: k ? void 0 : Se
          }
        )
      ]
    }
  );
}, wI = "_wrapper_19v8w_1", CI = "_inputWrapper_19v8w_6", II = "_buttonLink_19v8w_19", FI = "_noItemsFound_19v8w_23", EI = "_createIssueButton_19v8w_28", Si = {
  wrapper: wI,
  inputWrapper: CI,
  buttonLink: II,
  noItemsFound: FI,
  createIssueButton: EI
}, TI = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se(!1), { track: a } = bn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: C,
    danglingPullRequestLinks: _,
    isLoadingGithubItems: S,
    issues: j,
    pullRequests: k,
    error: L
  } = O1({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), E = (Y) => d({ key: Y, type: "ISSUE" }), I = !(!!j?.length).valueOf() && !(!!k?.length).valueOf() && !(!!C?.length).valueOf() && !(!!_?.length).valueOf(), F = !v && !S && !!C?.length && !!_?.length && !!n?.showDanglingLinks, A = n?.enableCreateIssue, K = !!j?.length || !!k?.length;
  return !S && L ? /* @__PURE__ */ pe.jsx(Cn, { error: L, retry: () => u() }) : /* @__PURE__ */ pe.jsxs(pe.Fragment, { children: [
    /* @__PURE__ */ pe.jsxs(b, { className: Si.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ pe.jsxs(b, { className: Si.inputWrapper, flexDirection: "column", children: [
        A && /* @__PURE__ */ pe.jsxs(pe.Fragment, { children: [
          /* @__PURE__ */ pe.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Si.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ pe.jsx("div", { className: Si.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ pe.jsx(
          cI,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: j,
            linkedPullRequests: k
          }
        )
      ] }),
      S ? /* @__PURE__ */ pe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ pe.jsx(ln, { "data-testid": "github-widget-item-spinner" }) }) : K ? /* @__PURE__ */ pe.jsx(
        J1,
        {
          items: [...j, ...k],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ pe.jsx(D.Paragraph, { align: "center", className: Si.noItemsFound, children: "No linked items found." }),
      F && /* @__PURE__ */ pe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ pe.jsx(D.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ pe.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              C.map((Y) => /* @__PURE__ */ pe.jsx(
                An,
                {
                  onDelete: () => m({
                    key: Y,
                    type: "ISSUE"
                  }),
                  children: nr(Y)
                },
                nr(Y)
              )),
              _.map((Y) => /* @__PURE__ */ pe.jsx(
                An,
                {
                  onDelete: () => m({ key: Y, type: "PR" }),
                  children: nr(Y)
                },
                nr(Y)
              ))
            ] }),
            /* @__PURE__ */ pe.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && K && /* @__PURE__ */ pe.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: I,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ pe.jsx(
        jt,
        {
          slotEnd: /* @__PURE__ */ pe.jsx(me, { name: "external-link" }),
          variant: "tertiary",
          className: Si.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ pe.jsx(
      jI,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: E,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, Uu = [
  {
    key: "githubOrganization",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Zr = "GITHUB", $I = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, DI = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: $I
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: C
  } = qr({
    integrationId: e,
    integrationType: Zr,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: _,
    error: S,
    isWidgetUnknown: j,
    refetch: k,
    widgetConfiguration: L
  } = Hr({
    integrationId: e,
    fieldDefinitions: Uu,
    form: l,
    onMisconfigured: C
  }), { renderConditions: E, setRenderConditions: I, renderConditionsForSubmit: F } = Wr({
    integrationId: e,
    widgetConfiguration: L,
    renderConditionsEditor: o
  }), A = (Y) => Gr(Y, {
    fieldDefinitions: Uu,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: F
  }), K = l.watch("name");
  return /* @__PURE__ */ pe.jsxs(
    Kr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: S ?? h,
      onRetry: S ? k : void 0,
      isLoading: f || _,
      isWidgetUnknown: j,
      children: [
        v && /* @__PURE__ */ pe.jsx(Yr, { cause: v }),
        /* @__PURE__ */ pe.jsxs(rt, { children: [
          /* @__PURE__ */ pe.jsx(ue, { children: /* @__PURE__ */ pe.jsx(nn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ pe.jsx(
            $n,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(ue, { span: 3, children: /* @__PURE__ */ pe.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pe.jsx(ue, { span: 3 }),
          /* @__PURE__ */ pe.jsx(ue, { span: 3, children: /* @__PURE__ */ pe.jsx(
            Gn,
            {
              name: "githubOrganization",
              label: "GitHub organization or user",
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pe.jsx(ue, { span: 3 }),
          /* @__PURE__ */ pe.jsx(ue, { span: 3, children: /* @__PURE__ */ pe.jsx(nn, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ pe.jsx(
            $n,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(ue, { span: 3 }),
          /* @__PURE__ */ pe.jsx(ue, { span: 3, children: /* @__PURE__ */ pe.jsx(nn, { label: "Show unresolved links to GitHub items", children: /* @__PURE__ */ pe.jsx(
            $n,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(ue, { span: 3 }),
          /* @__PURE__ */ pe.jsx(ue, { span: 3, children: /* @__PURE__ */ pe.jsx(nn, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ pe.jsx(
            $n,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(ue, { span: 3 }),
          !s && e && /* @__PURE__ */ pe.jsx(
            Hi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Zr,
              label: "Authorize with OAuth"
            }
          ),
          o && E !== null && /* @__PURE__ */ pe.jsx(ue, { children: o({
            value: E,
            onChange: I,
            configurationKey: L?.id
          }) })
        ] }),
        /* @__PURE__ */ pe.jsx(
          Qr,
          {
            integrationType: Zr,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ pe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ pe.jsx(
                me,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ pe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ pe.jsxs(D.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Zr,
                  " integration, all links between Dixa and ",
                  Zr,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ pe.jsxs(D.Paragraph, { children: [
                  "All data in ",
                  Zr,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ pe.jsxs(D.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Zr,
                  " ",
                  'integration "',
                  K,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Vd = { exports: {} }, da = {}, Sg;
function RI() {
  if (Sg) return da;
  Sg = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return da.Fragment = r, da.jsx = s, da.jsxs = s, da;
}
var ko = {}, Ng;
function OI() {
  return Ng || (Ng = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    ko.Fragment = i, ko.jsx = Rn, ko.jsxs = Mn;
  })()), ko;
}
var jg;
function PI() {
  return jg || (jg = 1, process.env.NODE_ENV === "production" ? Vd.exports = RI() : Vd.exports = OI()), Vd.exports;
}
var xe = PI(), Oa = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Oa || {}), ai = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(ai || {}), zt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(zt || {});
const AI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, LI = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": AI
};
function VI(e) {
  return LI[e] ?? {};
}
const zI = VI(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), wg = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, Cx = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, UI = "_listItem_16pij_4", MI = "_clickableIcon_16pij_15", Qa = {
  listItem: UI,
  clickableIcon: MI
}, Ix = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = se(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ xe.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ xe.jsx(me, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ xe.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ xe.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: Qa.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ xe.jsx(
              me,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ xe.jsx(Ge, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: v } = l, C = l.currency ?? r;
      return /* @__PURE__ */ xe.jsx(
        Ge.Item,
        {
          contentLeft: /* @__PURE__ */ xe.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ xe.jsx(D.Paragraph, { children: u }),
            /* @__PURE__ */ xe.jsx(D.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "tertiary", children: Cx(f / 100, C) })
          ] }),
          contentRight: h && /* @__PURE__ */ xe.jsx(Wi, { src: h, alt: m ?? "Product image" }),
          className: Qa.listItem
        },
        `item-${d}-${v}`
      );
    }) })
  ] }) });
}, BI = "_boxWrapper_89s7l_1", qI = "_trackButton_89s7l_10", Cg = {
  boxWrapper: BI,
  trackButton: qI
}, HI = {
  [zt.StepUnknown]: "Unknown",
  [zt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [zt.StepPreparedByMerchant]: "Prepared by merchant",
  [zt.StepSubmittedToCarrier]: "Submitted to carrier",
  [zt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [zt.StepOnRoute]: "On route",
  [zt.StepDeliveredToPickupPoint]: "At pickup point",
  [zt.StepDeliveredToConsumer]: "Delivered to customer",
  [zt.StepDeliveredToMerchant]: "Returned to merchant",
  [zt.StepReturnRequested]: "Return requested",
  [zt.StepSentBack]: "Sent back",
  [zt.StepTerminated]: "Terminated",
  [zt.StepAwaitingSupplier]: "Awaiting supplier"
}, WI = {
  [ai.Delivery]: "Home delivery",
  [ai.Pickup]: "Pickup point",
  [ai.Instore]: "In-store pickup",
  [ai.Mailbox]: "Mailbox",
  [ai.Inwarehouse]: "Warehouse",
  [ai.Unknown]: "Unknown"
}, KI = {
  [Oa.Outbound]: "From merchant to customer",
  [Oa.Return]: "Return from customer to merchant",
  [Oa.Unspecified]: "Unspecified",
  [Oa.UnknownDirectionType]: "Unknown"
}, GI = (e) => e ? HI[e] ?? e : "", YI = (e) => e ? WI[e] ?? e : "", QI = (e) => e ? KI[e] ?? e : "", JI = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, XI = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = Jt();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, v = m || l || i, C = a?.filter((E) => E?.time !== ""), _ = GI(C?.[0]?.step), S = YI(u), j = QI(f), k = JI(e.location?.address), L = 14;
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: Cg.boxWrapper,
      children: [
        /* @__PURE__ */ xe.jsx(D.Heading, { variant: "heading-4", children: v }),
        /* @__PURE__ */ xe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ xe.jsx(
              me,
              {
                size: L,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsx(We, { content: "Copy tracking ID", children: /* @__PURE__ */ xe.jsx(
            me,
            {
              size: L,
              name: n ? "done" : "copy",
              className: Qa.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        _ && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(me, { size: L, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "secondary", children: _ })
          ] })
        ] }),
        j && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(me, { size: L, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        h && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(me, { size: L, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ xe.jsxs(D.Paragraph, { variant: "4", color: "secondary", children: [
              wg(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "secondary", children: wg(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(me, { size: L, name: "info", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "secondary", children: S })
          ] })
        ] }),
        k && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ xe.jsx(me, { size: L, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "secondary", children: k })
          ] })
        ] }),
        /* @__PURE__ */ xe.jsx(Ix, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ xe.jsxs(
          jt,
          {
            variant: "secondary",
            className: Cg.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ xe.jsx(me, { name: "external-link" }),
            children: [
              "Track on ",
              v ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, ZI = "_order_135ze_1", eF = "_orderIsOpen_135ze_9", nF = "_orderHeader_135ze_12", zd = {
  order: ZI,
  orderIsOpen: eF,
  orderHeader: nF
}, Ig = "No order number found", tF = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { isCopied: a, copy: o } = Jt(), { isCopied: s, copy: l } = Jt();
  if (!e)
    return null;
  const { cart: d, parcels: m, sender_name: u, tos_id: f } = e, h = e.external_id?.trim(), v = d?.currency || "", C = d?.prices?.total?.price ?? 0, _ = Cx(C / 100, v), S = 14, j = u && u.trim() !== "" ? u : "unknown sender";
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      className: tt(zd.order, {
        [zd.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ xe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: zd.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ xe.jsxs(D.Paragraph, { variant: "4", children: [
                  "From ",
                  j
                ] }),
                h ? /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "3", children: /* @__PURE__ */ xe.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "tertiary", children: Ig })
              ] }),
              /* @__PURE__ */ xe.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ xe.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ xe.jsx(me, { size: S, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ xe.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "tertiary", children: Ig }) })
              ] })
            ] }),
            h && /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsx(We, { content: "Copy order number", children: /* @__PURE__ */ xe.jsx(
              me,
              {
                size: S,
                name: s ? "done" : "copy",
                className: Qa.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ xe.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ xe.jsx(
                me,
                {
                  size: S,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsx(We, { content: "Copy tracking ID", children: /* @__PURE__ */ xe.jsx(
              me,
              {
                size: S,
                name: a ? "done" : "copy",
                className: Qa.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          u && /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ xe.jsx(me, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", children: u })
            ] })
          ] }),
          /* @__PURE__ */ xe.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ xe.jsx(me, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ xe.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", children: _ })
            ] })
          ] }),
          /* @__PURE__ */ xe.jsx(
            Ix,
            {
              openByDefault: !0,
              title: "Order items",
              items: d?.items?.map((k) => k),
              currency: d?.currency
            }
          ),
          m && /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ xe.jsx(D.Heading, { variant: "heading-4", children: "Parcels" }),
              m.length > 0 && /* @__PURE__ */ xe.jsx(Pn, { variant: "success", size: "small", children: m.length })
            ] }),
            m.length === 0 && /* @__PURE__ */ xe.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            m.map((k, L) => /* @__PURE__ */ xe.jsx(
              XI,
              {
                parcel: k
              },
              `parcel-${L}-${k?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, rF = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, Fg = (e) => {
  let n = 1 / 0;
  for (const r of e?.parcels ?? [])
    for (const i of r?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, iF = (e) => [...e].sort(
  (n, r) => Fg(r) - Fg(n)
), aF = ({
  customerEmail: e
}) => {
  const { useQuery: n } = un(), [r, i] = se([]), a = !e, { data: o, loading: s, error: l } = n(zI, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? oS({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? eb({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return qe(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      iF(
        rF(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ xe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ xe.jsx(ln, {}) }) : m || !d && !l ? /* @__PURE__ */ xe.jsx(D.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ xe.jsx(D.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ xe.jsx(Cn, { error: l }) : /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ xe.jsx(D.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ xe.jsx(Pn, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ xe.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ xe.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ xe.jsx(
      tF,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, oF = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ xe.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ xe.jsx(aF, { customerEmail: n })
    }
  );
}, Mu = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], sF = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, lF = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: sF
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = qr({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: _,
    isWidgetUnknown: S,
    refetch: j,
    widgetConfiguration: k
  } = Hr({
    integrationId: e,
    fieldDefinitions: Mu,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: E, renderConditionsForSubmit: I } = Wr({
    integrationId: e,
    widgetConfiguration: k,
    renderConditionsEditor: a
  }), F = (K) => Gr(K, {
    fieldDefinitions: Mu,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), A = s.watch("name");
  return /* @__PURE__ */ xe.jsxs(
    Kr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: _ ?? f,
      onRetry: _ ? j : void 0,
      isLoading: u || C,
      isWidgetUnknown: S,
      children: [
        h && /* @__PURE__ */ xe.jsx(Yr, { cause: h }),
        /* @__PURE__ */ xe.jsxs(rt, { children: [
          /* @__PURE__ */ xe.jsx(ue, { children: /* @__PURE__ */ xe.jsx(nn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ xe.jsx(
            $n,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(ue, { span: 3, children: /* @__PURE__ */ xe.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(ue, { span: 3 }),
          /* @__PURE__ */ xe.jsx(ue, { span: 3, children: /* @__PURE__ */ xe.jsx(nn, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ xe.jsx(
            $n,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(ue, { span: 3 }),
          /* @__PURE__ */ xe.jsx(ue, { span: 3, children: /* @__PURE__ */ xe.jsx(
            Gn,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(ue, { span: 3 }),
          /* @__PURE__ */ xe.jsx(ue, { span: 3, children: /* @__PURE__ */ xe.jsx(
            bs,
            {
              name: "ingridApiToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(ue, { span: 3 }),
          a && L !== null && /* @__PURE__ */ xe.jsx(ue, { children: a({
            value: L,
            onChange: E,
            configurationKey: k?.id
          }) })
        ] }),
        /* @__PURE__ */ xe.jsx(
          Qr,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ud = { exports: {} }, ua = {}, Eg;
function cF() {
  if (Eg) return ua;
  Eg = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ua.Fragment = r, ua.jsx = s, ua.jsxs = s, ua;
}
var bo = {}, Tg;
function dF() {
  return Tg || (Tg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    bo.Fragment = i, bo.jsx = Rn, bo.jsxs = Mn;
  })()), bo;
}
var $g;
function uF() {
  return $g || ($g = 1, process.env.NODE_ENV === "production" ? Ud.exports = cF() : Ud.exports = dF()), Ud.exports;
}
var oe = uF();
const ap = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => ap(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, mF = "_jiraCode_h30p6_1", pF = "_jiraCodeInline_h30p6_8", Md = {
  jiraCode: mF,
  jiraCodeInline: pF
}, Fx = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ oe.jsx(oe.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ oe.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ oe.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ oe.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ oe.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ oe.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ oe.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ oe.jsx("pre", { children: /* @__PURE__ */ oe.jsx("code", { className: Md.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ oe.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ oe.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ oe.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ oe.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ oe.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ oe.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ oe.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ oe.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ oe.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ oe.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ oe.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ oe.jsx("code", { className: tt(Md.jiraCode, Md.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, ds = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = se(!1);
  return !e || i ? /* @__PURE__ */ oe.jsx(me, { size: r, name: "question", className: n }) : /* @__PURE__ */ oe.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, fF = "_collapse_m2gjh_1", hF = "_collapseHeader_m2gjh_10", yF = "_collapseHeaderLink_m2gjh_31", gF = "_collapseHeaderStatus_m2gjh_40", vF = "_collapseHeaderTitle_m2gjh_51", kF = "_collapseContent_m2gjh_59", bF = "_collapseContentHeadline_m2gjh_62", xF = "_collapseContentButtonSpacer_m2gjh_68", _F = "_collapseContentButtonLink_m2gjh_71", SF = "_collapseContentStatusTag_m2gjh_74", NF = "_collapseContentDescription_m2gjh_77", lr = {
  collapse: fF,
  collapseHeader: hF,
  collapseHeaderLink: yF,
  collapseHeaderStatus: gF,
  collapseHeaderTitle: vF,
  collapseContent: kF,
  collapseContentHeadline: bF,
  collapseContentButtonSpacer: xF,
  collapseContentButtonLink: _F,
  collapseContentStatusTag: SF,
  collapseContentDescription: NF
}, Ex = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, jF = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = se(i), { track: s } = bn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ oe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, v = Ex({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), C = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ oe.jsxs(
      rr,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: C,
        className: lr.collapse,
        children: [
          /* @__PURE__ */ oe.jsx(rr.Header, { className: lr.collapseHeader, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ oe.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ oe.jsx(ds, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ oe.jsx(
                      "a",
                      {
                        className: lr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (_) => {
                          _.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ oe.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ oe.jsx(me, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ oe.jsx("span", { className: lr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ oe.jsx(An, { className: lr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ oe.jsx("div", { className: lr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ oe.jsx(rr.Content, { className: lr.collapseContent, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ oe.jsx("div", { className: lr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ oe.jsx(Zn, { className: lr.collapseContentDescription, children: u ? ap(u, Fx) : "" }),
            /* @__PURE__ */ oe.jsx(
              Kn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: lr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ oe.jsx(
              jt,
              {
                slotEnd: /* @__PURE__ */ oe.jsx(me, { name: "external-link" }),
                variant: "tertiary",
                className: lr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ oe.jsx(oe.Fragment, {}) });
}, wF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, CF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, IF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, FF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, EF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, TF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, $F = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, DF = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': wF,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": CF,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": IF,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": FF,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': EF,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': TF,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": $F
};
function ki(e) {
  return DF[e] ?? {};
}
const Tx = ki(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), RF = ki(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), OF = ki(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), PF = ki(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), AF = ki(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), LF = ki(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), VF = ki(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), op = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), zF = new RegExp(`^${op.source}$`), UF = new RegExp(`/${op.source}$`), Dg = new RegExp(
  `.+?[&?]selectedIssue=(${op.source})[&?]?.*`
);
function $x(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = se([]), [o, s] = se([]), [l, d] = se(), { track: m } = bn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: v } = un(), {
    loading: C,
    data: _,
    error: S,
    store: j
  } = xm(e ?? null), [
    k,
    { loading: L, error: E, data: I }
  ] = h(Tx, {
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    const de = I?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    de?.length && (s(de), a(de.map((ye) => ye?.key).filter(Boolean)));
  }, [I]), qe(
    () => d(S || E || void 0),
    [S, E]
  ), qe(
    () => {
      C || B();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [_?.jira?.issues, C]
  );
  const F = async (de, ye) => {
    await j(de).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: ye.success.title,
        text: ye.success.text
      });
    }).catch((q) => {
      u({
        title: ye.error.title,
        text: `${ye.error.text} ${q.message && " (" + q.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [A] = v(RF, {
    onError: (de) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${de.message && " (" + de.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), K = (de, ye) => {
    const q = window.location.href, Se = ye ? q.replace(
      e?.toString() ?? "",
      ye?.toString()
    ) : q, Ce = ye ? `# ${ye}` : `# ${e}`;
    A({
      variables: {
        issueKey: de,
        title: Ce,
        url: Se,
        globalId: `system=${Se}`
      }
    });
  }, [Y] = v(OF, {
    onError: (de) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${de.message && " (" + de.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ie = (de) => {
    const ye = window.location.href;
    Y({
      variables: {
        issueKey: de,
        globalId: `system=${ye}`
      }
    });
  }, G = (de) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: de
  }), B = () => {
    _ && _.jira?.issues?.length > 0 ? k({
      variables: {
        jql: `key in (${_?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, O = async (de, ye) => {
    m("jira:issue:link:clicked", G(de));
    const q = _?.jira?.issues ? _ : r;
    q.jira.issues = Array.from(
      new Set(q.jira.issues).add(de)
    ), await j(q, ye?.toString()).then(() => K(de, ye)).catch((Se) => {
      u({
        title: "Linking failed",
        text: `Linking ${de} failed. Please try again. ${Se.message && " (" + Se.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, z = (de) => {
    m("jira:issue:link:clicked", G(de));
    const ye = _?.jira?.issues ? _ : r;
    ye.jira.issues = Array.from(
      new Set(ye.jira.issues).add(de)
    ), F(ye, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${de} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${de} failed. Please try again.`
      }
    }).then(() => K(de));
  }, Z = (de) => {
    m("jira:issue:unlink:clicked", G(de)), f({
      headline: `Unlink issue ${de}?`,
      text: `You are about to unlink the issue ${de}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", G(de));
        const ye = {
          ..._,
          jira: {
            ..._?.jira,
            issues: _?.jira?.issues.filter((q) => q !== de) || []
          }
        };
        F(ye, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${de}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${de} failed.`
          }
        }).then(() => ie(de));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", G(de))
    });
  }, be = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((de) => de?.key && ie(de.key)), F(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, he = _?.jira?.issues?.filter(
    (de) => !i?.includes(de)
  ) || [];
  return {
    linkIssue: z,
    linkIssueQuietly: O,
    unlinkIssue: Z,
    loadIssues: B,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const de = {
        ..._,
        jira: {
          ..._?.jira,
          issues: _?.jira?.issues.filter(
            (ye) => !he.includes(ye)
          ) || []
        }
      };
      j(de);
    },
    unlinkAllIssues: be,
    maybeExtractIssueKey: (de) => {
      const ye = de.replace(/\s/g, "");
      if (zF.test(ye))
        return ye;
      if (Dg.test(de))
        return de.match(Dg)?.[1];
      if (de.startsWith(n) && UF.test(de))
        return de.substring(de.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: C,
    danglingIssueLinks: he,
    isLoadingIssues: L,
    issues: o,
    error: l
  };
}
function MF(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const BF = "_result_axxxc_48", qF = "_resultName_axxxc_68", HF = "_resultNameIcon_axxxc_76", WF = "_resultDescription_axxxc_81", KF = "_resultLinkIcon_axxxc_93", GF = "_tooltip_axxxc_102", YF = "_tooltipContent_axxxc_108", QF = "_tooltipName_axxxc_115", JF = "_tooltipNameIcon_axxxc_120", XF = "_tooltipDescription_axxxc_125", ZF = "_tooltipSummary_axxxc_133", eE = "_tooltipTag_axxxc_137", er = {
  result: BF,
  resultName: qF,
  resultNameIcon: HF,
  resultDescription: WF,
  resultLinkIcon: KF,
  tooltip: GF,
  tooltipContent: YF,
  tooltipName: QF,
  tooltipNameIcon: JF,
  tooltipDescription: XF,
  tooltipSummary: ZF,
  tooltipTag: eE
}, nE = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = se(!1), h = Ex({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ oe.jsx(
    We,
    {
      disabled: i,
      className: er.tooltip,
      content: /* @__PURE__ */ oe.jsxs("div", { className: er.tooltipContent, children: [
        /* @__PURE__ */ oe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ oe.jsxs("span", { className: er.tooltipName, children: [
                /* @__PURE__ */ oe.jsx(
                  ds,
                  {
                    width: 16,
                    iconUrl: h,
                    className: er.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ oe.jsx(An, { className: er.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ oe.jsx("div", { className: er.tooltipSummary, children: m }),
        d && /* @__PURE__ */ oe.jsx("div", { className: er.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ oe.jsxs(
        "button",
        {
          ...a,
          className: er.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ oe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ oe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ oe.jsxs("span", { className: er.resultName, children: [
                    /* @__PURE__ */ oe.jsx(
                      ds,
                      {
                        width: 16,
                        iconUrl: h,
                        className: er.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ oe.jsx("div", { className: er.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ oe.jsx(
              me,
              {
                className: er.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, tE = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ oe.jsx(
  jt,
  {
    slotEnd: /* @__PURE__ */ oe.jsx(me, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), rE = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = un(), [o, s] = se([]), [l, d] = se(""), [m, { loading: u, error: f, data: h, networkStatus: v }] = a(Tx, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: C } = $x(null, n);
  yi(
    () => {
      !u && l && v === Wt.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const E = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      E.map((I) => ({
        id: I?.key ?? "",
        name: I?.key ?? "",
        description: I?.fields.summary,
        status: I?.fields.status,
        issuetype: I?.fields.issuetype,
        text: I?.fields.description ? ap(I?.fields.description, Fx) : /* @__PURE__ */ oe.jsx(oe.Fragment, {})
      }))
    );
  }, [h]);
  const _ = (E) => {
    e(E.id), d("");
  }, S = (E) => {
    const I = E.trim(), F = C(I);
    if (F) {
      const A = F.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${A}'`);
    } else I !== "" && d(
      `text ~ '${I}'${r ? " and project = " + r : ""}`
    );
  }, j = () => {
    d("");
  }, k = (E) => /* @__PURE__ */ oe.jsx(tE, { ...E, jiraInstanceUrl: n }), L = (E) => /* @__PURE__ */ oe.jsx(
    nE,
    {
      ...E,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ oe.jsx(Cn, { error: f }) : /* @__PURE__ */ oe.jsx(
    hr,
    {
      items: o,
      loading: u,
      onSearch: S,
      onSelect: _,
      onClear: j,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: k,
      itemComponent: L,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, iE = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = se(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return qe(() => {
    r(i);
  }, [i]), /* @__PURE__ */ oe.jsx(
    hr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, aE = "_itemButton_1hl53_1", oE = "_result_1hl53_6", sE = "_resultIcon_1hl53_26", lE = "_resultName_1hl53_30", cE = "_resultCheckIcon_1hl53_38", ma = {
  itemButton: aE,
  result: oE,
  resultIcon: sE,
  resultName: lE,
  resultCheckIcon: cE
}, Bu = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ oe.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ oe.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: ma.itemButton,
          children: /* @__PURE__ */ oe.jsxs(b, { className: ma.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(
              ds,
              {
                width: 36,
                iconUrl: o || "",
                className: ma.resultIcon
              }
            ),
            /* @__PURE__ */ oe.jsx(Zn, { className: ma.resultName, children: e.name }),
            n && /* @__PURE__ */ oe.jsx(Zn, { className: ma.resultCheckIcon, children: /* @__PURE__ */ oe.jsx(me, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, dE = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = un(), [o, s] = se([]), [l, d] = se(), m = 2, [u, { loading: f, error: h, data: v, networkStatus: C }] = a(VF, {
    notifyOnNetworkStatusChange: !0
  });
  return yi(
    () => {
      !f && l && l.length >= m && C === Wt.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((_) => {
      if (_?.data?.Jira.findUsers?.length === 1) {
        const S = _?.data?.Jira?.findUsers[0];
        r(S.accountId), s([
          {
            id: S.accountId,
            name: S.displayName
          }
        ]);
      }
    });
  }, []), qe(() => {
    const _ = v?.Jira?.findUsers || [];
    s(
      _.filter(({ active: S }) => S).map(({ accountId: S, displayName: j, avatarUrls: k, active: L }) => ({
        id: S,
        name: j,
        avatarUrls: k,
        active: L
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ oe.jsx(Cn, { error: h }) : /* @__PURE__ */ oe.jsx(
    hr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (_) => d(_),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: _, onSelect: S, checked: j }) => /* @__PURE__ */ oe.jsx(
        Bu,
        {
          item: _,
          checked: j,
          onSelectItem: S,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, Rg = ({
  field: e
}) => {
  const [n, r] = se(!1), [i, a] = Ub();
  return qe(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ oe.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ oe.jsx(b, { children: /* @__PURE__ */ oe.jsx(me, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ oe.jsx(D.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ oe.jsx(We, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ oe.jsx(
      Kt,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, uE = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ oe.jsx(Rg, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ oe.jsx(pr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ oe.jsx($u, { onChange: n, value: r }) : /* @__PURE__ */ oe.jsx(pr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ oe.jsx($u, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ oe.jsx(pr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ oe.jsx(
        dE,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ oe.jsx(
        hr,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ oe.jsx(iE, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ oe.jsx(Rg, { field: e });
  }
}, mE = ["description", "reporter", "summary"], pE = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ oe.jsx(oe.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || mE.includes(o)
).map((o) => /* @__PURE__ */ oe.jsx(
  Nt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ oe.jsx(
      nn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: uE({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), fE = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ oe.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ oe.jsxs(D.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ oe.jsxs(
          D.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ oe.jsx(me, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ oe.jsx(nn, { label: "Jira issue link", children: /* @__PURE__ */ oe.jsx(
        pr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), hE = "_modalBody_1hk1o_1", yE = "_modalBodyFormFields_1hk1o_4", Og = {
  modalBody: hE,
  modalBodyFormFields: yE
}, gE = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), vE = (e) => e?.custom?.split(":")?.[1] || null, kE = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, bE = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = kE(a, n), l = vE(s) ?? a;
        return r.includes(l) ? i[a] = gE(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, xE = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = se([]), [m, u] = se(), [f, h] = se(0), [v, C] = se([]), [_, S] = se([]), [j, k] = se(!1), [L, E] = se(!1), [I, F] = se({}), { track: A } = bn(), { isCopied: K, copyToClipboard: Y } = MF(), ie = Bn(() => i?.conversationId, [e]), { useMutation: G, useLazyQuery: B, showNotification: O } = un(), {
    control: z,
    handleSubmit: Z,
    formState: { errors: be },
    reset: he,
    setValue: de,
    getValues: ye
  } = mt({
    defaultValues: s
  }), q = _.length > 0, Se = `${a}/browse`, Ce = Object.keys(I).length > 0, [H, { loading: He, error: Be }] = B(PF, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ge) => {
      d(ge.Jira.getAllProjects);
    },
    onError: (ge) => {
      O({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", ge), d([]);
    }
  }), [
    Re,
    { loading: Ue, error: Te }
  ] = B(AF, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ge) => {
      h(0);
      const $e = ge?.Jira?.getCreateIssueMeta?.projects[0];
      if ($e) {
        const Le = $e?.issuetypes.filter(
          ({ subtask: Pe }) => !Pe
        );
        C(Le || []), de(
          "issuetype",
          Le.length > 0 ? Le[0] : void 0
        );
      } else
        O({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), C([]), S([]);
    },
    onError: (ge) => {
      O({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", ge), C([]), S([]), h(0);
    }
  }), [Me, { error: De }] = G(
    LF,
    {
      onError: () => {
        k(!1), O({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), A("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (ge) => {
        if (k(!1), ge?.Jira && "key" in ge.Jira.createIssue)
          u(ge?.Jira?.createIssue), O({
            title: "Success",
            text: `Jira issue '${ge.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), A("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: ge.Jira.createIssue.key
          }), ie && r(
            ge.Jira.createIssue.key,
            ie
          );
        else if ("errorMessages" in ge.Jira.createIssue || "errors" in ge.Jira.createIssue) {
          const $e = ge?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", $e), O({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), on = (ge) => {
    k(!0), F({}), Me({
      variables: {
        input: bE(ge, _)
      }
    });
  };
  qe(() => {
    if (e)
      try {
        H();
      } catch (ge) {
        console.warn("Error when fetching initial projects", ge);
      }
  }, [e]), qe(() => {
    const ge = L ? window.setTimeout(() => E(!1), 2e3) : void 0;
    return () => window.clearTimeout(ge);
  }, [L]), qe(() => {
    if (v?.length > 0) {
      de("issuetype", v[f]);
      const ge = v[f]?.fields?.additionalProperties;
      if (ge?.length > 0) {
        const $e = ge.map(
          ({ value: J }) => J
        ), Le = (o ? $e.sort(({ name: J }, { name: T }) => J.localeCompare(T)) : $e).sort(
          ({ required: J }, { required: T }) => Number(T) - Number(J)
        ), { project: Pe, issuetype: mn } = ye();
        he({ project: Pe, issuetype: mn }), S(Le);
      }
    } else
      S([]), de("issuetype", void 0);
  }, [v, de, f]), qe(() => {
    if (De && lb(De)) {
      if (De?.graphQLErrors?.length > 0) {
        const { graphQLErrors: ge } = De, $e = ge[0].extensions?.integration?.responseBody;
        try {
          const Le = JSON.parse($e);
          if (Le?.errors) {
            const Pe = Object.keys(Le.errors).reduce(
              (mn, J) => ({
                ...mn,
                [J]: {
                  type: "required",
                  message: Le.errors[J],
                  ref: {
                    name: J
                  }
                }
              }),
              {}
            );
            F(Pe);
          }
        } catch {
        }
      }
    } else
      F({});
  }, [De]);
  const Fe = () => {
    d([]), S([]), C([]), u(void 0), h(0), k(!1), F({});
  }, Ye = () => {
    Fe(), he(s), n();
  }, Ze = (ge) => {
    ge && Re({
      variables: {
        projectKey: ge
      }
    });
  }, fe = (ge) => {
    const $e = v.map((Le) => Le.id).indexOf(ge);
    h($e ?? 0);
  };
  return /* @__PURE__ */ oe.jsxs(
    wt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Ye,
      children: [
        /* @__PURE__ */ oe.jsx(
          Ct,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: Ye
          }
        ),
        /* @__PURE__ */ oe.jsxs(It, { className: Og.modalBody, children: [
          !He && Be && /* @__PURE__ */ oe.jsx(Cn, { error: Be, retry: H }),
          !Ue && Te && /* @__PURE__ */ oe.jsx(
            Cn,
            {
              error: Te,
              retry: Re
            }
          ),
          !j && Ce && /* @__PURE__ */ oe.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ oe.jsx(
            _s,
            {
              variant: "warning",
              description: /* @__PURE__ */ oe.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ oe.jsx(D.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ oe.jsx(
                      Kn,
                      {
                        icon: K ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Y(JSON.stringify(_, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ oe.jsx(
            fE,
            {
              createdIssue: m,
              issueBaseLink: Se,
              issueLinkCopied: L,
              setIssueLinkCopied: E,
              copyToClipboard: Y
            }
          ) : /* @__PURE__ */ oe.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: Z(on),
              children: /* @__PURE__ */ oe.jsxs(rt, { children: [
                /* @__PURE__ */ oe.jsx(ue, { span: 3, children: /* @__PURE__ */ oe.jsx(nn, { label: "Project", required: !0, children: /* @__PURE__ */ oe.jsx(
                  Nt,
                  {
                    control: z,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: ge, value: $e } }) => /* @__PURE__ */ oe.jsx(
                      hr,
                      {
                        searchable: !0,
                        loading: He,
                        onSelect: (Le) => {
                          Ze(Le.key), ge(Le);
                        },
                        selectedItems: [$e],
                        placeholder: "Select Jira project",
                        emptyMessage: Be ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Le, onSelect: Pe, checked: mn }) => /* @__PURE__ */ oe.jsx(
                          Bu,
                          {
                            item: Le,
                            checked: mn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ oe.jsx(ue, { span: 3, children: /* @__PURE__ */ oe.jsx(nn, { label: "Issue type", required: !0, children: /* @__PURE__ */ oe.jsx(
                  Nt,
                  {
                    control: z,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: ge, value: $e } }) => /* @__PURE__ */ oe.jsx(
                      hr,
                      {
                        disabled: v.length === 0,
                        loading: Ue,
                        onSelect: (Le) => {
                          fe(Le.id), ge(Le);
                        },
                        selectedItems: [$e],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: Te ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Le, onSelect: Pe, checked: mn }) => /* @__PURE__ */ oe.jsx(
                          Bu,
                          {
                            item: Le,
                            checked: mn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                q && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ oe.jsx(ue, { className: Og.modalBodyFormFields, children: /* @__PURE__ */ oe.jsx(
                  pE,
                  {
                    control: z,
                    errors: { ...be, ...I },
                    getValues: ye,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: _
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ oe.jsx(
          Tt,
          {
            confirmOnClick: m ? Ye : Z(on),
            confirmProps: {
              disabled: !q,
              isLoading: j,
              loadingIndicator: /* @__PURE__ */ oe.jsx(ln, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : Ye
          }
        )
      ]
    }
  );
}, _E = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, SE = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, NE = "_wrapper_1bylq_1", jE = "_inputWrapper_1bylq_6", wE = "_inputSeparator_1bylq_18", CE = "_buttonLink_1bylq_23", IE = "_noIssuesFound_1bylq_27", pa = {
  wrapper: NE,
  inputWrapper: jE,
  inputSeparator: wE,
  buttonLink: CE,
  noIssuesFound: IE
}, FE = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = bn(), i = _E(n?.jiraSiteUrl), [a, o] = se(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: C,
    isLoadingIssues: _,
    issues: S,
    error: j
  } = $x(
    s ? e.conversationId : null,
    i
  ), k = !!n?.enableCreateIssue, L = !!n?.enableSortIssueTypeByLabel, E = !!(S?.length || v?.length), I = !!n?.enableRemoveAllLinks && E, F = !C && !_ && v?.length > 0 && !!n?.showDanglingLinks;
  return !_ && j ? /* @__PURE__ */ oe.jsx(Cn, { error: j, retry: () => f() }) : /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
    /* @__PURE__ */ oe.jsxs(b, { className: pa.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ oe.jsxs(b, { className: pa.inputWrapper, flexDirection: "column", children: [
        k && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
          /* @__PURE__ */ oe.jsx(
            Kn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ oe.jsx("div", { className: pa.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ oe.jsx(
          rE,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      _ ? /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ oe.jsx(ln, { "data-testid": "jira-widget-issue-spinner" }) }) : S?.length ? /* @__PURE__ */ oe.jsx(
        jF,
        {
          issues: S,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ oe.jsx(D.Paragraph, { align: "center", className: pa.noIssuesFound, children: "No linked issues found" }),
      I && S?.length > 0 && /* @__PURE__ */ oe.jsx(
        Kn,
        {
          variant: "secondary",
          disabled: !S?.length && !v?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      F && /* @__PURE__ */ oe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ oe.jsx(D.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ oe.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((A) => /* @__PURE__ */ oe.jsx(An, { onDelete: () => m(A), children: A }, A)) }),
            /* @__PURE__ */ oe.jsx(
              Kn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ oe.jsx(
        jt,
        {
          slotEnd: /* @__PURE__ */ oe.jsx(me, { name: "external-link" }),
          variant: "tertiary",
          className: pa.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ oe.jsx(
      xE,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: L
      }
    )
  ] });
}, qu = [
  {
    key: "jiraSiteUrl",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  }
], EE = (e) => {
  const n = SE(e);
  return typeof n == "string" ? n : !0;
}, ei = "JIRA", TE = {
  enabled: !1,
  name: "",
  jiraSiteUrl: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0,
  enableSortIssueTypeByLabel: !1
}, $E = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: TE
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: C
  } = qr({
    integrationId: e,
    integrationType: ei,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: _,
    error: S,
    isWidgetUnknown: j,
    refetch: k,
    widgetConfiguration: L
  } = Hr({
    integrationId: e,
    fieldDefinitions: qu,
    form: l,
    onMisconfigured: C
  }), { renderConditions: E, setRenderConditions: I, renderConditionsForSubmit: F } = Wr({
    integrationId: e,
    widgetConfiguration: L,
    renderConditionsEditor: o
  }), A = (Y) => Gr(Y, {
    fieldDefinitions: qu,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: F
  }), K = l.watch("name");
  return /* @__PURE__ */ oe.jsxs(
    Kr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: S ?? h,
      onRetry: S ? k : void 0,
      isLoading: f || _,
      isWidgetUnknown: j,
      children: [
        v && /* @__PURE__ */ oe.jsx(Yr, { cause: v }),
        /* @__PURE__ */ oe.jsxs(rt, { children: [
          /* @__PURE__ */ oe.jsx(ue, { children: /* @__PURE__ */ oe.jsx(nn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ oe.jsx(
            $n,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(ue, { span: 3, children: /* @__PURE__ */ oe.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ oe.jsx(ue, { span: 3 }),
          /* @__PURE__ */ oe.jsx(ue, { span: 3, children: /* @__PURE__ */ oe.jsx(
            Gn,
            {
              name: "jiraSiteUrl",
              label: "Jira site URL",
              control: l.control,
              rules: {
                validate: (Y) => EE(Y)
              },
              componentProps: {
                placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ oe.jsx(ue, { span: 3 }),
          /* @__PURE__ */ oe.jsx(ue, { span: 3, children: /* @__PURE__ */ oe.jsx(nn, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ oe.jsx(
            $n,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(ue, { span: 3 }),
          /* @__PURE__ */ oe.jsx(ue, { span: 3, children: /* @__PURE__ */ oe.jsx(nn, { label: "Show unresolved links to Jira issues", children: /* @__PURE__ */ oe.jsx(
            $n,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(ue, { span: 3 }),
          /* @__PURE__ */ oe.jsx(ue, { span: 3, children: /* @__PURE__ */ oe.jsx(nn, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ oe.jsx(
            $n,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(ue, { span: 3 }),
          /* @__PURE__ */ oe.jsx(ue, { span: 3, children: /* @__PURE__ */ oe.jsx(nn, { label: "Enable to sort the issue types by label", children: /* @__PURE__ */ oe.jsx(
            $n,
            {
              name: "enableSortIssueTypeByLabel",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(ue, { span: 3 }),
          !s && e && /* @__PURE__ */ oe.jsx(
            Hi,
            {
              configuration: n,
              integrationId: e,
              integrationType: ei,
              label: "Authorize with OAuth"
            }
          ),
          o && E !== null && /* @__PURE__ */ oe.jsx(ue, { children: o({
            value: E,
            onChange: I,
            configurationKey: L?.id
          }) })
        ] }),
        /* @__PURE__ */ oe.jsx(
          Qr,
          {
            integrationType: ei,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ oe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ oe.jsx(
                me,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsxs(D.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  ei,
                  " integration, all links between Dixa and ",
                  ei,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ oe.jsxs(D.Paragraph, { children: [
                  "All data in ",
                  ei,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ oe.jsxs(D.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  ei,
                  " ",
                  'integration "',
                  K,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Bd = { exports: {} }, fa = {}, Pg;
function DE() {
  if (Pg) return fa;
  Pg = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return fa.Fragment = r, fa.jsx = s, fa.jsxs = s, fa;
}
var xo = {}, Ag;
function RE() {
  return Ag || (Ag = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    xo.Fragment = i, xo.jsx = Rn, xo.jsxs = Mn;
  })()), xo;
}
var Lg;
function OE() {
  return Lg || (Lg = 1, process.env.NODE_ENV === "production" ? Bd.exports = DE() : Bd.exports = RE()), Bd.exports;
}
var we = OE();
function PE({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = un(), [a, o] = se([]), [s] = i(e, n), [l, d] = se(
    []
  );
  return qe(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((C) => {
        const _ = setTimeout(C, r);
        d([...l, _]);
      });
      const v = await s({
        variables: h
      });
      u.push(v);
    }
    o(u);
  }, a];
}
var Dx = /* @__PURE__ */ ((e) => (e.List = "list", e))(Dx || {}), Hu = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(Hu || {}), Wu = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(Wu || {}), Ku = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(Ku || {});
const AE = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, LE = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, VE = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, zE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, UE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, ME = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, BE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, qE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, HE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, WE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, KE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, GE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, YE = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": AE,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": LE,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": zE,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": UE,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": VE,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": ME,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": BE,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": qE,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": HE,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": WE,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": KE,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": GE
};
function Pr(e) {
  return YE[e] ?? {};
}
const QE = Pr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), JE = Pr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), XE = Pr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), ZE = Pr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), eT = Pr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), nT = Pr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), tT = Pr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), rT = Pr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), iT = Pr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function Gu(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function Vg(e) {
  return Gu(e) && e?.attributes?.event_properties?.$message;
}
function aT(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function zg(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function oT(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function sT(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function lT(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function cT(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function dT(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function uT(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function Ug(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function mT(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function pT(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const fT = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function hT(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function yT(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function gT({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = un(), { track: a } = bn(), [o, s] = se(null), [l, d] = se(
    null
  ), [m, u] = se(null), [f, h] = se(null), [v, C] = se(
    null
  ), [_, S] = se([]), {
    data: j,
    error: k,
    loading: L,
    networkStatus: E
  } = i(XE, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    I,
    {
      data: F,
      error: A,
      loading: K,
      networkStatus: Y
    }
  ] = r(QE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return qe(() => {
    if (j && !L && E === Wt.ready) {
      const ie = oT(j);
      s(
        ie.find((G) => G?.attributes?.name === "Received Email")?.id || null
      ), d(
        ie.find((G) => G?.attributes?.name === "Opened Email")?.id || null
      ), u(
        ie.find((G) => G?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ie.find((G) => G?.attributes?.name === "Bounced Email")?.id || null
      ), C(
        ie.find((G) => G?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), C(null);
  }, [j]), qe(() => {
    o && l && m && f && v && !K && Y === Wt.ready ? I({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : S([]);
  }, [
    o,
    l,
    m,
    f,
    v
  ]), qe(() => {
    if (!K && F) {
      const ie = sT(F), G = cT(
        F
      ).map(
        (he) => he?.attributes?.event_properties.$message
      ), B = dT(
        F
      ).map(
        (he) => he?.attributes?.event_properties.$message
      );
      ie.forEach((he) => {
        const de = he.attributes?.event_properties.$message;
        he.opened = G.includes(de), he.clicked = B.includes(de);
      });
      const O = lT(F), z = uT(F), Z = [
        ...ie,
        ...z,
        ...O
      ].sort((he, de) => {
        const ye = zg(he), q = zg(de);
        return ye == null && q == null ? 0 : ye == null ? 1 : q == null ? -1 : q - ye;
      }).slice(0, n);
      S(Z);
      const be = Z.map((he) => he.id);
      a("klaviyo:messages:received", {
        emailsReceived: ie.filter(
          (he) => be.includes(he.id)
        ).length,
        emailsBounced: z.filter(
          (he) => be.includes(he.id)
        ).length,
        smsReceived: O.filter(
          (he) => be.includes(he.id)
        ).length,
        total: be.length
      });
    } else
      S([]);
  }, [K, F]), Bn(
    () => ({
      receivedMessages: _,
      isLoading: L || K,
      error: k || A
    }),
    [
      _,
      L,
      K,
      k,
      A
    ]
  );
}
function vT({ profileId: e }) {
  const { useQuery: n } = un(), [r, i] = se(), [a, o] = se(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(eT, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  qe(() => {
    l && o(l);
  }, [l]), qe(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Bn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function kT({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = bn(), { useLazyQuery: i } = un(), [a, o] = se(), [s, l] = se(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(ZE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    if (!f && m) {
      const v = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, C = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(v, C);
    }
  }, [f, m]);
  const h = (v, C) => {
    const _ = v?.data?.length === 1 && v.data[0]?.id || void 0, S = C?.data?.length === 1 && C.data[0]?.id || void 0, j = _ || S, k = !_ || !S || _ === S;
    if (j && k) {
      o(_ || S), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), k || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${_}) and phone number ${n} (profile ID ${S}).`
      )
    );
  };
  return Bn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const Mg = 800, bT = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, xT = 3, _T = 1.5, ST = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = xT,
  useDelayRange: a = !1
}) => {
  const o = (A) => Math.floor(Math.random() * (A.max - A.min) + A.min), [s, l] = se(0), [d, m] = se(n || Mg), [u, f] = se(r || bT), [h, v] = se(!1), [C, _] = se(!1), S = a || !!r, j = S ? o(u) : n || Mg, [k, L] = se(j);
  iw(
    async () => {
      const A = s + 1, K = _T ** A;
      l(A), L(
        (S ? o(u) : d) * K
      ), await e().then(() => {
        _(!0), F();
      });
    },
    h ? k : null
  ), ow(() => F());
  const E = at(() => {
    l(0), L(j);
  }, [j]), I = at(
    (A = {}) => {
      const { delay: K, delayRange: Y } = A;
      _(!1), E(), Y && (f(Y), L(o(Y))), K && (m(K), L(K)), v(!0);
    },
    [E]
  ), F = at(() => {
    v(!1), E();
  }, [E]);
  return qe(() => {
    s >= i && F();
  }, [s, i, F]), Bn(
    () => ({ isRunning: h, isSuccessful: C, start: I, stop: F }),
    [h, C, I, F]
  );
}, NT = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, jT = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function wT({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = un(), [i, a] = se(), [o, s] = se(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? nT : tT,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: C
  } = ST({
    query: u,
    useDelayRange: !0
  }), _ = m || h;
  return qe(() => {
    if (d)
      if (dS({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const S = NT(d);
          v({
            ...S && {
              delayRange: jT(S)
            }
          });
        }
      } else
        s(d);
  }, [d]), qe(() => {
    if (!m && l?.Klaviyo) {
      let S = {}, j = {};
      n === "lists" && (S = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (j = l?.Klaviyo?.get_segments_for_profile), (S?.data || j?.data) && (C(), a(
        (n === "lists" ? S?.data : j?.data)?.map((k) => ({
          ...k,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Bn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: _,
      error: o,
      networkStatus: f
    }),
    [i, _, o, f, v]
  );
}
const CT = "_notificationText_1polx_1", sp = {
  notificationText: CT
}, As = ({ error: e }) => {
  const { track: n } = bn();
  let r = e;
  if (lb(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && eb({ error: i[0] }), o = i.length === 1 && lS({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ we.jsx(Cn, { error: e });
  }
  return /* @__PURE__ */ we.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ we.jsx(
    Ge.Item,
    {
      contentLeft: /* @__PURE__ */ we.jsx(me, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, IT = "_message_1vrar_48", FT = "_messageIsOpen_1vrar_56", ET = "_messageHeader_1vrar_59", TT = "_messageLabel_1vrar_65", $T = "_messageText_1vrar_68", Ai = {
  message: IT,
  messageIsOpen: FT,
  messageHeader: ET,
  messageLabel: TT,
  messageText: $T
}, DT = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && mT(e.flowMessage);
  return /* @__PURE__ */ we.jsxs(we.Fragment, { children: [
    /* @__PURE__ */ we.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ we.jsx(D.Paragraph, { variant: "4", className: Ai.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ we.jsx(D.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ we.jsx(ln, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ we.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ we.jsx(b, { children: /* @__PURE__ */ we.jsx(
            D.Paragraph,
            {
              variant: "4",
              className: Ai.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ we.jsx(D.Paragraph, { variant: "4", className: Ai.messageText, children: i })
        ]
      }
    )
  ] });
}, RT = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ we.jsx(we.Fragment, { children: /* @__PURE__ */ we.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ we.jsx(b, { children: /* @__PURE__ */ we.jsx(D.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ we.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, OT = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = se(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = Bn(
    () => () => l ? Ln(l).format(m) : d ? Ln.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, C = f && e.clicked, _ = f && o?.event_properties.Subject, S = h && o?.event_properties["Message Name"], j = f ? "mail" : "sms";
  return /* @__PURE__ */ we.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: tt(Ai.message, {
        [Ai.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ we.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: Ai.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ we.jsx(me, { size: 16, name: j }),
                  " ",
                  fT(s),
                  u && /* @__PURE__ */ we.jsx(Pn, { size: "small", variant: "info", children: u })
                ] }),
                _ && _,
                S && S
              ] }),
              /* @__PURE__ */ we.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ we.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ we.jsx(Sm, {}),
          aT(e) && /* @__PURE__ */ we.jsx(b, { children: /* @__PURE__ */ we.jsx(Pn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ we.jsxs(we.Fragment, { children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ we.jsx(An, { children: /* @__PURE__ */ we.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ we.jsx(
                  me,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ we.jsx(An, { children: /* @__PURE__ */ we.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ we.jsx(
                  me,
                  {
                    size: 16,
                    color: C ? "green.400" : "red.400",
                    name: C ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ we.jsx(DT, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ we.jsx(RT, { event: e })
        ] })
      ]
    }
  );
}, PT = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, AT = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = se(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = gT({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = PE({
    query: JE,
    options: PT,
    delayMs: 1e3
  }), [m, u] = se([]);
  qe(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((v) => Gu(v)).map((v) => Vg(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), qe(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && Gu(h) && !h.flowMessage) {
          const v = Vg(h), C = d.find((S) => (S.data && Ug(S.data))?.id === v), _ = C?.data && Ug(C.data);
          if (_)
            return {
              ...pT(h),
              flowMessage: _
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ we.jsx(we.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ we.jsx(
    Cn,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ we.jsx(
    As,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ we.jsxs(we.Fragment, { children: [
    /* @__PURE__ */ we.jsx(D.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ we.jsx(ln, {}) }) : /* @__PURE__ */ we.jsx(we.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, v) => /* @__PURE__ */ we.jsx(
      OT,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ we.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: sp.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, LT = "_list_ld0hf_1", VT = "_listItem_ld0hf_4", Rr = {
  list: LT,
  listItem: VT
}, zT = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsx(D.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ we.jsx(D.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ we.jsx(Ge, { className: Rr.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ we.jsx(Ge.Text, { variant: "dense", className: Rr.listItem, children: /* @__PURE__ */ we.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ we.jsx(D.Paragraph, { variant: "4", children: cS(a) }),
          /* @__PURE__ */ we.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: Ka(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, Bg = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = se(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = wT({ profileId: e, query: n });
  qe(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ we.jsx(As, { error: o }) : s ? /* @__PURE__ */ we.jsx(Ge.Text, { variant: "dense", className: Rr.listItem, children: /* @__PURE__ */ we.jsx(ln, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ we.jsx(we.Fragment, { children: u.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ we.jsx(Ge.Text, { variant: "dense", className: Rr.listItem, children: /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx(D.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ we.jsx(An, { children: nb(h) })
    ] }) }, v)
  ) }) : r && !a ? /* @__PURE__ */ we.jsx(Ge.Text, { variant: "dense", className: Rr.listItem, children: /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ we.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ we.jsx(me, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ we.jsxs(D.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ we.jsx(We, { content: "Refresh lists and segments", children: /* @__PURE__ */ we.jsx(Kn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ we.jsx(Ge.Text, { variant: "dense", className: Rr.listItem, children: /* @__PURE__ */ we.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ we.jsx(D.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ we.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, UT = 0.7, MT = 0.3, BT = (e) => e >= UT ? { variant: "error", label: "High risk" } : e >= MT ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, qT = (e) => /* @__PURE__ */ we.jsx(D.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), HT = (e) => {
  const n = BT(e);
  return /* @__PURE__ */ we.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ we.jsx(Pn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ we.jsx(D.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, WT = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: qT(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: Ka(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: HT(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: Ka(o)
      }
    ] : []
  ];
}, KT = ({
  profile: e
}) => {
  const n = WT(e);
  return /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsx(D.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ we.jsx(D.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ we.jsx(Ge, { className: Rr.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ we.jsx(Ge.Text, { variant: "dense", className: Rr.listItem, children: /* @__PURE__ */ we.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ we.jsx(D.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, GT = "_tagHover_kzbzk_1", YT = "_channelUnsubscribed_kzbzk_6", qg = {
  tagHover: GT,
  channelUnsubscribed: YT
}, Hg = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ we.jsx(
    We,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ we.jsx(
        An,
        {
          className: qg.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ we.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: tt({
                [qg.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ we.jsx(ln, { size: 16 }) : /* @__PURE__ */ we.jsx(me, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, QT = "_subscriptionError_1qhhx_1", JT = {
  subscriptionError: QT
}, XT = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(), { track: h } = bn(), [v, C] = aw({
    channel: null,
    request: null
  }), _ = hT(n), S = yT(n), j = !!e, { useMutation: k } = un(), [L] = k(
    rT
  ), [E] = k(
    iT
  ), I = (K) => {
    h("klaviyo:profile:subscribe:clicked", { channel: K }), C.setAll({
      channel: K,
      request: "subscribed"
    }), ((Y) => L({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: Hu.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...Y === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: Wu.Subscribed
                        }
                      }
                    },
                    ...Y === "SMS" && {
                      sms: {
                        marketing: {
                          consent: Wu.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: Dx.List,
              id: e
            }
          }
        }
      }
    }))(K).then(
      (Y) => A({
        channel: K,
        mutationResponse: Y,
        isSubscriptionRequest: !0
      })
    ).catch(
      (Y) => A({
        channel: K,
        mutationErrorResponse: Y,
        isSubscriptionRequest: !0
      })
    );
  }, F = (K) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: K }), C.setAll({
      channel: K,
      request: "unsubscribed"
    }), E({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: Hu.Profile,
                attributes: {
                  ...K === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...K === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...K === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: Ku.Unsubscribed
                        }
                      }
                    },
                    ...K === "SMS" && {
                      sms: {
                        marketing: {
                          consent: Ku.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (Y) => A({
        channel: K,
        mutationResponse: Y,
        isSubscriptionRequest: !1
      })
    ).catch(
      (Y) => A({
        channel: K,
        mutationErrorResponse: Y,
        isSubscriptionRequest: !1
      })
    );
  }, A = async ({
    channel: K,
    mutationResponse: Y,
    mutationErrorResponse: ie,
    isSubscriptionRequest: G
  }) => {
    const B = ie?.networkError, O = B ? B?.statusCode : NaN, z = Y?.errors, Z = !!z && tb({
      errors: z
    });
    O === 202 ? (h(
      G ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: K }
    ), await o()) : Z ? (h(
      G ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: K,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${G ? "opt-in" : "opt-out"}.`
    )) : (h(
      G ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: K,
        reason: B?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${G ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return qe(() => {
    if (v.request === "subscribed") {
      const K = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(K), C.reset()), v.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(K), C.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ we.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ we.jsx(D.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(
            Hg,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: _,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: j,
              handleAction: () => {
                l(!0), f(void 0), _ ? F("EMAIL") : I("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ we.jsx(
            Hg,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: S,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: j,
              handleAction: () => {
                m(!0), f(void 0), S ? F("SMS") : I("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ we.jsx(b, { className: JT.subscriptionError, children: u })
      ] })
    }
  );
}, ZT = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: d,
  subscriptionListId: m
}) => {
  const {
    profile: u,
    error: f,
    isLoading: h,
    refetchProfile: v
  } = vT({ profileId: e });
  return f ? /* @__PURE__ */ we.jsx(As, { error: f }) : h ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ we.jsx(ln, {}) }) : !u && !h ? /* @__PURE__ */ we.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: sp.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ we.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ we.jsx(D.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ we.jsxs(Ge, { className: Rr.list, children: [
        i && /* @__PURE__ */ we.jsx(Bg, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ we.jsx(
          Bg,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ we.jsx(
      XT,
      {
        profile: u,
        profileId: e,
        subscriptionListId: m,
        refetchProfile: v,
        email: n,
        phoneNumber: r
      }
    ),
    u && l && /* @__PURE__ */ we.jsx(KT, { profile: u }),
    u && s && /* @__PURE__ */ we.jsx(zT, { profile: u }),
    /* @__PURE__ */ we.jsx(
      AT,
      {
        profileId: e,
        noOfMessagesToShow: d
      }
    )
  ] });
}, e$ = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, d = n?.showPredictiveAnalytics, m = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: v,
    error: C
  } = kT({ email: r, phoneNumber: i });
  return _S(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : v ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ we.jsx(ln, {}) }) : C ? /* @__PURE__ */ we.jsx(As, { error: C }) : f ? /* @__PURE__ */ we.jsx(
    ZT,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: d,
      noOfMessagesToShow: m,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ we.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: sp.notificationText,
      children: "No profile ID found"
    }
  );
}, n$ = [
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    label: "Show custom properties for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    label: "Show predictive analytics for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: sS
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
], t$ = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Hi
  }
], r$ = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
];
function i$(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const a$ = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, o$ = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, s$ = {};
function Wg(e, n) {
  return (s$.jsx ? o$ : a$).test(e);
}
const l$ = /[ \t\n\f\r]/g;
function c$(e) {
  return typeof e == "object" ? e.type === "text" ? Kg(e.value) : !1 : Kg(e);
}
function Kg(e) {
  return e.replace(l$, "") === "";
}
class so {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
so.prototype.property = {};
so.prototype.normal = {};
so.prototype.space = null;
function Rx(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new so(r, i, n);
}
function Yu(e) {
  return e.toLowerCase();
}
class or {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
or.prototype.space = null;
or.prototype.boolean = !1;
or.prototype.booleanish = !1;
or.prototype.overloadedBoolean = !1;
or.prototype.number = !1;
or.prototype.commaSeparated = !1;
or.prototype.spaceSeparated = !1;
or.prototype.commaOrSpaceSeparated = !1;
or.prototype.mustUseProperty = !1;
or.prototype.defined = !1;
let d$ = 0;
const In = bi(), pt = bi(), Ox = bi(), ze = bi(), Xn = bi(), Li = bi(), Gt = bi();
function bi() {
  return 2 ** ++d$;
}
const Qu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: In,
  booleanish: pt,
  commaOrSpaceSeparated: Gt,
  commaSeparated: Li,
  number: ze,
  overloadedBoolean: Ox,
  spaceSeparated: Xn
}, Symbol.toStringTag, { value: "Module" })), qd = Object.keys(Qu);
class lp extends or {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), Gg(this, "space", a), typeof i == "number")
      for (; ++o < qd.length; ) {
        const s = qd[o];
        Gg(this, qd[o], (i & Qu[s]) === Qu[s]);
      }
  }
}
lp.prototype.defined = !0;
function Gg(e, n, r) {
  r && (e[n] = r);
}
const u$ = {}.hasOwnProperty;
function Xi(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (u$.call(e.properties, i)) {
      const a = e.properties[i], o = new lp(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[Yu(i)] = i, r[Yu(o.attribute)] = i;
    }
  return new so(n, r, e.space);
}
const Px = Xi({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Ax = Xi({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function Lx(e, n) {
  return n in e ? e[n] : n;
}
function Vx(e, n) {
  return Lx(e, n.toLowerCase());
}
const zx = Xi({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: Vx,
  properties: { xmlns: null, xmlnsXLink: null }
}), Ux = Xi({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: pt,
    ariaAutoComplete: null,
    ariaBusy: pt,
    ariaChecked: pt,
    ariaColCount: ze,
    ariaColIndex: ze,
    ariaColSpan: ze,
    ariaControls: Xn,
    ariaCurrent: null,
    ariaDescribedBy: Xn,
    ariaDetails: null,
    ariaDisabled: pt,
    ariaDropEffect: Xn,
    ariaErrorMessage: null,
    ariaExpanded: pt,
    ariaFlowTo: Xn,
    ariaGrabbed: pt,
    ariaHasPopup: null,
    ariaHidden: pt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Xn,
    ariaLevel: ze,
    ariaLive: null,
    ariaModal: pt,
    ariaMultiLine: pt,
    ariaMultiSelectable: pt,
    ariaOrientation: null,
    ariaOwns: Xn,
    ariaPlaceholder: null,
    ariaPosInSet: ze,
    ariaPressed: pt,
    ariaReadOnly: pt,
    ariaRelevant: null,
    ariaRequired: pt,
    ariaRoleDescription: Xn,
    ariaRowCount: ze,
    ariaRowIndex: ze,
    ariaRowSpan: ze,
    ariaSelected: pt,
    ariaSetSize: ze,
    ariaSort: null,
    ariaValueMax: ze,
    ariaValueMin: ze,
    ariaValueNow: ze,
    ariaValueText: null,
    role: null
  }
}), m$ = Xi({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: Vx,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Li,
    acceptCharset: Xn,
    accessKey: Xn,
    action: null,
    allow: null,
    allowFullScreen: In,
    allowPaymentRequest: In,
    allowUserMedia: In,
    alt: null,
    as: null,
    async: In,
    autoCapitalize: null,
    autoComplete: Xn,
    autoFocus: In,
    autoPlay: In,
    blocking: Xn,
    capture: null,
    charSet: null,
    checked: In,
    cite: null,
    className: Xn,
    cols: ze,
    colSpan: null,
    content: null,
    contentEditable: pt,
    controls: In,
    controlsList: Xn,
    coords: ze | Li,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: In,
    defer: In,
    dir: null,
    dirName: null,
    disabled: In,
    download: Ox,
    draggable: pt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: In,
    formTarget: null,
    headers: Xn,
    height: ze,
    hidden: In,
    high: ze,
    href: null,
    hrefLang: null,
    htmlFor: Xn,
    httpEquiv: Xn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: In,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: In,
    itemId: null,
    itemProp: Xn,
    itemRef: Xn,
    itemScope: In,
    itemType: Xn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: In,
    low: ze,
    manifest: null,
    max: null,
    maxLength: ze,
    media: null,
    method: null,
    min: null,
    minLength: ze,
    multiple: In,
    muted: In,
    name: null,
    nonce: null,
    noModule: In,
    noValidate: In,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: In,
    optimum: ze,
    pattern: null,
    ping: Xn,
    placeholder: null,
    playsInline: In,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: In,
    referrerPolicy: null,
    rel: Xn,
    required: In,
    reversed: In,
    rows: ze,
    rowSpan: ze,
    sandbox: Xn,
    scope: null,
    scoped: In,
    seamless: In,
    selected: In,
    shadowRootClonable: In,
    shadowRootDelegatesFocus: In,
    shadowRootMode: null,
    shape: null,
    size: ze,
    sizes: null,
    slot: null,
    span: ze,
    spellCheck: pt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: ze,
    step: null,
    style: null,
    tabIndex: ze,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: In,
    useMap: null,
    value: pt,
    width: ze,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Xn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: ze,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: ze,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: In,
    // Lists. Use CSS to reduce space between items instead
    declare: In,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: ze,
    // `<img>` and `<object>`
    leftMargin: ze,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: ze,
    // `<body>`
    marginWidth: ze,
    // `<body>`
    noResize: In,
    // `<frame>`
    noHref: In,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: In,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: In,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: ze,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: pt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: ze,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: ze,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: In,
    disableRemotePlayback: In,
    prefix: null,
    property: null,
    results: ze,
    security: null,
    unselectable: null
  }
}), p$ = Xi({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: Lx,
  properties: {
    about: Gt,
    accentHeight: ze,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: ze,
    amplitude: ze,
    arabicForm: null,
    ascent: ze,
    attributeName: null,
    attributeType: null,
    azimuth: ze,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: ze,
    by: null,
    calcMode: null,
    capHeight: ze,
    className: Xn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: ze,
    diffuseConstant: ze,
    direction: null,
    display: null,
    dur: null,
    divisor: ze,
    dominantBaseline: null,
    download: In,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: ze,
    enableBackground: null,
    end: null,
    event: null,
    exponent: ze,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: ze,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Li,
    g2: Li,
    glyphName: Li,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: ze,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: ze,
    horizOriginX: ze,
    horizOriginY: ze,
    id: null,
    ideographic: ze,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: ze,
    k: ze,
    k1: ze,
    k2: ze,
    k3: ze,
    k4: ze,
    kernelMatrix: Gt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: ze,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: ze,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: ze,
    overlineThickness: ze,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: ze,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Xn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: ze,
    pointsAtY: ze,
    pointsAtZ: ze,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Gt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Gt,
    rev: Gt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Gt,
    requiredFeatures: Gt,
    requiredFonts: Gt,
    requiredFormats: Gt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: ze,
    specularExponent: ze,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: ze,
    strikethroughThickness: ze,
    string: null,
    stroke: null,
    strokeDashArray: Gt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: ze,
    strokeOpacity: ze,
    strokeWidth: null,
    style: null,
    surfaceScale: ze,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Gt,
    tabIndex: ze,
    tableValues: null,
    target: null,
    targetX: ze,
    targetY: ze,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Gt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: ze,
    underlineThickness: ze,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: ze,
    values: null,
    vAlphabetic: ze,
    vMathematical: ze,
    vectorEffect: null,
    vHanging: ze,
    vIdeographic: ze,
    version: null,
    vertAdvY: ze,
    vertOriginX: ze,
    vertOriginY: ze,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: ze,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), f$ = /^data[-\w.:]+$/i, Yg = /-[a-z]/g, h$ = /[A-Z]/g;
function y$(e, n) {
  const r = Yu(n);
  let i = n, a = or;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && f$.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(Yg, v$);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!Yg.test(o)) {
        let s = o.replace(h$, g$);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = lp;
  }
  return new a(i, n);
}
function g$(e) {
  return "-" + e.toLowerCase();
}
function v$(e) {
  return e.charAt(1).toUpperCase();
}
const k$ = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, b$ = Rx([Ax, Px, zx, Ux, m$], "html"), cp = Rx([Ax, Px, zx, Ux, p$], "svg");
function x$(e) {
  return e.join(" ").trim();
}
var Ni = {}, Hd, Qg;
function _$() {
  if (Qg) return Hd;
  Qg = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", v = "declaration";
  Hd = function(_, S) {
    if (typeof _ != "string")
      throw new TypeError("First argument must be a string");
    if (!_) return [];
    S = S || {};
    var j = 1, k = 1;
    function L(O) {
      var z = O.match(n);
      z && (j += z.length);
      var Z = O.lastIndexOf(d);
      k = ~Z ? O.length - Z : k + O.length;
    }
    function E() {
      var O = { line: j, column: k };
      return function(z) {
        return z.position = new I(O), K(), z;
      };
    }
    function I(O) {
      this.start = O, this.end = { line: j, column: k }, this.source = S.source;
    }
    I.prototype.content = _;
    function F(O) {
      var z = new Error(
        S.source + ":" + j + ":" + k + ": " + O
      );
      if (z.reason = O, z.filename = S.source, z.line = j, z.column = k, z.source = _, !S.silent) throw z;
    }
    function A(O) {
      var z = O.exec(_);
      if (z) {
        var Z = z[0];
        return L(Z), _ = _.slice(Z.length), z;
      }
    }
    function K() {
      A(r);
    }
    function Y(O) {
      var z;
      for (O = O || []; z = ie(); )
        z !== !1 && O.push(z);
      return O;
    }
    function ie() {
      var O = E();
      if (!(m != _.charAt(0) || u != _.charAt(1))) {
        for (var z = 2; f != _.charAt(z) && (u != _.charAt(z) || m != _.charAt(z + 1)); )
          ++z;
        if (z += 2, f === _.charAt(z - 1))
          return F("End of comment missing");
        var Z = _.slice(2, z - 2);
        return k += 2, L(Z), _ = _.slice(z), k += 2, O({
          type: h,
          comment: Z
        });
      }
    }
    function G() {
      var O = E(), z = A(i);
      if (z) {
        if (ie(), !A(a)) return F("property missing ':'");
        var Z = A(o), be = O({
          type: v,
          property: C(z[0].replace(e, f)),
          value: Z ? C(Z[0].replace(e, f)) : f
        });
        return A(s), be;
      }
    }
    function B() {
      var O = [];
      Y(O);
      for (var z; z = G(); )
        z !== !1 && (O.push(z), Y(O));
      return O;
    }
    return K(), B();
  };
  function C(_) {
    return _ ? _.replace(l, f) : f;
  }
  return Hd;
}
var Jg;
function S$() {
  if (Jg) return Ni;
  Jg = 1;
  var e = Ni && Ni.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(Ni, "__esModule", { value: !0 }), Ni.default = r;
  var n = e(_$());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return Ni;
}
var N$ = S$();
const Xg = /* @__PURE__ */ wm(N$), j$ = Xg.default || Xg, Mx = Bx("end"), dp = Bx("start");
function Bx(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function w$(e) {
  const n = dp(e), r = Mx(e);
  if (n && r)
    return { start: n, end: r };
}
function Ua(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Zg(e.position) : "start" in e || "end" in e ? Zg(e) : "line" in e || "column" in e ? Ju(e) : "";
}
function Ju(e) {
  return ev(e && e.line) + ":" + ev(e && e.column);
}
function Zg(e) {
  return Ju(e && e.start) + "-" + Ju(e && e.end);
}
function ev(e) {
  return e && typeof e == "number" ? e : 1;
}
class $t extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = Ua(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
$t.prototype.file = "";
$t.prototype.name = "";
$t.prototype.reason = "";
$t.prototype.message = "";
$t.prototype.stack = "";
$t.prototype.column = void 0;
$t.prototype.line = void 0;
$t.prototype.ancestors = void 0;
$t.prototype.cause = void 0;
$t.prototype.fatal = void 0;
$t.prototype.place = void 0;
$t.prototype.ruleId = void 0;
$t.prototype.source = void 0;
const up = {}.hasOwnProperty, C$ = /* @__PURE__ */ new Map(), I$ = /[A-Z]/g, F$ = /-([a-z])/g, E$ = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), T$ = /* @__PURE__ */ new Set(["td", "th"]), qx = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function $$(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = z$(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = V$(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? cp : b$,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = Hx(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function Hx(e, n, r) {
  if (n.type === "element")
    return D$(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return R$(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return P$(e, n, r);
  if (n.type === "mdxjsEsm")
    return O$(e, n);
  if (n.type === "root")
    return A$(e, n, r);
  if (n.type === "text")
    return L$(e, n);
}
function D$(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = cp, e.schema = a), e.ancestors.push(n);
  const o = Kx(e, n.tagName, !1), s = U$(e, n);
  let l = pp(e, n);
  return E$.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !c$(d) : !0;
  })), Wx(e, s, o, n), mp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function R$(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Ja(e, n.position);
}
function O$(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Ja(e, n.position);
}
function P$(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = cp, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : Kx(e, n.name, !0), s = M$(e, n), l = pp(e, n);
  return Wx(e, s, o, n), mp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function A$(e, n, r) {
  const i = {};
  return mp(i, pp(e, n)), e.create(n, e.Fragment, i, r);
}
function L$(e, n) {
  return n.value;
}
function Wx(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function mp(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function V$(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function z$(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = dp(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function U$(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && up.call(n.properties, a)) {
      const o = B$(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && T$.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function M$(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Ja(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Ja(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function pp(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : C$;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = Hx(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function B$(e, n, r) {
  const i = y$(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? i$(r) : x$(r)), i.property === "style") {
      let a = typeof r == "object" ? r : q$(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = H$(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? k$[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function q$(e, n) {
  const r = {};
  try {
    j$(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new $t("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = qx + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(F$, K$)), r[s] = o;
  }
}
function Kx(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = Wg(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = Wg(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return up.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Ja(e);
}
function Ja(e, n) {
  const r = new $t(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = qx + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function H$(e) {
  const n = {};
  let r;
  for (r in e)
    up.call(e, r) && (n[W$(r)] = e[r]);
  return n;
}
function W$(e) {
  let n = e.replace(I$, G$);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function K$(e, n) {
  return n.toUpperCase();
}
function G$(e) {
  return "-" + e.toLowerCase();
}
const Wd = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, Y$ = {};
function Q$(e, n) {
  const r = Y$, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return Gx(e, i, a);
}
function Gx(e, n, r) {
  if (J$(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return nv(e.children, n, r);
  }
  return Array.isArray(e) ? nv(e, n, r) : "";
}
function nv(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = Gx(e[a], n, r);
  return i.join("");
}
function J$(e) {
  return !!(e && typeof e == "object");
}
const tv = document.createElement("i");
function fp(e) {
  const n = "&" + e + ";";
  tv.innerHTML = n;
  const r = tv.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function jr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function tr(e, n) {
  return e.length > 0 ? (jr(e, e.length, 0, n), e) : n;
}
const rv = {}.hasOwnProperty;
function X$(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    Z$(n, e[r]);
  return n;
}
function Z$(e, n) {
  let r;
  for (r in n) {
    const a = (rv.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        rv.call(a, s) || (a[s] = []);
        const l = o[s];
        eD(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function eD(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  jr(e, 0, 0, i);
}
function Yx(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function Vi(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const br = Xr(/[A-Za-z]/), Xt = Xr(/[\dA-Za-z]/), nD = Xr(/[#-'*+\--9=?A-Z^-~]/);
function Xu(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Zu = Xr(/\d/), tD = Xr(/[\dA-Fa-f]/), rD = Xr(/[!-/:-@[-`{-~]/);
function kn(e) {
  return e !== null && e < -2;
}
function Ht(e) {
  return e !== null && (e < 0 || e === 32);
}
function zn(e) {
  return e === -2 || e === -1 || e === 32;
}
const iD = Xr(new RegExp("\\p{P}|\\p{S}", "u")), aD = Xr(/\s/);
function Xr(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Zi(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && Xt(e.charCodeAt(r + 1)) && Xt(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function et(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return zn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return zn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const oD = {
  tokenize: sD
};
function sD(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return kn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const lD = {
  tokenize: cD
}, iv = {
  tokenize: dD
};
function cD(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(L) {
    if (i < r.length) {
      const E = r[i];
      return n.containerState = E[1], e.attempt(E[0].continuation, d, m)(L);
    }
    return m(L);
  }
  function d(L) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && k();
      const E = n.events.length;
      let I = E, F;
      for (; I--; )
        if (n.events[I][0] === "exit" && n.events[I][1].type === "chunkFlow") {
          F = n.events[I][1].end;
          break;
        }
      j(i);
      let A = E;
      for (; A < n.events.length; )
        n.events[A][1].end = {
          ...F
        }, A++;
      return jr(n.events, I + 1, 0, n.events.slice(E)), n.events.length = A, m(L);
    }
    return l(L);
  }
  function m(L) {
    if (i === r.length) {
      if (!a)
        return h(L);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return C(L);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(iv, u, f)(L);
  }
  function u(L) {
    return a && k(), j(i), h(L);
  }
  function f(L) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, C(L);
  }
  function h(L) {
    return n.containerState = {}, e.attempt(iv, v, C)(L);
  }
  function v(L) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(L);
  }
  function C(L) {
    if (L === null) {
      a && k(), j(0), e.consume(L);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), _(L);
  }
  function _(L) {
    if (L === null) {
      S(e.exit("chunkFlow"), !0), j(0), e.consume(L);
      return;
    }
    return kn(L) ? (e.consume(L), S(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(L), _);
  }
  function S(L, E) {
    const I = n.sliceStream(L);
    if (E && I.push(null), L.previous = o, o && (o.next = L), o = L, a.defineSkip(L.start), a.write(I), n.parser.lazy[L.start.line]) {
      let F = a.events.length;
      for (; F--; )
        if (
          // The token starts before the line ending…
          a.events[F][1].start.offset < s && // …and either is not ended yet…
          (!a.events[F][1].end || // …or ends after it.
          a.events[F][1].end.offset > s)
        )
          return;
      const A = n.events.length;
      let K = A, Y, ie;
      for (; K--; )
        if (n.events[K][0] === "exit" && n.events[K][1].type === "chunkFlow") {
          if (Y) {
            ie = n.events[K][1].end;
            break;
          }
          Y = !0;
        }
      for (j(i), F = A; F < n.events.length; )
        n.events[F][1].end = {
          ...ie
        }, F++;
      jr(n.events, K + 1, 0, n.events.slice(A)), n.events.length = F;
    }
  }
  function j(L) {
    let E = r.length;
    for (; E-- > L; ) {
      const I = r[E];
      n.containerState = I[1], I[0].exit.call(n, e);
    }
    r.length = L;
  }
  function k() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function dD(e, n, r) {
  return et(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function av(e) {
  if (e === null || Ht(e) || aD(e))
    return 1;
  if (iD(e))
    return 2;
}
function hp(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const em = {
  name: "attention",
  resolveAll: uD,
  tokenize: mD
};
function uD(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          ov(f, -d), ov(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = tr(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = tr(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = tr(m, hp(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = tr(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = tr(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, jr(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function mD(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = av(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = av(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function ov(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const pD = {
  name: "autolink",
  tokenize: fD
};
function fD(e, n, r) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return br(v) ? (e.consume(v), s) : v === 64 ? r(v) : m(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || Xt(v) ? (i = 1, l(v)) : m(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, d) : (v === 43 || v === 45 || v === 46 || Xt(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, m(v));
  }
  function d(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || Xu(v) ? r(v) : (e.consume(v), d);
  }
  function m(v) {
    return v === 64 ? (e.consume(v), u) : nD(v) ? (e.consume(v), m) : r(v);
  }
  function u(v) {
    return Xt(v) ? f(v) : r(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, u) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || Xt(v)) && i++ < 63) {
      const C = v === 45 ? h : f;
      return e.consume(v), C;
    }
    return r(v);
  }
}
const Ls = {
  partial: !0,
  tokenize: hD
};
function hD(e, n, r) {
  return i;
  function i(o) {
    return zn(o) ? et(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || kn(o) ? n(o) : r(o);
  }
}
const Qx = {
  continuation: {
    tokenize: gD
  },
  exit: vD,
  name: "blockQuote",
  tokenize: yD
};
function yD(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return zn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function gD(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return zn(s) ? et(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(Qx, n, r)(s);
  }
}
function vD(e) {
  e.exit("blockQuote");
}
const Jx = {
  name: "characterEscape",
  tokenize: kD
};
function kD(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return rD(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const Xx = {
  name: "characterReference",
  tokenize: bD
};
function bD(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = Xt, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = tD, u) : (e.enter("characterReferenceValue"), o = 7, s = Zu, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === Xt && !fp(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const sv = {
  partial: !0,
  tokenize: _D
}, lv = {
  concrete: !0,
  name: "codeFenced",
  tokenize: xD
};
function xD(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: I
  };
  let o = 0, s = 0, l;
  return d;
  function d(F) {
    return m(F);
  }
  function m(F) {
    const A = i.events[i.events.length - 1];
    return o = A && A[1].type === "linePrefix" ? A[2].sliceSerialize(A[1], !0).length : 0, l = F, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(F);
  }
  function u(F) {
    return F === l ? (s++, e.consume(F), u) : s < 3 ? r(F) : (e.exit("codeFencedFenceSequence"), zn(F) ? et(e, f, "whitespace")(F) : f(F));
  }
  function f(F) {
    return F === null || kn(F) ? (e.exit("codeFencedFence"), i.interrupt ? n(F) : e.check(sv, _, E)(F)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(F));
  }
  function h(F) {
    return F === null || kn(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(F)) : zn(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), et(e, v, "whitespace")(F)) : F === 96 && F === l ? r(F) : (e.consume(F), h);
  }
  function v(F) {
    return F === null || kn(F) ? f(F) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), C(F));
  }
  function C(F) {
    return F === null || kn(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(F)) : F === 96 && F === l ? r(F) : (e.consume(F), C);
  }
  function _(F) {
    return e.attempt(a, E, S)(F);
  }
  function S(F) {
    return e.enter("lineEnding"), e.consume(F), e.exit("lineEnding"), j;
  }
  function j(F) {
    return o > 0 && zn(F) ? et(e, k, "linePrefix", o + 1)(F) : k(F);
  }
  function k(F) {
    return F === null || kn(F) ? e.check(sv, _, E)(F) : (e.enter("codeFlowValue"), L(F));
  }
  function L(F) {
    return F === null || kn(F) ? (e.exit("codeFlowValue"), k(F)) : (e.consume(F), L);
  }
  function E(F) {
    return e.exit("codeFenced"), n(F);
  }
  function I(F, A, K) {
    let Y = 0;
    return ie;
    function ie(Z) {
      return F.enter("lineEnding"), F.consume(Z), F.exit("lineEnding"), G;
    }
    function G(Z) {
      return F.enter("codeFencedFence"), zn(Z) ? et(F, B, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(Z) : B(Z);
    }
    function B(Z) {
      return Z === l ? (F.enter("codeFencedFenceSequence"), O(Z)) : K(Z);
    }
    function O(Z) {
      return Z === l ? (Y++, F.consume(Z), O) : Y >= s ? (F.exit("codeFencedFenceSequence"), zn(Z) ? et(F, z, "whitespace")(Z) : z(Z)) : K(Z);
    }
    function z(Z) {
      return Z === null || kn(Z) ? (F.exit("codeFencedFence"), A(Z)) : K(Z);
    }
  }
}
function _D(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const Kd = {
  name: "codeIndented",
  tokenize: ND
}, SD = {
  partial: !0,
  tokenize: jD
};
function ND(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), et(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : kn(m) ? e.attempt(SD, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || kn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function jD(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : kn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : et(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : kn(s) ? a(s) : r(s);
  }
}
const wD = {
  name: "codeText",
  previous: ID,
  resolve: CD,
  tokenize: FD
};
function CD(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function ID(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function FD(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : kn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || kn(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class ED {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && ha(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), ha(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), ha(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        ha(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        ha(this.left, r.reverse());
      }
  }
}
function ha(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function Zx(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new ED(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, TD(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return jr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function TD(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, v = r, C = 0, _ = 0;
  const S = [_];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (u = i.sliceStream(v), v.next || u.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (_ = h + 1, S.push(_), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : S.pop(), h = S.length; h--; ) {
    const j = l.slice(S[h], S[h + 1]), k = o.pop();
    d.push([k, k + j.length - 1]), e.splice(k, 2, j);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[C + d[h][0]] = C + d[h][1], C += d[h][1] - d[h][0] - 1;
  return m;
}
const $D = {
  resolve: RD,
  tokenize: OD
}, DD = {
  partial: !0,
  tokenize: PD
};
function RD(e) {
  return Zx(e), e;
}
function OD(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : kn(l) ? e.check(DD, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function PD(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), et(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || kn(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function e_(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(j) {
    return j === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(j), e.exit(o), h) : j === null || j === 32 || j === 41 || Xu(j) ? r(j) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), _(j));
  }
  function h(j) {
    return j === 62 ? (e.enter(o), e.consume(j), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(j));
  }
  function v(j) {
    return j === 62 ? (e.exit("chunkString"), e.exit(l), h(j)) : j === null || j === 60 || kn(j) ? r(j) : (e.consume(j), j === 92 ? C : v);
  }
  function C(j) {
    return j === 60 || j === 62 || j === 92 ? (e.consume(j), v) : v(j);
  }
  function _(j) {
    return !u && (j === null || j === 41 || Ht(j)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(j)) : u < m && j === 40 ? (e.consume(j), u++, _) : j === 41 ? (e.consume(j), u--, _) : j === null || j === 32 || j === 40 || Xu(j) ? r(j) : (e.consume(j), j === 92 ? S : _);
  }
  function S(j) {
    return j === 40 || j === 41 || j === 92 ? (e.consume(j), _) : _(j);
  }
}
function n_(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), u;
  }
  function u(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : kn(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || kn(v) || l++ > 999 ? (e.exit("chunkString"), u(v)) : (e.consume(v), d || (d = !zn(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function t_(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : kn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), et(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || kn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function Ma(e, n) {
  let r;
  return i;
  function i(a) {
    return kn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : zn(a) ? et(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const AD = {
  name: "definition",
  tokenize: VD
}, LD = {
  partial: !0,
  tokenize: zD
};
function VD(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return n_.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = Vi(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), d) : r(v);
  }
  function d(v) {
    return Ht(v) ? Ma(e, m)(v) : m(v);
  }
  function m(v) {
    return e_(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function u(v) {
    return e.attempt(LD, f, f)(v);
  }
  function f(v) {
    return zn(v) ? et(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || kn(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : r(v);
  }
}
function zD(e, n, r) {
  return i;
  function i(l) {
    return Ht(l) ? Ma(e, a)(l) : r(l);
  }
  function a(l) {
    return t_(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return zn(l) ? et(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || kn(l) ? n(l) : r(l);
  }
}
const UD = {
  name: "hardBreakEscape",
  tokenize: MD
};
function MD(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return kn(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const BD = {
  name: "headingAtx",
  resolve: qD,
  tokenize: HD
};
function qD(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, jr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function HD(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || Ht(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || kn(u) ? (e.exit("atxHeading"), n(u)) : zn(u) ? et(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || Ht(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const WD = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], cv = ["pre", "script", "style", "textarea"], KD = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: QD,
  tokenize: JD
}, GD = {
  partial: !0,
  tokenize: ZD
}, YD = {
  partial: !0,
  tokenize: XD
};
function QD(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function JD(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(H) {
    return u(H);
  }
  function u(H) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(H), f;
  }
  function f(H) {
    return H === 33 ? (e.consume(H), h) : H === 47 ? (e.consume(H), o = !0, _) : H === 63 ? (e.consume(H), a = 3, i.interrupt ? n : q) : br(H) ? (e.consume(H), s = String.fromCharCode(H), S) : r(H);
  }
  function h(H) {
    return H === 45 ? (e.consume(H), a = 2, v) : H === 91 ? (e.consume(H), a = 5, l = 0, C) : br(H) ? (e.consume(H), a = 4, i.interrupt ? n : q) : r(H);
  }
  function v(H) {
    return H === 45 ? (e.consume(H), i.interrupt ? n : q) : r(H);
  }
  function C(H) {
    const He = "CDATA[";
    return H === He.charCodeAt(l++) ? (e.consume(H), l === He.length ? i.interrupt ? n : B : C) : r(H);
  }
  function _(H) {
    return br(H) ? (e.consume(H), s = String.fromCharCode(H), S) : r(H);
  }
  function S(H) {
    if (H === null || H === 47 || H === 62 || Ht(H)) {
      const He = H === 47, Be = s.toLowerCase();
      return !He && !o && cv.includes(Be) ? (a = 1, i.interrupt ? n(H) : B(H)) : WD.includes(s.toLowerCase()) ? (a = 6, He ? (e.consume(H), j) : i.interrupt ? n(H) : B(H)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(H) : o ? k(H) : L(H));
    }
    return H === 45 || Xt(H) ? (e.consume(H), s += String.fromCharCode(H), S) : r(H);
  }
  function j(H) {
    return H === 62 ? (e.consume(H), i.interrupt ? n : B) : r(H);
  }
  function k(H) {
    return zn(H) ? (e.consume(H), k) : ie(H);
  }
  function L(H) {
    return H === 47 ? (e.consume(H), ie) : H === 58 || H === 95 || br(H) ? (e.consume(H), E) : zn(H) ? (e.consume(H), L) : ie(H);
  }
  function E(H) {
    return H === 45 || H === 46 || H === 58 || H === 95 || Xt(H) ? (e.consume(H), E) : I(H);
  }
  function I(H) {
    return H === 61 ? (e.consume(H), F) : zn(H) ? (e.consume(H), I) : L(H);
  }
  function F(H) {
    return H === null || H === 60 || H === 61 || H === 62 || H === 96 ? r(H) : H === 34 || H === 39 ? (e.consume(H), d = H, A) : zn(H) ? (e.consume(H), F) : K(H);
  }
  function A(H) {
    return H === d ? (e.consume(H), d = null, Y) : H === null || kn(H) ? r(H) : (e.consume(H), A);
  }
  function K(H) {
    return H === null || H === 34 || H === 39 || H === 47 || H === 60 || H === 61 || H === 62 || H === 96 || Ht(H) ? I(H) : (e.consume(H), K);
  }
  function Y(H) {
    return H === 47 || H === 62 || zn(H) ? L(H) : r(H);
  }
  function ie(H) {
    return H === 62 ? (e.consume(H), G) : r(H);
  }
  function G(H) {
    return H === null || kn(H) ? B(H) : zn(H) ? (e.consume(H), G) : r(H);
  }
  function B(H) {
    return H === 45 && a === 2 ? (e.consume(H), be) : H === 60 && a === 1 ? (e.consume(H), he) : H === 62 && a === 4 ? (e.consume(H), Se) : H === 63 && a === 3 ? (e.consume(H), q) : H === 93 && a === 5 ? (e.consume(H), ye) : kn(H) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(GD, Ce, O)(H)) : H === null || kn(H) ? (e.exit("htmlFlowData"), O(H)) : (e.consume(H), B);
  }
  function O(H) {
    return e.check(YD, z, Ce)(H);
  }
  function z(H) {
    return e.enter("lineEnding"), e.consume(H), e.exit("lineEnding"), Z;
  }
  function Z(H) {
    return H === null || kn(H) ? O(H) : (e.enter("htmlFlowData"), B(H));
  }
  function be(H) {
    return H === 45 ? (e.consume(H), q) : B(H);
  }
  function he(H) {
    return H === 47 ? (e.consume(H), s = "", de) : B(H);
  }
  function de(H) {
    if (H === 62) {
      const He = s.toLowerCase();
      return cv.includes(He) ? (e.consume(H), Se) : B(H);
    }
    return br(H) && s.length < 8 ? (e.consume(H), s += String.fromCharCode(H), de) : B(H);
  }
  function ye(H) {
    return H === 93 ? (e.consume(H), q) : B(H);
  }
  function q(H) {
    return H === 62 ? (e.consume(H), Se) : H === 45 && a === 2 ? (e.consume(H), q) : B(H);
  }
  function Se(H) {
    return H === null || kn(H) ? (e.exit("htmlFlowData"), Ce(H)) : (e.consume(H), Se);
  }
  function Ce(H) {
    return e.exit("htmlFlow"), n(H);
  }
}
function XD(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return kn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function ZD(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(Ls, n, r);
  }
}
const eR = {
  name: "htmlText",
  tokenize: nR
};
function nR(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(q) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(q), d;
  }
  function d(q) {
    return q === 33 ? (e.consume(q), m) : q === 47 ? (e.consume(q), I) : q === 63 ? (e.consume(q), L) : br(q) ? (e.consume(q), K) : r(q);
  }
  function m(q) {
    return q === 45 ? (e.consume(q), u) : q === 91 ? (e.consume(q), o = 0, C) : br(q) ? (e.consume(q), k) : r(q);
  }
  function u(q) {
    return q === 45 ? (e.consume(q), v) : r(q);
  }
  function f(q) {
    return q === null ? r(q) : q === 45 ? (e.consume(q), h) : kn(q) ? (s = f, he(q)) : (e.consume(q), f);
  }
  function h(q) {
    return q === 45 ? (e.consume(q), v) : f(q);
  }
  function v(q) {
    return q === 62 ? be(q) : q === 45 ? h(q) : f(q);
  }
  function C(q) {
    const Se = "CDATA[";
    return q === Se.charCodeAt(o++) ? (e.consume(q), o === Se.length ? _ : C) : r(q);
  }
  function _(q) {
    return q === null ? r(q) : q === 93 ? (e.consume(q), S) : kn(q) ? (s = _, he(q)) : (e.consume(q), _);
  }
  function S(q) {
    return q === 93 ? (e.consume(q), j) : _(q);
  }
  function j(q) {
    return q === 62 ? be(q) : q === 93 ? (e.consume(q), j) : _(q);
  }
  function k(q) {
    return q === null || q === 62 ? be(q) : kn(q) ? (s = k, he(q)) : (e.consume(q), k);
  }
  function L(q) {
    return q === null ? r(q) : q === 63 ? (e.consume(q), E) : kn(q) ? (s = L, he(q)) : (e.consume(q), L);
  }
  function E(q) {
    return q === 62 ? be(q) : L(q);
  }
  function I(q) {
    return br(q) ? (e.consume(q), F) : r(q);
  }
  function F(q) {
    return q === 45 || Xt(q) ? (e.consume(q), F) : A(q);
  }
  function A(q) {
    return kn(q) ? (s = A, he(q)) : zn(q) ? (e.consume(q), A) : be(q);
  }
  function K(q) {
    return q === 45 || Xt(q) ? (e.consume(q), K) : q === 47 || q === 62 || Ht(q) ? Y(q) : r(q);
  }
  function Y(q) {
    return q === 47 ? (e.consume(q), be) : q === 58 || q === 95 || br(q) ? (e.consume(q), ie) : kn(q) ? (s = Y, he(q)) : zn(q) ? (e.consume(q), Y) : be(q);
  }
  function ie(q) {
    return q === 45 || q === 46 || q === 58 || q === 95 || Xt(q) ? (e.consume(q), ie) : G(q);
  }
  function G(q) {
    return q === 61 ? (e.consume(q), B) : kn(q) ? (s = G, he(q)) : zn(q) ? (e.consume(q), G) : Y(q);
  }
  function B(q) {
    return q === null || q === 60 || q === 61 || q === 62 || q === 96 ? r(q) : q === 34 || q === 39 ? (e.consume(q), a = q, O) : kn(q) ? (s = B, he(q)) : zn(q) ? (e.consume(q), B) : (e.consume(q), z);
  }
  function O(q) {
    return q === a ? (e.consume(q), a = void 0, Z) : q === null ? r(q) : kn(q) ? (s = O, he(q)) : (e.consume(q), O);
  }
  function z(q) {
    return q === null || q === 34 || q === 39 || q === 60 || q === 61 || q === 96 ? r(q) : q === 47 || q === 62 || Ht(q) ? Y(q) : (e.consume(q), z);
  }
  function Z(q) {
    return q === 47 || q === 62 || Ht(q) ? Y(q) : r(q);
  }
  function be(q) {
    return q === 62 ? (e.consume(q), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(q);
  }
  function he(q) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(q), e.exit("lineEnding"), de;
  }
  function de(q) {
    return zn(q) ? et(e, ye, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(q) : ye(q);
  }
  function ye(q) {
    return e.enter("htmlTextData"), s(q);
  }
}
const yp = {
  name: "labelEnd",
  resolveAll: aR,
  resolveTo: oR,
  tokenize: sR
}, tR = {
  tokenize: lR
}, rR = {
  tokenize: cR
}, iR = {
  tokenize: dR
};
function aR(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && jr(e, 0, e.length, r), e;
}
function oR(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = tr(l, e.slice(o + 1, o + i + 3)), l = tr(l, [["enter", u, n]]), l = tr(l, hp(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = tr(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = tr(l, e.slice(s + 1)), l = tr(l, [["exit", d, n]]), jr(e, o, e.length, l), e;
}
function sR(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(Vi(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(tR, u, s ? u : f)(h) : h === 91 ? e.attempt(rR, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(iR, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function lR(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Ht(f) ? Ma(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : e_(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Ht(f) ? Ma(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? t_(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return Ht(f) ? Ma(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function cR(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return n_.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(Vi(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function dR(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const uR = {
  name: "labelStartImage",
  resolveAll: yp.resolveAll,
  tokenize: mR
};
function mR(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const pR = {
  name: "labelStartLink",
  resolveAll: yp.resolveAll,
  tokenize: fR
};
function fR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const Gd = {
  name: "lineEnding",
  tokenize: hR
};
function hR(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), et(e, n, "linePrefix");
  }
}
const Xo = {
  name: "thematicBreak",
  tokenize: yR
};
function yR(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || kn(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), zn(m) ? et(e, l, "whitespace")(m) : l(m));
  }
}
const Ut = {
  continuation: {
    tokenize: bR
  },
  exit: _R,
  name: "list",
  tokenize: kR
}, gR = {
  partial: !0,
  tokenize: SR
}, vR = {
  partial: !0,
  tokenize: xR
};
function kR(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const C = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (C === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : Zu(v)) {
      if (i.containerState.type || (i.containerState.type = C, e.enter(C, {
        _container: !0
      })), C === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check(Xo, r, m)(v) : m(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(v);
    }
    return r(v);
  }
  function d(v) {
    return Zu(v) && ++s < 10 ? (e.consume(v), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), m(v)) : r(v);
  }
  function m(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      Ls,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(gR, h, f)
    );
  }
  function u(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return zn(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : r(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function bR(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(Ls, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, et(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !zn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(vR, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, et(e, e.attempt(Ut, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function xR(e, n, r) {
  const i = this;
  return et(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function _R(e) {
  e.exit(this.containerState.type);
}
function SR(e, n, r) {
  const i = this;
  return et(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !zn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const dv = {
  name: "setextUnderline",
  resolveTo: NR,
  tokenize: jR
};
function NR(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function jR(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), zn(m) ? et(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || kn(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const wR = {
  tokenize: CR
};
function CR(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    Ls,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, et(e, e.attempt(this.parser.constructs.flow, a, e.attempt($D, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const IR = {
  resolveAll: i_()
}, FR = r_("string"), ER = r_("text");
function r_(e) {
  return {
    resolveAll: i_(e === "text" ? TR : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function i_(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function TR(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const $R = {
  42: Ut,
  43: Ut,
  45: Ut,
  48: Ut,
  49: Ut,
  50: Ut,
  51: Ut,
  52: Ut,
  53: Ut,
  54: Ut,
  55: Ut,
  56: Ut,
  57: Ut,
  62: Qx
}, DR = {
  91: AD
}, RR = {
  [-2]: Kd,
  [-1]: Kd,
  32: Kd
}, OR = {
  35: BD,
  42: Xo,
  45: [dv, Xo],
  60: KD,
  61: dv,
  95: Xo,
  96: lv,
  126: lv
}, PR = {
  38: Xx,
  92: Jx
}, AR = {
  [-5]: Gd,
  [-4]: Gd,
  [-3]: Gd,
  33: uR,
  38: Xx,
  42: em,
  60: [pD, eR],
  91: pR,
  92: [UD, Jx],
  93: yp,
  95: em,
  96: wD
}, LR = {
  null: [em, IR]
}, VR = {
  null: [42, 95]
}, zR = {
  null: []
}, UR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: VR,
  contentInitial: DR,
  disable: zR,
  document: $R,
  flow: OR,
  flowInitial: RR,
  insideSpan: LR,
  string: PR,
  text: AR
}, Symbol.toStringTag, { value: "Module" }));
function MR(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: A(I),
    check: A(F),
    consume: k,
    enter: L,
    exit: E,
    interrupt: A(F, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: _,
    events: [],
    now: C,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(G) {
    return s = tr(s, G), S(), s[s.length - 1] !== null ? [] : (K(n, 0), m.events = hp(o, m.events, m), m.events);
  }
  function h(G, B) {
    return qR(v(G), B);
  }
  function v(G) {
    return BR(s, G);
  }
  function C() {
    const {
      _bufferIndex: G,
      _index: B,
      line: O,
      column: z,
      offset: Z
    } = i;
    return {
      _bufferIndex: G,
      _index: B,
      line: O,
      column: z,
      offset: Z
    };
  }
  function _(G) {
    a[G.line] = G.column, ie();
  }
  function S() {
    let G;
    for (; i._index < s.length; ) {
      const B = s[i._index];
      if (typeof B == "string")
        for (G = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === G && i._bufferIndex < B.length; )
          j(B.charCodeAt(i._bufferIndex));
      else
        j(B);
    }
  }
  function j(G) {
    u = u(G);
  }
  function k(G) {
    kn(G) ? (i.line++, i.column = 1, i.offset += G === -3 ? 2 : 1, ie()) : G !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = G;
  }
  function L(G, B) {
    const O = B || {};
    return O.type = G, O.start = C(), m.events.push(["enter", O, m]), l.push(O), O;
  }
  function E(G) {
    const B = l.pop();
    return B.end = C(), m.events.push(["exit", B, m]), B;
  }
  function I(G, B) {
    K(G, B.from);
  }
  function F(G, B) {
    B.restore();
  }
  function A(G, B) {
    return O;
    function O(z, Z, be) {
      let he, de, ye, q;
      return Array.isArray(z) ? (
        /* c8 ignore next 1 */
        Ce(z)
      ) : "tokenize" in z ? (
        // Looks like a construct.
        Ce([
          /** @type {Construct} */
          z
        ])
      ) : Se(z);
      function Se(Re) {
        return Ue;
        function Ue(Te) {
          const Me = Te !== null && Re[Te], De = Te !== null && Re.null, on = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Me) ? Me : Me ? [Me] : [],
            ...Array.isArray(De) ? De : De ? [De] : []
          ];
          return Ce(on)(Te);
        }
      }
      function Ce(Re) {
        return he = Re, de = 0, Re.length === 0 ? be : H(Re[de]);
      }
      function H(Re) {
        return Ue;
        function Ue(Te) {
          return q = Y(), ye = Re, Re.partial || (m.currentConstruct = Re), Re.name && m.parser.constructs.disable.null.includes(Re.name) ? Be() : Re.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            B ? Object.assign(Object.create(m), B) : m,
            d,
            He,
            Be
          )(Te);
        }
      }
      function He(Re) {
        return G(ye, q), Z;
      }
      function Be(Re) {
        return q.restore(), ++de < he.length ? H(he[de]) : be;
      }
    }
  }
  function K(G, B) {
    G.resolveAll && !o.includes(G) && o.push(G), G.resolve && jr(m.events, B, m.events.length - B, G.resolve(m.events.slice(B), m)), G.resolveTo && (m.events = G.resolveTo(m.events, m));
  }
  function Y() {
    const G = C(), B = m.previous, O = m.currentConstruct, z = m.events.length, Z = Array.from(l);
    return {
      from: z,
      restore: be
    };
    function be() {
      i = G, m.previous = B, m.currentConstruct = O, m.events.length = z, l = Z, ie();
    }
  }
  function ie() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function BR(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function qR(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function HR(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      X$([UR, ...(e || {}).extensions || []])
    ),
    content: a(oD),
    defined: [],
    document: a(lD),
    flow: a(wR),
    lazy: {},
    string: a(FR),
    text: a(ER)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return MR(i, o, l);
    }
  }
}
function WR(e) {
  for (; !Zx(e); )
    ;
  return e;
}
const uv = /[\0\t\n\r]/g;
function KR() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (uv.lastIndex = f, m = uv.exec(o), h = m && m.index !== void 0 ? m.index : o.length, v = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const GR = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function YR(e) {
  return e.replace(GR, QR);
}
function QR(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return Yx(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return fp(r) || e;
}
const a_ = {}.hasOwnProperty;
function JR(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), XR(r)(WR(HR(r).document().write(KR()(e, n, !0))));
}
function XR(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Pe),
      autolinkProtocol: Y,
      autolinkEmail: Y,
      atxHeading: o(fe),
      blockQuote: o(De),
      characterEscape: Y,
      characterReference: Y,
      codeFenced: o(on),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(on, s),
      codeText: o(Fe, s),
      codeTextData: Y,
      data: Y,
      codeFlowValue: Y,
      definition: o(Ye),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Ze),
      hardBreakEscape: o(ge),
      hardBreakTrailing: o(ge),
      htmlFlow: o($e, s),
      htmlFlowData: Y,
      htmlText: o($e, s),
      htmlTextData: Y,
      image: o(Le),
      label: s,
      link: o(Pe),
      listItem: o(J),
      listItemValue: h,
      listOrdered: o(mn, f),
      listUnordered: o(mn),
      paragraph: o(T),
      reference: H,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(fe),
      strong: o(U),
      thematicBreak: o(re)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: I,
      autolink: d(),
      autolinkEmail: Me,
      autolinkProtocol: Te,
      blockQuote: d(),
      characterEscapeValue: ie,
      characterReferenceMarkerHexadecimal: Be,
      characterReferenceMarkerNumeric: Be,
      characterReferenceValue: Re,
      characterReference: Ue,
      codeFenced: d(S),
      codeFencedFence: _,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: C,
      codeFlowValue: ie,
      codeIndented: d(j),
      codeText: d(Z),
      codeTextData: ie,
      data: ie,
      definition: d(),
      definitionDestinationString: E,
      definitionLabelString: k,
      definitionTitleString: L,
      emphasis: d(),
      hardBreakEscape: d(B),
      hardBreakTrailing: d(B),
      htmlFlow: d(O),
      htmlFlowData: ie,
      htmlText: d(z),
      htmlTextData: ie,
      image: d(he),
      label: ye,
      labelText: de,
      lineEnding: G,
      link: d(be),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: He,
      resourceDestinationString: q,
      resourceTitleString: Se,
      resource: Ce,
      setextHeading: d(K),
      setextHeadingLineSequence: A,
      setextHeadingText: F,
      strong: d(),
      thematicBreak: d()
    }
  };
  o_(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(V) {
    let W = {
      type: "root",
      children: []
    };
    const le = {
      stack: [W],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, ke = [];
    let Ie = -1;
    for (; ++Ie < V.length; )
      if (V[Ie][1].type === "listOrdered" || V[Ie][1].type === "listUnordered")
        if (V[Ie][0] === "enter")
          ke.push(Ie);
        else {
          const en = ke.pop();
          Ie = a(V, en, Ie);
        }
    for (Ie = -1; ++Ie < V.length; ) {
      const en = n[V[Ie][0]];
      a_.call(en, V[Ie][1].type) && en[V[Ie][1].type].call(Object.assign({
        sliceSerialize: V[Ie][2].sliceSerialize
      }, le), V[Ie][1]);
    }
    if (le.tokenStack.length > 0) {
      const en = le.tokenStack[le.tokenStack.length - 1];
      (en[1] || mv).call(le, void 0, en[0]);
    }
    for (W.position = {
      start: Vr(V.length > 0 ? V[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Vr(V.length > 0 ? V[V.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Ie = -1; ++Ie < n.transforms.length; )
      W = n.transforms[Ie](W) || W;
    return W;
  }
  function a(V, W, le) {
    let ke = W - 1, Ie = -1, en = !1, hn, rn, cn, pn;
    for (; ++ke <= le; ) {
      const dn = V[ke];
      switch (dn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          dn[0] === "enter" ? Ie++ : Ie--, pn = void 0;
          break;
        }
        case "lineEndingBlank": {
          dn[0] === "enter" && (hn && !pn && !Ie && !cn && (cn = ke), pn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          pn = void 0;
      }
      if (!Ie && dn[0] === "enter" && dn[1].type === "listItemPrefix" || Ie === -1 && dn[0] === "exit" && (dn[1].type === "listUnordered" || dn[1].type === "listOrdered")) {
        if (hn) {
          let Sn = ke;
          for (rn = void 0; Sn--; ) {
            const Xe = V[Sn];
            if (Xe[1].type === "lineEnding" || Xe[1].type === "lineEndingBlank") {
              if (Xe[0] === "exit") continue;
              rn && (V[rn][1].type = "lineEndingBlank", en = !0), Xe[1].type = "lineEnding", rn = Sn;
            } else if (!(Xe[1].type === "linePrefix" || Xe[1].type === "blockQuotePrefix" || Xe[1].type === "blockQuotePrefixWhitespace" || Xe[1].type === "blockQuoteMarker" || Xe[1].type === "listItemIndent")) break;
          }
          cn && (!rn || cn < rn) && (hn._spread = !0), hn.end = Object.assign({}, rn ? V[rn][1].start : dn[1].end), V.splice(rn || ke, 0, ["exit", hn, dn[2]]), ke++, le++;
        }
        if (dn[1].type === "listItemPrefix") {
          const Sn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, dn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          hn = Sn, V.splice(ke, 0, ["enter", Sn, dn[2]]), ke++, le++, cn = void 0, pn = !0;
        }
      }
    }
    return V[W][1]._spread = en, le;
  }
  function o(V, W) {
    return le;
    function le(ke) {
      l.call(this, V(ke), ke), W && W.call(this, ke);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(V, W, le) {
    this.stack[this.stack.length - 1].children.push(V), this.stack.push(V), this.tokenStack.push([W, le || void 0]), V.position = {
      start: Vr(W.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(V) {
    return W;
    function W(le) {
      V && V.call(this, le), m.call(this, le);
    }
  }
  function m(V, W) {
    const le = this.stack.pop(), ke = this.tokenStack.pop();
    if (ke)
      ke[0].type !== V.type && (W ? W.call(this, V, ke[0]) : (ke[1] || mv).call(this, V, ke[0]));
    else throw new Error("Cannot close `" + V.type + "` (" + Ua({
      start: V.start,
      end: V.end
    }) + "): it’s not open");
    le.position.end = Vr(V.end);
  }
  function u() {
    return Q$(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(V) {
    if (this.data.expectingFirstListItemValue) {
      const W = this.stack[this.stack.length - 2];
      W.start = Number.parseInt(this.sliceSerialize(V), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const V = this.resume(), W = this.stack[this.stack.length - 1];
    W.lang = V;
  }
  function C() {
    const V = this.resume(), W = this.stack[this.stack.length - 1];
    W.meta = V;
  }
  function _() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function S() {
    const V = this.resume(), W = this.stack[this.stack.length - 1];
    W.value = V.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function j() {
    const V = this.resume(), W = this.stack[this.stack.length - 1];
    W.value = V.replace(/(\r?\n|\r)$/g, "");
  }
  function k(V) {
    const W = this.resume(), le = this.stack[this.stack.length - 1];
    le.label = W, le.identifier = Vi(this.sliceSerialize(V)).toLowerCase();
  }
  function L() {
    const V = this.resume(), W = this.stack[this.stack.length - 1];
    W.title = V;
  }
  function E() {
    const V = this.resume(), W = this.stack[this.stack.length - 1];
    W.url = V;
  }
  function I(V) {
    const W = this.stack[this.stack.length - 1];
    if (!W.depth) {
      const le = this.sliceSerialize(V).length;
      W.depth = le;
    }
  }
  function F() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function A(V) {
    const W = this.stack[this.stack.length - 1];
    W.depth = this.sliceSerialize(V).codePointAt(0) === 61 ? 1 : 2;
  }
  function K() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Y(V) {
    const le = this.stack[this.stack.length - 1].children;
    let ke = le[le.length - 1];
    (!ke || ke.type !== "text") && (ke = X(), ke.position = {
      start: Vr(V.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, le.push(ke)), this.stack.push(ke);
  }
  function ie(V) {
    const W = this.stack.pop();
    W.value += this.sliceSerialize(V), W.position.end = Vr(V.end);
  }
  function G(V) {
    const W = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const le = W.children[W.children.length - 1];
      le.position.end = Vr(V.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(W.type) && (Y.call(this, V), ie.call(this, V));
  }
  function B() {
    this.data.atHardBreak = !0;
  }
  function O() {
    const V = this.resume(), W = this.stack[this.stack.length - 1];
    W.value = V;
  }
  function z() {
    const V = this.resume(), W = this.stack[this.stack.length - 1];
    W.value = V;
  }
  function Z() {
    const V = this.resume(), W = this.stack[this.stack.length - 1];
    W.value = V;
  }
  function be() {
    const V = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const W = this.data.referenceType || "shortcut";
      V.type += "Reference", V.referenceType = W, delete V.url, delete V.title;
    } else
      delete V.identifier, delete V.label;
    this.data.referenceType = void 0;
  }
  function he() {
    const V = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const W = this.data.referenceType || "shortcut";
      V.type += "Reference", V.referenceType = W, delete V.url, delete V.title;
    } else
      delete V.identifier, delete V.label;
    this.data.referenceType = void 0;
  }
  function de(V) {
    const W = this.sliceSerialize(V), le = this.stack[this.stack.length - 2];
    le.label = YR(W), le.identifier = Vi(W).toLowerCase();
  }
  function ye() {
    const V = this.stack[this.stack.length - 1], W = this.resume(), le = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, le.type === "link") {
      const ke = V.children;
      le.children = ke;
    } else
      le.alt = W;
  }
  function q() {
    const V = this.resume(), W = this.stack[this.stack.length - 1];
    W.url = V;
  }
  function Se() {
    const V = this.resume(), W = this.stack[this.stack.length - 1];
    W.title = V;
  }
  function Ce() {
    this.data.inReference = void 0;
  }
  function H() {
    this.data.referenceType = "collapsed";
  }
  function He(V) {
    const W = this.resume(), le = this.stack[this.stack.length - 1];
    le.label = W, le.identifier = Vi(this.sliceSerialize(V)).toLowerCase(), this.data.referenceType = "full";
  }
  function Be(V) {
    this.data.characterReferenceType = V.type;
  }
  function Re(V) {
    const W = this.sliceSerialize(V), le = this.data.characterReferenceType;
    let ke;
    le ? (ke = Yx(W, le === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : ke = fp(W);
    const Ie = this.stack[this.stack.length - 1];
    Ie.value += ke;
  }
  function Ue(V) {
    const W = this.stack.pop();
    W.position.end = Vr(V.end);
  }
  function Te(V) {
    ie.call(this, V);
    const W = this.stack[this.stack.length - 1];
    W.url = this.sliceSerialize(V);
  }
  function Me(V) {
    ie.call(this, V);
    const W = this.stack[this.stack.length - 1];
    W.url = "mailto:" + this.sliceSerialize(V);
  }
  function De() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function on() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Fe() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ye() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ze() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function fe() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function ge() {
    return {
      type: "break"
    };
  }
  function $e() {
    return {
      type: "html",
      value: ""
    };
  }
  function Le() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Pe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function mn(V) {
    return {
      type: "list",
      ordered: V.type === "listOrdered",
      start: null,
      spread: V._spread,
      children: []
    };
  }
  function J(V) {
    return {
      type: "listItem",
      spread: V._spread,
      checked: null,
      children: []
    };
  }
  function T() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function U() {
    return {
      type: "strong",
      children: []
    };
  }
  function X() {
    return {
      type: "text",
      value: ""
    };
  }
  function re() {
    return {
      type: "thematicBreak"
    };
  }
}
function Vr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function o_(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? o_(e, i) : ZR(e, i);
  }
}
function ZR(e, n) {
  let r;
  for (r in n)
    if (a_.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function mv(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ua({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Ua({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Ua({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function eO(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return JR(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function nO(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function tO(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function rO(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function iO(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function aO(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function oO(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Zi(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function sO(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function lO(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function s_(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function cO(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return s_(e, n);
  const a = { src: Zi(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function dO(e, n) {
  const r = { src: Zi(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function uO(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function mO(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return s_(e, n);
  const a = { href: Zi(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function pO(e, n) {
  const r = { href: Zi(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function fO(e, n, r) {
  const i = e.all(n), a = r ? hO(r) : l_(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function hO(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = l_(r[i]);
  }
  return n;
}
function l_(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function yO(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function gO(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function vO(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function kO(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function bO(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = dp(n.children[1]), d = Mx(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function xO(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, v = s ? s[d] : void 0;
    v && (h.align = v);
    let C = { type: "element", tagName: o, properties: h, children: [] };
    f && (C.children = e.all(f), e.patch(f, C), C = e.applyData(f, C)), m.push(C);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function _O(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const pv = 9, fv = 32;
function SO(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      hv(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(hv(n.slice(a), a > 0, !1)), o.join("");
}
function hv(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === pv || o === fv; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === pv || o === fv; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function NO(e, n) {
  const r = { type: "text", value: SO(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function jO(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const wO = {
  blockquote: nO,
  break: tO,
  code: rO,
  delete: iO,
  emphasis: aO,
  footnoteReference: oO,
  heading: sO,
  html: lO,
  imageReference: cO,
  image: dO,
  inlineCode: uO,
  linkReference: mO,
  link: pO,
  listItem: fO,
  list: yO,
  paragraph: gO,
  // @ts-expect-error: root is different, but hard to type.
  root: vO,
  strong: kO,
  table: bO,
  tableCell: _O,
  tableRow: xO,
  text: NO,
  thematicBreak: jO,
  toml: _o,
  yaml: _o,
  definition: _o,
  footnoteDefinition: _o
};
function _o() {
}
const c_ = -1, Vs = 0, us = 1, ms = 2, gp = 3, vp = 4, kp = 5, bp = 6, d_ = 7, u_ = 8, yv = typeof self == "object" ? self : globalThis, CO = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Vs:
      case c_:
        return r(s, a);
      case us: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case ms: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case gp:
        return r(new Date(s), a);
      case vp: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case kp: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case bp: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case d_: {
        const { name: l, message: d } = s;
        return r(new yv[l](d), a);
      }
      case u_:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new yv[o](s), a);
  };
  return i;
}, gv = (e) => CO(/* @__PURE__ */ new Map(), e)(0), ji = "", { toString: IO } = {}, { keys: FO } = Object, ya = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Vs, n];
  const r = IO.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [us, ji];
    case "Object":
      return [ms, ji];
    case "Date":
      return [gp, ji];
    case "RegExp":
      return [vp, ji];
    case "Map":
      return [kp, ji];
    case "Set":
      return [bp, ji];
  }
  return r.includes("Array") ? [us, r] : r.includes("Error") ? [d_, r] : [ms, r];
}, So = ([e, n]) => e === Vs && (n === "function" || n === "symbol"), EO = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = ya(s);
    switch (l) {
      case Vs: {
        let u = s;
        switch (d) {
          case "bigint":
            l = u_, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([c_], s);
        }
        return a([l, u], s);
      }
      case us: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case ms: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of FO(s))
          (e || !So(ya(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case gp:
        return a([l, s.toISOString()], s);
      case vp: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case kp: {
        const u = [], f = a([l, u], s);
        for (const [h, v] of s)
          (e || !(So(ya(h)) || So(ya(v)))) && u.push([o(h), o(v)]);
        return f;
      }
      case bp: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !So(ya(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, vv = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return EO(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, ps = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? gv(vv(e, n)) : structuredClone(e)
) : (e, n) => gv(vv(e, n));
function TO(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function $O(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function DO(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || TO, i = e.options.footnoteBackLabel || $O, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = Zi(f.toLowerCase());
    let v = 0;
    const C = [], _ = e.footnoteCounts.get(f);
    for (; _ !== void 0 && ++v <= _; ) {
      C.length > 0 && C.push({ type: "text", value: " " });
      let k = typeof r == "string" ? r : r(d, v);
      typeof k == "string" && (k = { type: "text", value: k }), C.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(k) ? k : [k]
      });
    }
    const S = u[u.length - 1];
    if (S && S.type === "element" && S.tagName === "p") {
      const k = S.children[S.children.length - 1];
      k && k.type === "text" ? k.value += " " : S.children.push({ type: "text", value: " " }), S.children.push(...C);
    } else
      u.push(...C);
    const j = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, j), l.push(j);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...ps(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const m_ = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return AO;
    if (typeof e == "function")
      return zs(e);
    if (typeof e == "object")
      return Array.isArray(e) ? RO(e) : OO(e);
    if (typeof e == "string")
      return PO(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function RO(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = m_(e[r]);
  return zs(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function OO(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return zs(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function PO(e) {
  return zs(n);
  function n(r) {
    return r && r.type === e;
  }
}
function zs(e) {
  return n;
  function n(r, i, a) {
    return !!(LO(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function AO() {
  return !0;
}
function LO(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const p_ = [], VO = !0, kv = !1, zO = "skip";
function UO(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = m_(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = p_, C, _, S;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (v = MO(r(d, u)), v[0] === kv))
        return v;
      if ("children" in d && d.children) {
        const j = (
          /** @type {UnistParent} */
          d
        );
        if (j.children && v[0] !== zO)
          for (_ = (i ? j.children.length : -1) + s, S = u.concat(j); _ > -1 && _ < j.children.length; ) {
            const k = j.children[_];
            if (C = l(k, _, S)(), C[0] === kv)
              return C;
            _ = typeof C[1] == "number" ? C[1] : _ + s;
          }
      }
      return v;
    }
  }
}
function MO(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [VO, e] : e == null ? p_ : [e];
}
function f_(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), UO(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const nm = {}.hasOwnProperty, BO = {};
function qO(e, n) {
  const r = n || BO, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...wO, ...r.handlers }, l = {
    all: m,
    applyData: WO,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: HO,
    wrap: GO
  };
  return f_(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, v = l.handlers[h];
    if (nm.call(l.handlers, h) && v)
      return v(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: _, ...S } = u, j = ps(S);
        return j.children = l.all(u), j;
      }
      return ps(u);
    }
    return (l.options.unknownHandler || KO)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const C = l.one(h[v], u);
        if (C) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(C) && C.type === "text" && (C.value = bv(C.value)), !Array.isArray(C) && C.type === "element")) {
            const _ = C.children[0];
            _ && _.type === "text" && (_.value = bv(_.value));
          }
          Array.isArray(C) ? f.push(...C) : f.push(C);
        }
      }
    }
    return f;
  }
}
function HO(e, n) {
  e.position && (n.position = w$(e));
}
function WO(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, ps(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function KO(e, n) {
  const r = n.data || {}, i = "value" in n && !(nm.call(r, "hProperties") || nm.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function GO(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function bv(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function xv(e, n) {
  const r = qO(e, n), i = r.one(e, void 0), a = DO(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function YO(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      xv(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      xv(r, { file: i, ...e || n })
    );
  };
}
function _v(e) {
  if (e)
    throw e;
}
var Yd, Sv;
function QO() {
  if (Sv) return Yd;
  Sv = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return Yd = function d() {
    var m, u, f, h, v, C, _ = arguments[0], S = 1, j = arguments.length, k = !1;
    for (typeof _ == "boolean" && (k = _, _ = arguments[1] || {}, S = 2), (_ == null || typeof _ != "object" && typeof _ != "function") && (_ = {}); S < j; ++S)
      if (m = arguments[S], m != null)
        for (u in m)
          f = l(_, u), h = l(m, u), _ !== h && (k && h && (o(h) || (v = a(h))) ? (v ? (v = !1, C = f && a(f) ? f : []) : C = f && o(f) ? f : {}, s(_, { name: u, newValue: d(k, C, h) })) : typeof h < "u" && s(_, { name: u, newValue: h }));
    return _;
  }, Yd;
}
var JO = QO();
const Qd = /* @__PURE__ */ wm(JO);
function tm(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function XO() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? ZO(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function ZO(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const vr = { basename: eP, dirname: nP, extname: tP, join: rP, sep: "/" };
function eP(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  lo(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function nP(e) {
  if (lo(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function tP(e) {
  lo(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function rP(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    lo(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : iP(r);
}
function iP(e) {
  lo(e);
  const n = e.codePointAt(0) === 47;
  let r = aP(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function aP(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function lo(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const oP = { cwd: sP };
function sP() {
  return "/";
}
function rm(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function lP(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!rm(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return cP(e);
}
function cP(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const Jd = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class h_ {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? rm(n) ? r = { path: n } : typeof n == "string" || dP(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : oP.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < Jd.length; ) {
      const o = Jd[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      Jd.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? vr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Zd(n, "basename"), Xd(n, "basename"), this.path = vr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? vr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Nv(this.basename, "dirname"), this.path = vr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? vr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (Xd(n, "extname"), Nv(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = vr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    rm(n) && (n = lP(n)), Zd(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? vr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Zd(n, "stem"), Xd(n, "stem"), this.path = vr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new $t(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function Xd(e, n) {
  if (e && e.includes(vr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + vr.sep + "`"
    );
}
function Zd(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Nv(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function dP(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const uP = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), mP = {}.hasOwnProperty;
class xp extends uP {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = XO();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new xp()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(Qd(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (tu("data", this.frozen), this.namespace[n] = r, this) : mP.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (tu("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = No(n), i = this.parser || this.Parser;
    return eu("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), eu("process", this.parser || this.Parser), nu("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = No(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), C = i.stringify(v, h);
        hP(C) ? h.value = C : h.result = C, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), eu("processSync", this.parser || this.Parser), nu("processSync", this.compiler || this.Compiler), this.process(n, a), wv("processSync", "process", r), i;
    function a(o, s) {
      r = !0, _v(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    jv(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = No(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), wv("runSync", "run", i), a;
    function o(s, l) {
      _v(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = No(r), a = this.compiler || this.Compiler;
    return nu("stringify", a), jv(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (tu("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = Qd(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [v, ...C] = u;
        const _ = i[h][1];
        tm(_) && tm(v) && (v = Qd(!0, _, v)), i[h] = [m, v, ...C];
      }
    }
  }
}
const pP = new xp().freeze();
function eu(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function nu(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function tu(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function jv(e) {
  if (!tm(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function wv(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function No(e) {
  return fP(e) ? e : new h_(e);
}
function fP(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function hP(e) {
  return typeof e == "string" || yP(e);
}
function yP(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const gP = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Cv = [], Iv = { allowDangerousHtml: !0 }, vP = /^(https?|ircs?|mailto|xmpp)$/i, kP = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function bP(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || Cv, d = e.remarkPlugins || Cv, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Iv } : Iv, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || xP, v = pP().use(eO).use(d).use(YO, m).use(l), C = new h_();
  typeof i == "string" && (C.value = i);
  for (const k of kP)
    Object.hasOwn(e, k.from) && ("" + k.from + (k.to ? "use `" + k.to + "` instead" : "remove it") + gP + k.id, void 0);
  const _ = v.parse(C);
  let S = v.runSync(_, C);
  return a && (S = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      S.type === "root" ? S.children : [S]
    )
  }), f_(S, j), $$(S, {
    Fragment: Ve.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Ve.jsx,
    jsxs: Ve.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function j(k, L, E) {
    if (k.type === "raw" && E && typeof L == "number")
      return u ? E.children.splice(L, 1) : E.children[L] = { type: "text", value: k.value }, L;
    if (k.type === "element") {
      let I;
      for (I in Wd)
        if (Object.hasOwn(Wd, I) && Object.hasOwn(k.properties, I)) {
          const F = k.properties[I], A = Wd[I];
          (A === null || A.includes(k.tagName)) && (k.properties[I] = h(String(F || ""), I, k));
        }
    }
    if (k.type === "element") {
      let I = n ? !n.includes(k.tagName) : s ? s.includes(k.tagName) : !1;
      if (!I && r && typeof L == "number" && (I = !r(k, L, E)), I && E && typeof L == "number")
        return f && k.children ? E.children.splice(L, 1, ...k.children) : E.children.splice(L, 1), L;
    }
  }
}
function xP(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    vP.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ru = { exports: {} }, ga = {}, Fv;
function _P() {
  if (Fv) return ga;
  Fv = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ga.Fragment = r, ga.jsx = s, ga.jsxs = s, ga;
}
var jo = {}, Ev;
function SP() {
  return Ev || (Ev = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    jo.Fragment = i, jo.jsx = Rn, jo.jsxs = Mn;
  })()), jo;
}
var Tv;
function NP() {
  return Tv || (Tv = 1, process.env.NODE_ENV === "production" ? ru.exports = _P() : ru.exports = SP()), ru.exports;
}
var te = NP();
const jP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, wP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, CP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, IP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, FP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, EP = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": jP,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": wP,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": CP,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": IP,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": FP
};
function co(e) {
  return EP[e] ?? {};
}
const TP = co(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), $P = co(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), wo = ({
  title: e,
  children: n
}) => /* @__PURE__ */ te.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ te.jsx(D.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), DP = "_issueAvatar_kc0sw_1", RP = "_issueField_kc0sw_9", OP = "_issueDescription_kc0sw_12", Co = {
  issueAvatar: DP,
  issueField: RP,
  issueDescription: OP
}, y_ = ({ issue: e }) => /* @__PURE__ */ te.jsxs(te.Fragment, { children: [
  /* @__PURE__ */ te.jsx(wo, { title: "Assignee", children: /* @__PURE__ */ te.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: Co.issueAvatar,
      children: [
        /* @__PURE__ */ te.jsx(
          Nm,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ te.jsx(D.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ te.jsx(wo, { title: "Team", children: /* @__PURE__ */ te.jsx(
    D.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Co.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ te.jsx(wo, { title: "Project", children: /* @__PURE__ */ te.jsx(
    D.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Co.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ te.jsx(wo, { title: "Description", children: /* @__PURE__ */ te.jsx(bP, { className: Co.issueDescription, children: e.description }) })
] }), PP = /* @__PURE__ */ te.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ te.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ te.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ te.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), AP = /* @__PURE__ */ te.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ te.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ te.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ te.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), LP = /* @__PURE__ */ te.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ te.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ te.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ te.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), VP = /* @__PURE__ */ te.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ te.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ te.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ te.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), zP = /* @__PURE__ */ te.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ te.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), g_ = {
  0: PP,
  1: zP,
  2: VP,
  3: LP,
  4: AP
}, UP = (e) => e in g_, fs = ({ priority: e }) => UP(e) ? g_[e] : /* @__PURE__ */ te.jsx(An, { "data-testid": "defaultPriorityTag", children: e }), MP = (e, n) => /* @__PURE__ */ te.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ te.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), BP = (e, n) => /* @__PURE__ */ te.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ te.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ te.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), qP = (e, n) => /* @__PURE__ */ te.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ te.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ te.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), HP = (e, n) => /* @__PURE__ */ te.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ te.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), WP = (e, n) => /* @__PURE__ */ te.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ te.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), KP = (e, n) => /* @__PURE__ */ te.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ te.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), im = {
  backlog: (e, n) => MP(e, n),
  unstarted: (e, n) => BP(e, n),
  started: (e, n) => qP(e, n),
  done: (e, n) => HP(e, n),
  canceled: (e, n) => WP(e, n),
  completed: (e, n) => KP(e, n)
}, GP = (e) => e in im, hs = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => GP(e) ? im[e](n, r) : im.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), YP = "_wrapper_e0qj3_1", QP = "_resultTitle_e0qj3_21", JP = "_resultTooltipTitle_e0qj3_28", XP = "_resultLinkIcon_e0qj3_31", va = {
  wrapper: YP,
  resultTitle: QP,
  resultTooltipTitle: JP,
  resultLinkIcon: XP
}, ZP = ({
  issue: e
}) => {
  const [n, r] = se(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = _m(FS()), o = at(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ te.jsx(
    We,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ te.jsxs(b, { flexDirection: "column", gap: "300", className: va.wrapper, children: [
        /* @__PURE__ */ te.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ te.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ te.jsx(
              hs,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ te.jsx(D.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ te.jsx(fs, { priority: e.priority })
          ] }),
          /* @__PURE__ */ te.jsx(An, { children: e.state.name })
        ] }),
        /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ te.jsx(
            D.Heading,
            {
              variant: "heading-3",
              className: va.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ te.jsx(y_, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ te.jsx(
        lt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: va.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ te.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ te.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ te.jsx(
                    hs,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ te.jsx(D.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ te.jsx(fs, { priority: e.priority })
                ] }),
                /* @__PURE__ */ te.jsx(D.Paragraph, { variant: "4", className: va.resultTitle, children: e.title }),
                n && /* @__PURE__ */ te.jsx(
                  me,
                  {
                    className: va.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, eA = "_loader_13xpk_1", nA = "_dropdown_13xpk_8", tA = "_loadMore_13xpk_13", iu = {
  loader: eA,
  dropdown: nA,
  loadMore: tA
}, rA = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = se(), [a, o] = se([]), [s, l] = se(""), [d, m] = se(!1), { useLazyQuery: u } = un(), [f, { data: h, loading: v, networkStatus: C }] = u(
    TP,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  yi(
    () => {
      !v && s !== "" && C === Wt.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), qe(() => {
    v || o([]);
  }, [s]), qe(() => {
    if (h && Object.keys(h).length > 0) {
      const S = h.Linear.searchIssues.edges.map(
        ({ node: E }) => E
      ), j = a.filter(
        (E) => !n.find((I) => I.id === E.id)
      ), k = j.filter(
        (E) => !S.find(
          (I) => I.id === E.id
        )
      ), L = S.filter(
        (E) => !n.find((I) => I.id === E.id)
      );
      n.length > 0 ? o(
        d ? [...k, ...L] : L
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...j, ...S] : S
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const _ = () => {
    !v && s !== "" && C === Wt.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ te.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ te.jsxs(
    Ur,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (S) => S?.title,
      onChange: (S) => e(S.selectedValues[0]),
      dropdownProps: { className: iu.dropdown },
      filter: {
        value: s,
        onChange: (S) => {
          const j = S.target.value;
          l(j);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((S) => /* @__PURE__ */ te.jsx(ZP, { issue: S }, S.id)),
        r?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ te.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => _(),
            className: iu.loadMore,
            children: /* @__PURE__ */ te.jsx(D.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ te.jsx(b, { justifyContent: "center", className: iu.loader, children: /* @__PURE__ */ te.jsx(ln, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ te.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ te.jsx(D.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ te.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ te.jsx(D.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, iA = "_collapse_su0f9_1", aA = "_collapseHeader_su0f9_8", oA = "_collapseContent_su0f9_31", sA = "_url_su0f9_35", lA = "_externalLink_su0f9_51", cA = "_emptyState_su0f9_55", zr = {
  collapse: iA,
  collapseHeader: aA,
  collapseContent: oA,
  url: sA,
  externalLink: lA,
  emptyState: cA
}, dA = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = se(s), { track: m } = bn();
  return n ? /* @__PURE__ */ te.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ te.jsx(ln, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ te.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ te.jsx(
          D.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: zr.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ te.jsx(
          jt,
          {
            slotEnd: /* @__PURE__ */ te.jsx(me, { name: "external-link" }),
            variant: "tertiary",
            className: zr.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ te.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ te.jsxs(
            rr,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: zr.collapse,
              children: [
                /* @__PURE__ */ te.jsx(rr.Header, { className: zr.collapseHeader, children: /* @__PURE__ */ te.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ te.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ te.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ te.jsx(We, { content: /* @__PURE__ */ te.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ te.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ te.jsx(
                        hs,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ te.jsxs(
                        D.ExternalLink,
                        {
                          className: zr.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ te.jsx(me, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ te.jsx(We, { content: /* @__PURE__ */ te.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ te.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ te.jsx(fs, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ te.jsx(An, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ te.jsx(rr.Content, { className: zr.collapseContent, children: /* @__PURE__ */ te.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ te.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ te.jsx(An, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ te.jsx(y_, { issue: u }),
                  /* @__PURE__ */ te.jsx(
                    Kn,
                    {
                      slotStart: /* @__PURE__ */ te.jsx(me, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ te.jsxs(
                    jt,
                    {
                      slotEnd: /* @__PURE__ */ te.jsx(me, { name: "external-link" }),
                      variant: "tertiary",
                      className: zr.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ te.jsx(
          Kn,
          {
            slotStart: /* @__PURE__ */ te.jsx(me, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ te.jsx(
          jt,
          {
            slotEnd: /* @__PURE__ */ te.jsx(me, { name: "external-link" }),
            variant: "tertiary",
            className: zr.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, uA = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, v_ = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => v_(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, mA = "_modalBody_iv3ua_1", pA = "_error_iv3ua_5", fA = "_dropdown_iv3ua_16", wi = {
  modalBody: mA,
  error: pA,
  dropdown: fA
}, hA = co(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), yA = co(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), gA = co(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), vA = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = un(), { control: m, handleSubmit: u, reset: f } = mt(), [h, v] = se([]), [C, _] = se(), [S, j] = se([]), [k, L] = se(), [E, I] = se([]), [F, A] = se(), [K, Y] = se([]), [ie, G] = se(), [B, O] = se([]), [z, Z] = se(), [be, he] = se(!1), { useMutation: de } = un(), { track: ye } = bn(), [q, { loading: Se }] = de(
    hA,
    {
      onError: () => {
        he(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Fe) => {
        const Ye = {
          identifier: Fe.Linear?.issueCreate?.issue?.identifier,
          url: Fe.Linear?.issueCreate?.issue?.url
        };
        Fe.Linear && Fe.Linear?.issueCreate?.issue?.id && (a(Fe.Linear?.issueCreate?.issue?.id), Me(Ye), he(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Fe.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), ye("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Ce,
    { data: H, loading: He, error: Be }
  ] = l(yA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Fe) => {
      const Ye = Fe.Linear.teams.edges.map(
        ({ node: Ze }) => Ze
      );
      v(Ye), Y(Fe.Linear.issuePriorityValues), s(`${CA}${Fe.Linear.organization.urlKey}`);
    }
  }), [Re, { data: Ue, loading: Te }] = l(gA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Fe) => {
      const Ye = Fe?.Linear?.team?.projects?.edges?.map(
        ({ node: ge }) => ge
      );
      j(Ye);
      const Ze = Fe?.Linear?.team?.states?.edges?.map(
        ({ node: ge }) => ge
      );
      I(Ze);
      const fe = Fe?.Linear?.team?.templates?.edges?.map(
        ({ node: ge }) => ge
      );
      O(
        fe.filter(
          (ge) => ge.type === "issue"
        )
      );
    }
  }), Me = (Fe) => {
    r(!1), L(void 0), _(void 0), A(void 0), G(void 0), Z(void 0), Fe && (e(Fe), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, De = (Fe) => {
    H && !He && (q({
      variables: {
        issueTitle: Fe.title,
        issueDescription: Fe?.description,
        teamId: Fe.team.id,
        projectId: Fe?.project?.id,
        statusId: Fe?.status?.id,
        priority: Fe?.priority?.priority
      }
    }), he(!0));
  };
  qe(() => {
    n && Ce();
  }, [n]);
  const on = () => {
    ye("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ te.jsxs(
    wt,
    {
      isOpen: n,
      onClose: () => {
        on(), Me();
      },
      children: [
        /* @__PURE__ */ te.jsx(
          Ct,
          {
            title: "Create new Linear issue",
            onClose: () => {
              on(), Me();
            }
          }
        ),
        /* @__PURE__ */ te.jsx(
          It,
          {
            className: wi.modalBody,
            "data-testid": "createIssueModalBody",
            children: Be ? /* @__PURE__ */ te.jsx(Cn, { error: Be }) : /* @__PURE__ */ te.jsx("form", { onSubmit: u(De), id: "issueCreationForm", children: /* @__PURE__ */ te.jsxs(rt, { children: [
              /* @__PURE__ */ te.jsx(ue, { span: 3, children: /* @__PURE__ */ te.jsx(
                Nt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Fe, onChange: Ye },
                    fieldState: { error: Ze }
                  }) => /* @__PURE__ */ te.jsx(
                    nn,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Ze?.message ?? null
                      },
                      children: /* @__PURE__ */ te.jsx(
                        Ur,
                        {
                          dropdownProps: { className: wi.dropdown },
                          placeholder: "Select Linear team",
                          className: tt({ [wi.error]: Ze }),
                          getItemTitleByValue: (fe) => fe?.name,
                          onChange: (fe) => {
                            L(void 0), A(void 0), G(void 0), Z(void 0), _(fe.selectedValues[0]), Re({
                              variables: { teamId: fe.selectedValues[0].id }
                            }), Ye(fe.selectedValues[0]);
                          },
                          value: C ? [Fe] : void 0,
                          children: h?.map((fe) => /* @__PURE__ */ te.jsx(
                            lt.Item,
                            {
                              value: fe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ te.jsx(D.Paragraph, { children: fe.name })
                            },
                            fe.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ te.jsx(ue, { span: 3, children: /* @__PURE__ */ te.jsx(
                Nt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Fe, onChange: Ye } }) => {
                    const Ze = Te ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ te.jsx(nn, { label: "Project", children: /* @__PURE__ */ te.jsx(
                      Ur,
                      {
                        dropdownProps: { className: wi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (fe) => fe?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Linear project" : "Select a Team first",
                        onChange: (fe) => {
                          L(fe.selectedValues[0]), Ye(fe.selectedValues[0]);
                        },
                        value: k ? [Fe] : Ze,
                        children: /* @__PURE__ */ te.jsxs(te.Fragment, { children: [
                          Te && /* @__PURE__ */ te.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ te.jsx(ln, { size: 24 })
                            }
                          ),
                          Ue && !Te && S.map((fe) => /* @__PURE__ */ te.jsx(
                            lt.Item,
                            {
                              value: fe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ te.jsx(D.Paragraph, { children: fe.name })
                            },
                            fe.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ te.jsx(ue, { span: 6, children: /* @__PURE__ */ te.jsx(nn, { label: "Template", children: /* @__PURE__ */ te.jsx(
                Ur,
                {
                  clearable: !0,
                  dropdownProps: { className: wi.dropdown },
                  disabled: !C || Te,
                  placeholder: C ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Fe) => Fe?.name,
                  onChange: (Fe) => {
                    if (Fe.selectedValues.length > 0) {
                      Z(Fe.selectedValues[0]);
                      const Ye = JSON.parse(
                        Fe.selectedValues[0].templateData
                      ), Ze = K.filter(
                        (Le) => Le.priority === Ye.priority
                      );
                      G(
                        Ze ? Ze[0] : void 0
                      );
                      const fe = E.filter(
                        (Le) => Le.id === Ye.stateId
                      );
                      A(
                        fe ? fe[0] : void 0
                      );
                      const ge = S.filter(
                        (Le) => Le.id === Ye.projectId
                      );
                      L(
                        ge ? ge[0] : void 0
                      );
                      const $e = Ye.description;
                      f({
                        title: Ye?.title,
                        priority: Ze[0],
                        status: fe[0],
                        project: ge[0],
                        description: $e ? v_($e, uA) : "",
                        team: C
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: C
                      }), L(void 0), G(void 0), A(void 0), Z(void 0);
                  },
                  value: z ? [z] : void 0,
                  children: B?.map((Fe) => /* @__PURE__ */ te.jsx(
                    lt.Item,
                    {
                      value: Fe,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ te.jsx(D.Paragraph, { children: Fe.name })
                    },
                    Fe.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ te.jsx(ue, { span: 6, children: /* @__PURE__ */ te.jsx(
                Nt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Fe, value: Ye },
                    fieldState: { error: Ze }
                  }) => /* @__PURE__ */ te.jsx(
                    ir,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Ye || "",
                        onChange: Fe
                      },
                      meta: {
                        error: Ze?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ te.jsx(ue, { span: 3, children: /* @__PURE__ */ te.jsx(
                Nt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Fe, onChange: Ye } }) => {
                    const Ze = Te ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ te.jsx(nn, { label: "Status", children: /* @__PURE__ */ te.jsx(
                      Ur,
                      {
                        dropdownProps: { className: wi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (fe) => fe?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue status" : "Select a Team first",
                        onChange: (fe) => {
                          A(fe.selectedValues[0]), Ye(fe.selectedValues[0]);
                        },
                        value: F ? [Fe] : Ze,
                        children: /* @__PURE__ */ te.jsxs(te.Fragment, { children: [
                          Te && /* @__PURE__ */ te.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ te.jsx(ln, { size: 24 })
                            }
                          ),
                          Ue && !Te && E.map((fe) => /* @__PURE__ */ te.jsx(
                            lt.Item,
                            {
                              value: fe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ te.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ te.jsx(
                                      hs,
                                      {
                                        type: fe.type,
                                        color: fe.color,
                                        name: fe.name
                                      }
                                    ),
                                    /* @__PURE__ */ te.jsx(D.Paragraph, { children: fe.name })
                                  ]
                                }
                              )
                            },
                            fe.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ te.jsx(ue, { span: 3, children: /* @__PURE__ */ te.jsx(
                Nt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Fe, onChange: Ye } }) => {
                    const Ze = He ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ te.jsx(nn, { label: "Priority", children: /* @__PURE__ */ te.jsx(
                      Ur,
                      {
                        clearable: !0,
                        getItemTitleByValue: (fe) => fe?.label,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue priority" : "Select a Team first",
                        onChange: (fe) => {
                          G(fe.selectedValues[0]), Ye(fe.selectedValues[0]);
                        },
                        value: ie ? [Fe] : Ze,
                        children: /* @__PURE__ */ te.jsxs(te.Fragment, { children: [
                          Te && /* @__PURE__ */ te.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ te.jsx(ln, { size: 24 })
                            }
                          ),
                          H && !He && K.map((fe) => /* @__PURE__ */ te.jsx(
                            lt.Item,
                            {
                              value: fe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ te.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ te.jsx(
                                      fs,
                                      {
                                        priority: fe.priority
                                      }
                                    ),
                                    /* @__PURE__ */ te.jsx(D.Paragraph, { children: fe.label })
                                  ]
                                }
                              )
                            },
                            fe.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ te.jsx(ue, { children: /* @__PURE__ */ te.jsx(
                Nt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Fe, value: Ye },
                    fieldState: { error: Ze }
                  }) => /* @__PURE__ */ te.jsx(
                    CS,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Ye || "",
                        onChange: Fe
                      },
                      meta: {
                        error: Ze?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ te.jsx(
          Tt,
          {
            confirmOnClick: u(De),
            confirmProps: {
              disabled: Se || !H,
              isLoading: be || He || Te,
              loadingIndicator: /* @__PURE__ */ te.jsx(ln, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              on(), Me();
            }
          }
        )
      ]
    }
  );
}, kA = "_modalWrapper_4kh9u_1", bA = "_copyButton_4kh9u_6", xA = "_copyWrapper_4kh9u_15", _A = "_copyField_4kh9u_24", SA = "_externalLink_4kh9u_47", NA = "_externalLinkIcon_4kh9u_52", jA = "_textWrapper_4kh9u_56", ni = {
  modalWrapper: kA,
  copyButton: bA,
  copyWrapper: xA,
  copyField: _A,
  externalLink: SA,
  externalLinkIcon: NA,
  textWrapper: jA
}, wA = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ te.jsxs(
  wt,
  {
    isOpen: !!n && e,
    className: ni.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ te.jsx(
        Ct,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ te.jsx(It, { children: /* @__PURE__ */ te.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ te.jsxs(D.Paragraph, { className: ni.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ te.jsxs(
                D.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: ni.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ te.jsx(me, { name: "external-link", className: ni.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ te.jsx(nn, { label: "Linear issue link", children: /* @__PURE__ */ te.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: ni.copyWrapper,
                children: [
                  /* @__PURE__ */ te.jsx(
                    pr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: ni.copyField
                    }
                  ),
                  /* @__PURE__ */ te.jsx(
                    IS,
                    {
                      className: ni.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ te.jsx(
        Tt,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), CA = "https://linear.app/", IA = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), [a, o] = se([]), [s, l] = se(!1), [d, m] = se(!1), [u, f] = se(!1), [h, v] = se(), { useLazyQuery: C } = un(), [_, S] = se(""), j = n?.enableCreateIssue, k = !!n?.enableUnlinkAll, { track: L } = bn(), {
    loading: E,
    data: I,
    error: F,
    store: A
  } = xm(e?.conversationId ?? null), [
    K,
    {
      data: Y,
      loading: ie,
      networkStatus: G,
      error: B
    }
  ] = C($P, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    !E && !F && I && I?.linear?.issues?.length > 0 ? (o(I.linear.issues), K({
      variables: {
        linkedIssues: I.linear.issues
      }
    })) : !E && !F && (i([]), o([]));
  }, [I, E, F]), qe(() => {
    Y && Y?.Linear && !ie && G === Wt.ready && Object.keys(Y).length > 0 && i(Y.Linear.issues?.edges?.map(({ node: he }) => he));
  }, [Y, ie, G]);
  const O = (he) => {
    he && he?.team?.organization?.urlKey && L("linear:link:issue:clicked", {
      linearInstanceUrl: _,
      linearIssueKey: he.id
    });
    const de = (ye) => ye.id === he?.id;
    r.some((ye) => ye && de(ye)) || (I && a.length === 0 && o([]), A({
      linear: {
        issues: [...a, he.id]
      }
    }));
  }, z = (he) => {
    const de = I?.linear.issues.filter((ye) => ye !== he) || [];
    L("linear:unlink:issue:clicked", {
      linearInstanceUrl: _,
      linearIssueKey: he
    }), i(r.filter(({ id: ye }) => ye !== he)), o(de), A({
      linear: {
        issues: de
      }
    });
  }, Z = () => {
    l(!1), i([]), o([]), A({
      linear: {
        issues: []
      }
    });
  }, be = E || ie || !I && !F || (I?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !E && !ie && (B || F) ? /* @__PURE__ */ te.jsx(Cn, { error: B || F }) : /* @__PURE__ */ te.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ te.jsxs(
      wt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ te.jsx(
            Ct,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ te.jsx(It, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ te.jsx(
            Tt,
            {
              confirmOnClick: () => Z(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ te.jsx(
      vA,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (he) => m(he),
        setIsCreationSuccessfulModalOpen: (he) => f(he),
        addToLinkedIssueIds: (he) => {
          A({
            linear: {
              issues: [...a, he]
            }
          });
        },
        setCreatedIssue: (he) => v(he),
        organizationUrl: _,
        setOrganizationUrl: (he) => S(he)
      }
    ),
    /* @__PURE__ */ te.jsx(
      wA,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (he) => f(he),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ te.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          j && /* @__PURE__ */ te.jsxs(te.Fragment, { children: [
            /* @__PURE__ */ te.jsx(
              Kn,
              {
                variant: "primary",
                onClick: () => {
                  L("linear:create:new:issue:clicked", {
                    linearInstanceUrl: _
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ te.jsx(D.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ te.jsx(rA, { handleSelect: O, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ te.jsx(
      dA,
      {
        linkedIssues: r,
        isLoading: be,
        handleUnlinkIssue: z,
        showUnlinkAllModal: (he) => l(he),
        showUnlinkAllButton: k,
        organizationUrl: _
      }
    )
  ] });
}, am = [
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], ti = "LINEAR", FA = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, EA = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: FA
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: C
  } = qr({
    integrationId: e,
    integrationType: ti,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: _,
    error: S,
    isWidgetUnknown: j,
    refetch: k,
    widgetConfiguration: L
  } = Hr({
    integrationId: e,
    fieldDefinitions: am,
    form: l,
    onMisconfigured: C
  }), { renderConditions: E, setRenderConditions: I, renderConditionsForSubmit: F } = Wr({
    integrationId: e,
    widgetConfiguration: L,
    renderConditionsEditor: o
  }), A = (Y) => Gr(Y, {
    fieldDefinitions: am,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: F
  }), K = l.watch("name");
  return /* @__PURE__ */ te.jsxs(
    Kr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: S ?? h,
      onRetry: S ? k : void 0,
      isLoading: f || _,
      isWidgetUnknown: j,
      children: [
        v && /* @__PURE__ */ te.jsx(Yr, { cause: v }),
        /* @__PURE__ */ te.jsxs(rt, { children: [
          /* @__PURE__ */ te.jsx(ue, { children: /* @__PURE__ */ te.jsx(nn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ te.jsx(
            $n,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(ue, { span: 3, children: /* @__PURE__ */ te.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ te.jsx(ue, { span: 3 }),
          /* @__PURE__ */ te.jsx(ue, { span: 3, children: /* @__PURE__ */ te.jsx(nn, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ te.jsx(
            $n,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(ue, { span: 3 }),
          /* @__PURE__ */ te.jsx(ue, { span: 3, children: /* @__PURE__ */ te.jsx(nn, { label: 'Enable the "Unlink all" button', children: /* @__PURE__ */ te.jsx(
            $n,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(ue, { span: 3 }),
          !s && e && /* @__PURE__ */ te.jsx(
            Hi,
            {
              configuration: n,
              integrationId: e,
              integrationType: ti,
              label: "Authorize with OAuth"
            }
          ),
          o && E !== null && /* @__PURE__ */ te.jsx(ue, { children: o({
            value: E,
            onChange: I,
            configurationKey: L?.id
          }) })
        ] }),
        /* @__PURE__ */ te.jsx(
          Qr,
          {
            integrationType: ti,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ te.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ te.jsx(
                me,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ te.jsxs(D.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  ti,
                  " integration, all links between Dixa and ",
                  ti,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ te.jsxs(D.Paragraph, { children: [
                  "All data in ",
                  ti,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ te.jsxs(D.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  ti,
                  " ",
                  'integration "',
                  K,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var au = { exports: {} }, ka = {}, $v;
function TA() {
  if ($v) return ka;
  $v = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ka.Fragment = r, ka.jsx = s, ka.jsxs = s, ka;
}
var Io = {}, Dv;
function $A() {
  return Dv || (Dv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Io.Fragment = i, Io.jsx = Rn, Io.jsxs = Mn;
  })()), Io;
}
var Rv;
function DA() {
  return Rv || (Rv = 1, process.env.NODE_ENV === "production" ? au.exports = TA() : au.exports = $A()), au.exports;
}
var je = DA();
const RA = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, OA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, PA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, AA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, LA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, VA = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": RA,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": OA,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": PA,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": AA,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": LA
};
function Us(e) {
  return VA[e] ?? {};
}
const zA = Us(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), UA = Us(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), MA = Us(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), BA = Us(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function ou(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const qA = "_wrapper_27vny_1", HA = "_copyIcon_27vny_12", ba = {
  wrapper: qA,
  copyIcon: HA
}, WA = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = ou(), { isCopied: i, copy: a } = ou(), { isCopied: o, copy: s } = ou();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: C,
    referral_url: _
  } = e, S = f ? Ln(f).isSame(Date.now(), "day") : !1, { name: j, first_name: k, last_name: L } = m ?? {}, E = j ?? (`${k} ${L}`.trim() || "A customer has no name"), I = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ je.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ je.jsxs(b, { className: ba.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: ba.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ je.jsx(D.Heading, { variant: "heading-2", children: E }),
          S && /* @__PURE__ */ je.jsx(D.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ je.jsx(D.Paragraph, { variant: "4", color: "secondary", children: Ln(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ je.jsx(b, { gap: "200", children: /* @__PURE__ */ je.jsxs(D.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Ln(C).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ je.jsx(me, { size: l, name: "mail" }),
        /* @__PURE__ */ je.jsx(D.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ je.jsx(We, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ je.jsx(
        me,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: ba.copyIcon
        }
      ) })
    ] }),
    I && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ je.jsx(me, { size: l, name: "link" }),
        /* @__PURE__ */ je.jsx(We, { content: "Shopify shop", children: /* @__PURE__ */ je.jsx(
          D.ExternalLink,
          {
            href: I,
            target: "_blank",
            rel: "noreferrer",
            children: I.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ je.jsx(We, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ je.jsx(
        me,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(I),
          className: ba.copyIcon
        }
      ) })
    ] }),
    _ && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ je.jsx(me, { size: l, name: "external-link" }),
        /* @__PURE__ */ je.jsx(We, { content: "Referral link", children: /* @__PURE__ */ je.jsx(
          D.ExternalLink,
          {
            href: _,
            target: "_blank",
            rel: "noreferrer",
            children: _.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ je.jsx(We, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ je.jsx(
        me,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(_),
          className: ba.copyIcon
        }
      ) })
    ] })
  ] }) });
}, KA = "_list_1q5b5_5", GA = "_listItem_1q5b5_8", YA = "_listItemEdit_1q5b5_15", QA = "_notificationText_1q5b5_19", Bi = {
  list: KA,
  listItem: GA,
  listItemEdit: YA,
  notificationText: QA
}, JA = "_modalBody_1clhs_1", XA = {
  modalBody: JA
}, ZA = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = bn(), [d, m] = se(n), [u, f] = se(""), [h, v] = se(), [C, { loading: _ }] = o(
    MA,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), G();
      }
    }
  ), [S, { loading: j }] = o(BA), k = _ || j, L = !!h, E = n === d ? "Change the value to update the points" : "", I = isNaN(d), F = I ? "Points can not be empty" : "", A = d > n && d - n > 1e6, K = A ? "Points can not exceed 1,000,000" : "", Y = () => {
    if (!r) {
      v(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && C({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((B) => {
      const O = B?.networkError;
      (O ? O?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), G()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), d < n && S({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((B) => {
      B.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), G()) : "errors" in B && (l("loyaltylion:remove:points:failed"), v(
        B.errors?.map((O) => O.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, ie = () => {
    I && m(n), f(""), i();
  }, G = () => {
    a(), ie();
  };
  return /* @__PURE__ */ je.jsxs(
    wt,
    {
      isOpen: e,
      onClose: ie,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ je.jsx(Ct, { title: "Change points", onClose: ie }),
        /* @__PURE__ */ je.jsxs(It, { className: XA.modalBody, children: [
          /* @__PURE__ */ je.jsxs(rt, { children: [
            /* @__PURE__ */ je.jsx(ue, { span: 6, children: /* @__PURE__ */ je.jsx(
              ir,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: K || F,
                  warning: E
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (B) => m(B?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ je.jsx(ue, { span: 6, children: /* @__PURE__ */ je.jsx(
              ir,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (B) => f(B?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !k && L && /* @__PURE__ */ je.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ je.jsx(Ge, { children: h?.map((B, O) => /* @__PURE__ */ je.jsx(
            Ge.Item,
            {
              variant: "dense",
              title: B,
              contentLeft: /* @__PURE__ */ je.jsx(
                me,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            O
          )) }) })
        ] }),
        /* @__PURE__ */ je.jsx(
          Tt,
          {
            confirmName: "Save",
            confirmOnClick: () => Y(),
            confirmProps: {
              isLoading: k,
              disabled: I || A || n === d,
              loadingIndicator: /* @__PURE__ */ je.jsx(ln, { size: 16 })
            },
            cancelOnClick: ie
          }
        )
      ]
    }
  );
}, e2 = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ je.jsx(Ge.Text, { variant: "dense", className: Bi.listItem, children: /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(me, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ je.jsx(D.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ je.jsx(We, { content: "Edit points", children: /* @__PURE__ */ je.jsx(
        me,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Bi.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ je.jsx(Pn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, n2 = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = se(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsx(D.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ je.jsx(Ge, { className: Bi.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ je.jsx(
      e2,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      u
    )) }),
    /* @__PURE__ */ je.jsx(
      ZA,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, t2 = "_reward_1wxia_1", r2 = {
  reward: t2
}, i2 = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ je.jsx(b, { gap: "100", flexDirection: "column", className: r2.reward, children: /* @__PURE__ */ je.jsx(We, { content: a ?? "No description", children: /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ je.jsx(me, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ je.jsxs(Pn, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(me, { size: 14, name: "external-link" }),
      /* @__PURE__ */ je.jsx(
        D.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, a2 = ({ customer: e }) => {
  const { useQuery: n } = un(), [r, i] = se(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(UA, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (qe(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return Xa({ errors: d }) ? /* @__PURE__ */ je.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Bi.notificationText,
        children: "No rewards found"
      }
    ) : tb({ errors: d }) ? /* @__PURE__ */ je.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Bi.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ je.jsx(Cn, { error: s });
  }
  return /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsx(D.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ je.jsx(ln, {}) }) : /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ je.jsx(i2, { reward: d }, d.id)) })
  ] });
}, o2 = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ je.jsx(b, { alignItems: "start", children: /* @__PURE__ */ je.jsx(An, { children: /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(
        me,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ je.jsx(b, { alignItems: "start", children: /* @__PURE__ */ je.jsx(An, { children: /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(me, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ je.jsx(b, { alignItems: "start", children: /* @__PURE__ */ je.jsx(We, { content: "Insights segment", children: /* @__PURE__ */ je.jsx(An, { children: /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(me, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, s2 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = un(), { track: i } = bn(), [a, o] = se(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: v,
    data: C,
    refetch: _
  } = r(zA, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return qe(() => {
    if (C && !h) {
      const S = (C?.LoyaltyLion?.getCustomers).customers;
      S && S.length > 0 && (o(S[0]), i("loyaltylion:customer:received"));
    }
  }, [C, h]), s?.email ? v ? Xa({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ je.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Bi.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ je.jsx(Cn, { error: v }) : h ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ je.jsx(ln, {}) }) : f ? /* @__PURE__ */ je.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ je.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ je.jsxs(je.Fragment, { children: [
        l && /* @__PURE__ */ je.jsx(WA, { customer: a }),
        d && /* @__PURE__ */ je.jsx(o2, { customer: a }),
        m && /* @__PURE__ */ je.jsx(
          n2,
          {
            customer: a,
            refetchCustomerData: _
          }
        ),
        u && /* @__PURE__ */ je.jsx(a2, { customer: a })
      ] }) : /* @__PURE__ */ je.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ je.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, om = [
  {
    key: "basicAuthorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Ov = "LOYALTYLION", l2 = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, c2 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: l2
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = qr({
    integrationId: e,
    integrationType: Ov,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: _,
    isWidgetUnknown: S,
    refetch: j,
    widgetConfiguration: k
  } = Hr({
    integrationId: e,
    fieldDefinitions: om,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: E, renderConditionsForSubmit: I } = Wr({
    integrationId: e,
    widgetConfiguration: k,
    renderConditionsEditor: a
  }), F = (K) => Gr(K, {
    fieldDefinitions: om,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), A = s.watch("name");
  return /* @__PURE__ */ je.jsxs(
    Kr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: _ ?? f,
      onRetry: _ ? j : void 0,
      isLoading: u || C,
      isWidgetUnknown: S,
      children: [
        h && /* @__PURE__ */ je.jsx(Yr, { cause: h }),
        /* @__PURE__ */ je.jsxs(rt, { children: [
          /* @__PURE__ */ je.jsx(ue, { children: /* @__PURE__ */ je.jsx(nn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ je.jsx(
            $n,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(ue, { span: 3, children: /* @__PURE__ */ je.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(ue, { span: 3 }),
          /* @__PURE__ */ je.jsx(ue, { span: 3, children: /* @__PURE__ */ je.jsx(
            uS,
            {
              name: "basicAuthorization",
              label: "LoyaltyLion authorization",
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ je.jsx(ue, { span: 3 }),
          /* @__PURE__ */ je.jsx(ue, { span: 3, children: /* @__PURE__ */ je.jsx(nn, { label: "Show customer summary", children: /* @__PURE__ */ je.jsx(
            $n,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(ue, { span: 3 }),
          /* @__PURE__ */ je.jsx(ue, { span: 3, children: /* @__PURE__ */ je.jsx(nn, { label: "Show tags", children: /* @__PURE__ */ je.jsx(
            $n,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(ue, { span: 3 }),
          /* @__PURE__ */ je.jsx(ue, { span: 3, children: /* @__PURE__ */ je.jsx(nn, { label: "Show points balance", children: /* @__PURE__ */ je.jsx(
            $n,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(ue, { span: 3 }),
          /* @__PURE__ */ je.jsx(ue, { span: 3, children: /* @__PURE__ */ je.jsx(nn, { label: "Show available rewards", children: /* @__PURE__ */ je.jsx(
            $n,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(ue, { span: 3 }),
          a && L !== null && /* @__PURE__ */ je.jsx(ue, { children: a({
            value: L,
            onChange: E,
            configurationKey: k?.id
          }) })
        ] }),
        /* @__PURE__ */ je.jsx(
          Qr,
          {
            integrationType: Ov,
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var su = { exports: {} }, xa = {}, Pv;
function d2() {
  if (Pv) return xa;
  Pv = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return xa.Fragment = r, xa.jsx = s, xa.jsxs = s, xa;
}
var Fo = {}, Av;
function u2() {
  return Av || (Av = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Fo.Fragment = i, Fo.jsx = Rn, Fo.jsxs = Mn;
  })()), Fo;
}
var Lv;
function m2() {
  return Lv || (Lv = 1, process.env.NODE_ENV === "production" ? su.exports = d2() : su.exports = u2()), su.exports;
}
var tn = m2();
const p2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, f2 = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": p2
};
function h2(e) {
  return f2[e] ?? {};
}
const {
  entries: k_,
  setPrototypeOf: Vv,
  isFrozen: y2,
  getPrototypeOf: g2,
  getOwnPropertyDescriptor: v2
} = Object;
let {
  freeze: Vt,
  seal: ar,
  create: Ti
} = Object, {
  apply: sm,
  construct: lm
} = typeof Reflect < "u" && Reflect;
Vt || (Vt = function(e) {
  return e;
});
ar || (ar = function(e) {
  return e;
});
sm || (sm = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
lm || (lm = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const _a = ft(Array.prototype.forEach), k2 = ft(Array.prototype.lastIndexOf), zv = ft(Array.prototype.pop), Sa = ft(Array.prototype.push), b2 = ft(Array.prototype.splice), Rt = Array.isArray, Pa = ft(String.prototype.toLowerCase), lu = ft(String.prototype.toString), Uv = ft(String.prototype.match), Ci = ft(String.prototype.replace), Mv = ft(String.prototype.indexOf), x2 = ft(String.prototype.trim), _2 = ft(Number.prototype.toString), S2 = ft(Boolean.prototype.toString), Bv = typeof BigInt > "u" ? null : ft(BigInt.prototype.toString), qv = typeof Symbol > "u" ? null : ft(Symbol.prototype.toString), it = ft(Object.prototype.hasOwnProperty), Na = ft(Object.prototype.toString), bt = ft(RegExp.prototype.test), Eo = N2(TypeError);
function ft(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return sm(e, n, i);
  };
}
function N2(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return lm(e, r);
  };
}
function Fn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Pa;
  if (Vv && Vv(e, null), !Rt(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (y2(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function j2(e) {
  for (let n = 0; n < e.length; n++)
    it(e, n) || (e[n] = null);
  return e;
}
function Mt(e) {
  const n = Ti(null);
  for (const [r, i] of k_(e))
    it(e, r) && (Rt(i) ? n[r] = j2(i) : i && typeof i == "object" && i.constructor === Object ? n[r] = Mt(i) : n[r] = i);
  return n;
}
function w2(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return _2(e);
    case "boolean":
      return S2(e);
    case "bigint":
      return Bv ? Bv(e) : "0";
    case "symbol":
      return qv ? qv(e) : "Symbol()";
    case "undefined":
      return Na(e);
    case "function":
    case "object": {
      if (e === null)
        return Na(e);
      const n = e, r = $i(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : Na(i);
      }
      return Na(e);
    }
    default:
      return Na(e);
  }
}
function $i(e, n) {
  for (; e !== null; ) {
    const i = v2(e, n);
    if (i) {
      if (i.get)
        return ft(i.get);
      if (typeof i.value == "function")
        return ft(i.value);
    }
    e = g2(e);
  }
  function r() {
    return null;
  }
  return r;
}
function C2(e) {
  try {
    return bt(e, ""), !0;
  } catch {
    return !1;
  }
}
const Hv = Vt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), cu = Vt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), du = Vt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), I2 = Vt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), uu = Vt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), F2 = Vt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Wv = Vt(["#text"]), Kv = Vt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), mu = Vt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Gv = Vt(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), To = Vt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), E2 = ar(/\{\{[\w\W]*|[\w\W]*\}\}/gm), T2 = ar(/<%[\w\W]*|[\w\W]*%>/gm), $2 = ar(/\$\{[\w\W]*/gm), D2 = ar(/^data-[\-\w.\u00B7-\uFFFF]+$/), R2 = ar(/^aria-[\-\w]+$/), b_ = ar(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), O2 = ar(/^(?:\w+script|data):/i), P2 = ar(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), x_ = ar(/^html$/i), A2 = ar(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Yv = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: R2,
  ATTR_WHITESPACE: P2,
  CUSTOM_ELEMENT: A2,
  DATA_ATTR: D2,
  DOCTYPE_NAME: x_,
  ERB_EXPR: T2,
  IS_ALLOWED_URI: b_,
  IS_SCRIPT_OR_DATA: O2,
  MUSTACHE_EXPR: E2,
  TMPLIT_EXPR: $2
});
const ja = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, L2 = function() {
  return typeof window > "u" ? null : window;
}, V2 = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, Qv = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function __() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : L2();
  const n = (x) => __(x);
  if (n.version = "3.4.2", n.removed = [], !e || !e.document || e.document.nodeType !== ja.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: r
  } = e;
  const i = r, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: d,
    NodeFilter: m,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: v
  } = e, C = d.prototype, _ = $i(C, "cloneNode"), S = $i(C, "remove"), j = $i(C, "nextSibling"), k = $i(C, "childNodes"), L = $i(C, "parentNode");
  if (typeof s == "function") {
    const x = r.createElement("template");
    x.content && x.content.ownerDocument && (r = x.content.ownerDocument);
  }
  let E, I = "";
  const {
    implementation: F,
    createNodeIterator: A,
    createDocumentFragment: K,
    getElementsByTagName: Y
  } = r, {
    importNode: ie
  } = i;
  let G = Qv();
  n.isSupported = typeof k_ == "function" && typeof L == "function" && F && F.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: B,
    ERB_EXPR: O,
    TMPLIT_EXPR: z,
    DATA_ATTR: Z,
    ARIA_ATTR: be,
    IS_SCRIPT_OR_DATA: he,
    ATTR_WHITESPACE: de,
    CUSTOM_ELEMENT: ye
  } = Yv;
  let {
    IS_ALLOWED_URI: q
  } = Yv, Se = null;
  const Ce = Fn({}, [...Hv, ...cu, ...du, ...uu, ...Wv]);
  let H = null;
  const He = Fn({}, [...Kv, ...mu, ...Gv, ...To]);
  let Be = Object.seal(Ti(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Re = null, Ue = null;
  const Te = Object.seal(Ti(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Me = !0, De = !0, on = !1, Fe = !0, Ye = !1, Ze = !0, fe = !1, ge = !1, $e = !1, Le = !1, Pe = !1, mn = !1, J = !0, T = !1;
  const U = "user-content-";
  let X = !0, re = !1, V = {}, W = null;
  const le = Fn({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let ke = null;
  const Ie = Fn({}, ["audio", "video", "img", "source", "image", "track"]);
  let en = null;
  const hn = Fn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), rn = "http://www.w3.org/1998/Math/MathML", cn = "http://www.w3.org/2000/svg", pn = "http://www.w3.org/1999/xhtml";
  let dn = pn, Sn = !1, Xe = null;
  const Nn = Fn({}, [rn, cn, pn], lu);
  let Oe = Fn({}, ["mi", "mo", "mn", "ms", "mtext"]), an = Fn({}, ["annotation-xml"]);
  const sn = Fn({}, ["title", "style", "font", "a", "script"]);
  let gn = null;
  const qn = ["application/xhtml+xml", "text/html"], jn = "text/html";
  let vn = null, yn = null;
  const wn = r.createElement("form"), Un = function(x) {
    return x instanceof RegExp || x instanceof Function;
  }, Vn = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (yn && yn === x)
      return;
    (!x || typeof x != "object") && (x = {}), x = Mt(x), gn = // eslint-disable-next-line unicorn/prefer-includes
    qn.indexOf(x.PARSER_MEDIA_TYPE) === -1 ? jn : x.PARSER_MEDIA_TYPE, vn = gn === "application/xhtml+xml" ? lu : Pa, Se = it(x, "ALLOWED_TAGS") && Rt(x.ALLOWED_TAGS) ? Fn({}, x.ALLOWED_TAGS, vn) : Ce, H = it(x, "ALLOWED_ATTR") && Rt(x.ALLOWED_ATTR) ? Fn({}, x.ALLOWED_ATTR, vn) : He, Xe = it(x, "ALLOWED_NAMESPACES") && Rt(x.ALLOWED_NAMESPACES) ? Fn({}, x.ALLOWED_NAMESPACES, lu) : Nn, en = it(x, "ADD_URI_SAFE_ATTR") && Rt(x.ADD_URI_SAFE_ATTR) ? Fn(Mt(hn), x.ADD_URI_SAFE_ATTR, vn) : hn, ke = it(x, "ADD_DATA_URI_TAGS") && Rt(x.ADD_DATA_URI_TAGS) ? Fn(Mt(Ie), x.ADD_DATA_URI_TAGS, vn) : Ie, W = it(x, "FORBID_CONTENTS") && Rt(x.FORBID_CONTENTS) ? Fn({}, x.FORBID_CONTENTS, vn) : le, Re = it(x, "FORBID_TAGS") && Rt(x.FORBID_TAGS) ? Fn({}, x.FORBID_TAGS, vn) : Mt({}), Ue = it(x, "FORBID_ATTR") && Rt(x.FORBID_ATTR) ? Fn({}, x.FORBID_ATTR, vn) : Mt({}), V = it(x, "USE_PROFILES") ? x.USE_PROFILES && typeof x.USE_PROFILES == "object" ? Mt(x.USE_PROFILES) : x.USE_PROFILES : !1, Me = x.ALLOW_ARIA_ATTR !== !1, De = x.ALLOW_DATA_ATTR !== !1, on = x.ALLOW_UNKNOWN_PROTOCOLS || !1, Fe = x.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ye = x.SAFE_FOR_TEMPLATES || !1, Ze = x.SAFE_FOR_XML !== !1, fe = x.WHOLE_DOCUMENT || !1, Le = x.RETURN_DOM || !1, Pe = x.RETURN_DOM_FRAGMENT || !1, mn = x.RETURN_TRUSTED_TYPE || !1, $e = x.FORCE_BODY || !1, J = x.SANITIZE_DOM !== !1, T = x.SANITIZE_NAMED_PROPS || !1, X = x.KEEP_CONTENT !== !1, re = x.IN_PLACE || !1, q = C2(x.ALLOWED_URI_REGEXP) ? x.ALLOWED_URI_REGEXP : b_, dn = typeof x.NAMESPACE == "string" ? x.NAMESPACE : pn, Oe = it(x, "MATHML_TEXT_INTEGRATION_POINTS") && x.MATHML_TEXT_INTEGRATION_POINTS && typeof x.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Mt(x.MATHML_TEXT_INTEGRATION_POINTS) : Fn({}, ["mi", "mo", "mn", "ms", "mtext"]), an = it(x, "HTML_INTEGRATION_POINTS") && x.HTML_INTEGRATION_POINTS && typeof x.HTML_INTEGRATION_POINTS == "object" ? Mt(x.HTML_INTEGRATION_POINTS) : Fn({}, ["annotation-xml"]);
    const Q = it(x, "CUSTOM_ELEMENT_HANDLING") && x.CUSTOM_ELEMENT_HANDLING && typeof x.CUSTOM_ELEMENT_HANDLING == "object" ? Mt(x.CUSTOM_ELEMENT_HANDLING) : Ti(null);
    if (Be = Ti(null), it(Q, "tagNameCheck") && Un(Q.tagNameCheck) && (Be.tagNameCheck = Q.tagNameCheck), it(Q, "attributeNameCheck") && Un(Q.attributeNameCheck) && (Be.attributeNameCheck = Q.attributeNameCheck), it(Q, "allowCustomizedBuiltInElements") && typeof Q.allowCustomizedBuiltInElements == "boolean" && (Be.allowCustomizedBuiltInElements = Q.allowCustomizedBuiltInElements), Ye && (De = !1), Pe && (Le = !0), V && (Se = Fn({}, Wv), H = Ti(null), V.html === !0 && (Fn(Se, Hv), Fn(H, Kv)), V.svg === !0 && (Fn(Se, cu), Fn(H, mu), Fn(H, To)), V.svgFilters === !0 && (Fn(Se, du), Fn(H, mu), Fn(H, To)), V.mathMl === !0 && (Fn(Se, uu), Fn(H, Gv), Fn(H, To))), Te.tagCheck = null, Te.attributeCheck = null, it(x, "ADD_TAGS") && (typeof x.ADD_TAGS == "function" ? Te.tagCheck = x.ADD_TAGS : Rt(x.ADD_TAGS) && (Se === Ce && (Se = Mt(Se)), Fn(Se, x.ADD_TAGS, vn))), it(x, "ADD_ATTR") && (typeof x.ADD_ATTR == "function" ? Te.attributeCheck = x.ADD_ATTR : Rt(x.ADD_ATTR) && (H === He && (H = Mt(H)), Fn(H, x.ADD_ATTR, vn))), it(x, "ADD_URI_SAFE_ATTR") && Rt(x.ADD_URI_SAFE_ATTR) && Fn(en, x.ADD_URI_SAFE_ATTR, vn), it(x, "FORBID_CONTENTS") && Rt(x.FORBID_CONTENTS) && (W === le && (W = Mt(W)), Fn(W, x.FORBID_CONTENTS, vn)), it(x, "ADD_FORBID_CONTENTS") && Rt(x.ADD_FORBID_CONTENTS) && (W === le && (W = Mt(W)), Fn(W, x.ADD_FORBID_CONTENTS, vn)), X && (Se["#text"] = !0), fe && Fn(Se, ["html", "head", "body"]), Se.table && (Fn(Se, ["tbody"]), delete Re.tbody), x.TRUSTED_TYPES_POLICY) {
      if (typeof x.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Eo('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof x.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Eo('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      E = x.TRUSTED_TYPES_POLICY, I = E.createHTML("");
    } else
      E === void 0 && (E = V2(v, a)), E !== null && typeof I == "string" && (I = E.createHTML(""));
    Vt && Vt(x), yn = x;
  }, xn = Fn({}, [...cu, ...du, ...I2]), _n = Fn({}, [...uu, ...F2]), Hn = function(x) {
    let Q = L(x);
    (!Q || !Q.tagName) && (Q = {
      namespaceURI: dn,
      tagName: "template"
    });
    const ce = Pa(x.tagName), _e = Pa(Q.tagName);
    return Xe[x.namespaceURI] ? x.namespaceURI === cn ? Q.namespaceURI === pn ? ce === "svg" : Q.namespaceURI === rn ? ce === "svg" && (_e === "annotation-xml" || Oe[_e]) : !!xn[ce] : x.namespaceURI === rn ? Q.namespaceURI === pn ? ce === "math" : Q.namespaceURI === cn ? ce === "math" && an[_e] : !!_n[ce] : x.namespaceURI === pn ? Q.namespaceURI === cn && !an[_e] || Q.namespaceURI === rn && !Oe[_e] ? !1 : !_n[ce] && (sn[ce] || !xn[ce]) : !!(gn === "application/xhtml+xml" && Xe[x.namespaceURI]) : !1;
  }, Dn = function(x) {
    Sa(n.removed, {
      element: x
    });
    try {
      L(x).removeChild(x);
    } catch {
      S(x);
    }
  }, Rn = function(x, Q) {
    try {
      Sa(n.removed, {
        attribute: Q.getAttributeNode(x),
        from: Q
      });
    } catch {
      Sa(n.removed, {
        attribute: null,
        from: Q
      });
    }
    if (Q.removeAttribute(x), x === "is")
      if (Le || Pe)
        try {
          Dn(Q);
        } catch {
        }
      else
        try {
          Q.setAttribute(x, "");
        } catch {
        }
  }, Mn = function(x) {
    let Q = null, ce = null;
    if ($e)
      x = "<remove></remove>" + x;
    else {
      const Ke = Uv(x, /^[\r\n\t ]+/);
      ce = Ke && Ke[0];
    }
    gn === "application/xhtml+xml" && dn === pn && (x = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + x + "</body></html>");
    const _e = E ? E.createHTML(x) : x;
    if (dn === pn)
      try {
        Q = new h().parseFromString(_e, gn);
      } catch {
      }
    if (!Q || !Q.documentElement) {
      Q = F.createDocument(dn, "template", null);
      try {
        Q.documentElement.innerHTML = Sn ? I : _e;
      } catch {
      }
    }
    const ee = Q.body || Q.documentElement;
    return x && ce && ee.insertBefore(r.createTextNode(ce), ee.childNodes[0] || null), dn === pn ? Y.call(Q, fe ? "html" : "body")[0] : fe ? Q.documentElement : ee;
  }, t = function(x) {
    return A.call(
      x.ownerDocument || x,
      x,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, c = function(x) {
    return x instanceof f && (typeof x.nodeName != "string" || typeof x.textContent != "string" || typeof x.removeChild != "function" || !(x.attributes instanceof u) || typeof x.removeAttribute != "function" || typeof x.setAttribute != "function" || typeof x.namespaceURI != "string" || typeof x.insertBefore != "function" || typeof x.hasChildNodes != "function");
  }, p = function(x) {
    return typeof l == "function" && x instanceof l;
  };
  function y(x, Q, ce) {
    _a(x, (_e) => {
      _e.call(n, Q, ce, yn);
    });
  }
  const $ = function(x) {
    let Q = null;
    if (y(G.beforeSanitizeElements, x, null), c(x))
      return Dn(x), !0;
    const ce = vn(x.nodeName);
    if (y(G.uponSanitizeElement, x, {
      tagName: ce,
      allowedTags: Se
    }), Ze && x.hasChildNodes() && !p(x.firstElementChild) && bt(/<[/\w!]/g, x.innerHTML) && bt(/<[/\w!]/g, x.textContent) || Ze && x.namespaceURI === pn && ce === "style" && p(x.firstElementChild) || x.nodeType === ja.progressingInstruction || Ze && x.nodeType === ja.comment && bt(/<[/\w]/g, x.data))
      return Dn(x), !0;
    if (Re[ce] || !(Te.tagCheck instanceof Function && Te.tagCheck(ce)) && !Se[ce]) {
      if (!Re[ce] && N(ce) && (Be.tagNameCheck instanceof RegExp && bt(Be.tagNameCheck, ce) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(ce)))
        return !1;
      if (X && !W[ce]) {
        const _e = L(x) || x.parentNode, ee = k(x) || x.childNodes;
        if (ee && _e) {
          const Ke = ee.length;
          for (let Tn = Ke - 1; Tn >= 0; --Tn) {
            const En = _(ee[Tn], !0);
            _e.insertBefore(En, j(x));
          }
        }
      }
      return Dn(x), !0;
    }
    return x instanceof d && !Hn(x) || (ce === "noscript" || ce === "noembed" || ce === "noframes") && bt(/<\/no(script|embed|frames)/i, x.innerHTML) ? (Dn(x), !0) : (Ye && x.nodeType === ja.text && (Q = x.textContent, _a([B, O, z], (_e) => {
      Q = Ci(Q, _e, " ");
    }), x.textContent !== Q && (Sa(n.removed, {
      element: x.cloneNode()
    }), x.textContent = Q)), y(G.afterSanitizeElements, x, null), !1);
  }, P = function(x, Q, ce) {
    if (Ue[Q] || J && (Q === "id" || Q === "name") && (ce in r || ce in wn))
      return !1;
    const _e = H[Q] || Te.attributeCheck instanceof Function && Te.attributeCheck(Q, x);
    if (!(De && !Ue[Q] && bt(Z, Q)) && !(Me && bt(be, Q))) {
      if (!_e || Ue[Q]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(N(x) && (Be.tagNameCheck instanceof RegExp && bt(Be.tagNameCheck, x) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(x)) && (Be.attributeNameCheck instanceof RegExp && bt(Be.attributeNameCheck, Q) || Be.attributeNameCheck instanceof Function && Be.attributeNameCheck(Q, x)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          Q === "is" && Be.allowCustomizedBuiltInElements && (Be.tagNameCheck instanceof RegExp && bt(Be.tagNameCheck, ce) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(ce)))
        ) return !1;
      } else if (!en[Q] && !bt(q, Ci(ce, de, "")) && !((Q === "src" || Q === "xlink:href" || Q === "href") && x !== "script" && Mv(ce, "data:") === 0 && ke[x]) && !(on && !bt(he, Ci(ce, de, ""))) && ce)
        return !1;
    }
    return !0;
  }, w = Fn({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), N = function(x) {
    return !w[Pa(x)] && bt(ye, x);
  }, ne = function(x) {
    y(G.beforeSanitizeAttributes, x, null);
    const {
      attributes: Q
    } = x;
    if (!Q || c(x))
      return;
    const ce = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: H,
      forceKeepAttr: void 0
    };
    let _e = Q.length;
    for (; _e--; ) {
      const ee = Q[_e], {
        name: Ke,
        namespaceURI: Tn,
        value: En
      } = ee, Dt = vn(Ke), Lr = En;
      let vt = Ke === "value" ? Lr : x2(Lr);
      if (ce.attrName = Dt, ce.attrValue = vt, ce.keepAttr = !0, ce.forceKeepAttr = void 0, y(G.uponSanitizeAttribute, x, ce), vt = ce.attrValue, T && (Dt === "id" || Dt === "name") && Mv(vt, U) !== 0 && (Rn(Ke, x), vt = U + vt), Ze && bt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, vt)) {
        Rn(Ke, x);
        continue;
      }
      if (Dt === "attributename" && Uv(vt, "href")) {
        Rn(Ke, x);
        continue;
      }
      if (ce.forceKeepAttr)
        continue;
      if (!ce.keepAttr) {
        Rn(Ke, x);
        continue;
      }
      if (!Fe && bt(/\/>/i, vt)) {
        Rn(Ke, x);
        continue;
      }
      Ye && _a([B, O, z], (X_) => {
        vt = Ci(vt, X_, " ");
      });
      const Op = vn(x.nodeName);
      if (!P(Op, Dt, vt)) {
        Rn(Ke, x);
        continue;
      }
      if (E && typeof v == "object" && typeof v.getAttributeType == "function" && !Tn)
        switch (v.getAttributeType(Op, Dt)) {
          case "TrustedHTML": {
            vt = E.createHTML(vt);
            break;
          }
          case "TrustedScriptURL": {
            vt = E.createScriptURL(vt);
            break;
          }
        }
      if (vt !== Lr)
        try {
          Tn ? x.setAttributeNS(Tn, Ke, vt) : x.setAttribute(Ke, vt), c(x) ? Dn(x) : zv(n.removed);
        } catch {
          Rn(Ke, x);
        }
    }
    y(G.afterSanitizeAttributes, x, null);
  }, M = function(x) {
    let Q = null;
    const ce = t(x);
    for (y(G.beforeSanitizeShadowDOM, x, null); Q = ce.nextNode(); )
      y(G.uponSanitizeShadowNode, Q, null), $(Q), ne(Q), Q.content instanceof o && M(Q.content);
    y(G.afterSanitizeShadowDOM, x, null);
  };
  return n.sanitize = function(x) {
    let Q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ce = null, _e = null, ee = null, Ke = null;
    if (Sn = !x, Sn && (x = "<!-->"), typeof x != "string" && !p(x) && (x = w2(x), typeof x != "string"))
      throw Eo("dirty is not a string, aborting");
    if (!n.isSupported)
      return x;
    if (ge || Vn(Q), n.removed = [], typeof x == "string" && (re = !1), re) {
      const Dt = x.nodeName;
      if (typeof Dt == "string") {
        const Lr = vn(Dt);
        if (!Se[Lr] || Re[Lr])
          throw Eo("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (x instanceof l)
      ce = Mn("<!---->"), _e = ce.ownerDocument.importNode(x, !0), _e.nodeType === ja.element && _e.nodeName === "BODY" || _e.nodeName === "HTML" ? ce = _e : ce.appendChild(_e);
    else {
      if (!Le && !Ye && !fe && // eslint-disable-next-line unicorn/prefer-includes
      x.indexOf("<") === -1)
        return E && mn ? E.createHTML(x) : x;
      if (ce = Mn(x), !ce)
        return Le ? null : mn ? I : "";
    }
    ce && $e && Dn(ce.firstChild);
    const Tn = t(re ? x : ce);
    for (; ee = Tn.nextNode(); )
      $(ee), ne(ee), ee.content instanceof o && M(ee.content);
    if (re)
      return x;
    if (Le) {
      if (Ye) {
        ce.normalize();
        let Dt = ce.innerHTML;
        _a([B, O, z], (Lr) => {
          Dt = Ci(Dt, Lr, " ");
        }), ce.innerHTML = Dt;
      }
      if (Pe)
        for (Ke = K.call(ce.ownerDocument); ce.firstChild; )
          Ke.appendChild(ce.firstChild);
      else
        Ke = ce;
      return (H.shadowroot || H.shadowrootmode) && (Ke = ie.call(i, Ke, !0)), Ke;
    }
    let En = fe ? ce.outerHTML : ce.innerHTML;
    return fe && Se["!doctype"] && ce.ownerDocument && ce.ownerDocument.doctype && ce.ownerDocument.doctype.name && bt(x_, ce.ownerDocument.doctype.name) && (En = "<!DOCTYPE " + ce.ownerDocument.doctype.name + `>
` + En), Ye && _a([B, O, z], (Dt) => {
      En = Ci(En, Dt, " ");
    }), E && mn ? E.createHTML(En) : En;
  }, n.setConfig = function() {
    let x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn(x), ge = !0;
  }, n.clearConfig = function() {
    yn = null, ge = !1;
  }, n.isValidAttribute = function(x, Q, ce) {
    yn || Vn({});
    const _e = vn(x), ee = vn(Q);
    return P(_e, ee, ce);
  }, n.addHook = function(x, Q) {
    typeof Q == "function" && Sa(G[x], Q);
  }, n.removeHook = function(x, Q) {
    if (Q !== void 0) {
      const ce = k2(G[x], Q);
      return ce === -1 ? void 0 : b2(G[x], ce, 1)[0];
    }
    return zv(G[x]);
  }, n.removeHooks = function(x) {
    G[x] = [];
  }, n.removeAllHooks = function() {
    G = Qv();
  }, n;
}
var z2 = __();
const U2 = "_messageContainer_1rxr4_1", M2 = "_chip_1rxr4_7", B2 = "_chipLabel_1rxr4_10", q2 = "_chipValue_1rxr4_13", $o = {
  messageContainer: U2,
  chip: M2,
  chipLabel: B2,
  chipValue: q2
}, Jv = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, H2 = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  qe(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ tn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ tn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ tn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ tn.jsx(We, { content: "Conversation Attributes", children: /* @__PURE__ */ tn.jsx(
        Nm,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ tn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ tn.jsx(An, { className: $o.chip, children: /* @__PURE__ */ tn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ tn.jsxs(Zn, { className: $o.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ tn.jsx(Zn, { className: $o.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ tn.jsx(
      b,
      {
        className: $o.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? Jv[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? Jv[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ tn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ tn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ tn.jsx(D.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ tn.jsx(D.Paragraph, { variant: "4", children: /* @__PURE__ */ tn.jsx(ES, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ tn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: z2.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ tn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ tn.jsx(
      TS,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ tn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, W2 = "_conversation_1draa_1", K2 = "_conversationSubLine_1draa_9", G2 = "_modal_1draa_14", pu = {
  conversation: W2,
  conversationSubLine: K2,
  modal: G2
}, Y2 = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), Q2 = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), J2 = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = se(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ tn.jsxs(b, { className: pu.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ tn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ tn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ tn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ tn.jsx(D.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ tn.jsx(Pn, { size: "small", variant: "info", children: Ln(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ tn.jsx(
          D.Heading,
          {
            variant: "heading-4",
            className: pu.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ tn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ tn.jsx(An, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ tn.jsx(We, { content: "Show conversation preview", children: /* @__PURE__ */ tn.jsx(
        Kt,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ tn.jsxs(
      wt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: pu.modal,
        children: [
          /* @__PURE__ */ tn.jsx(
            Ct,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ tn.jsx(It, { children: /* @__PURE__ */ tn.jsx(
            H2,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: Y2(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: Q2(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, X2 = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = se(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Bn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ tn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ tn.jsx(
      J2,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ tn.jsxs(
      Kn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, Z2 = h2(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), eL = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = se([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = un(), { data: l, loading: d, error: m } = s(Z2, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return qe(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ tn.jsx(Cn, { error: m }) : d ? /* @__PURE__ */ tn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ tn.jsx(ln, {}) }) : r?.length === 0 ? /* @__PURE__ */ tn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ tn.jsx(
    X2,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, cm = [
  {
    key: "miurosClientId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], fu = "MIUROS", nL = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, tL = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = mt({
    mode: "onChange",
    defaultValues: nL
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: v,
    setMisconfigurationCause: C
  } = qr({
    integrationId: e,
    integrationType: fu,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: _,
    error: S,
    isWidgetUnknown: j,
    refetch: k,
    widgetConfiguration: L
  } = Hr({
    integrationId: e,
    fieldDefinitions: cm,
    form: l,
    onMisconfigured: C
  }), { renderConditions: E, setRenderConditions: I, renderConditionsForSubmit: F } = Wr({
    integrationId: e,
    widgetConfiguration: L,
    renderConditionsEditor: o
  }), A = (Y) => Gr(Y, {
    fieldDefinitions: cm,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: F
  }), K = l.watch("name");
  return /* @__PURE__ */ tn.jsxs(
    Kr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: A,
      error: S ?? h,
      onRetry: S ? k : void 0,
      isLoading: f || _,
      isWidgetUnknown: j,
      children: [
        v && /* @__PURE__ */ tn.jsx(Yr, { cause: v }),
        /* @__PURE__ */ tn.jsxs(rt, { children: [
          /* @__PURE__ */ tn.jsx(ue, { children: /* @__PURE__ */ tn.jsx(nn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ tn.jsx(
            $n,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ tn.jsx(ue, { span: 3, children: /* @__PURE__ */ tn.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ tn.jsx(ue, { span: 3 }),
          /* @__PURE__ */ tn.jsx(ue, { span: 3, children: /* @__PURE__ */ tn.jsx(
            Gn,
            {
              name: "miurosClientId",
              label: "Authorization: Client ID",
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ tn.jsx(ue, { span: 3 }),
          /* @__PURE__ */ tn.jsx(ue, { span: 3, children: /* @__PURE__ */ tn.jsx(
            bs,
            {
              name: "miurosClientSecret",
              label: "Authorization: Client secret",
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ tn.jsx(ue, { span: 3 }),
          /* @__PURE__ */ tn.jsx(ue, { span: 3, children: /* @__PURE__ */ tn.jsx(
            Gn,
            {
              name: "amountOfConversationsToShow",
              label: "Number of conversation to show before the fold",
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (Y) => !Number.isNaN(Number.parseInt(Y, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ tn.jsx(ue, { span: 3 }),
          !s && e && /* @__PURE__ */ tn.jsx(
            Hi,
            {
              configuration: n,
              integrationId: e,
              integrationType: fu,
              label: "Authorize"
            }
          ),
          o && E !== null && /* @__PURE__ */ tn.jsx(ue, { children: o({
            value: E,
            onChange: I,
            configurationKey: L?.id
          }) })
        ] }),
        /* @__PURE__ */ tn.jsx(
          Qr,
          {
            integrationType: fu,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var hu = { exports: {} }, wa = {}, Xv;
function rL() {
  if (Xv) return wa;
  Xv = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return wa.Fragment = r, wa.jsx = s, wa.jsxs = s, wa;
}
var Do = {}, Zv;
function iL() {
  return Zv || (Zv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Do.Fragment = i, Do.jsx = Rn, Do.jsxs = Mn;
  })()), Do;
}
var ek;
function aL() {
  return ek || (ek = 1, process.env.NODE_ENV === "production" ? hu.exports = rL() : hu.exports = iL()), hu.exports;
}
var Ne = aL();
const oL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, sL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, lL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, cL = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": oL,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": sL,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": lL
};
function _p(e) {
  return cL[e] ?? {};
}
const dL = _p(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), uL = _p(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), mL = _p(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function dm(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const pL = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, S_ = "DD MMM YYYY @ HH:mm", fL = "_list_2c4dq_1", hL = "_listItem_2c4dq_4", yL = "_copyIcon_2c4dq_12", pi = {
  list: fL,
  listItem: hL,
  copyIcon: yL
}, um = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = dm(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: v,
    country_code: C
  } = e ?? {}, _ = `${d} ${m}`.trim() || void 0, S = `${h} ${v}`.trim() || void 0, j = [_, u, f, S, C].filter(
    Boolean
  );
  return /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Ne.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ne.jsx(me, { size: l, name: n }),
      i ? /* @__PURE__ */ Ne.jsx(ln, { size: l }) : /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "4", children: j.map((k, L) => /* @__PURE__ */ Ne.jsx(Zn, { children: k }, L)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Ne.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Ne.jsx(We, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Ne.jsx(
        me,
        {
          size: l,
          name: "exclamation",
          className: pi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Ne.jsx(We, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Ne.jsx(
        me,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(j.join(", ")),
          className: pi.copyIcon
        }
      ) })
    ] })
  ] });
}, gL = "_wrapper_1nher_1", vL = {
  wrapper: gL
}, kL = ({
  customer: e,
  store: n
}) => {
  const { track: r } = bn(), { isCopied: i, copy: a } = dm(), { isCopied: o, copy: s } = dm(), { useQuery: l } = un(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(uL, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, v = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, C = (h?.addresses?.length ?? 0) > 1;
  if (qe(() => {
    v && r("recharge:profile:received");
  }, [v, r]), u)
    return /* @__PURE__ */ Ne.jsx(Cn, { error: u });
  if (!e)
    return null;
  const {
    id: _,
    phone: S,
    email: j,
    first_name: k,
    last_name: L,
    created_at: E,
    has_valid_payment_method: I
  } = e, F = 14, A = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${_}` : null, K = `${k || ""} ${L || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ne.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ne.jsxs(b, { className: vL.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ne.jsx(D.Heading, { variant: "heading-2", children: K }),
    E && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "4", children: Ln(E).format(S_) })
    ] }),
    j && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(me, { size: F, name: "mail" }),
        /* @__PURE__ */ Ne.jsx(D.ExternalLink, { href: `mailto:${j}`, children: j })
      ] }),
      /* @__PURE__ */ Ne.jsx(We, { content: "Copy email", children: /* @__PURE__ */ Ne.jsx(
        me,
        {
          size: F,
          name: i ? "done" : "copy",
          onClick: () => a(j),
          className: pi.copyIcon
        }
      ) })
    ] }),
    S && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(me, { size: F, name: "phone" }),
        /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "4", children: S })
      ] }),
      /* @__PURE__ */ Ne.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ Ne.jsx(
        me,
        {
          size: F,
          name: o ? "done" : "copy",
          onClick: () => s(S),
          className: pi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Ne.jsx(
      um,
      {
        address: v,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: C
      }
    ),
    /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(me, { size: F, name: "credit-card" }),
        /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Ne.jsx(
        me,
        {
          size: F,
          name: I ? "check-circle" : "close-circle-filled",
          color: I ? "green.500" : "red.500"
        }
      )
    ] }),
    A && /* @__PURE__ */ Ne.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Ne.jsx(me, { size: F, name: "external-link" }),
      /* @__PURE__ */ Ne.jsx(
        D.ExternalLink,
        {
          href: A,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, bL = "_order_1dlaa_1", xL = "_orderIsOpen_1dlaa_9", _L = "_orderHeader_1dlaa_12", SL = "_note_1dlaa_16", Ro = {
  order: bL,
  orderIsOpen: xL,
  orderHeader: _L,
  note: SL
}, NL = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = bn(), [a, o] = se(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: C,
    is_prepaid: _
  } = e, S = 14, j = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, k = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Ne.jsxs(
    b,
    {
      className: tt(Ro.order, {
        [Ro.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ne.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ro.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Ne.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "4", children: Ln(f).format(S_) }) }),
                /* @__PURE__ */ Ne.jsxs(D.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Ne.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Ne.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ Ne.jsx(We, { content: "Note", children: /* @__PURE__ */ Ne.jsx(
            D.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: Ro.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ Ne.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ne.jsx(me, { size: S, name: "activity" }),
            /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "4", children: pL(l) })
            ] })
          ] }),
          /* @__PURE__ */ Ne.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ne.jsx(me, { size: S, name: "credit-card" }),
            /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "4", children: _ ? "Yes" : "No" })
            ] })
          ] }),
          k && /* @__PURE__ */ Ne.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ne.jsx(me, { size: S, name: "cog" }),
            /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "4", children: k })
            ] })
          ] }),
          /* @__PURE__ */ Ne.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ne.jsx(me, { size: S, name: "chart-bar" }),
            /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ne.jsxs(D.Paragraph, { variant: "4", children: [
                C,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Ne.jsx(
            um,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Ne.jsx(
            um,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          j && /* @__PURE__ */ Ne.jsx(
            jt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(j, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Ne.jsx(me, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, jL = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = bn(), { useQuery: i } = un(), {
    loading: a,
    error: o,
    data: s
  } = i(mL, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Ne.jsx(Cn, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ne.jsx(D.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Ne.jsx(Pn, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ne.jsx(ln, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ Ne.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Ne.jsx(D.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ Ne.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ Ne.jsx(
        NL,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ Ne.jsx(
        jt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Ne.jsx(me, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, wL = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ne.jsx(D.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Ne.jsxs(Ge, { className: pi.list, children: [
      /* @__PURE__ */ Ne.jsx(Ge.Text, { variant: "dense", className: pi.listItem, children: /* @__PURE__ */ Ne.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Ne.jsx(Ge.Text, { variant: "dense", className: pi.listItem, children: /* @__PURE__ */ Ne.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Ne.jsx(D.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, CL = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = un(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(dL, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const v = m.graphQLErrors;
    return km({ errors: v }) ? /* @__PURE__ */ Ne.jsx(
      D.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : bm({ errors: v }) ? /* @__PURE__ */ Ne.jsx(
      D.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ne.jsx(Cn, { error: m });
  }
  return d ? /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ne.jsx(ln, {}) }) : f ? l ? /* @__PURE__ */ Ne.jsx(
    D.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Ne.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Ne.jsx(kL, { customer: f, store: h }),
        o && /* @__PURE__ */ Ne.jsx(wL, { customer: f }),
        s && /* @__PURE__ */ Ne.jsx(jL, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Ne.jsx(
    D.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, mm = [
  {
    key: "rechargeAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], IL = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, FL = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: IL
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = qr({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: _,
    isWidgetUnknown: S,
    refetch: j,
    widgetConfiguration: k
  } = Hr({
    integrationId: e,
    fieldDefinitions: mm,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: E, renderConditionsForSubmit: I } = Wr({
    integrationId: e,
    widgetConfiguration: k,
    renderConditionsEditor: a
  }), F = (K) => Gr(K, {
    fieldDefinitions: mm,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), A = s.watch("name");
  return /* @__PURE__ */ Ne.jsxs(
    Kr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: _ ?? f,
      onRetry: _ ? j : void 0,
      isLoading: u || C,
      isWidgetUnknown: S,
      children: [
        h && /* @__PURE__ */ Ne.jsx(Yr, { cause: h }),
        /* @__PURE__ */ Ne.jsxs(rt, { children: [
          /* @__PURE__ */ Ne.jsx(ue, { children: /* @__PURE__ */ Ne.jsx(nn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ne.jsx(
            $n,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(ue, { span: 3, children: /* @__PURE__ */ Ne.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ne.jsx(ue, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(ue, { span: 3, children: /* @__PURE__ */ Ne.jsx(
            bs,
            {
              name: "rechargeAccessToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ne.jsx(ue, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(ue, { span: 3, children: /* @__PURE__ */ Ne.jsx(nn, { label: "Displays details of a customer", children: /* @__PURE__ */ Ne.jsx(
            $n,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(ue, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(ue, { span: 3, children: /* @__PURE__ */ Ne.jsx(nn, { label: "Displays the subscription overview", children: /* @__PURE__ */ Ne.jsx(
            $n,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(ue, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(ue, { span: 3, children: /* @__PURE__ */ Ne.jsx(nn, { label: "Displays the last 5 orders", children: /* @__PURE__ */ Ne.jsx(
            $n,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(ue, { span: 3 }),
          a && L !== null && /* @__PURE__ */ Ne.jsx(ue, { children: a({
            value: L,
            onChange: E,
            configurationKey: k?.id
          }) })
        ] }),
        /* @__PURE__ */ Ne.jsx(
          Qr,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_yc0fe_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._order_yc0fe_6{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_yc0fe_6:hover,._orderIsOpen_yc0fe_14{border-color:var(--dixa-color-neutral-400)}._orderHeader_yc0fe_17{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var yu = { exports: {} }, Ca = {}, nk;
function EL() {
  if (nk) return Ca;
  nk = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ca.Fragment = r, Ca.jsx = s, Ca.jsxs = s, Ca;
}
var Oo = {}, tk;
function TL() {
  return tk || (tk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Oo.Fragment = i, Oo.jsx = Rn, Oo.jsxs = Mn;
  })()), Oo;
}
var rk;
function $L() {
  return rk || (rk = 1, process.env.NODE_ENV === "production" ? yu.exports = EL() : yu.exports = TL()), yu.exports;
}
var g = $L();
const ik = "__PairingContext__", DL = () => globalThis[ik] ?? (() => {
  const e = ib({});
  return globalThis[ik] = e, e;
})(), RL = DL(), OL = () => _m(RL), PL = "_banner_d9pot_1", AL = "_list_d9pot_8", ak = {
  banner: PL,
  list: AL
}, ok = "https://apps.shopify.com/dixa-dashboard", LL = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, N_ = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = OL(), [i, a] = se(!1), [o, s] = se(null), l = LL[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? ok,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(ok, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsxs(b, { gap: "300", flexDirection: "column", className: ak.banner, children: [
    /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ g.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ g.jsx(b, { children: /* @__PURE__ */ g.jsx(me, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ g.jsx(D.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ g.jsx(D.Paragraph, { as: "div", children: /* @__PURE__ */ g.jsx(m, { className: ak.list, children: l.listItems.map((u, f) => /* @__PURE__ */ g.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ g.jsx(D.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ g.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ g.jsx(
      Kn,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ g.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ g.jsx(ln, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, VL = (e) => /* @__PURE__ */ g.jsx(N_, { ...e, bannerVariant: "install" }), zL = (e) => /* @__PURE__ */ g.jsx(N_, { ...e, bannerVariant: "migration" }), UL = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], ML = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], BL = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: VL
  }
], qL = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], sk = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: zL,
    additionalProperties: { renderAboveForm: !0 }
  }
], j_ = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], lk = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Zk(e)
  },
  ...j_
];
var Di = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Di || {}), fi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(fi || {}), xr = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(xr || {}), w_ = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(w_ || {}), oi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(oi || {}), Dr = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Dr || {}), Zo = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(Zo || {}), C_ = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(C_ || {});
const HL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, WL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, KL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, GL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, YL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, QL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, JL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, XL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, ZL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, eV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, nV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, tV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, rV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, iV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, aV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, oV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, sV = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": HL,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": WL,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": KL,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": GL,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": YL,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": QL,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": JL,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": XL,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": ZL,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": eV,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": nV,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": tV,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": rV,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": iV,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": aV,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": oV
};
function sr(e) {
  return sV[e] ?? {};
}
const lV = sr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), cV = sr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), dV = sr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), uV = sr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Sp = sr(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), mV = sr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), pV = sr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), fV = sr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), hV = sr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), yV = sr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), gV = sr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), vV = sr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), I_ = Ss`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, kV = Ss`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, bV = ({
  conversationContext: e
}) => {
  const { useQuery: n } = un(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: d,
    data: m,
    refetch: u,
    networkStatus: f
  } = n(lV, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: d,
    customerData: m,
    refetchCustomer: u,
    customerNetworkStatus: f
  };
}, xV = () => {
  const { useLazyQuery: e } = un(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(cV);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Nr(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const _V = "_list_alvh6_1", SV = "_listItem_alvh6_4", NV = "_fullWidth_alvh6_15", jV = "_boxWrapper_alvh6_19", Et = {
  list: _V,
  listItem: SV,
  fullWidth: NV,
  boxWrapper: jV
}, wV = "_modal_1vkwz_1", CV = "_disabled_1vkwz_5", gu = {
  modal: wV,
  disabled: CV
}, ck = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: fi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: fi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: fi.Unknown
  }
], dk = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: xr.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: xr.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: xr.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: xr.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: xr.Unsubscribed
  }
], IV = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = bn(), { useMutation: l, showNotification: d } = un(), [m, u] = se(), [f, h] = se(), [v, C] = vf(!0), [_, S] = vf(!0), j = !!m, k = e.customer?.email, L = e.customer?.phone_number, E = e.customer?.given_name, I = e.customer?.family_name, F = {
    email: k ?? "",
    phone: L ?? "",
    firstName: E ?? "",
    lastName: I ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, A = mt({
    defaultValues: F
  });
  qe(() => {
    f?.forEach((O) => {
      const z = O?.field?.[0];
      z && (A.setError(z, {
        type: "server",
        message: O.message
      }), A.setFocus(z));
    });
  }, [f, A]);
  const [K, { error: Y, reset: ie }] = l(gV, {
    onError: (O) => {
      u(O.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (O) => {
      const z = O?.Shopify?.customerCreate?.userErrors || [];
      z.length > 0 ? (h(z), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), G = at(
    (O) => {
      a(!0), u(void 0), K({
        variables: {
          input: {
            firstName: O.firstName,
            lastName: O.lastName,
            ...v && { email: O.email },
            ..._ && { phone: O.phone },
            ...O.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: O.smsMarketingState,
                marketingOptInLevel: O.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [K, a, _, v]
  ), B = () => {
    r(!1), ie(), u(void 0), A.reset(F);
  };
  return /* @__PURE__ */ g.jsxs(wt, { isOpen: n, onClose: B, className: gu.modal, children: [
    /* @__PURE__ */ g.jsx(Ct, { title: "Create new customer", onClose: B }),
    /* @__PURE__ */ g.jsx(It, { children: /* @__PURE__ */ g.jsxs(rt, { children: [
      /* @__PURE__ */ g.jsx(ue, { span: 3, children: /* @__PURE__ */ g.jsx(
        Gn,
        {
          label: "First name",
          name: "firstName",
          control: A.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ g.jsx(ue, { span: 3, children: /* @__PURE__ */ g.jsx(
        Gn,
        {
          label: "Last name",
          name: "lastName",
          control: A.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(
        Gn,
        {
          label: "Email",
          name: "email",
          control: A.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: tt({
              [gu.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ g.jsx(
                Tu,
                {
                  disabled: !_,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => C()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(
        Gn,
        {
          label: "Phone",
          name: "phone",
          control: A.control,
          rules: {
            required: _ ? "Phone is required" : void 0
          },
          componentProps: {
            className: tt({
              [gu.disabled]: !_
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ g.jsx(
                Tu,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: _,
                  onChange: () => S()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(
        fr,
        {
          control: A.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (O, z) => O === z,
            getItemTitleByValue: (O) => {
              const z = dk.find(
                (Z) => Z.value === O
              );
              return /* @__PURE__ */ g.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: z.label }),
                    /* @__PURE__ */ g.jsx(D.Paragraph, { color: "secondary", children: z.description })
                  ]
                }
              );
            }
          },
          children: dk.map((O) => /* @__PURE__ */ g.jsx(lt.Item, { value: O.value, children: /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ g.jsx(D.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(
        fr,
        {
          control: A.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (O, z) => O === z,
            getItemTitleByValue: (O) => {
              const z = ck.find(
                (Z) => Z.value === O
              );
              return /* @__PURE__ */ g.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: z.label }),
                    /* @__PURE__ */ g.jsx(D.Paragraph, { color: "secondary", children: z.description })
                  ]
                }
              );
            }
          },
          children: ck.map((O) => /* @__PURE__ */ g.jsx(lt.Item, { value: O.value, children: /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ g.jsx(D.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      j && /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ g.jsx(me, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ g.jsx(D.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ g.jsx(
      Tt,
      {
        confirmProps: {
          disabled: !(A.formState.isValid && A.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ g.jsx(ln, { size: 16 })
        },
        confirmOnClick: A.handleSubmit(G),
        cancelOnClick: B,
        confirmName: Y ? "Close" : "Save",
        cancelName: Y ? void 0 : "Cancel"
      }
    )
  ] });
}, FV = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = se(!1), [a, o] = se(!1);
  return /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
    /* @__PURE__ */ g.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ g.jsx(ln, { size: 16 }),
        slotStart: /* @__PURE__ */ g.jsx(me, { size: 14, name: "user-plus", color: "green.500" }),
        className: Et.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ g.jsx(
      IV,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Np = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, pm = "DD MMM YYYY @ HH:mm", EV = "_wrapper_10fld_1", TV = "_copyIcon_10fld_7", Po = {
  wrapper: EV,
  copyIcon: TV
}, $V = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Nr(), { isCopied: l, copy: d } = Nr(), { track: m } = bn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: C = [],
    verifiedEmail: _
  } = e, S = h?.emailAddress, j = v?.phoneNumber, k = Np(u), L = `https://${n}/admin/customers/${k ?? ""}`, E = i && a === Wt.refetch, I = 14;
  return /* @__PURE__ */ g.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ g.jsxs(b, { className: Po.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: f }),
        E ? /* @__PURE__ */ g.jsx(ln, { size: I }) : /* @__PURE__ */ g.jsx(We, { content: "Reload customer", children: /* @__PURE__ */ g.jsx(
          me,
          {
            size: I,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: Po.copyIcon
          }
        ) })
      ] }),
      S && /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ g.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ g.jsx(me, { size: I, name: "mail" }),
          /* @__PURE__ */ g.jsx(D.ExternalLink, { href: `mailto:${S}`, children: S }),
          /* @__PURE__ */ g.jsx(
            We,
            {
              content: _ ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ g.jsx(b, { alignItems: "center", children: /* @__PURE__ */ g.jsx(
                me,
                {
                  size: I,
                  color: _ ? "green.500" : "red.500",
                  name: _ ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ g.jsx(We, { content: "Copy Email", children: /* @__PURE__ */ g.jsx(
          me,
          {
            size: I,
            name: o ? "done" : "copy",
            onClick: () => s(S),
            className: Po.copyIcon
          }
        ) })
      ] }),
      j && /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ g.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ g.jsx(me, { size: I, name: "phone" }),
          /* @__PURE__ */ g.jsx(D.ExternalLink, { href: `tel:${j}`, children: j })
        ] }),
        /* @__PURE__ */ g.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ g.jsx(
          me,
          {
            size: I,
            name: l ? "done" : "copy",
            onClick: () => d(j),
            className: Po.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ g.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ g.jsx(me, { size: I, name: "external-link" }),
        /* @__PURE__ */ g.jsx(
          D.ExternalLink,
          {
            href: L,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    C.length > 0 && /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
      /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ g.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: C.map((F) => /* @__PURE__ */ g.jsx(An, { children: F }, `${u}-${F}`)) })
    ] })
  ] });
}, DV = "_creationModal_pbe64_1", RV = "_detailsModal_pbe64_5", OV = "_percentageSuffix_pbe64_9", vu = {
  creationModal: DV,
  detailsModal: RV,
  percentageSuffix: OV
}, PV = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, AV = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: w_.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, uk = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], mk = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], pk = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], LV = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = Jt(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ g.jsxs(Ge, { children: [
      /* @__PURE__ */ g.jsx(Ge.Text, { children: /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ g.jsx(Ge.Text, { children: /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ g.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ g.jsx(
            me,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ g.jsx(Ge.Text, { children: /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ g.jsx(Ge.Text, { children: /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ g.jsx(Ge.Text, { children: /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "2", color: "secondary", children: Ln(e?.startsAt).format(gt) })
      ] }) })
    ] }),
    /* @__PURE__ */ g.jsx(nn, { label: "Discount code", children: /* @__PURE__ */ g.jsx(
      pr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, VV = "shopify-discount-code-form", fk = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, zV = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = bn(), { useMutation: i, showNotification: a } = un(), [o, s] = se(
    []
  ), [l, d] = se(), m = mt({
    mode: "all",
    defaultValues: fk
  });
  qe(() => {
    o?.forEach((I) => {
      const F = I?.field?.[1];
      F && m.setError(F, {
        type: "server",
        message: I.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), v = Bn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    C,
    {
      loading: _,
      error: S,
      reset: j
    }
  ] = i(vV, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (I) => {
      const F = I?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (F && F.length > 0)
        s(F);
      else {
        const A = I?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        A && "codes" in A && d(A), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), k = () => {
    m.setValue("code", PV(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, L = (I) => {
    C({
      variables: {
        input: AV(I)
      }
    });
  }, E = () => {
    m.reset(fk), s([]), j(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ g.jsxs(
    wt,
    {
      isOpen: e,
      onClose: E,
      className: tt({
        [vu.creationModal]: !u,
        [vu.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ g.jsx(
          Ct,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: E
          }
        ),
        /* @__PURE__ */ g.jsxs(It, { children: [
          u && /* @__PURE__ */ g.jsx(LV, { codeDiscount: l }),
          !u && /* @__PURE__ */ g.jsxs("form", { noValidate: !0, id: VV, onSubmit: m.handleSubmit(L), children: [
            /* @__PURE__ */ g.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ g.jsx(
              _s,
              {
                variant: "info",
                description: /* @__PURE__ */ g.jsx(D.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ g.jsxs(rt, { children: [
              /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(
                Gn,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ g.jsx(ue, { span: 3, children: /* @__PURE__ */ g.jsx(
                fr,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (I, F) => I === F,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (I) => {
                      const F = uk.find(
                        (A) => A.value === I
                      );
                      return /* @__PURE__ */ g.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: uk.map((I) => /* @__PURE__ */ g.jsx(lt.Item, { value: I.value, children: /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ g.jsx(D.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ g.jsx(ue, { span: 3, children: /* @__PURE__ */ g.jsx(
                Gn,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (I) => {
                      if (I) {
                        if (h === "percentage" && (I < 0 || I > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && I < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ g.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: vu.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(
                Gn,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: k
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ g.jsx(ue, { span: 3, children: /* @__PURE__ */ g.jsx(
                fr,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (I, F) => I === F,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (I) => {
                      const F = mk.find(
                        (A) => A.value === I
                      );
                      return /* @__PURE__ */ g.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: mk.map((I) => /* @__PURE__ */ g.jsx(lt.Item, { value: I.value, children: /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ g.jsx(D.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ g.jsx(ue, { span: 3, children: /* @__PURE__ */ g.jsx(
                Gn,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (I) => {
                      if (I && f !== "none" && I < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(
                fr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (I, F) => I === F,
                    getItemTitleByValue: (I) => {
                      const F = pk.find(
                        (A) => A.value === I
                      );
                      return /* @__PURE__ */ g.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: pk.map((I) => /* @__PURE__ */ g.jsx(lt.Item, { value: I.value, children: /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ g.jsx(D.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) })
            ] })
          ] }),
          S && /* @__PURE__ */ g.jsx(Cn, { error: S })
        ] }),
        /* @__PURE__ */ g.jsx(
          Tt,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: _,
              loadingIndicator: /* @__PURE__ */ g.jsx(ln, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? E : m.handleSubmit(L),
            cancelOnClick: u ? void 0 : E
          }
        )
      ]
    }
  );
}, UV = ({ code: e }) => {
  const { isCopied: n, copy: r } = Nr();
  return /* @__PURE__ */ g.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ g.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ g.jsx(me, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ g.jsx(
          Kt,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, MV = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ g.jsx(Ge, { children: i.map((a) => /* @__PURE__ */ g.jsx(Ge.Item, { className: Et.listItem, children: /* @__PURE__ */ g.jsx(UV, { code: a.code }, a.id) }, a.id)) })
  ] });
}, BV = "_modal_11d6e_1", qV = "_modalBody_11d6e_4", HV = "_codeContainer_11d6e_9", ku = {
  modal: BV,
  modalBody: qV,
  codeContainer: HV
}, WV = [50, 100, 250], F_ = 50, KV = {
  maxNumberOfCodesToDisplay: F_
}, GV = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = un(), [i, a] = se(
    F_
  ), [o, s] = se([]), l = o.length === 0, d = o.length > i, m = mt({
    mode: "all",
    defaultValues: KV
  }), { loading: u, error: f } = r(mV, {
    variables: {
      first: i
    },
    onCompleted: (v) => {
      const C = v?.Shopify?.codeDiscountNodes?.nodes ?? [];
      C && C.length > 0 && s(C);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ g.jsxs(wt, { isOpen: e, onClose: h, className: ku.modal, children: [
    /* @__PURE__ */ g.jsx(Ct, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ g.jsxs(It, { className: ku.modalBody, children: [
      d && /* @__PURE__ */ g.jsx(rt, { children: /* @__PURE__ */ g.jsx(ue, { span: 3, children: /* @__PURE__ */ g.jsx(
        fr,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (v) => {
              a(v.selectedValues[0]);
            },
            getItemTitleByValue: (v) => /* @__PURE__ */ g.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: v }) })
          },
          children: WV.map((v) => /* @__PURE__ */ g.jsx(lt.Item, { value: v, children: /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: v }) }, v))
        }
      ) }) }),
      u && /* @__PURE__ */ g.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ g.jsx(ln, {}) }),
      f && /* @__PURE__ */ g.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ g.jsx(D.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !u && l && /* @__PURE__ */ g.jsx(
        ts,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !u && !f && !l && o.map((v) => /* @__PURE__ */ g.jsx("div", { className: ku.codeContainer, children: /* @__PURE__ */ g.jsx(MV, { discountCode: v }) }, v.id))
    ] }),
    /* @__PURE__ */ g.jsx(Tt, { confirmName: "Close", confirmOnClick: h })
  ] });
}, YV = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = se(!1), [i, a] = se(!1);
  return /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
    /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ g.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ g.jsx(b, { flex: "1", children: /* @__PURE__ */ g.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ g.jsx(b, { flex: "1", children: /* @__PURE__ */ g.jsx(
          Kn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ g.jsx(
      GV,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ g.jsx(
      zV,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, QV = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? nb(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case Di.Invalid:
      case Di.NotSubscribed:
      case xr.NotSubscribed:
        return "red.500";
      case Di.Pending:
      case xr.Pending:
      case Di.Unsubscribed:
      case xr.Unsubscribed:
        return "orange.500";
      case Di.Subscribed:
      case xr.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case fi.SingleOptIn:
      case fi.ConfirmedOptIn:
        return "green.500";
      case fi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ g.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ g.jsx(me, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ g.jsx(We, { content: "Last updated at", children: /* @__PURE__ */ g.jsx(Pn, { size: "small", variant: "info", children: Ln(l).format(pm) }) }),
      /* @__PURE__ */ g.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ g.jsx(We, { content: "Opt-In state", children: /* @__PURE__ */ g.jsx(An, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ g.jsx(We, { content: "Marketing state", children: /* @__PURE__ */ g.jsx(An, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ g.jsx(me, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ g.jsx(We, { content: "Last updated at", children: /* @__PURE__ */ g.jsx(Pn, { size: "small", variant: "info", children: Ln(u).format(pm) }) }),
      /* @__PURE__ */ g.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ g.jsx(We, { content: "Opt-In state", children: /* @__PURE__ */ g.jsx(An, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ g.jsx(We, { content: "Marketing state", children: /* @__PURE__ */ g.jsx(An, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, JV = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a ?? "",
          kind: C_.Refund,
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    refunds: r.refunds
  }));
}, hk = [
  {
    value: Dr.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Dr.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Dr.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Dr.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Dr.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Dr.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Dr.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], yk = [
  {
    value: Zo.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: Zo.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: Zo.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], E_ = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), Ri = (e) => XV(ZV(e)), XV = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), ZV = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, ri = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ g.jsx(
  Nt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ g.jsx(
      ir,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), e3 = "_modal_1wlra_1", n3 = {
  modal: e3
};
function gk(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const vk = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], kk = "shopify-shiping-address-form", t3 = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = un(), { track: f } = bn(), [h, v] = se(!1), [C, _] = se({}), S = !l, [
    j,
    { error: k, reset: L }
  ] = m(pV, {
    onError: () => {
      v(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (G) => {
      v(!1);
      const B = G?.Shopify?.orderUpdate?.userErrors;
      if (B != null && B.length > 0) {
        const O = B.reduce(
          (z, Z) => {
            const be = Z.field;
            if (be == null || be.length === 0)
              return z;
            const he = be[be.length - 1];
            return he != null && (z[he] = Z.message), z;
          },
          {}
        );
        _(O);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), ie();
    }
  }), E = at(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: vk.find(
        (G) => G === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: I, handleSubmit: F, formState: A, reset: K } = mt({
    mode: "all",
    defaultValues: E()
  }), Y = F((G) => {
    if (S) {
      if (v(!0), !o || !a) {
        v(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: B, ...O } = G, z = {
        ...O,
        countryCode: B
      };
      j({
        variables: {
          input: {
            id: a,
            shippingAddress: z
          }
        }
      });
    } else
      l(G), ie();
  });
  qe(() => {
    r && K(E());
  }, [r, n, K, E]);
  const ie = () => {
    K(E()), _({}), L(), i(!1);
  };
  return /* @__PURE__ */ g.jsxs(
    wt,
    {
      isOpen: r,
      onClose: ie,
      className: n3.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ g.jsx(Ct, { title: e, onClose: () => ie() }),
        /* @__PURE__ */ g.jsx(It, { children: /* @__PURE__ */ g.jsxs("form", { noValidate: !0, id: kk, onSubmit: Y, children: [
          k && /* @__PURE__ */ g.jsx(Cn, { error: k }),
          /* @__PURE__ */ g.jsxs(rt, { children: [
            /* @__PURE__ */ g.jsx(ue, { span: 3, children: /* @__PURE__ */ g.jsx(
              ri,
              {
                required: !0,
                control: I,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ g.jsx(ue, { span: 3, children: /* @__PURE__ */ g.jsx(
              ri,
              {
                required: !0,
                control: I,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ g.jsx(ue, { span: 6, children: /* @__PURE__ */ g.jsx(
              ri,
              {
                control: I,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ g.jsx(ue, { span: 6, children: /* @__PURE__ */ g.jsx(
              ri,
              {
                required: !0,
                control: I,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ g.jsx(ue, { span: 6, children: /* @__PURE__ */ g.jsx(
              ri,
              {
                control: I,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ g.jsx(ue, { span: 3, children: /* @__PURE__ */ g.jsx(
              ri,
              {
                required: !0,
                control: I,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ g.jsx(ue, { span: 3, children: /* @__PURE__ */ g.jsx(
              ri,
              {
                required: !0,
                control: I,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ g.jsx(ue, { span: 6, children: /* @__PURE__ */ g.jsx(
              fr,
              {
                name: "countryCodeV2",
                control: I,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (G) => G ? gk(G) : ""
                },
                children: vk.filter((G) => s.includes(G)).map((G) => /* @__PURE__ */ g.jsx(lt.Item, { value: G, children: /* @__PURE__ */ g.jsx(D.Paragraph, { children: gk(G) }) }, G))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ g.jsx(
          Tt,
          {
            confirmProps: {
              disabled: !(A.isValid && A.isDirty),
              type: "submit",
              form: kk,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ g.jsx(ln, { size: 16 })
            },
            confirmOnClick: () => {
              k && ie();
            },
            cancelOnClick: () => {
              o && a && !k && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ie();
            },
            confirmName: k ? "Close" : "Save",
            cancelName: k ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, r3 = "_clickableIcon_33mqm_1", bu = {
  clickableIcon: r3
}, bk = ({
  formFieldName: e,
  ...n
}) => {
  const r = wr(), { field: i } = zm({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ g.jsx(
    fm,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, fm = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = se(!1), [h, v] = se(m), { isCopied: C, copy: _ } = Nr(), { track: S } = bn(), j = 14, k = o && (!!r || !!l), L = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), E = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), I = n?.countryCodeV2 && mS(n.countryCodeV2), F = at(() => [
    E,
    n?.company,
    n?.address1,
    n?.address2,
    L,
    n?.province,
    I
  ].filter(Boolean).join(`
`), [n, E, L, I]);
  if (!n)
    return null;
  const A = () => {
    i && r && S("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
    /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ g.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ g.jsx(me, { size: j, name: s, color: "green.500" }),
        /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ g.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: bu.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ g.jsx(
                  me,
                  {
                    size: j,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ g.jsxs(b, { gap: "100", flexDirection: "column", children: [
            E && /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: E }),
            n?.company && /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: n.address2 }),
            L && /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: L }),
            n?.province && /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: n.province }),
            I && /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: I })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ g.jsxs(b, { gap: "250", flexDirection: "row", children: [
        k && /* @__PURE__ */ g.jsx(We, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ g.jsx(
          me,
          {
            size: j,
            name: "pen",
            onClick: () => A(),
            className: bu.clickableIcon
          }
        ) }),
        /* @__PURE__ */ g.jsx(We, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ g.jsx(
          me,
          {
            size: j,
            name: C ? "done" : "copy",
            onClick: () => _(F()),
            className: bu.clickableIcon
          }
        ) })
      ] })
    ] }),
    k && /* @__PURE__ */ g.jsx(
      t3,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, jp = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = wr(), i = La({ control: r.control, name: "lineItems" }), a = La({
    control: r.control,
    name: "billingAddress"
  }), o = La({
    control: r.control,
    name: "shippingAddress"
  }), s = Bn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = Bn(() => !s || s.length === 0 ? 0 : s.reduce((m, u) => {
    const f = u.priceRangeV2?.minVariantPrice?.amount || 0, h = u.quantity || 0;
    return m + f * h;
  }, 0), [s]), d = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
      /* @__PURE__ */ g.jsxs(D.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ g.jsx(
        bk,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ g.jsx(
        bk,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${d}` })
    ] }),
    /* @__PURE__ */ g.jsx(D.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, i3 = "_productTableHeader_6h6pl_1", a3 = "_productImage_6h6pl_5", Ba = {
  productTableHeader: i3,
  productImage: a3
}, wp = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, o3 = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = wr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = wp(e);
  return /* @__PURE__ */ g.jsxs(Jn.Tr, { children: [
    /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ g.jsx(
        Wi,
        {
          src: d,
          alt: e.title,
          className: Ba.productImage
        }
      ),
      /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(
      Gn,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ g.jsx(Kt, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, s3 = 300, Ia = 2, l3 = 25, c3 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = un(), [i, a] = se(""), [o, s] = se([]), l = wr(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(Sp, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (_) => {
      const S = _?.Shopify?.products?.nodes || [];
      s(
        S.filter((j) => !!j).sort((j, k) => j.title.localeCompare(k.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  yi(
    () => {
      i.trim().length >= Ia && !u && f === Wt.ready ? m({
        variables: {
          query: i.trim(),
          productCount: l3,
          mediaCount: 1
        }
      }) : i.trim().length < Ia && s([]);
    },
    s3,
    [i]
  ), qe(() => {
    if (!d) return;
    const _ = o.find(
      (S) => S.id === d
    );
    _ && e(_), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== Wt.ready, v = i.trim().length >= Ia, C = !o.length && !h && v;
  return /* @__PURE__ */ g.jsx(
    fr,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${Ia} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (_) => {
          const S = o.find(
            (j) => j.id === _
          );
          return S ? /* @__PURE__ */ g.jsx(D.Paragraph, { children: S.title }) : null;
        },
        filter: {
          value: i,
          onChange: (_) => {
            a(_.target.value);
          }
        },
        onToggleDropdown: (_) => {
          !_ && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
        h && /* @__PURE__ */ g.jsx(lt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ g.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ g.jsx(ln, {}) }) }),
        !h && o.map((_) => {
          const S = _.totalInventory <= 0, j = wp(_);
          return /* @__PURE__ */ g.jsx(
            lt.Item,
            {
              value: _.id,
              isDisabled: S,
              children: /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ g.jsxs(b, { gap: "200", alignItems: "center", children: [
                  j && /* @__PURE__ */ g.jsx(
                    Wi,
                    {
                      src: j,
                      alt: _.title,
                      className: Ba.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ g.jsx(
                    $S,
                    {
                      text: _.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: _.title })
                ] }),
                /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "5", children: S ? "Out of stock" : `${_.totalInventory} in stock` })
              ] })
            },
            _.id
          );
        }),
        C && /* @__PURE__ */ g.jsx(lt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ g.jsx(
          ts,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !v && !h && /* @__PURE__ */ g.jsx(lt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ g.jsx(
          ts,
          {
            title: "Search for products",
            description: `Type at least ${Ia} characters to search.`
          }
        ) })
      ] })
    }
  );
}, Cp = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const m = wr(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (S) => !o.includes(S?.id)
  ) : [], v = h.length > 0 && h.every(
    (S) => a.includes(S?.id)
  ), C = h.some(
    (S) => a.includes(S?.id)
  ) && !v, _ = at(
    (S) => {
      const j = m.getValues("lineItems"), k = j.findIndex(
        (L) => L?.id === S.id
      );
      if (k > -1) {
        const L = m.getValues(`lineItems.${k}.quantity`) || 0, E = [...j];
        E[k] = {
          ...E[k],
          quantity: L + 1
        }, m.setValue("lineItems", E);
      } else
        m.setValue("lineItems", [
          ...j,
          { ...S, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ g.jsx(c3, { onProductSelected: _ }),
    !f && e && /* @__PURE__ */ g.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Et.boxWrapper,
        children: /* @__PURE__ */ g.jsx(ln, {})
      }
    ),
    !f && !e && /* @__PURE__ */ g.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Et.boxWrapper,
        children: /* @__PURE__ */ g.jsx(
          ts,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ g.jsx(b, { margin: "300 0", children: /* @__PURE__ */ g.jsxs(
      Jn,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Ba.productTable,
        children: [
          /* @__PURE__ */ g.jsx(Jn.Thead, { className: Ba.productTableHeader, children: /* @__PURE__ */ g.jsxs(Jn.Tr, { children: [
            n && /* @__PURE__ */ g.jsx(Jn.Th, { children: /* @__PURE__ */ g.jsx(
              Pp,
              {
                checked: v,
                indeterminate: C,
                onChange: () => d?.(!v)
              }
            ) }),
            /* @__PURE__ */ g.jsx(Jn.Th, { children: "Product" }),
            /* @__PURE__ */ g.jsx(Jn.Th, { children: "In stock" }),
            /* @__PURE__ */ g.jsx(Jn.Th, { children: "Price" }),
            /* @__PURE__ */ g.jsx(Jn.Th, { children: "Quantity" }),
            /* @__PURE__ */ g.jsx(Jn.Th, { children: "Total" }),
            !r && /* @__PURE__ */ g.jsx(Jn.Th, {})
          ] }) }),
          /* @__PURE__ */ g.jsx(Jn.Tbody, { children: u?.map((S, j) => {
            if (!n)
              return /* @__PURE__ */ g.jsx(
                o3,
                {
                  product: S,
                  index: j,
                  onRemove: () => {
                    const B = u.filter(
                      (O, z) => z !== j
                    );
                    m.setValue("lineItems", B);
                  }
                },
                `${S?.id}-${j}`
              );
            const k = S, L = k.priceRangeV2.minVariantPrice.amount, E = k.priceRangeV2.minVariantPrice.currencyCode, I = `lineItems.${j}.quantity`, F = m.watch(I) || 0, A = L * F, K = wp(k), Y = a.includes(k.id), ie = o.includes(k.id), G = s?.[k.id] ?? k.totalInventory;
            return /* @__PURE__ */ g.jsxs(
              Jn.Tr,
              {
                style: ie ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(
                    Pp,
                    {
                      checked: Y,
                      disabled: ie,
                      onChange: () => l?.(k.id, !Y)
                    }
                  ) }),
                  /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsxs(b, { gap: "200", alignItems: "center", children: [
                    K && /* @__PURE__ */ g.jsx(
                      Wi,
                      {
                        src: K,
                        alt: k.title,
                        className: Ba.productImage
                      }
                    ),
                    /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: k.title }),
                      ie && /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: k.totalInventory }) }),
                  /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: `${L} ${E}` }) }),
                  /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(
                    Gn,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: ie || G <= 1,
                      name: I,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: G,
                        tabIndex: 0
                      }
                    },
                    `${I}-${m.watch(I)}`
                  ) }),
                  /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: `${A} ${E}` }) }),
                  !r && /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ g.jsx(
                    Kt,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const B = u.filter(
                          (O, z) => z !== j
                        );
                        m.setValue("lineItems", B), Y && l?.(k.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${k.id}-${j}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, T_ = ({
  previousOrderStatus: e
} = {}) => {
  const n = wr();
  return /* @__PURE__ */ g.jsx(
    fr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = hk.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ g.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ g.jsxs(D.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: hk.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ g.jsx(lt.Item, { value: r.value, children: /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ g.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, $_ = () => {
  const e = wr();
  return /* @__PURE__ */ g.jsx(
    fr,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = yk.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ g.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ g.jsxs(D.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: yk.map((n) => /* @__PURE__ */ g.jsx(lt.Item, { value: n.value, children: /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, d3 = "_modal_1mprq_1", u3 = {
  modal: d3
}, xu = "create-shopify-order-form", m3 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = bn(), [d, m] = se(!1), [
    u,
    f
  ] = se(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Dr.Pending,
    fulfillmentStatus: void 0
  }, [C, _] = se([]), S = mt({
    mode: "all",
    defaultValues: v
  }), j = S.watch("lineItems").length > 0, k = () => {
    S.reset(v), _([]), i(!1);
  };
  qe(() => {
    C.length > 0 && S.setValue("tags", C, { shouldDirty: !0 });
  }, [C, S]);
  const [L, { error: E }] = o(
    I_,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), k();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), k();
      }
    }
  ), [I, { error: F }] = o(
    kV,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), k();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), k();
      }
    }
  ), A = (Y) => {
    const ie = Y.lineItems.map((O) => ({
      productId: O.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: O.priceRangeV2.maxVariantPrice.amount,
          currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: O.quantity
    }));
    m(!0);
    const G = Ri(Y?.billingAddress), B = Ri(
      Y?.shippingAddress
    );
    L({
      variables: {
        order: {
          lineItems: ie,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: Y.customNote,
          tags: Y.tags,
          financialStatus: Y.financialStatus,
          fulfillmentStatus: Y.fulfillmentStatus,
          shippingAddress: B,
          billingAddress: G
        }
      }
    });
  }, K = (Y) => {
    const ie = Y.lineItems.map((O) => ({
      title: O.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: O.priceRangeV2.maxVariantPrice.amount,
        currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: O.quantity
    }));
    f(!0);
    const G = Ri(Y?.billingAddress), B = Ri(
      Y?.shippingAddress
    );
    I({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: Y.customNote,
          tags: Y.tags,
          lineItems: ie,
          shippingAddress: B,
          billingAddress: G
        }
      }
    });
  };
  return /* @__PURE__ */ g.jsxs(
    wt,
    {
      isOpen: e,
      onClose: k,
      className: u3.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ g.jsx(Ct, { title: "Create new order", onClose: k }),
        /* @__PURE__ */ g.jsxs(It, { children: [
          /* @__PURE__ */ g.jsx(Vm, { ...S, children: /* @__PURE__ */ g.jsx("form", { id: xu, children: /* @__PURE__ */ g.jsxs(rt, { children: [
            /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(Cp, {}) }),
            /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(
              Nt,
              {
                name: "tags",
                render: ({ fieldState: { error: Y } }) => /* @__PURE__ */ g.jsx(
                  nn,
                  {
                    label: "Tags",
                    meta: {
                      error: Y?.message
                    },
                    children: /* @__PURE__ */ g.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ie) => {
                          ie.key === "Enter" && (ie.preventDefault(), ie.stopPropagation());
                        },
                        children: /* @__PURE__ */ g.jsx(
                          xs,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: C,
                            onChange: (ie) => {
                              _(ie);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ g.jsx(ue, { span: 4, children: /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ g.jsx(T_, {}),
              /* @__PURE__ */ g.jsx($_, {}),
              /* @__PURE__ */ g.jsx(
                Gn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ g.jsx(ue, { span: 2, children: /* @__PURE__ */ g.jsx(nn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ g.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Et.boxWrapper,
                children: /* @__PURE__ */ g.jsx(jp, {})
              }
            ) }) })
          ] }) }) }),
          (E || F) && /* @__PURE__ */ g.jsx(Cn, { error: E || F })
        ] }),
        /* @__PURE__ */ g.jsx(
          Tt,
          {
            confirmProps: {
              type: "submit",
              form: xu,
              disabled: !j || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ g.jsx(ln, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: S.handleSubmit(A),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                S.handleSubmit(K)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: xu,
                disabled: !j || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ g.jsx(ln, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, p3 = "_modal_al73g_1", f3 = {
  modal: p3
}, xk = [
  {
    label: "Customer",
    value: oi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: oi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: oi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: oi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: oi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: oi.Staff,
    description: "Staff made an error."
  }
], h3 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = bn(), { useMutation: d, showNotification: m } = un(), [u, f] = se([]), h = u.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, C = mt({
    defaultValues: v
  }), [_, { error: S, reset: j }] = d(hV, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (E) => {
      const I = E.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (I.length > 0)
        o(!1), f(I), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const F = E.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, F ? 0 : 4e3), m({
          title: "Success",
          text: `${F ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), k = at(
    (E) => {
      E.reason != null && (o(!0), _({
        variables: {
          orderId: E.orderId,
          reason: E.reason,
          refundMethod: E.refundMethod,
          restock: E.restock,
          notifyCustomer: E.notifyCustomer,
          staffNote: E.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), L = () => {
    i(!1), j(), f([]), C.reset(v);
  };
  return /* @__PURE__ */ g.jsxs(wt, { isOpen: n, onClose: L, className: f3.modal, children: [
    /* @__PURE__ */ g.jsx(Ct, { title: `Cancel order ${r}`, onClose: L }),
    /* @__PURE__ */ g.jsx(It, { children: /* @__PURE__ */ g.jsxs(rt, { children: [
      /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(
        fr,
        {
          control: C.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (E, I) => E === I,
            getItemTitleByValue: (E) => {
              if (!E)
                return "";
              const I = xk.find(
                (F) => F.value === E
              );
              return /* @__PURE__ */ g.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: I.label }),
                /* @__PURE__ */ g.jsx(D.Paragraph, { color: "secondary", children: I.description })
              ] });
            }
          },
          children: xk.map((E) => /* @__PURE__ */ g.jsx(lt.Item, { value: E.value, children: /* @__PURE__ */ g.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: E.label }),
            /* @__PURE__ */ g.jsx(D.Paragraph, { color: "secondary", children: E.description })
          ] }) }, E.value))
        }
      ) }),
      /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(nn, { label: "Refund order", children: /* @__PURE__ */ g.jsx(
        $n,
        {
          control: C.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(nn, { label: "Restock items", children: /* @__PURE__ */ g.jsx($n, { control: C.control, name: "restock" }) }) }),
      /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(nn, { label: "Notify the customer", children: /* @__PURE__ */ g.jsx($n, { control: C.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(
        Gn,
        {
          name: "staffNote",
          label: "Staff note",
          control: C.control
        }
      ) }),
      h && /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(b, { gap: "200", flexDirection: "column", children: u.map((E) => /* @__PURE__ */ g.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ g.jsx(me, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: E.code }),
            /* @__PURE__ */ g.jsxs(D.Paragraph, { children: [
              "(",
              E.field?.join(","),
              ") ",
              E.message
            ] })
          ]
        },
        E.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ g.jsx(
      Tt,
      {
        confirmProps: {
          disabled: !(C.formState.isValid && C.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ g.jsx(ln, { size: 16 })
        },
        confirmOnClick: C.handleSubmit(k),
        cancelOnClick: L,
        confirmName: S ? "Close" : "Cancel order",
        cancelName: S ? void 0 : "Cancel"
      }
    )
  ] });
}, y3 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = se(!1), [s, l] = se(!1);
  return /* @__PURE__ */ g.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ g.jsx(
      Kn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ g.jsx(ln, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ g.jsx(
          me,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Et.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ g.jsx(
      h3,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, g3 = "_modal_1mprq_1", v3 = {
  modal: g3
}, k3 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = un(), { track: m } = bn(), [u, f] = se(!1), [h, v] = se(e?.tags || []), C = "duplicate-shopify-order-form", _ = (B) => ({
    firstName: B?.firstName,
    lastName: B?.lastName,
    company: B?.company,
    address1: B?.address1,
    address2: B?.address2,
    city: B?.city,
    provinceCode: B?.provinceCode,
    zip: B?.zip,
    countryCode: B?.countryCodeV2,
    phone: B?.phone
  }), S = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: _(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: _(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, j = mt({
    mode: "all",
    defaultValues: S
  }), k = j.watch("lineItems").length > 0, L = Bn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), E = Bn(
    () => E_(L),
    [L]
  ), {
    data: I,
    loading: F,
    error: A
  } = d(Sp, {
    skip: !E,
    variables: {
      query: E,
      productCount: L.length,
      mediaCount: 1
    }
  });
  qe(() => {
    A && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [A, l]), qe(() => {
    if (!r || F || !I || j.getValues("lineItems")?.length)
      return;
    const B = I?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((z) => {
      const Z = B.find(
        (be) => be.id === z.product?.id
      );
      Z && O.push({
        ...Z,
        quantity: z.quantity || 1,
        sku: z.sku,
        discountedUnitPrice: z.discountedUnitPriceSet?.shopMoney
      });
    }), O.length > 0 && j.setValue("lineItems", O, { shouldDirty: !0 });
  }, [r, I, F, e, j]), qe(() => {
    (h.length > 0 || (j.getValues("tags") || []).length > 0) && j.setValue("tags", h, { shouldDirty: !0 });
  }, [h, j]);
  const [K, { error: Y }] = s(
    I_,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), G();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), G();
      }
    }
  ), ie = (B) => {
    const O = B.lineItems.map((Z) => ({
      productId: Z.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: Z.discountedUnitPrice?.amount ?? Z.priceRangeV2.maxVariantPrice.amount,
          currencyCode: Z.discountedUnitPrice?.currencyCode ?? Z.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: Z.quantity,
      sku: Z.sku
    })), z = (e?.shippingLines ?? []).map(
      (Z) => ({
        title: Z.title,
        code: Z.code,
        source: Z.source,
        priceSet: {
          shopMoney: {
            amount: Z.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: Z.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), K({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: O,
          shippingLines: z,
          note: B.customNote,
          tags: B.tags,
          financialStatus: B.financialStatus,
          fulfillmentStatus: B.fulfillmentStatus,
          shippingAddress: Ri(B?.shippingAddress),
          billingAddress: Ri(B?.billingAddress)
        }
      }
    });
  }, G = () => {
    j.reset(S), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ g.jsxs(
    wt,
    {
      isOpen: r,
      onClose: G,
      className: v3.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ g.jsx(Ct, { title: `Duplicate order ${n}`, onClose: G }),
        /* @__PURE__ */ g.jsxs(It, { children: [
          /* @__PURE__ */ g.jsx(Vm, { ...j, children: /* @__PURE__ */ g.jsx("form", { id: C, children: /* @__PURE__ */ g.jsxs(rt, { children: [
            /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(Cp, { loading: F }) }),
            /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(
              Nt,
              {
                name: "tags",
                render: ({ fieldState: { error: B } }) => /* @__PURE__ */ g.jsx(
                  nn,
                  {
                    label: "Tags",
                    meta: {
                      error: B?.message
                    },
                    children: /* @__PURE__ */ g.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (O) => {
                          O.key === "Enter" && (O.preventDefault(), O.stopPropagation());
                        },
                        children: /* @__PURE__ */ g.jsx(
                          xs,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (O) => {
                              v(O);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ g.jsx(ue, { span: 4, children: /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ g.jsx(
                T_,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ g.jsx($_, {}),
              /* @__PURE__ */ g.jsx(
                Gn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ g.jsx(ue, { span: 2, children: /* @__PURE__ */ g.jsx(nn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ g.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Et.boxWrapper,
                children: /* @__PURE__ */ g.jsx(jp, {})
              }
            ) }) })
          ] }) }) }),
          Y && /* @__PURE__ */ g.jsx(Cn, { error: Y })
        ] }),
        /* @__PURE__ */ g.jsx(
          Tt,
          {
            confirmProps: {
              type: "submit",
              form: C,
              disabled: !k || u || F,
              isLoading: u || F,
              loadingIndicator: /* @__PURE__ */ g.jsx(ln, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: j.handleSubmit(ie)
          }
        )
      ]
    }
  );
}, b3 = "_copyIcon_1dlzg_1", x3 = {
  copyIcon: b3
}, _3 = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  const { isCopied: i, copy: a } = Nr();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(r).some(
    (l) => l > 0
  ), s = n.map(
    ({ title: l, quantity: d, variantTitle: m }) => m ? `${d}x ${l} (${m})` : `${d}x ${l}`
  ).join(`
`);
  return /* @__PURE__ */ g.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ g.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ g.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ g.jsx(me, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ g.jsx(We, { content: "Copy line items", children: /* @__PURE__ */ g.jsx(
            me,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(s),
              className: x3.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ g.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ g.jsx(An, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ g.jsx(Ge, { children: n.map(({ id: l, title: d, quantity: m, variantTitle: u, image: f }) => {
      const h = r[l], v = h > 0, C = h > 1 ? `Refunded (${h} items)` : "Refunded";
      return /* @__PURE__ */ g.jsx(
        Ge.Item,
        {
          contentLeft: /* @__PURE__ */ g.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ g.jsx(D.Paragraph, { children: m }),
            /* @__PURE__ */ g.jsx(D.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ g.jsxs(D.Paragraph, { variant: "4", children: [
            d,
            " ",
            u && `(${u})`,
            v && /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "3", color: "red.500", children: C })
          ] }),
          contentRight: f?.url && /* @__PURE__ */ g.jsx(Wi, { src: `${f?.url}&height=48`, alt: d })
        },
        `list-${e}-${l}`
      );
    }) })
  ] });
}, S3 = Ss`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, N3 = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, D_ = (e) => {
  const n = {}, r = N3(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, j3 = "_modal_21e62_1", w3 = {
  modal: j3
}, _k = "partial-refund-shopify-order-form", C3 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = bn(), { useQuery: d } = un(), [m, u] = se(!1), [f, h] = se([]), v = Bn(
    () => e?.refunds ? D_(e) : {},
    [e]
  ), C = Bn(
    () => (e?.lineItems || []).filter((B) => (v[B.id] || 0) >= (B.quantity || 0)).map((B) => B.product?.id).filter((B) => !!B),
    [e, v]
  ), _ = Bn(() => {
    const B = {};
    return (e?.lineItems || []).forEach((O) => {
      if (O.product?.id) {
        const z = v[O.id] || 0, Z = Math.max(
          0,
          (O.quantity || 0) - z
        );
        B[O.product.id] = Z;
      }
    }), B;
  }, [e, v]), S = Bn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), j = Bn(
    () => E_(S),
    [S]
  ), {
    data: k,
    loading: L,
    error: E
  } = d(Sp, {
    skip: !j,
    variables: {
      query: j,
      productCount: S.length,
      mediaCount: 1
    }
  });
  qe(() => {
    E && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [E, s]);
  const I = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, F = mt({
    mode: "all",
    defaultValues: I
  }), A = f.length > 0, [K, { error: Y }] = o(
    S3,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), G();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), G();
      }
    }
  );
  qe(() => {
    if (!r || L || !k || F.getValues("lineItems")?.length)
      return;
    const B = k?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((z) => {
      const Z = B.find(
        (be) => be.id === z.product?.id
      );
      if (Z) {
        const be = v[z.id] || 0, he = (z.quantity || 1) - be;
        O.push({
          ...Z,
          quantity: he > 0 ? he : z.quantity || 1
        });
      }
    }), O.length > 0 && (F.setValue("lineItems", O, { shouldDirty: !0 }), h([]));
  }, [
    r,
    k,
    L,
    e,
    F,
    v
  ]);
  const ie = (B) => {
    u(!0);
    const O = (B.lineItems || []).filter(
      (z) => f.includes(z.id)
    ).map((z) => {
      const Z = e?.lineItems?.find(
        (ye) => ye.product?.id === z.id
      ), be = v[Z?.id || ""] || 0, he = (Z?.quantity || 0) - be, de = Math.max(
        0,
        Math.min(he, z.quantity || 0)
      );
      return Z && de > 0 ? { lineItemId: Z.id, quantity: de } : void 0;
    }).filter((z) => !!z);
    K({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: O,
          note: B.customNote || void 0,
          notify: !0
        }
      }
    });
  }, G = () => {
    F.reset(I), u(!1), i(!1);
  };
  return /* @__PURE__ */ g.jsxs(wt, { isOpen: r, onClose: G, className: w3.modal, children: [
    /* @__PURE__ */ g.jsx(Ct, { title: `Refund order ${n}`, onClose: G }),
    /* @__PURE__ */ g.jsxs(It, { children: [
      /* @__PURE__ */ g.jsx(Vm, { ...F, children: /* @__PURE__ */ g.jsx("form", { id: _k, children: /* @__PURE__ */ g.jsxs(rt, { children: [
        /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(
          Cp,
          {
            loading: L,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: C,
            maxQuantities: _,
            onToggleSelect: (B, O) => {
              h((z) => O ? Array.from(/* @__PURE__ */ new Set([...z, B])) : z.filter((Z) => Z !== B));
            },
            onToggleSelectAll: (B) => {
              const O = (F.getValues("lineItems") || []).map((z) => z.id).filter((z) => !C.includes(z));
              h(B ? O : []);
            }
          }
        ) }),
        /* @__PURE__ */ g.jsx(ue, { span: 4, children: /* @__PURE__ */ g.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ g.jsx(
          Gn,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ g.jsx(ue, { span: 2, children: /* @__PURE__ */ g.jsx(nn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ g.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Et.boxWrapper,
            children: /* @__PURE__ */ g.jsx(
              jp,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      Y && /* @__PURE__ */ g.jsx(Cn, { error: Y })
    ] }),
    /* @__PURE__ */ g.jsx(
      Tt,
      {
        confirmProps: {
          type: "submit",
          form: _k,
          disabled: !A || m || L,
          isLoading: m || L,
          loadingIndicator: /* @__PURE__ */ g.jsx(ln, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: F.handleSubmit(ie)
      }
    )
  ] });
}, I3 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = un(), { track: l } = bn(), { suggestedRefund: d, currencyCode: m, id: u, name: f } = e, h = parseFloat(String(d?.amount)), v = !isNaN(h) && h > 0, [C] = a(fV, {
    onError: (j) => {
      setTimeout(() => S(j), 500);
    },
    onCompleted: (j) => {
      const k = j.Shopify?.refundCreate?.userErrors;
      k && k.length > 0 ? S(
        new cb({
          graphQLErrors: k.map((L) => ({
            message: L.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), _ = at(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: u });
    const { amount: j, ...k } = d;
    s(v ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ g.jsxs(D.Paragraph, { children: [
        "You are about to refund ",
        j,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: u }), C({
          variables: {
            input: k
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: u })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ g.jsx(D.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    u,
    f,
    m,
    d,
    v,
    s,
    C,
    l
  ]), S = at(
    (j) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ g.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ g.jsx(Cn, { error: j }),
          /* @__PURE__ */ g.jsx(
            jt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ g.jsx(me, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ g.jsx(b, { width: "100%", children: /* @__PURE__ */ g.jsx(
    Kn,
    {
      variant: "secondary",
      onClick: _,
      disabled: d?.refundLineItems?.length === 0 || !v,
      slotStart: /* @__PURE__ */ g.jsx(me, { size: 14, name: "undo" }),
      className: Et.fullWidth,
      children: "Full refund"
    }
  ) });
}, F3 = "_modal_al73g_1", E3 = {
  modal: F3
}, T3 = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = bn(), { useMutation: s, showNotification: l } = un(), [d, m] = se(n), [u, f] = se(!1), h = mt({
    defaultValues: {
      tags: n
    }
  });
  qe(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [v, { error: C, reset: _ }] = s(yV, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), S = at(
    (k) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: k.tags
          }
        }
      }).then((L) => {
        const E = L.data?.Shopify?.orderUpdate?.order?.tags ?? k.tags;
        h.reset({ tags: E });
      });
    },
    [e, h, v]
  ), j = () => {
    i(!1), _();
  };
  return /* @__PURE__ */ g.jsxs(wt, { isOpen: r, onClose: j, className: E3.modal, children: [
    /* @__PURE__ */ g.jsx(Ct, { title: "Manage tags for order", onClose: j }),
    /* @__PURE__ */ g.jsxs(It, { children: [
      /* @__PURE__ */ g.jsx(rt, { children: /* @__PURE__ */ g.jsx(ue, { children: /* @__PURE__ */ g.jsx(
        Nt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: k } }) => /* @__PURE__ */ g.jsx(
            nn,
            {
              label: "Tags",
              meta: {
                error: k?.message
              },
              children: /* @__PURE__ */ g.jsx(
                xs,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (L) => m(L)
                }
              )
            }
          )
        }
      ) }) }),
      C && /* @__PURE__ */ g.jsx(Cn, { error: C })
    ] }),
    /* @__PURE__ */ g.jsx(
      Tt,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ g.jsx(ln, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(S),
        cancelOnClick: j,
        confirmName: C ? "Close" : "Save",
        cancelName: C ? void 0 : "Cancel"
      }
    )
  ] });
}, $3 = "_editIcon_1yp2k_1", D3 = "_copyIcon_1yp2k_2", Sk = {
  editIcon: $3,
  copyIcon: D3
}, R3 = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = se(!1), { isCopied: o, copy: s } = Nr(), l = 14, d = n.length > 0;
  return /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
    /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ g.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ g.jsx(me, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ g.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !d && /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            d && n.map((m, u) => /* @__PURE__ */ g.jsx(Pn, { size: "small", variant: "primary", children: m }, u))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ g.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ g.jsx(We, { content: "Edit tags", children: /* @__PURE__ */ g.jsx(
          me,
          {
            size: l,
            name: "pen",
            className: Sk.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        d && /* @__PURE__ */ g.jsx(We, { content: "Copy tags", children: /* @__PURE__ */ g.jsx(
          me,
          {
            size: l,
            name: o ? "done" : "copy",
            className: Sk.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ g.jsx(
      T3,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, O3 = "_icon_cddi1_1", P3 = "_link_cddi1_6", Nk = {
  icon: O3,
  link: P3
}, A3 = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Nr(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ g.jsx(
    Ge.Item,
    {
      contentLeft: /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ g.jsx(
        D.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: Nk.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ g.jsx(We, { content: "Copy tracking code", children: /* @__PURE__ */ g.jsx(
        me,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: Nk.icon
        }
      ) })
    }
  );
}, L3 = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ g.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ g.jsx(me, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ g.jsx(Ge, { children: e.map((n) => /* @__PURE__ */ g.jsx(A3, { trackingInfo: n }, n.number)) })
] }), V3 = "_copyIcon_yc0fe_1", z3 = "_order_yc0fe_6", U3 = "_orderIsOpen_yc0fe_14", M3 = "_orderHeader_yc0fe_17", Ii = {
  copyIcon: V3,
  order: z3,
  orderIsOpen: U3,
  orderHeader: M3
}, B3 = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = bn(), { isCopied: h, copy: v } = Nr(), { isCopied: C, copy: _ } = Nr(), { isCopied: S, copy: j } = Nr(), [k, L] = se(!1), [E, I] = se(!1), [F, A] = se(r), {
    id: K,
    name: Y,
    createdAt: ie,
    status: G,
    currentTotalPriceSet: B,
    currencyCode: O,
    lineItems: z,
    billingAddress: Z,
    shippingAddress: be,
    trackingInfos: he,
    tags: de
  } = e, ye = !!be, q = Np(K), Se = `https://${l}/admin/orders/${q ?? ""}`, Ce = B?.shopMoney?.amount ?? 0, H = G.includes("cancelled"), He = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: O
  }).format(Ce), Be = e?.refunds ? D_(e) : {}, Re = !!z?.length && z.every((Ue) => (Be[Ue.id] || 0) >= (Ue.quantity || 0));
  return /* @__PURE__ */ g.jsxs(
    b,
    {
      className: tt(Ii.order, {
        [Ii.orderIsOpen]: F
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ g.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ii.orderHeader,
            onClick: () => A(!F),
            children: [
              /* @__PURE__ */ g.jsxs(b, { gap: "100", flexDirection: "column", children: [
                ie && /* @__PURE__ */ g.jsx(b, { alignItems: "center", children: /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: Ln(ie).format(pm) }) }),
                /* @__PURE__ */ g.jsxs(D.Paragraph, { variant: "1", children: [
                  "Order ",
                  Y
                ] })
              ] }),
              /* @__PURE__ */ g.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: F ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        F && /* @__PURE__ */ g.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ g.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ g.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ g.jsx(me, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: Y.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ g.jsx(We, { content: "Copy order number", children: /* @__PURE__ */ g.jsx(
                  me,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => v(Y.replace("#", "")),
                    className: Ii.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ g.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ g.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ g.jsx(me, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: G })
                  ] })
                ] }),
                /* @__PURE__ */ g.jsx(We, { content: "Copy order status", children: /* @__PURE__ */ g.jsx(
                  me,
                  {
                    size: 14,
                    name: S ? "done" : "copy",
                    onClick: () => j(G),
                    className: Ii.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ g.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ g.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ g.jsx(me, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "3", children: "Order value" }),
                    /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: He })
                  ] })
                ] }),
                /* @__PURE__ */ g.jsx(We, { content: "Copy order value", children: /* @__PURE__ */ g.jsx(
                  me,
                  {
                    size: 14,
                    name: C ? "done" : "copy",
                    onClick: () => _(Ce),
                    className: Ii.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ g.jsx(
            R3,
            {
              orderId: K,
              tags: de,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ g.jsx(
            fm,
            {
              openByDefault: !ye,
              labelText: "Billing address",
              address: Z,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ g.jsx(
            fm,
            {
              openByDefault: ye,
              shopifyId: n,
              orderId: K,
              icon: "map-pin",
              labelText: "Shipping address",
              address: be,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ g.jsx(
            _3,
            {
              orderId: K,
              lineItems: z,
              refundedQuantities: Be
            }
          ),
          /* @__PURE__ */ g.jsx(L3, { trackingInfos: he }),
          (o || m) && /* @__PURE__ */ g.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ g.jsx(
              I3,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: Se
              }
            ),
            m && /* @__PURE__ */ g.jsx(b, { width: "100%", children: /* @__PURE__ */ g.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => I(!0),
                className: Et.fullWidth,
                disabled: H || Re,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ g.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ g.jsx(b, { width: "100%", children: /* @__PURE__ */ g.jsx(
              Kn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => L(!0),
                className: Et.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ g.jsx(
              y3,
              {
                orderId: K,
                orderName: Y,
                disabled: H,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ g.jsx(
            jt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(Se, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ g.jsx(me, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: K
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        k && /* @__PURE__ */ g.jsx(
          k3,
          {
            order: e,
            shopifyId: n,
            orderName: Y,
            isOpen: k,
            setIsOpen: L,
            refetchOrders: u
          }
        ),
        E && /* @__PURE__ */ g.jsx(
          C3,
          {
            order: e,
            orderName: Y,
            isOpen: E,
            setIsOpen: I,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, q3 = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = bn(), [f, h] = se([]), [v, C] = se(!1), _ = Np(m?.id), S = `https://${n}/admin/orders?customer_id=${_ ?? ""}`, {
    getCustomerOrders: j,
    isCustomerOrdersLoading: k,
    customerOrdersError: L,
    customerOrders: E,
    refetchCustomerOrders: I
  } = xV();
  return qe(() => {
    !k && _ && j({
      variables: {
        query: `customer_id:${_}`
      }
    });
  }, [_]), qe(() => {
    const F = E?.Shopify?.orders?.edges;
    F && h(JV({ ordersData: F }));
  }, [E]), m ? L ? /* @__PURE__ */ g.jsx(Cn, { error: L }) : /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: "Customer orders" }),
      !k && /* @__PURE__ */ g.jsx(Pn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ g.jsx(
      Kn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => C(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
      k && /* @__PURE__ */ g.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ g.jsx(ln, {}) }),
      !k && f.length === 0 && /* @__PURE__ */ g.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ g.jsx(D.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !k && f.length > 0 && /* @__PURE__ */ g.jsx(b, { gap: "200", flexDirection: "column", children: f.map((F, A) => /* @__PURE__ */ g.jsx(
        B3,
        {
          order: F,
          openByDefault: A === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: I,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${A}-${F.id}`
      )) }),
      /* @__PURE__ */ g.jsx(
        jt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(S, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ g.jsx(me, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ g.jsx(
      m3,
      {
        isOpen: v,
        setIsOpen: C,
        shopifyCustomer: m,
        refetchCustomerOrders: I,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, H3 = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ g.jsx(g.Fragment, { children: /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ g.jsxs(Ge, { className: Et.list, children: [
      /* @__PURE__ */ g.jsx(Ge.Text, { variant: "dense", className: Et.listItem, children: /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ g.jsx(Ge.Text, { variant: "dense", className: Et.listItem, children: /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, W3 = "_segmentName_1dkhk_1", K3 = {
  segmentName: W3
}, G3 = 100, Ao = 10, Y3 = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = un(), [i, a] = se([]), [o, s] = se(Ao), [l, d] = se(!1), m = Bn(
    () => i.filter((_) => _.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    dV,
    {
      skip: !e,
      variables: {
        first: G3
      },
      onCompleted: (_) => {
        const S = _?.Shopify?.segments?.edges;
        if (S && S.length > 0) {
          const j = S.map(({ node: k }) => ({
            ...k,
            isMember: !1
          })).sort((k, L) => k.name.localeCompare(L.name));
          a(j), h({
            variables: {
              customerId: e,
              segmentIds: j.map((k) => k.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: C }
  ] = r(uV, {
    onCompleted: (_) => {
      const S = _?.Shopify?.customerSegmentMembership?.memberships;
      if (S && S.length > 0) {
        const j = i.map((k) => {
          const L = S.find(
            (E) => E.segmentId === k.id
          );
          return {
            ...k,
            ...L?.isMember && { isMember: L.isMember }
          };
        }).sort(
          (k, L) => k.isMember === L.isMember ? 0 : k.isMember ? -1 : 1
        );
        a(j);
      }
    }
  });
  return qe(() => {
    s(l ? i.length : Ao);
  }, [l]), e ? /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ g.jsx(D.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ g.jsx(Pn, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ g.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ g.jsx(ln, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ g.jsx(D.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ g.jsx(Cn, { error: f }),
    C && /* @__PURE__ */ g.jsx(Cn, { error: C }),
    !u && i.length > 0 && /* @__PURE__ */ g.jsxs(Ge, { className: Et.list, children: [
      i.slice(0, o).map(({ id: _, name: S, isMember: j }) => /* @__PURE__ */ g.jsx(Ge.Text, { className: Et.listItem, children: /* @__PURE__ */ g.jsx(
        We,
        {
          content: `${j ? "Member of" : "Not a member of"} ${S}`,
          children: /* @__PURE__ */ g.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ g.jsx(D.Paragraph, { variant: "4", className: K3.segmentName, children: S }),
            v && /* @__PURE__ */ g.jsx(ln, { size: 12 }),
            !v && /* @__PURE__ */ g.jsx(b, { children: /* @__PURE__ */ g.jsx(
              me,
              {
                color: j ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, _)),
      i.length > Ao && /* @__PURE__ */ g.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ g.jsx(
        Kn,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Ao} more`
        }
      ) })
    ] })
  ] }) : null;
}, Q3 = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: r,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = bV({ conversationContext: e }), [l, d] = se(), [m, u] = se(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, v = n.displayCancelOrder ?? !1, C = n.enableEditShippingAddress ?? !1, _ = n.displayEmailMarketingConsent ?? !1, S = n.displayOrdersOverview ?? !1, j = n.displaySegmentMembership ?? !1, k = n.displayDiscountCodeCreation ?? !1, L = n.displayDiscountCodes ?? !1, E = n.displayCreateOrder ?? !1, I = n.displayDuplicateOrder ?? !1, F = n.displayCreateDraftOrder ?? !1, A = n.displayPartialRefundOrder ?? !1;
  if (qe(() => {
    const K = a?.Shopify?.customers?.edges[0]?.node;
    K && !r ? (u(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(K)) : d(void 0);
  }, [a]), !r && i)
    return /* @__PURE__ */ g.jsx(Cn, { error: i, retry: o });
  if (!r && !i && !l) {
    const K = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ g.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ g.jsx(D.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ g.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ g.jsx(
              FV,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ g.jsx(
              jt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(K, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ g.jsx(me, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return r && s !== Wt.refetch ? /* @__PURE__ */ g.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ g.jsx(ln, {}) }) : /* @__PURE__ */ g.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ g.jsx(
          $V,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: r,
            networkStatus: s
          }
        ),
        S && /* @__PURE__ */ g.jsx(
          H3,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        j && /* @__PURE__ */ g.jsx(Y3, { shopifyId: l?.id }),
        _ && /* @__PURE__ */ g.jsx(QV, { customer: l }),
        L && /* @__PURE__ */ g.jsx(
          YV,
          {
            displayDiscountCodeCreation: k
          }
        ),
        /* @__PURE__ */ g.jsx(
          q3,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: v,
            displayCreateOrder: E,
            displayCreateDraftOrder: F,
            enableEditShippingAddress: C,
            customerCountryCodes: m,
            displayDuplicateOrder: I,
            displayPartialRefundOrder: A
          }
        )
      ]
    }
  );
}, xt = [];
for (let e = 0; e < 256; ++e)
  xt.push((e + 256).toString(16).slice(1));
function J3(e, n = 0) {
  return (xt[e[n + 0]] + xt[e[n + 1]] + xt[e[n + 2]] + xt[e[n + 3]] + "-" + xt[e[n + 4]] + xt[e[n + 5]] + "-" + xt[e[n + 6]] + xt[e[n + 7]] + "-" + xt[e[n + 8]] + xt[e[n + 9]] + "-" + xt[e[n + 10]] + xt[e[n + 11]] + xt[e[n + 12]] + xt[e[n + 13]] + xt[e[n + 14]] + xt[e[n + 15]]).toLowerCase();
}
const X3 = new Uint8Array(16);
function Z3() {
  return crypto.getRandomValues(X3);
}
function ez(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : nz(e);
}
function nz(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? Z3();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, J3(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var _u = { exports: {} }, Fa = {}, jk;
function tz() {
  if (jk) return Fa;
  jk = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Fa.Fragment = r, Fa.jsx = s, Fa.jsxs = s, Fa;
}
var Lo = {}, wk;
function rz() {
  return wk || (wk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Lo.Fragment = i, Lo.jsx = Rn, Lo.jsxs = Mn;
  })()), Lo;
}
var Ck;
function iz() {
  return Ck || (Ck = 1, process.env.NODE_ENV === "production" ? _u.exports = tz() : _u.exports = rz()), _u.exports;
}
var R = iz(), R_ = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(R_ || {}), hm = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(hm || {});
const az = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, oz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, sz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, lz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, cz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, dz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, uz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, mz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, pz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, fz = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": az,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": oz,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": sz,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": lz,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": cz,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": dz,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": uz,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": mz,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": pz
};
function Ar(e) {
  return fz[e] ?? {};
}
const hz = Ar(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), yz = Ar(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), gz = Ar(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), vz = Ar(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), kz = Ar(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), bz = Ar(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), xz = Ar(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), _z = Ar(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), Sz = Ar(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), Nz = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), { track: r } = bn(), [i, a] = se(), [o, s] = se(), [l, d] = se(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(hz, {
    skip: !e,
    variables: { contactId: e }
  });
  return qe(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !m && v && typeof v == "object" && ("id" in v && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && d(
      v?.consents?.filter(
        (C) => C !== null
      ) || void 0
    )), !m && (!v || typeof v != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Bn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function es(e = !1, n) {
  const [r, i] = se(e);
  return qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const jz = {
  count: 0,
  items: []
}, wz = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), { track: r } = bn(), [i, a] = se(jz), {
    loading: o,
    error: s,
    data: l
  } = n(vz, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, Cz = {
  count: 0,
  totalCount: 0,
  items: []
}, Iz = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), { track: r } = bn(), [i, a] = se(
    Cz
  ), {
    loading: o,
    error: s,
    data: l
  } = n(kz, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, Fz = ({
  conversationContext: e
}) => {
  const { useQuery: n } = un(), [r, i] = se(void 0), [a, o] = se(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(gz, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return qe(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, Ez = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = un(), [i, a] = se(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(yz, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return qe(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Bn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, Tz = "_pointer_ls8kj_48", $z = "_list_ls8kj_53", Dz = "_listItem_ls8kj_63", nt = {
  pointer: Tz,
  list: $z,
  listItem: Dz
}, Rz = "_modalBody_1clhs_1", Oz = {
  modalBody: Rz
}, Pz = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = bn(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = mt({
    defaultValues: u,
    mode: "onChange"
  }), C = La({ control: f }), _ = parseInt(C?.balance ?? "0", 10), S = m === _, j = S ? "Change the value to update the points" : "", k = _ < 0, L = k ? "Points can not be negative" : "", E = C.description === "", I = E ? "Description can not be empty" : "";
  qe(() => {
    _ > m ? h(
      "transactionType",
      hm.Addition
    ) : _ < m && h(
      "transactionType",
      hm.Deduction
    );
  }, [m, _, h]);
  const [F, { loading: A, error: K, reset: Y }] = o(Sz, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ie = () => {
    if (d) {
      const B = ez();
      F({
        variables: {
          input: {
            accountId: d,
            transactionId: B,
            amount: Math.abs(_ - m),
            transactionType: C.transactionType,
            description: C.description,
            source: R_.UpdateBalance
          }
        }
      }).then(async (O) => {
        O?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), G());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, G = () => {
    v(u), Y(), n();
  };
  return /* @__PURE__ */ R.jsxs(
    wt,
    {
      isOpen: e,
      onClose: G,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ R.jsx(Ct, { title: "Update points balance", onClose: G }),
        /* @__PURE__ */ R.jsxs(It, { className: Oz.modalBody, children: [
          /* @__PURE__ */ R.jsxs(rt, { children: [
            /* @__PURE__ */ R.jsx(ue, { span: 6, children: /* @__PURE__ */ R.jsx(
              Nt,
              {
                name: "balance",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ R.jsx(
                  ir,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: j || L
                    },
                    input: {
                      ...B,
                      value: B.value.toString(),
                      onChange: (O) => B.onChange(O)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ R.jsx(ue, { span: 6, children: /* @__PURE__ */ R.jsx(
              Nt,
              {
                name: "description",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ R.jsx(
                  ir,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: B,
                    meta: {
                      warning: I
                    }
                  }
                )
              }
            ) })
          ] }),
          K && /* @__PURE__ */ R.jsx(Cn, { error: K })
        ] }),
        /* @__PURE__ */ R.jsx(
          Tt,
          {
            confirmName: "Save",
            confirmOnClick: () => ie(),
            confirmProps: {
              isLoading: A,
              disabled: S || k || E,
              loadingIndicator: /* @__PURE__ */ R.jsx(ln, { size: 16 })
            },
            cancelOnClick: G
          }
        )
      ]
    }
  );
}, Az = "_wrapper_1ge6c_1", Lz = "_block_1ge6c_12", Ik = {
  wrapper: Az,
  block: Lz
}, Vz = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = un(), { isCopied: i, copy: a } = es(), { isCopied: o, copy: s } = es(), { isCopied: l, copy: d } = es(), [m, u] = se(!1), [f, h] = se(), [v, C] = se(!1), {
    loading: _,
    data: S,
    refetch: j
  } = r(xz, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  qe(() => {
    if (S) {
      const Z = S?.Voyado?.PointAccountV_GetPointAccounts;
      Z && Z?.length > 0 && h(Z[0]);
    }
  }, [S]);
  const k = !!f?.id, L = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: E,
    lastName: I,
    street: F,
    zipCode: A,
    city: K,
    country: Y,
    isRegistrationCompleted: ie,
    email: G,
    mobilePhone: B
  } = e, O = 14, z = `${E || ""} ${I || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", className: Ik.wrapper, children: [
    /* @__PURE__ */ R.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Ik.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ R.jsx(D.Heading, { variant: "heading-2", children: z }),
          _ && /* @__PURE__ */ R.jsx(ln, { size: 12 }),
          k && !_ && /* @__PURE__ */ R.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ R.jsxs(Pn, { size: "small", variant: "warning", children: [
              L,
              " points"
            ] }),
            /* @__PURE__ */ R.jsx(We, { content: "Update points balance", children: /* @__PURE__ */ R.jsx(
              me,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: nt.pointer
              }
            ) }),
            v && /* @__PURE__ */ R.jsx(We, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ R.jsx(
              me,
              {
                name: "info",
                size: 12,
                className: nt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (F || K || A || Y || B || G) && /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
      B && /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(me, { size: O, name: "phone" }),
          /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: B })
        ] }),
        /* @__PURE__ */ R.jsx(
          me,
          {
            size: O,
            name: o ? "done" : "copy",
            onClick: () => s(B),
            className: nt.pointer
          }
        )
      ] }),
      G && /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(me, { size: O, name: "mail" }),
          /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: G })
        ] }),
        /* @__PURE__ */ R.jsx(
          me,
          {
            size: O,
            name: i ? "done" : "copy",
            onClick: () => a(G),
            className: nt.pointer
          }
        )
      ] }),
      (F || K || A || Y) && /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ R.jsx(me, { size: O, name: "home" }),
          /* @__PURE__ */ R.jsxs(D.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ R.jsx(Zn, { children: F }),
            /* @__PURE__ */ R.jsxs(Zn, { children: [
              A,
              " ",
              K
            ] }),
            /* @__PURE__ */ R.jsx(Zn, { children: Y })
          ] })
        ] }),
        /* @__PURE__ */ R.jsx(
          me,
          {
            size: O,
            name: l ? "done" : "copy",
            onClick: () => d(`${F}, ${A} ${K}, ${Y}`),
            className: nt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(me, { size: O, name: "sign-in" }),
          /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ R.jsx(
          me,
          {
            name: ie ? "check-circle-filled" : "close-circle-filled",
            color: ie ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    k && /* @__PURE__ */ R.jsx(
      Pz,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: C,
        refetchPointsQuery: j
      }
    )
  ] });
}, zz = "_list_yud4a_7", Uz = "_listItem_yud4a_11", Mz = "_listItemTooltip_yud4a_15", Bz = "_listItemTimestamp_yud4a_18", Vo = {
  list: zz,
  listItem: Uz,
  listItemTooltip: Mz,
  listItemTimestamp: Bz
}, qz = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ R.jsx(D.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ R.jsx(Ge, { className: Vo.list, children: e.map((n, r) => /* @__PURE__ */ R.jsx(Ge.Text, { variant: "dense", className: Vo.listItem, children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ R.jsx(We, { content: n?.comment, children: /* @__PURE__ */ R.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: tt({
          [Vo.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ R.jsx(D.Paragraph, { className: Vo.listItemTimestamp, children: Ln(n.date).format(gt) }),
          n?.comment && /* @__PURE__ */ R.jsx(me, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ R.jsx(
      me,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), Hz = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Ln(e.latestChange).format(gt) : null, o = e?.expires ? `${Ln(e.expires).fromNow()} (${Ln(e.expires).format(gt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ R.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ R.jsx(D.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ R.jsx(We, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ R.jsx(
        me,
        {
          name: "question",
          size: 14,
          className: nt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ R.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ R.jsxs(Ge, { className: nt.list, children: [
      s && /* @__PURE__ */ R.jsx(Ge.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ R.jsx(Ge.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ R.jsx(We, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ R.jsx(Pn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ R.jsx(Ge.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ R.jsx(We, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ R.jsx(Pn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ R.jsx(Ge.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ R.jsx(We, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ R.jsx(Pn, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ R.jsx(Ge.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ R.jsx(We, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ R.jsx(Ge.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ R.jsx(We, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, Wz = "_tagHover_kzbzk_1", Kz = "_channelUnsubscribed_kzbzk_6", Fk = {
  tagHover: Wz,
  channelUnsubscribed: Kz
}, Su = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = bn(), { useMutation: l } = un(), [d, m] = se(!1), [u, { loading: f }] = l(_z), h = async ({
    newPreference: C,
    isSubscribed: _,
    channelType: S
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...C
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? _ ? s("voyado:channel:unsubscribe:succeeded", { channel: S }) : s("voyado:channel:subscribe:succeeded", { channel: S }) : _ ? s("voyado:channel:unsubscribe:failed", { channel: S }) : s("voyado:channel:subscribe:failed", { channel: S }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, v = d || f;
  return /* @__PURE__ */ R.jsx(We, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ R.jsx(
    An,
    {
      className: Fk.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ R.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: tt({
            [Fk.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ R.jsx(ln, { size: 16 }) : /* @__PURE__ */ R.jsx(me, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, Gz = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ R.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsx(D.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        Su,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ R.jsx(
        Su,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ R.jsx(
        Su,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, Yz = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = Nz({ contactId: e }), {
    isLoading: v,
    error: C,
    memberLevel: _
  } = Ez({ contactId: e, skip: !s }), S = v || l, j = Bn(
    () => h?.filter(
      (k) => k !== null
    ),
    [h]
  );
  return d || C ? Xa({
    errors: d?.graphQLErrors || C?.graphQLErrors || []
  }) ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx(D.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ R.jsx(Cn, { error: d || C }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx(D.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : S ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(ln, {}) }) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    r && /* @__PURE__ */ R.jsx(
      Vz,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ R.jsx(Hz, { memberLevel: _ }),
    i && /* @__PURE__ */ R.jsx(
      Gz,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ R.jsx(qz, { contactConsents: j })
  ] });
}, ym = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, Qz = "_list_zu4s7_1", Jz = "_listItem_zu4s7_4", Xz = "_listSum_zu4s7_7", zo = {
  list: Qz,
  listItem: Jz,
  listSum: Xz
}, Zz = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ R.jsxs(Ge, { className: zo.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ R.jsx(Ge.Text, { variant: "dense", className: zo.listItem, children: /* @__PURE__ */ R.jsx(We, { content: s, children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ R.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ R.jsx(b, { flex: "auto", children: /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ R.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: ym(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ R.jsx(
    Ge.Text,
    {
      variant: "dense",
      className: tt(zo.listItem, zo.listSum),
      children: /* @__PURE__ */ R.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "3", children: ym(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), eU = "_transaction_1kr8d_1", nU = "_transactionIsOpen_1kr8d_9", tU = "_transactionHeader_1kr8d_12", rU = "_transactionHeaderSubLine_1kr8d_15", iU = "_transactionHeaderAlignItemRight_1kr8d_19", Fi = {
  transaction: eU,
  transactionIsOpen: nU,
  transactionHeader: tU,
  transactionHeaderSubLine: rU,
  transactionHeaderAlignItemRight: iU
}, aU = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", v = f ?? 0, C = m?.length ? m : [];
  return /* @__PURE__ */ R.jsxs(
    b,
    {
      className: tt(Fi.transaction, {
        [Fi.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Fi.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ R.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ R.jsx(Pn, { size: "small", variant: "info", children: Ln(o).format(gt) }),
                  /* @__PURE__ */ R.jsxs(
                    D.Heading,
                    {
                      variant: "heading-4",
                      className: Fi.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ R.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: Fi.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ R.jsx(D.Heading, { variant: "heading-4", children: ym(v, h) }),
                      /* @__PURE__ */ R.jsxs(
                        D.Heading,
                        {
                          variant: "heading-4",
                          className: Fi.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ R.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ R.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ R.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ R.jsx(Sm, {}),
              /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ R.jsx(D.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ R.jsx(An, { children: /* @__PURE__ */ R.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ R.jsx(
                  Zz,
                  {
                    lineItems: C,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, oU = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = Iz({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ R.jsx(Cn, { error: r }) : /* @__PURE__ */ R.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(D.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ R.jsx(Pn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(ln, {}) }) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
          s === 0 && /* @__PURE__ */ R.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ R.jsx(
            aU,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, sU = "_message_unsvt_48", lU = "_messageIsOpen_unsvt_56", cU = "_messageHeader_unsvt_60", dU = "_messageText_unsvt_64", uU = "_buttonLink_unsvt_86", Ea = {
  message: sU,
  messageIsOpen: lU,
  messageHeader: cU,
  messageText: dU,
  buttonLink: uU
}, Nu = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, ju = (e, n) => n && e in Nu && n in Nu[e] ? Nu[e][n] : null, mU = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = se(n), { track: a } = bn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, v = l ? ju("type", l) : null, C = d ? ju("source", d) : null, _ = u ? ju("status", u) : null, S = l?.replace("Message", "");
  return /* @__PURE__ */ R.jsxs(
    b,
    {
      className: tt(Ea.message, {
        [Ea.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ea.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
                    /* @__PURE__ */ R.jsx(me, { name: v, size: 16 }),
                    " ",
                    S
                  ] }),
                  s && /* @__PURE__ */ R.jsx(Pn, { size: "small", variant: "info", children: Ln(s).format(gt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ R.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ R.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ R.jsx(Sm, {}),
          /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            _ && /* @__PURE__ */ R.jsx(An, { children: /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ R.jsx(me, { name: _ }),
              " ",
              u
            ] }) }),
            C && /* @__PURE__ */ R.jsx(An, { children: /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ R.jsx(me, { name: C }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ R.jsx(An, { children: /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ R.jsx(me, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", className: Ea.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ R.jsx(
            jt,
            {
              slotEnd: /* @__PURE__ */ R.jsx(me, { name: "external-link" }),
              variant: "tertiary",
              className: Ea.buttonLink,
              navigate: () => {
                S && a("voyado:message:external-link:opened", {
                  channel: S.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, pU = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = wz({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ R.jsx(Cn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ R.jsx(D.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ R.jsx(Pn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ R.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(ln, {}) }) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ R.jsx(
        mU,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, Ms = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, Ek = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = es(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = at(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(me, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ R.jsx(We, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ R.jsx(
      me,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: nt.pointer
      }
    ) })
  ] });
}, fU = "_order_19t4p_1", hU = "_orderIsOpen_19t4p_9", yU = "_orderHeader_19t4p_12", gU = "_orderIconColor_19t4p_15", kr = {
  order: fU,
  orderIsOpen: hU,
  orderHeader: yU,
  orderIconColor: gU
}, vU = "_delivery_1m9nb_1", kU = "_deliveryCode_1m9nb_4", wu = {
  delivery: vU,
  deliveryCode: kU
}, bU = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = Jt();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ R.jsx(
      me,
      {
        size: l,
        name: "eye",
        className: kr.orderIconColor
      }
    ),
    /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ R.jsx(
        We,
        {
          content: /* @__PURE__ */ R.jsxs(D.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Ln(s).format(gt)
          ] }),
          children: /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ R.jsx(
              D.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ R.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: wu.delivery,
                    children: [
                      /* @__PURE__ */ R.jsx(me, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ R.jsx(
              D.Paragraph,
              {
                variant: "4",
                className: tt(wu.delivery, wu.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ R.jsx(We, { content: "Copy tracking code", children: /* @__PURE__ */ R.jsx(
      me,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: nt.pointer
      }
    ) })
  ] });
}, xU = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        me,
        {
          size: 14,
          name: "file-text",
          className: kr.orderIconColor
        }
      ),
      /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ R.jsx(Ge, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ R.jsx(Ge.Item, { className: nt.listItem, children: /* @__PURE__ */ R.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ R.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ R.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: nt.listItemAlignRight,
              children: [
                /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: Ms({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, _U = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        me,
        {
          size: 14,
          name: "tag",
          className: kr.orderIconColor
        }
      ),
      /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ R.jsx(Ge, { className: nt.list, children: r?.map((i) => /* @__PURE__ */ R.jsx(
      Ge.Item,
      {
        className: nt.listItem,
        contentLeft: /* @__PURE__ */ R.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ R.jsx(
          We,
          {
            content: /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ R.jsx(b, { children: /* @__PURE__ */ R.jsx(Pn, { size: "small", variant: "info", children: Ms({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ R.jsx(
          Wi,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, SU = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        me,
        {
          size: 14,
          name: "credit-card",
          className: kr.orderIconColor
        }
      ),
      /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ R.jsx(Ge, { className: nt.list, children: r?.map((i, a) => /* @__PURE__ */ R.jsx(
      Ge.Item,
      {
        className: nt.listItem,
        children: /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ R.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: nt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "5", children: Ln(i?.paidAt).format(gt) }),
                    /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: Ms({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, NU = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = se(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: C
  } = e, _ = 14;
  return /* @__PURE__ */ R.jsxs(
    b,
    {
      className: tt(kr.order, {
        [kr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: kr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ R.jsx(b, { alignItems: "center", children: /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: Ln(m).format(gt) }) }),
                /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ R.jsx(
                Kt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ R.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ R.jsx(
              me,
              {
                size: _,
                name: "activity",
                className: kr.orderIconColor
              }
            ),
            /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ R.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ R.jsx(We, { content: "Internal status", children: /* @__PURE__ */ R.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ R.jsx(R.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ R.jsx(We, { content: "External status", children: /* @__PURE__ */ R.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ R.jsx(R.Fragment, { children: s }) }) }),
                /* @__PURE__ */ R.jsx(We, { content: "Last updated at", children: /* @__PURE__ */ R.jsx(D.Paragraph, { as: "span", variant: "5", children: Ln(u).format(gt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ R.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ R.jsx(
              me,
              {
                size: _,
                name: "chart-bar",
                className: kr.orderIconColor
              }
            ),
            /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: Ms({
                value: C,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ R.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ R.jsx(
              me,
              {
                size: _,
                name: "channels",
                className: kr.orderIconColor
              }
            ),
            /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", children: /* @__PURE__ */ R.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ R.jsx(R.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ R.jsx(Ek, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ R.jsx(
            Ek,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ R.jsx(bU, { delivery: e.delivery }),
          /* @__PURE__ */ R.jsx(_U, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ R.jsx(xU, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ R.jsx(
            SU,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, jU = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || Xa({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ R.jsx(Cn, { error: e }) : /* @__PURE__ */ R.jsx(R.Fragment, { children: r }), wU = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), [r, i] = se([]), { track: a } = bn(), {
    loading: o,
    error: s,
    data: l
  } = n(bz, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return qe(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ R.jsx(D.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ R.jsx(Pn, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx(ln, {}) }) : /* @__PURE__ */ R.jsx(jU, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ R.jsx(
      NU,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, CU = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = Fz({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: C
  } = n;
  return s ? /* @__PURE__ */ R.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ R.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? Xa({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ R.jsx(Cn, { error: o }) : !d && !m && !u && !f && !h && !v ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(ln, {}) }) : /* @__PURE__ */ R.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ R.jsx(Yz, { contactId: i, settings: n }),
        h && /* @__PURE__ */ R.jsx(pU, { contactId: i }),
        v && /* @__PURE__ */ R.jsx(oU, { contactId: i }),
        C && /* @__PURE__ */ R.jsx(wU, { contactId: i }),
        !l && /* @__PURE__ */ R.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ R.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, gm = [
  {
    key: "voyadoApiKey",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "apiHostName",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "showCustomerAttributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPreferences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAudiences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showConsents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], IU = {
  enabled: !1,
  name: "",
  voyadoApiKey: "",
  apiHostName: "",
  showCustomerAttributes: !0,
  showPreferences: !0,
  showAudiences: !0,
  showConsents: !0,
  showLastMessages: !0,
  showCustomerTransactions: !0,
  showOrders: !0,
  showMemberLevel: !0
}, FU = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = mt({
    mode: "onChange",
    defaultValues: IU
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: v
  } = qr({
    integrationId: e,
    integrationType: "VOYADO",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: _,
    isWidgetUnknown: S,
    refetch: j,
    widgetConfiguration: k
  } = Hr({
    integrationId: e,
    fieldDefinitions: gm,
    form: s,
    onMisconfigured: v
  }), { renderConditions: L, setRenderConditions: E, renderConditionsForSubmit: I } = Wr({
    integrationId: e,
    widgetConfiguration: k,
    renderConditionsEditor: a
  }), F = (K) => Gr(K, {
    fieldDefinitions: gm,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), A = s.watch("name");
  return /* @__PURE__ */ R.jsxs(
    Kr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: _ ?? f,
      onRetry: _ ? j : void 0,
      isLoading: u || C,
      isWidgetUnknown: S,
      children: [
        h && /* @__PURE__ */ R.jsx(Yr, { cause: h }),
        /* @__PURE__ */ R.jsxs(rt, { children: [
          /* @__PURE__ */ R.jsx(ue, { children: /* @__PURE__ */ R.jsx(nn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ R.jsx(
            $n,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ue, { span: 3, children: /* @__PURE__ */ R.jsx(
            Gn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ R.jsx(ue, { span: 3 }),
          /* @__PURE__ */ R.jsx(ue, { span: 3, children: /* @__PURE__ */ R.jsx(
            bs,
            {
              name: "voyadoApiKey",
              label: "API key",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "API key from Voyado",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ R.jsx(ue, { span: 3 }),
          /* @__PURE__ */ R.jsx(ue, { span: 3, children: /* @__PURE__ */ R.jsx(
            Gn,
            {
              name: "apiHostName",
              label: "API URL",
              control: s.control,
              rules: { required: "API URL is required" },
              componentProps: {
                placeholder: "The URL of the Voyado API",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ R.jsx(ue, { span: 3 }),
          /* @__PURE__ */ R.jsx(ue, { span: 3, children: /* @__PURE__ */ R.jsx(nn, { label: "Show the customer attributes", children: /* @__PURE__ */ R.jsx(
            $n,
            {
              name: "showCustomerAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ue, { span: 3 }),
          /* @__PURE__ */ R.jsx(ue, { span: 3, children: /* @__PURE__ */ R.jsx(nn, { label: "Show preferences", children: /* @__PURE__ */ R.jsx(
            $n,
            {
              name: "showPreferences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ue, { span: 3 }),
          /* @__PURE__ */ R.jsx(ue, { span: 3, children: /* @__PURE__ */ R.jsx(nn, { label: "Show audiences", children: /* @__PURE__ */ R.jsx(
            $n,
            {
              name: "showAudiences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ue, { span: 3 }),
          /* @__PURE__ */ R.jsx(ue, { span: 3, children: /* @__PURE__ */ R.jsx(nn, { label: "Show consents", children: /* @__PURE__ */ R.jsx(
            $n,
            {
              name: "showConsents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ue, { span: 3 }),
          /* @__PURE__ */ R.jsx(ue, { span: 3, children: /* @__PURE__ */ R.jsx(nn, { label: "Show the last 5 messages", children: /* @__PURE__ */ R.jsx(
            $n,
            {
              name: "showLastMessages",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ue, { span: 3 }),
          /* @__PURE__ */ R.jsx(ue, { span: 3, children: /* @__PURE__ */ R.jsx(nn, { label: "Show customer transactions", children: /* @__PURE__ */ R.jsx(
            $n,
            {
              name: "showCustomerTransactions",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ue, { span: 3 }),
          /* @__PURE__ */ R.jsx(ue, { span: 3, children: /* @__PURE__ */ R.jsx(nn, { label: "Show orders by contact", children: /* @__PURE__ */ R.jsx(
            $n,
            {
              name: "showOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ue, { span: 3 }),
          /* @__PURE__ */ R.jsx(ue, { span: 3, children: /* @__PURE__ */ R.jsx(nn, { label: "Show member level", children: /* @__PURE__ */ R.jsx(
            $n,
            {
              name: "showMemberLevel",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(ue, { span: 3 }),
          a && L !== null && /* @__PURE__ */ R.jsx(ue, { children: a({
            value: L,
            onChange: E,
            configurationKey: k?.id
          }) })
        ] }),
        /* @__PURE__ */ R.jsx(
          Qr,
          {
            integrationType: "VOYADO",
            integrationId: e,
            widgetName: A,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_11mz1_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_11mz1_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_11mz1_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_11mz1_63:last-child{box-shadow:none}._listItemHighlighted_11mz1_72{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Cu = { exports: {} }, Ta = {}, Tk;
function EU() {
  if (Tk) return Ta;
  Tk = 1;
  var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ta.Fragment = r, Ta.jsx = s, Ta.jsxs = s, Ta;
}
var Uo = {}, $k;
function TU() {
  return $k || ($k = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ae, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), C = Symbol.iterator, _ = "@@iterator";
    function S(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[_];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        L("error", t, p);
      }
    }
    function L(t, c, p) {
      {
        var y = j.ReactDebugCurrentFrame, $ = y.getStackAddendum();
        $ !== "" && (c += "%s", p = p.concat([$]));
        var P = p.map(function(w) {
          return String(w);
        });
        P.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, P);
      }
    }
    var E = !1, I = !1, F = !1, A = !1, K = !1, Y;
    Y = Symbol.for("react.module.reference");
    function ie(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || A || t === v || E || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Y || t.getModuleId !== void 0));
    }
    function G(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var $ = c.displayName || c.name || "";
      return $ !== "" ? p + "(" + $ + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return G(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : O(t.type) || "Memo";
          case h: {
            var $ = t, P = $._payload, w = $._init;
            try {
              return O(w(P));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, Z = 0, be, he, de, ye, q, Se, Ce;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function He() {
      {
        if (Z === 0) {
          be = console.log, he = console.info, de = console.warn, ye = console.error, q = console.group, Se = console.groupCollapsed, Ce = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Z++;
      }
    }
    function Be() {
      {
        if (Z--, Z === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, t, {
              value: be
            }),
            info: z({}, t, {
              value: he
            }),
            warn: z({}, t, {
              value: de
            }),
            error: z({}, t, {
              value: ye
            }),
            group: z({}, t, {
              value: q
            }),
            groupCollapsed: z({}, t, {
              value: Se
            }),
            groupEnd: z({}, t, {
              value: Ce
            })
          });
        }
        Z < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Re = j.ReactCurrentDispatcher, Ue;
    function Te(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch ($) {
            var y = $.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Me = !1, De;
    {
      var on = typeof WeakMap == "function" ? WeakMap : Map;
      De = new on();
    }
    function Fe(t, c) {
      if (!t || Me)
        return "";
      {
        var p = De.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Me = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var P;
      P = Re.current, Re.current = null, He();
      try {
        if (c) {
          var w = function() {
            throw Error();
          };
          if (Object.defineProperty(w.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(w, []);
            } catch (ee) {
              y = ee;
            }
            Reflect.construct(t, [], w);
          } else {
            try {
              w.call();
            } catch (ee) {
              y = ee;
            }
            t.call(w.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            y = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && y && typeof ee.stack == "string") {
          for (var N = ee.stack.split(`
`), ne = y.stack.split(`
`), M = N.length - 1, x = ne.length - 1; M >= 1 && x >= 0 && N[M] !== ne[x]; )
            x--;
          for (; M >= 1 && x >= 0; M--, x--)
            if (N[M] !== ne[x]) {
              if (M !== 1 || x !== 1)
                do
                  if (M--, x--, x < 0 || N[M] !== ne[x]) {
                    var Q = `
` + N[M].replace(" at new ", " at ");
                    return t.displayName && Q.includes("<anonymous>") && (Q = Q.replace("<anonymous>", t.displayName)), typeof t == "function" && De.set(t, Q), Q;
                  }
                while (M >= 1 && x >= 0);
              break;
            }
        }
      } finally {
        Me = !1, Re.current = P, Be(), Error.prepareStackTrace = $;
      }
      var ce = t ? t.displayName || t.name : "", _e = ce ? Te(ce) : "";
      return typeof t == "function" && De.set(t, _e), _e;
    }
    function Ye(t, c, p) {
      return Fe(t, !1);
    }
    function Ze(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function fe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Fe(t, Ze(t));
      if (typeof t == "string")
        return Te(t);
      switch (t) {
        case m:
          return Te("Suspense");
        case u:
          return Te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ye(t.render);
          case f:
            return fe(t.type, c, p);
          case h: {
            var y = t, $ = y._payload, P = y._init;
            try {
              return fe(P($), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, $e = {}, Le = j.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, y, $) {
      {
        var P = Function.call.bind(ge);
        for (var w in t)
          if (P(t, w)) {
            var N = void 0;
            try {
              if (typeof t[w] != "function") {
                var ne = Error((y || "React class") + ": " + p + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ne.name = "Invariant Violation", ne;
              }
              N = t[w](c, w, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              N = M;
            }
            N && !(N instanceof Error) && (Pe($), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, w, typeof N), Pe(null)), N instanceof Error && !(N.message in $e) && ($e[N.message] = !0, Pe($), k("Failed %s type: %s", p, N.message), Pe(null));
          }
      }
    }
    var J = Array.isArray;
    function T(t) {
      return J(t);
    }
    function U(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function X(t) {
      try {
        return re(t), !1;
      } catch {
        return !0;
      }
    }
    function re(t) {
      return "" + t;
    }
    function V(t) {
      if (X(t))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(t)), re(t);
    }
    var W = j.ReactCurrentOwner, le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ke, Ie;
    function en(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function hn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function rn(t, c) {
      typeof t.ref == "string" && W.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          ke || (ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ie || (Ie = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, y, $, P, w) {
      var N = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: w,
        // Record the component responsible for creating this element.
        _owner: P
      };
      return N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(N, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(N, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    };
    function Sn(t, c, p, y, $) {
      {
        var P, w = {}, N = null, ne = null;
        p !== void 0 && (V(p), N = "" + p), hn(c) && (V(c.key), N = "" + c.key), en(c) && (ne = c.ref, rn(c));
        for (P in c)
          ge.call(c, P) && !le.hasOwnProperty(P) && (w[P] = c[P]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (P in M)
            w[P] === void 0 && (w[P] = M[P]);
        }
        if (N || ne) {
          var x = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          N && cn(w, x), ne && pn(w, x);
        }
        return dn(t, N, ne, $, y, W.current, w);
      }
    }
    var Xe = j.ReactCurrentOwner, Nn = j.ReactDebugCurrentFrame;
    function Oe(t) {
      if (t) {
        var c = t._owner, p = fe(t.type, t._source, c ? c.type : null);
        Nn.setExtraStackFrame(p);
      } else
        Nn.setExtraStackFrame(null);
    }
    var an;
    an = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function gn() {
      {
        if (Xe.current) {
          var t = O(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var jn = {};
    function vn(t) {
      {
        var c = gn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function yn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = vn(c);
        if (jn[p])
          return;
        jn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Xe.current && (y = " It was passed a child from " + O(t._owner.type) + "."), Oe(t), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Oe(null);
      }
    }
    function wn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (T(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            sn(y) && yn(y, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var $ = S(t);
          if (typeof $ == "function" && $ !== t.entries)
            for (var P = $.call(t), w; !(w = P.next()).done; )
              sn(w.value) && yn(w.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = O(c);
          mn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !an) {
          an = !0;
          var $ = O(c);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Oe(t), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Oe(null);
            break;
          }
        }
        t.ref !== null && (Oe(t), k("Invalid attribute `ref` supplied to `React.Fragment`."), Oe(null));
      }
    }
    var xn = {};
    function _n(t, c, p, y, $, P) {
      {
        var w = ie(t);
        if (!w) {
          var N = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ne = qn();
          ne ? N += ne : N += gn();
          var M;
          t === null ? M = "null" : T(t) ? M = "array" : t !== void 0 && t.$$typeof === n ? (M = "<" + (O(t.type) || "Unknown") + " />", N = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, N);
        }
        var x = Sn(t, c, p, $, P);
        if (x == null)
          return x;
        if (w) {
          var Q = c.children;
          if (Q !== void 0)
            if (y)
              if (T(Q)) {
                for (var ce = 0; ce < Q.length; ce++)
                  wn(Q[ce], t);
                Object.freeze && Object.freeze(Q);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wn(Q, t);
        }
        if (ge.call(c, "key")) {
          var _e = O(t), ee = Object.keys(c).filter(function(En) {
            return En !== "key";
          }), Ke = ee.length > 0 ? "{key: someKey, " + ee.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xn[_e + Ke]) {
            var Tn = ee.length > 0 ? "{" + ee.join(": ..., ") + ": ...}" : "{}";
            k(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, _e, Tn, _e), xn[_e + Ke] = !0;
          }
        }
        return t === i ? Vn(x) : Un(x), x;
      }
    }
    function Hn(t, c, p) {
      return _n(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return _n(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Uo.Fragment = i, Uo.jsx = Rn, Uo.jsxs = Mn;
  })()), Uo;
}
var Dk;
function $U() {
  return Dk || (Dk = 1, process.env.NODE_ENV === "production" ? Cu.exports = EU() : Cu.exports = TU()), Cu.exports;
}
var Ee = $U();
const DU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, RU = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": DU
};
function OU(e) {
  return RU[e] ?? {};
}
const PU = OU(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), AU = "_copyIcon_11mz1_48", LU = "_list_11mz1_53", VU = "_listItem_11mz1_63", zU = "_listItemHighlighted_11mz1_72", qi = {
  copyIcon: AU,
  list: LU,
  listItem: VU,
  listItemHighlighted: zU
}, UU = "_wrapper_1xucg_1", MU = "_externalLink_1xucg_7", Iu = {
  wrapper: UU,
  externalLink: MU
}, BU = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Jt(), { isCopied: i, copy: a } = Jt();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: d,
    account_created_at: m
  } = e, u = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ee.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ee.jsxs(b, { className: Iu.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ee.jsx(
      b,
      {
        justifyContent: "space-between",
        className: Iu.block,
        alignItems: "center",
        children: /* @__PURE__ */ Ee.jsx(D.Heading, { variant: "heading-2", children: f })
      }
    ),
    m && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ee.jsx(D.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ee.jsx(D.Paragraph, { variant: "4", children: Ln(m).format(gt) })
    ] }),
    l && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ee.jsx(me, { size: u, name: "mail" }),
        /* @__PURE__ */ Ee.jsx("span", { className: Iu.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Ee.jsx(We, { content: "Copy email", children: /* @__PURE__ */ Ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ee.jsx(
        me,
        {
          size: u,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: qi.copyIcon
        }
      ) }) })
    ] }),
    d && /* @__PURE__ */ Ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ee.jsx(me, { size: u, name: "phone" }),
        /* @__PURE__ */ Ee.jsx(D.Paragraph, { variant: "4", children: d })
      ] }),
      /* @__PURE__ */ Ee.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ Ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ee.jsx(
        me,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: qi.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Wn = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = SS(n);
  return /* @__PURE__ */ Ee.jsx(
    Ge.Text,
    {
      variant: "dense",
      className: tt(qi.listItem, {
        [qi.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Ee.jsx(We, { content: r, children: /* @__PURE__ */ Ee.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Ee.jsx(D.Paragraph, { variant: "4", children: e }),
        a ? n : Ka(n)
      ] }) })
    }
  );
}, qU = ({
  loyalty: e
}) => /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ee.jsx(D.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ee.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Ee.jsxs(Ge, { className: qi.list, children: [
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), HU = 0.8, WU = 0.4, Rk = (e) => {
  if (e != null)
    return e >= HU ? /* @__PURE__ */ Ee.jsx(Pn, { variant: "success", size: "small", children: "Positive" }) : e <= WU ? /* @__PURE__ */ Ee.jsx(Pn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Ee.jsx(Pn, { variant: "warning", size: "small", children: "Neutral" });
}, KU = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ee.jsx(D.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ee.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Ee.jsxs(Ge, { className: qi.list, children: [
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: Rk(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: Rk(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Ln(e.last_review_date).format(
          gt
        )
      }
    ),
    /* @__PURE__ */ Ee.jsx(
      Wn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Ee.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Ee.jsx(Pn, { variant: "info", size: "small", children: /* @__PURE__ */ Ee.jsx(Ee.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), GU = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = un(), { track: i } = bn(), [a, o] = se(), [s, l] = se(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showUserGeneratedContent ?? !1, C = n?.displayLoyalty ?? !1, _ = n?.displaySubscriptions ?? !1, S = !f, j = !h && !v && !C && !_, {
    loading: k,
    error: L,
    data: E
  } = r(PU, {
    skip: u || S,
    variables: {
      ...d && { email: d },
      ...!d && m && { phone: m },
      storeId: f,
      expand: "all"
    }
  });
  if (qe(() => {
    const I = E?.Yotpo?.getCustomers?.customers?.[0];
    I ? (o(I), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [E?.Yotpo, k]), S)
    return /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ee.jsx(
      Cn,
      {
        error: new cb({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (u)
    return /* @__PURE__ */ Ee.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Ee.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (j)
    return /* @__PURE__ */ Ee.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Ee.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (k)
    return /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ee.jsx(ln, {}) });
  if (s)
    return /* @__PURE__ */ Ee.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ee.jsx(D.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (L) {
    const I = L.graphQLErrors;
    return km({ errors: I }) ? /* @__PURE__ */ Ee.jsx(
      D.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : bm({ errors: I }) ? /* @__PURE__ */ Ee.jsx(
      D.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ee.jsx(Cn, { error: L });
  }
  return /* @__PURE__ */ Ee.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Ee.jsx(BU, { customerDetails: a }),
        v && /* @__PURE__ */ Ee.jsx(
          KU,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        C && /* @__PURE__ */ Ee.jsx(qU, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var uo = (e) => e.type === "checkbox", ci = (e) => e instanceof Date, Lt = (e) => e == null;
const O_ = (e) => typeof e == "object";
var dt = (e) => !Lt(e) && !Array.isArray(e) && O_(e) && !ci(e), P_ = (e) => dt(e) && e.target ? uo(e.target) ? e.target.checked : e.target.value : e, YU = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, A_ = (e, n) => e.has(YU(n)), QU = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return dt(n) && n.hasOwnProperty("isPrototypeOf");
}, Ip = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function St(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Ip && (e instanceof Blob || i)) && (r || dt(e)))
    if (n = r ? [] : {}, !r && !QU(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = St(e[a]));
  else
    return e;
  return n;
}
var Bs = (e) => Array.isArray(e) ? e.filter(Boolean) : [], st = (e) => e === void 0, Je = (e, n, r) => {
  if (!n || !dt(e))
    return r;
  const i = Bs(n.split(/[,[\].]+?/)).reduce((a, o) => Lt(a) ? a : a[o], e);
  return st(i) || i === e ? st(e[n]) ? r : e[n] : i;
}, Qt = (e) => typeof e == "boolean", Fp = (e) => /^\w*$/.test(e), L_ = (e) => Bs(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Qn = (e, n, r) => {
  let i = -1;
  const a = Fp(n) ? [n] : L_(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = dt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const ys = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, ur = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, $r = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, JU = Ae.createContext(null), Ep = () => Ae.useContext(JU);
var V_ = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== ur.all && (n._proxyFormState[s] = !i || ur.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function XU(e) {
  const n = Ep(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Ae.useState(r._formState), d = Ae.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Ae.useRef(a);
  return m.current = a, Ae.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Ae.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Ae.useMemo(() => V_(s, r, d.current, !1), [s, r]);
}
var Sr = (e) => typeof e == "string", z_ = (e, n, r, i, a) => Sr(e) ? (i && n.watch.add(e), Je(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Je(r, o))) : (i && (n.watchAll = !0), r);
function U_(e) {
  const n = Ep(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Ae.useRef(i), d = Ae.useRef(a);
  l.current = i, Ae.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(z_(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Ae.useState(r._getWatch(i, a));
  return Ae.useEffect(() => r._removeUnmounted()), m;
}
function ZU(e) {
  const n = Ep(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = A_(a._names.array, r), l = U_({
    control: a,
    name: r,
    defaultValue: Je(a._formValues, r, Je(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = XU({
    control: a,
    name: r,
    exact: !0
  }), m = Ae.useRef(e), u = Ae.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...Qt(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Ae.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Je(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Je(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Je(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Je(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Je(d.errors, r)
    }
  }), [d, r]), h = Ae.useCallback((S) => u.current.onChange({
    target: {
      value: P_(S),
      name: r
    },
    type: ys.CHANGE
  }), [r]), v = Ae.useCallback(() => u.current.onBlur({
    target: {
      value: Je(a._formValues, r),
      name: r
    },
    type: ys.BLUR
  }), [r, a._formValues]), C = Ae.useCallback((S) => {
    const j = Je(a._fields, r);
    j && S && (j._f.ref = {
      focus: () => S.focus(),
      select: () => S.select(),
      setCustomValidity: (k) => S.setCustomValidity(k),
      reportValidity: () => S.reportValidity()
    });
  }, [a._fields, r]), _ = Ae.useMemo(() => ({
    name: r,
    value: l,
    ...Qt(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: C
  }), [r, i, d.disabled, h, v, C, l]);
  return Ae.useEffect(() => {
    const S = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...Qt(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const j = (k, L) => {
      const E = Je(a._fields, k);
      E && E._f && (E._f.mount = L);
    };
    if (j(r, !0), S) {
      const k = St(Je(a._options.defaultValues, r));
      Qn(a._defaultValues, r, k), st(Je(a._formValues, r)) && Qn(a._formValues, r, k);
    }
    return !s && a.register(r), () => {
      (s ? S && !a._state.action : S) ? a.unregister(r) : j(r, !1);
    };
  }, [r, a, s, o]), Ae.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Ae.useMemo(() => ({
    field: _,
    formState: d,
    fieldState: f
  }), [_, d, f]);
}
const Ok = (e) => e.render(ZU(e));
var eM = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, qa = (e) => Array.isArray(e) ? e : [e], Pk = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, vm = (e) => Lt(e) || !O_(e);
function Br(e, n) {
  if (vm(e) || vm(n))
    return e === n;
  if (ci(e) && ci(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (ci(o) && ci(s) || dt(o) && dt(s) || Array.isArray(o) && Array.isArray(s) ? !Br(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Pt = (e) => dt(e) && !Object.keys(e).length, Tp = (e) => e.type === "file", mr = (e) => typeof e == "function", gs = (e) => {
  if (!Ip)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, M_ = (e) => e.type === "select-multiple", $p = (e) => e.type === "radio", nM = (e) => $p(e) || uo(e), Fu = (e) => gs(e) && e.isConnected;
function tM(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = st(e) ? i++ : e[n[i++]];
  return e;
}
function rM(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !st(e[n]))
      return !1;
  return !0;
}
function yt(e, n) {
  const r = Array.isArray(n) ? n : Fp(n) ? [n] : L_(n), i = r.length === 1 ? e : tM(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (dt(i) && Pt(i) || Array.isArray(i) && rM(i)) && yt(e, r.slice(0, -1)), e;
}
var B_ = (e) => {
  for (const n in e)
    if (mr(e[n]))
      return !0;
  return !1;
};
function vs(e, n = {}) {
  const r = Array.isArray(e);
  if (dt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || dt(e[i]) && !B_(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, vs(e[i], n[i])) : Lt(e[i]) || (n[i] = !0);
  return n;
}
function q_(e, n, r) {
  const i = Array.isArray(e);
  if (dt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || dt(e[a]) && !B_(e[a]) ? st(n) || vm(r[a]) ? r[a] = Array.isArray(e[a]) ? vs(e[a], []) : { ...vs(e[a]) } : q_(e[a], Lt(n) ? {} : n[a], r[a]) : r[a] = !Br(e[a], n[a]);
  return r;
}
var $a = (e, n) => q_(e, n, vs(n));
const Ak = {
  value: !1,
  isValid: !1
}, Lk = { value: !0, isValid: !0 };
var H_ = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !st(e[0].attributes.value) ? st(e[0].value) || e[0].value === "" ? Lk : { value: e[0].value, isValid: !0 } : Lk
    ) : Ak;
  }
  return Ak;
}, W_ = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => st(e) ? e : n ? e === "" ? NaN : e && +e : r && Sr(e) ? new Date(e) : i ? i(e) : e;
const Vk = {
  isValid: !1,
  value: null
};
var K_ = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Vk) : Vk;
function zk(e) {
  const n = e.ref;
  return Tp(n) ? n.files : $p(n) ? K_(e.refs).value : M_(n) ? [...n.selectedOptions].map(({ value: r }) => r) : uo(n) ? H_(e.refs).value : W_(st(n.value) ? e.ref.value : n.value, e);
}
var iM = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Je(n, o);
    s && Qn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, ks = (e) => e instanceof RegExp, Da = (e) => st(e) ? e : ks(e) ? e.source : dt(e) ? ks(e.value) ? e.value.source : e.value : e, Uk = (e) => ({
  isOnSubmit: !e || e === ur.onSubmit,
  isOnBlur: e === ur.onBlur,
  isOnChange: e === ur.onChange,
  isOnAll: e === ur.all,
  isOnTouch: e === ur.onTouched
});
const Mk = "AsyncFunction";
var aM = (e) => !!e && !!e.validate && !!(mr(e.validate) && e.validate.constructor.name === Mk || dt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Mk)), oM = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Bk = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ha = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Je(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ha(l, n))
          break;
      } else if (dt(l) && Ha(l, n))
        break;
    }
  }
};
function qk(e, n, r) {
  const i = Je(e, r);
  if (i || Fp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Je(n, o), l = Je(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var sM = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Pt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || ur.all));
}, lM = (e, n, r) => !e || !n || e === n || qa(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), cM = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, dM = (e, n) => !Bs(Je(e, n)).length && yt(e, n), uM = (e, n, r) => {
  const i = qa(Je(e, r));
  return Qn(i, "root", n[r]), Qn(e, r, i), e;
}, ns = (e) => Sr(e);
function Hk(e, n, r = "validate") {
  if (ns(e) || Array.isArray(e) && e.every(ns) || Qt(e) && !e)
    return {
      type: r,
      message: ns(e) ? e : "",
      ref: n
    };
}
var Ei = (e) => dt(e) && !ks(e) ? e : {
  value: e,
  message: ""
}, Wk = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: v, validate: C, name: _, valueAsNumber: S, mount: j } = e._f, k = Je(r, _);
  if (!j || n.has(_))
    return {};
  const L = l ? l[0] : s, E = (B) => {
    a && L.reportValidity && (L.setCustomValidity(Qt(B) ? "" : B || ""), L.reportValidity());
  }, I = {}, F = $p(s), A = uo(s), K = F || A, Y = (S || Tp(s)) && st(s.value) && st(k) || gs(s) && s.value === "" || k === "" || Array.isArray(k) && !k.length, ie = eM.bind(null, _, i, I), G = (B, O, z, Z = $r.maxLength, be = $r.minLength) => {
    const he = B ? O : z;
    I[_] = {
      type: B ? Z : be,
      message: he,
      ref: s,
      ...ie(B ? Z : be, he)
    };
  };
  if (o ? !Array.isArray(k) || !k.length : d && (!K && (Y || Lt(k)) || Qt(k) && !k || A && !H_(l).isValid || F && !K_(l).isValid)) {
    const { value: B, message: O } = ns(d) ? { value: !!d, message: d } : Ei(d);
    if (B && (I[_] = {
      type: $r.required,
      message: O,
      ref: L,
      ...ie($r.required, O)
    }, !i))
      return E(O), I;
  }
  if (!Y && (!Lt(f) || !Lt(h))) {
    let B, O;
    const z = Ei(h), Z = Ei(f);
    if (!Lt(k) && !isNaN(k)) {
      const be = s.valueAsNumber || k && +k;
      Lt(z.value) || (B = be > z.value), Lt(Z.value) || (O = be < Z.value);
    } else {
      const be = s.valueAsDate || new Date(k), he = (q) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + q), de = s.type == "time", ye = s.type == "week";
      Sr(z.value) && k && (B = de ? he(k) > he(z.value) : ye ? k > z.value : be > new Date(z.value)), Sr(Z.value) && k && (O = de ? he(k) < he(Z.value) : ye ? k < Z.value : be < new Date(Z.value));
    }
    if ((B || O) && (G(!!B, z.message, Z.message, $r.max, $r.min), !i))
      return E(I[_].message), I;
  }
  if ((m || u) && !Y && (Sr(k) || o && Array.isArray(k))) {
    const B = Ei(m), O = Ei(u), z = !Lt(B.value) && k.length > +B.value, Z = !Lt(O.value) && k.length < +O.value;
    if ((z || Z) && (G(z, B.message, O.message), !i))
      return E(I[_].message), I;
  }
  if (v && !Y && Sr(k)) {
    const { value: B, message: O } = Ei(v);
    if (ks(B) && !k.match(B) && (I[_] = {
      type: $r.pattern,
      message: O,
      ref: s,
      ...ie($r.pattern, O)
    }, !i))
      return E(O), I;
  }
  if (C) {
    if (mr(C)) {
      const B = await C(k, r), O = Hk(B, L);
      if (O && (I[_] = {
        ...O,
        ...ie($r.validate, O.message)
      }, !i))
        return E(O.message), I;
    } else if (dt(C)) {
      let B = {};
      for (const O in C) {
        if (!Pt(B) && !i)
          break;
        const z = Hk(await C[O](k, r), L, O);
        z && (B = {
          ...z,
          ...ie(O, z.message)
        }, E(z.message), i && (I[_] = B));
      }
      if (!Pt(B) && (I[_] = {
        ref: L,
        ...B
      }, !i))
        return I;
    }
  }
  return E(!0), I;
};
const mM = {
  mode: ur.onSubmit,
  reValidateMode: ur.onChange,
  shouldFocusError: !0
};
function pM(e = {}) {
  let n = {
    ...mM,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: mr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = dt(n.defaultValues) || dt(n.values) ? St(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : St(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Pk(),
    state: Pk()
  }, v = Uk(n.mode), C = Uk(n.reValidateMode), _ = n.criteriaMode === ur.all, S = (J) => (T) => {
    clearTimeout(m), m = setTimeout(J, T);
  }, j = async (J) => {
    if (!n.disabled && (u.isValid || f.isValid || J)) {
      const T = n.resolver ? Pt((await Y()).errors) : await G(i, !0);
      T !== r.isValid && h.state.next({
        isValid: T
      });
    }
  }, k = (J, T) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((J || Array.from(l.mount)).forEach((U) => {
      U && (T ? Qn(r.validatingFields, U, T) : yt(r.validatingFields, U));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Pt(r.validatingFields)
    }));
  }, L = (J, T = [], U, X, re = !0, V = !0) => {
    if (X && U && !n.disabled) {
      if (s.action = !0, V && Array.isArray(Je(i, J))) {
        const W = U(Je(i, J), X.argA, X.argB);
        re && Qn(i, J, W);
      }
      if (V && Array.isArray(Je(r.errors, J))) {
        const W = U(Je(r.errors, J), X.argA, X.argB);
        re && Qn(r.errors, J, W), dM(r.errors, J);
      }
      if ((u.touchedFields || f.touchedFields) && V && Array.isArray(Je(r.touchedFields, J))) {
        const W = U(Je(r.touchedFields, J), X.argA, X.argB);
        re && Qn(r.touchedFields, J, W);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = $a(a, o)), h.state.next({
        name: J,
        isDirty: O(J, T),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Qn(o, J, T);
  }, E = (J, T) => {
    Qn(r.errors, J, T), h.state.next({
      errors: r.errors
    });
  }, I = (J) => {
    r.errors = J, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, F = (J, T, U, X) => {
    const re = Je(i, J);
    if (re) {
      const V = Je(o, J, st(U) ? Je(a, J) : U);
      st(V) || X && X.defaultChecked || T ? Qn(o, J, T ? V : zk(re._f)) : be(J, V), s.mount && j();
    }
  }, A = (J, T, U, X, re) => {
    let V = !1, W = !1;
    const le = {
      name: J
    };
    if (!n.disabled) {
      if (!U || X) {
        (u.isDirty || f.isDirty) && (W = r.isDirty, r.isDirty = le.isDirty = O(), V = W !== le.isDirty);
        const ke = Br(Je(a, J), T);
        W = !!Je(r.dirtyFields, J), ke ? yt(r.dirtyFields, J) : Qn(r.dirtyFields, J, !0), le.dirtyFields = r.dirtyFields, V = V || (u.dirtyFields || f.dirtyFields) && W !== !ke;
      }
      if (U) {
        const ke = Je(r.touchedFields, J);
        ke || (Qn(r.touchedFields, J, U), le.touchedFields = r.touchedFields, V = V || (u.touchedFields || f.touchedFields) && ke !== U);
      }
      V && re && h.state.next(le);
    }
    return V ? le : {};
  }, K = (J, T, U, X) => {
    const re = Je(r.errors, J), V = (u.isValid || f.isValid) && Qt(T) && r.isValid !== T;
    if (n.delayError && U ? (d = S(() => E(J, U)), d(n.delayError)) : (clearTimeout(m), d = null, U ? Qn(r.errors, J, U) : yt(r.errors, J)), (U ? !Br(re, U) : re) || !Pt(X) || V) {
      const W = {
        ...X,
        ...V && Qt(T) ? { isValid: T } : {},
        errors: r.errors,
        name: J
      };
      r = {
        ...r,
        ...W
      }, h.state.next(W);
    }
  }, Y = async (J) => {
    k(J, !0);
    const T = await n.resolver(o, n.context, iM(J || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return k(J), T;
  }, ie = async (J) => {
    const { errors: T } = await Y(J);
    if (J)
      for (const U of J) {
        const X = Je(T, U);
        X ? Qn(r.errors, U, X) : yt(r.errors, U);
      }
    else
      r.errors = T;
    return T;
  }, G = async (J, T, U = {
    valid: !0
  }) => {
    for (const X in J) {
      const re = J[X];
      if (re) {
        const { _f: V, ...W } = re;
        if (V) {
          const le = l.array.has(V.name), ke = re._f && aM(re._f);
          ke && u.validatingFields && k([X], !0);
          const Ie = await Wk(re, l.disabled, o, _, n.shouldUseNativeValidation && !T, le);
          if (ke && u.validatingFields && k([X]), Ie[V.name] && (U.valid = !1, T))
            break;
          !T && (Je(Ie, V.name) ? le ? uM(r.errors, Ie, V.name) : Qn(r.errors, V.name, Ie[V.name]) : yt(r.errors, V.name));
        }
        !Pt(W) && await G(W, T, U);
      }
    }
    return U.valid;
  }, B = () => {
    for (const J of l.unMount) {
      const T = Je(i, J);
      T && (T._f.refs ? T._f.refs.every((U) => !Fu(U)) : !Fu(T._f.ref)) && Me(J);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (J, T) => !n.disabled && (J && T && Qn(o, J, T), !Br(Ce(), a)), z = (J, T, U) => z_(J, l, {
    ...s.mount ? o : st(T) ? a : Sr(J) ? { [J]: T } : T
  }, U, T), Z = (J) => Bs(Je(s.mount ? o : a, J, n.shouldUnregister ? Je(a, J, []) : [])), be = (J, T, U = {}) => {
    const X = Je(i, J);
    let re = T;
    if (X) {
      const V = X._f;
      V && (!V.disabled && Qn(o, J, W_(T, V)), re = gs(V.ref) && Lt(T) ? "" : T, M_(V.ref) ? [...V.ref.options].forEach((W) => W.selected = re.includes(W.value)) : V.refs ? uo(V.ref) ? V.refs.length > 1 ? V.refs.forEach((W) => (!W.defaultChecked || !W.disabled) && (W.checked = Array.isArray(re) ? !!re.find((le) => le === W.value) : re === W.value)) : V.refs[0] && (V.refs[0].checked = !!re) : V.refs.forEach((W) => W.checked = W.value === re) : Tp(V.ref) ? V.ref.value = "" : (V.ref.value = re, V.ref.type || h.state.next({
        name: J,
        values: St(o)
      })));
    }
    (U.shouldDirty || U.shouldTouch) && A(J, re, U.shouldTouch, U.shouldDirty, !0), U.shouldValidate && Se(J);
  }, he = (J, T, U) => {
    for (const X in T) {
      const re = T[X], V = `${J}.${X}`, W = Je(i, V);
      (l.array.has(J) || dt(re) || W && !W._f) && !ci(re) ? he(V, re, U) : be(V, re, U);
    }
  }, de = (J, T, U = {}) => {
    const X = Je(i, J), re = l.array.has(J), V = St(T);
    Qn(o, J, V), re ? (h.array.next({
      name: J,
      values: St(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && U.shouldDirty && h.state.next({
      name: J,
      dirtyFields: $a(a, o),
      isDirty: O(J, V)
    })) : X && !X._f && !Lt(V) ? he(J, V, U) : be(J, V, U), Bk(J, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? J : void 0,
      values: St(o)
    });
  }, ye = async (J) => {
    s.mount = !0;
    const T = J.target;
    let U = T.name, X = !0;
    const re = Je(i, U), V = (W) => {
      X = Number.isNaN(W) || ci(W) && isNaN(W.getTime()) || Br(W, Je(o, U, W));
    };
    if (re) {
      let W, le;
      const ke = T.type ? zk(re._f) : P_(J), Ie = J.type === ys.BLUR || J.type === ys.FOCUS_OUT, en = !oM(re._f) && !n.resolver && !Je(r.errors, U) && !re._f.deps || cM(Ie, Je(r.touchedFields, U), r.isSubmitted, C, v), hn = Bk(U, l, Ie);
      Qn(o, U, ke), Ie ? (re._f.onBlur && re._f.onBlur(J), d && d(0)) : re._f.onChange && re._f.onChange(J);
      const rn = A(U, ke, Ie), cn = !Pt(rn) || hn;
      if (!Ie && h.state.next({
        name: U,
        type: J.type,
        values: St(o)
      }), en)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Ie && j() : Ie || j()), cn && h.state.next({ name: U, ...hn ? {} : rn });
      if (!Ie && hn && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await Y([U]);
        if (V(ke), X) {
          const dn = qk(r.errors, i, U), Sn = qk(pn, i, dn.name || U);
          W = Sn.error, U = Sn.name, le = Pt(pn);
        }
      } else
        k([U], !0), W = (await Wk(re, l.disabled, o, _, n.shouldUseNativeValidation))[U], k([U]), V(ke), X && (W ? le = !1 : (u.isValid || f.isValid) && (le = await G(i, !0)));
      X && (re._f.deps && Se(re._f.deps), K(U, le, W, rn));
    }
  }, q = (J, T) => {
    if (Je(r.errors, T) && J.focus)
      return J.focus(), 1;
  }, Se = async (J, T = {}) => {
    let U, X;
    const re = qa(J);
    if (n.resolver) {
      const V = await ie(st(J) ? J : re);
      U = Pt(V), X = J ? !re.some((W) => Je(V, W)) : U;
    } else J ? (X = (await Promise.all(re.map(async (V) => {
      const W = Je(i, V);
      return await G(W && W._f ? { [V]: W } : W);
    }))).every(Boolean), !(!X && !r.isValid) && j()) : X = U = await G(i);
    return h.state.next({
      ...!Sr(J) || (u.isValid || f.isValid) && U !== r.isValid ? {} : { name: J },
      ...n.resolver || !J ? { isValid: U } : {},
      errors: r.errors
    }), T.shouldFocus && !X && Ha(i, q, J ? re : l.mount), X;
  }, Ce = (J) => {
    const T = {
      ...s.mount ? o : a
    };
    return st(J) ? T : Sr(J) ? Je(T, J) : J.map((U) => Je(T, U));
  }, H = (J, T) => ({
    invalid: !!Je((T || r).errors, J),
    isDirty: !!Je((T || r).dirtyFields, J),
    error: Je((T || r).errors, J),
    isValidating: !!Je(r.validatingFields, J),
    isTouched: !!Je((T || r).touchedFields, J)
  }), He = (J) => {
    J && qa(J).forEach((T) => yt(r.errors, T)), h.state.next({
      errors: J ? r.errors : {}
    });
  }, Be = (J, T, U) => {
    const X = (Je(i, J, { _f: {} })._f || {}).ref, re = Je(r.errors, J) || {}, { ref: V, message: W, type: le, ...ke } = re;
    Qn(r.errors, J, {
      ...ke,
      ...T,
      ref: X
    }), h.state.next({
      name: J,
      errors: r.errors,
      isValid: !1
    }), U && U.shouldFocus && X && X.focus && X.focus();
  }, Re = (J, T) => mr(J) ? h.state.subscribe({
    next: (U) => J(z(void 0, T), U)
  }) : z(J, T, !0), Ue = (J) => h.state.subscribe({
    next: (T) => {
      lM(J.name, T.name, J.exact) && sM(T, J.formState || u, Pe, J.reRenderRoot) && J.callback({
        values: { ...o },
        ...r,
        ...T
      });
    }
  }).unsubscribe, Te = (J) => (s.mount = !0, f = {
    ...f,
    ...J.formState
  }, Ue({
    ...J,
    formState: f
  })), Me = (J, T = {}) => {
    for (const U of J ? qa(J) : l.mount)
      l.mount.delete(U), l.array.delete(U), T.keepValue || (yt(i, U), yt(o, U)), !T.keepError && yt(r.errors, U), !T.keepDirty && yt(r.dirtyFields, U), !T.keepTouched && yt(r.touchedFields, U), !T.keepIsValidating && yt(r.validatingFields, U), !n.shouldUnregister && !T.keepDefaultValue && yt(a, U);
    h.state.next({
      values: St(o)
    }), h.state.next({
      ...r,
      ...T.keepDirty ? { isDirty: O() } : {}
    }), !T.keepIsValid && j();
  }, De = ({ disabled: J, name: T }) => {
    (Qt(J) && s.mount || J || l.disabled.has(T)) && (J ? l.disabled.add(T) : l.disabled.delete(T));
  }, on = (J, T = {}) => {
    let U = Je(i, J);
    const X = Qt(T.disabled) || Qt(n.disabled);
    return Qn(i, J, {
      ...U || {},
      _f: {
        ...U && U._f ? U._f : { ref: { name: J } },
        name: J,
        mount: !0,
        ...T
      }
    }), l.mount.add(J), U ? De({
      disabled: Qt(T.disabled) ? T.disabled : n.disabled,
      name: J
    }) : F(J, !0, T.value), {
      ...X ? { disabled: T.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!T.required,
        min: Da(T.min),
        max: Da(T.max),
        minLength: Da(T.minLength),
        maxLength: Da(T.maxLength),
        pattern: Da(T.pattern)
      } : {},
      name: J,
      onChange: ye,
      onBlur: ye,
      ref: (re) => {
        if (re) {
          on(J, T), U = Je(i, J);
          const V = st(re.value) && re.querySelectorAll && re.querySelectorAll("input,select,textarea")[0] || re, W = nM(V), le = U._f.refs || [];
          if (W ? le.find((ke) => ke === V) : V === U._f.ref)
            return;
          Qn(i, J, {
            _f: {
              ...U._f,
              ...W ? {
                refs: [
                  ...le.filter(Fu),
                  V,
                  ...Array.isArray(Je(a, J)) ? [{}] : []
                ],
                ref: { type: V.type, name: J }
              } : { ref: V }
            }
          }), F(J, !1, void 0, V);
        } else
          U = Je(i, J, {}), U._f && (U._f.mount = !1), (n.shouldUnregister || T.shouldUnregister) && !(A_(l.array, J) && s.action) && l.unMount.add(J);
      }
    };
  }, Fe = () => n.shouldFocusError && Ha(i, q, l.mount), Ye = (J) => {
    Qt(J) && (h.state.next({ disabled: J }), Ha(i, (T, U) => {
      const X = Je(i, U);
      X && (T.disabled = X._f.disabled || J, Array.isArray(X._f.refs) && X._f.refs.forEach((re) => {
        re.disabled = X._f.disabled || J;
      }));
    }, 0, !1));
  }, Ze = (J, T) => async (U) => {
    let X;
    U && (U.preventDefault && U.preventDefault(), U.persist && U.persist());
    let re = St(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: V, values: W } = await Y();
      r.errors = V, re = W;
    } else
      await G(i);
    if (l.disabled.size)
      for (const V of l.disabled)
        Qn(re, V, void 0);
    if (yt(r.errors, "root"), Pt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await J(re, U);
      } catch (V) {
        X = V;
      }
    } else
      T && await T({ ...r.errors }, U), Fe(), setTimeout(Fe);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Pt(r.errors) && !X,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), X)
      throw X;
  }, fe = (J, T = {}) => {
    Je(i, J) && (st(T.defaultValue) ? de(J, St(Je(a, J))) : (de(J, T.defaultValue), Qn(a, J, St(T.defaultValue))), T.keepTouched || yt(r.touchedFields, J), T.keepDirty || (yt(r.dirtyFields, J), r.isDirty = T.defaultValue ? O(J, St(Je(a, J))) : O()), T.keepError || (yt(r.errors, J), u.isValid && j()), h.state.next({ ...r }));
  }, ge = (J, T = {}) => {
    const U = J ? St(J) : a, X = St(U), re = Pt(J), V = re ? a : X;
    if (T.keepDefaultValues || (a = U), !T.keepValues) {
      if (T.keepDirtyValues) {
        const W = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys($a(a, o))
        ]);
        for (const le of Array.from(W))
          Je(r.dirtyFields, le) ? Qn(V, le, Je(o, le)) : de(le, Je(V, le));
      } else {
        if (Ip && st(J))
          for (const W of l.mount) {
            const le = Je(i, W);
            if (le && le._f) {
              const ke = Array.isArray(le._f.refs) ? le._f.refs[0] : le._f.ref;
              if (gs(ke)) {
                const Ie = ke.closest("form");
                if (Ie) {
                  Ie.reset();
                  break;
                }
              }
            }
          }
        for (const W of l.mount)
          de(W, Je(V, W));
      }
      o = St(V), h.array.next({
        values: { ...V }
      }), h.state.next({
        values: { ...V }
      });
    }
    l = {
      mount: T.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!T.keepIsValid || !!T.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: T.keepSubmitCount ? r.submitCount : 0,
      isDirty: re ? !1 : T.keepDirty ? r.isDirty : !!(T.keepDefaultValues && !Br(J, a)),
      isSubmitted: T.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: re ? {} : T.keepDirtyValues ? T.keepDefaultValues && o ? $a(a, o) : r.dirtyFields : T.keepDefaultValues && J ? $a(a, J) : T.keepDirty ? r.dirtyFields : {},
      touchedFields: T.keepTouched ? r.touchedFields : {},
      errors: T.keepErrors ? r.errors : {},
      isSubmitSuccessful: T.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, $e = (J, T) => ge(mr(J) ? J(o) : J, T), Le = (J, T = {}) => {
    const U = Je(i, J), X = U && U._f;
    if (X) {
      const re = X.refs ? X.refs[0] : X.ref;
      re.focus && (re.focus(), T.shouldSelect && mr(re.select) && re.select());
    }
  }, Pe = (J) => {
    r = {
      ...r,
      ...J
    };
  }, mn = {
    control: {
      register: on,
      unregister: Me,
      getFieldState: H,
      handleSubmit: Ze,
      setError: Be,
      _subscribe: Ue,
      _runSchema: Y,
      _getWatch: z,
      _getDirty: O,
      _setValid: j,
      _setFieldArray: L,
      _setDisabledField: De,
      _setErrors: I,
      _getFieldArray: Z,
      _reset: ge,
      _resetDefaultValues: () => mr(n.defaultValues) && n.defaultValues().then((J) => {
        $e(J, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ye,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(J) {
        s = J;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(J) {
        l = J;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(J) {
        n = {
          ...n,
          ...J
        };
      }
    },
    subscribe: Te,
    trigger: Se,
    register: on,
    handleSubmit: Ze,
    watch: Re,
    setValue: de,
    getValues: Ce,
    reset: $e,
    resetField: fe,
    clearErrors: He,
    unregister: Me,
    setError: Be,
    setFocus: Le,
    getFieldState: H
  };
  return {
    ...mn,
    formControl: mn
  };
}
function fM(e = {}) {
  const n = Ae.useRef(void 0), r = Ae.useRef(void 0), [i, a] = Ae.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: mr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: mr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : pM(e),
    formState: i
  }, e.formControl && e.defaultValues && !mr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Ae.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Ae.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Ae.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Ae.useEffect(() => {
    e.values && !Br(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Ae.useEffect(() => {
    e.errors && !Pt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Ae.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Ae.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = V_(i, o), n.current;
}
const hM = "_settingsWrapper_1ycvy_1", yM = "_settingsWrapperHeader_1ycvy_6", gM = "_settingsWrapperContent_1ycvy_10", vM = "_settingsWrapperContentCode_1ycvy_18", kM = "_settingsWrapperContentCURL_1ycvy_26", Ra = {
  settingsWrapper: hM,
  settingsWrapperHeader: yM,
  settingsWrapperContent: gM,
  settingsWrapperContentCode: vM,
  settingsWrapperContentCURL: kM
}, bM = ({
  handleChangeText: e
}) => {
  const [n, r] = se(!1), { isCopied: i, copy: a } = Jt(), { control: o } = fM({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = U_({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = at(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Ee.jsx(Ee.Fragment, { children: /* @__PURE__ */ Ee.jsx(ue, { span: 6, children: /* @__PURE__ */ Ee.jsxs(b, { flexDirection: "column", className: Ra.settingsWrapper, children: [
    /* @__PURE__ */ Ee.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: Ra.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Ee.jsx(D.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Ee.jsx(me, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Ee.jsxs(
      b,
      {
        flexDirection: "column",
        className: Ra.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Ee.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ee.jsx(
            _s,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Ee.jsxs("ol", { children: [
                /* @__PURE__ */ Ee.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Ee.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Ee.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Ee.jsx("span", { className: Ra.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Ee.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Ee.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Ee.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Ee.jsx(
            Ok,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ee.jsx(
                ir,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Ee.jsx(
            Ok,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ee.jsx(
                ir,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ Ee.jsxs(Ee.Fragment, { children: [
            /* @__PURE__ */ Ee.jsx(nn, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Ee.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: Ra.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ Ee.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Ee.jsx(
              We,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Ee.jsx(
                  Kn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, xM = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], _M = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Hi
  }
], SM = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: bM
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], NM = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, jM = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, wM = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: BL,
  featureSettings: []
} : n ? {
  authSettings: qL,
  featureSettings: [...j_]
} : e ? {
  authSettings: [
    ...sk,
    ...UL
  ],
  featureSettings: [...lk]
} : {
  authSettings: [
    ...sk,
    ...ML
  ],
  featureSettings: [...lk]
}, G_ = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, CM = G_(
  _M,
  SM
), IM = G_(
  t$,
  r$
), Y_ = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = jM(a?.value, r), s = i !== void 0 ? i : NM(
    r
  );
  return o !== void 0 ? o : s;
}, Dp = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = wM(n), s = CM(r), l = IM(i);
  return {
    SHOPIFY: {
      widget: Q3,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: FE,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      fieldDefinitions: qu,
      WidgetSettings: $E
    },
    GITHUB: {
      widget: TI,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      fieldDefinitions: Uu,
      WidgetSettings: DI
    },
    MIUROS: {
      widget: eL,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      fieldDefinitions: cm,
      WidgetSettings: tL
    },
    KLAVIYO: {
      widget: e$,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...l, ...n$]
    },
    LINEAR: {
      widget: IA,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      fieldDefinitions: am,
      WidgetSettings: EA
    },
    VOYADO: {
      widget: CU,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: gm,
      WidgetSettings: FU
    },
    LOYALTYLION: {
      widget: s2,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      fieldDefinitions: om,
      WidgetSettings: c2
    },
    RECHARGE: {
      widget: CL,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      fieldDefinitions: mm,
      WidgetSettings: FL
    },
    BRAZE: {
      widget: Kj,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...Gj]
    },
    YOTPO: {
      widget: GU,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...s, ...xM]
    },
    INGRID: {
      widget: oF,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Mu,
      WidgetSettings: lF
    }
  };
}, FM = (e, n) => {
  const r = n.find(
    (i) => i.key === e.key
  )?.value;
  return e.type === "boolean" ? pS(r, e.defaultValue) : fS(r, e.defaultValue);
}, EM = (e, n) => e.map((r) => ({
  key: r.key,
  value: FM(r, n)
})), TM = (e, n) => e.map(({ key: r, type: i, defaultValue: a }) => ({
  key: r,
  value: Y_({
    key: r,
    configuration: n,
    settingType: i,
    settingDefault: a
  })
})), $M = ({ fieldDefinitions: e, settingsConfiguration: n }, r) => e ? EM(
  e.filter(({ secret: i }) => !i),
  r
) : TM(
  (n ?? []).filter(({ secret: i }) => !i),
  r
), DM = (e) => {
  const n = Dp();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: d
    }) => {
      const u = n[i];
      return {
        id: r,
        type: i,
        name: a,
        settings: $M(u, o),
        misconfigured: s,
        renderConditions: l,
        icon: u.icon,
        iconColors: u.iconColors,
        widget: u.widget,
        integrationKey: d
      };
    }
  );
}, I4 = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d,
  renderConditionMatchedIndicator: m,
  widgetAnnotations: u
}) => {
  const f = di(
    {}
  ), h = (F) => (f.current[F] || (f.current[F] = { current: null }), f.current[F]), { track: v } = bn(), C = Bn(
    () => DM(e),
    [e]
  ), _ = {
    headline: "",
    text: "",
    onConfirm: () => I(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [S, j] = se(_), [k, L] = se(!1), E = (F) => {
    L(!0), j(F);
  }, I = () => {
    L(!1), j(_);
  };
  return /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
    C.map(
      ({
        id: F,
        name: A,
        type: K,
        widget: Y,
        settings: ie,
        misconfigured: G,
        renderConditions: B,
        icon: O,
        iconColors: z,
        integrationKey: Z
      }, be) => {
        const he = `partner-integration-${K}`, de = u?.get(F) === !1, ye = /* @__PURE__ */ Ve.jsx(Nm, { icon: O, color: z }), q = ie?.reduce(
          (Se, Ce) => (Se[Ce.key] = Ce.value, Se),
          {}
        );
        return s ? /* @__PURE__ */ Ve.jsx("div", { className: "icon-holder", children: ye }, `partner-icon-${F}`) : /* @__PURE__ */ Ve.jsxs(
          rr,
          {
            onToggle: () => {
              v(
                o(Z) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: F,
                  widgetType: K.toLowerCase()
                }
              ), a(Z);
            },
            isOpen: o(Z),
            className: he,
            containerRef: (Se) => {
              h(Z).current = Se;
            },
            children: [
              /* @__PURE__ */ Ve.jsx(
                rr.Header,
                {
                  className: tt({
                    [kj.unmatchedHeader]: de
                  }),
                  wrap: "normal",
                  avatar: ye,
                  slotBeforeTitle: d?.(
                    Z,
                    be,
                    h(Z)
                  ),
                  slotAfterTitle: /* @__PURE__ */ Ve.jsx(Ve.Fragment, { children: l?.(Z) }),
                  children: /* @__PURE__ */ Ve.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
                    A,
                    m?.(
                      B ?? [],
                      F
                    )
                  ] })
                }
              ),
              /* @__PURE__ */ Ve.jsx(rr.Content, { children: G ? /* @__PURE__ */ Ve.jsx(Cn, { isMisconfigured: !0 }) : /* @__PURE__ */ Ve.jsx(
                ab.Provider,
                {
                  value: {
                    onError: (Se, Ce) => console.warn(
                      `Something went wrong with a partner widget of type '${K}' and id '${F}'`,
                      Se,
                      Ce
                    )
                  },
                  children: /* @__PURE__ */ Ve.jsx(
                    Vb,
                    {
                      integrationId: F,
                      type: K,
                      configuration: n,
                      showNotification: i,
                      showModal: E,
                      children: NS(Y, {
                        conversationContext: r,
                        settings: q
                      })
                    }
                  )
                }
              ) })
            ]
          },
          Z
        );
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      rb,
      {
        isOpen: k,
        setIsOpen: L,
        headline: S.headline,
        text: S.text,
        confirmLabel: S.confirmLabel,
        confirmVariant: S.confirmVariant,
        cancelLabel: S.cancelLabel,
        cancelVariant: S.cancelVariant,
        onConfirm: S.onConfirm ? () => {
          try {
            S.onConfirm && S.onConfirm();
          } finally {
            L(!1), j(_);
          }
        } : void 0,
        onCancel: S.onCancel ? () => {
          try {
            S.onCancel && S.onCancel();
          } finally {
            L(!1), j(_);
          }
        } : void 0,
        children: S.children
      }
    )
  ] });
}, RM = Ss`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function F4(e, { skip: n = !1 } = {}) {
  const [r, i] = se([]), [a, o] = se(!1);
  return qe(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), Lb(e).query({
      query: RM
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const OM = ({
  widgetConfiguration: e
}) => {
  const n = Bn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = Bn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, PM = "FULL_ACCESS", AM = "2", LM = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [PM],
        version: AM
      })
    }).then((l) => l.json())
  };
}, VM = "dixaApiToken", Rp = "dixaApiTokenId", Q_ = "dixaApiTokenName", Kk = (e) => [Rp, Q_].every(
  (r) => e.find((i) => i?.key === r)
);
function zM({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = UM(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const UM = (e) => [
  {
    key: VM,
    value: e.value,
    secret: !0
  },
  {
    key: Rp,
    value: e.id,
    secret: !1
  },
  {
    key: Q_,
    value: e.name,
    secret: !1
  }
], MM = "_wrapper_1lmim_1", BM = "_wrapperBox_1lmim_4", qM = "_wrapperBoxErrorBorder_1lmim_9", Eu = {
  wrapper: MM,
  wrapperBox: BM,
  wrapperBoxErrorBorder: qM
}, HM = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (L) => L.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: v } = f, C = `Insert your ${h.label.toLowerCase()}`, _ = `Insert your ${v.label.toLowerCase()}`, [S, j] = se({
    username: "",
    password: ""
  }), k = at(
    (L) => {
      m({
        target: {
          name: s,
          value: L
        }
      });
    },
    [s, m]
  );
  return qe(() => {
    k(
      S.username !== "" && S.password !== "" ? window.btoa(`${S.username}:${S.password}`) : ""
    );
  }, [S]), /* @__PURE__ */ Ve.jsx(
    nn,
    {
      required: e,
      label: a,
      meta: l,
      className: Eu.wrapper,
      children: /* @__PURE__ */ Ve.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: tt(Eu.wrapperBox, {
            [Eu.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ Ve.jsx(
              ir,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: C,
                input: {
                  name: s,
                  value: S.username,
                  onChange: (L) => j({
                    username: L?.target.value ?? "",
                    password: S.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ Ve.jsx(
              ir,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: _,
                input: {
                  name: s,
                  value: S.password,
                  onChange: (L) => j({
                    username: S.username,
                    password: L?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function Gk({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: v,
  isCreationMode: C,
  prefix: _,
  integrationId: S,
  integrationType: j,
  configuration: k,
  settings: L,
  otherProps: E
}) {
  const I = v === "custom" && E?.component, F = u(n)?.value;
  return I ? /* @__PURE__ */ Ve.jsx(
    I,
    {
      configuration: k,
      integrationId: S,
      integrationType: j,
      label: r,
      settings: L,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
    /* @__PURE__ */ Ve.jsx(ue, { span: 3, children: /* @__PURE__ */ Ve.jsx(
      WM,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: C,
        children: v === "input" ? /* @__PURE__ */ Ve.jsx(
          ir,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: F,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: _,
            ...e && !C && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : v === "basicAuthInput" ? /* @__PURE__ */ Ve.jsx(
          HM,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: C,
            label: r,
            widgetSettingsKey: n,
            settings: L,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : v === "switch" ? /* @__PURE__ */ Ve.jsx(nn, { label: r, children: /* @__PURE__ */ Ve.jsx(
          ob,
          {
            input: {
              name: n,
              value: "",
              checked: F,
              onChange: l
            }
          }
        ) }) : v === "select" ? /* @__PURE__ */ Ve.jsx(nn, { label: r, children: /* @__PURE__ */ Ve.jsx(
          Ur,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (A) => d(n, A),
            getItemTitleByValue: (A) => A ? /* @__PURE__ */ Ve.jsx(D.Paragraph, { children: A.label }) : /* @__PURE__ */ Ve.jsx(Ve.Fragment, {}),
            value: F ? [
              {
                label: (E?.selectItems || []).find(
                  (A) => A.value === F
                )?.label,
                value: F
              }
            ] : [],
            equalityFn: (A, K) => A.value === K.value,
            children: (E?.selectItems || []).map((A) => /* @__PURE__ */ Ve.jsx(lt.Item, { value: A, children: A.label }, A.value))
          }
        ) }) : /* @__PURE__ */ Ve.jsx(Ve.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ Ve.jsx(ue, { span: 3 })
  ] });
}
function WM({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ Ve.jsx(nn, { label: n, children: /* @__PURE__ */ Ve.jsxs(
    Kn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const Wa = "partner-integrations-widget-name-form-field", Yk = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: Y_({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), KM = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = se(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = se({}), s = (E) => i(E), l = (E) => !E || E === "", d = (E) => {
    const { [E]: I, ...F } = a;
    o(F);
  }, m = (E) => ({
    ...E,
    settings: E.settings.filter(({ isEditing: I }) => I).map(({ key: I, value: F, secret: A }) => ({
      key: I,
      value: F,
      secret: A
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (E) => {
    if (!E)
      return;
    const {
      target: { name: I, value: F }
    } = E;
    a[I] && !l(F) && d(I), i({
      ...r,
      settings: r.settings.map(
        (A) => A.key === I ? { ...A, value: F } : A
      )
    });
  }, h = (E) => {
    if (!E)
      return;
    const {
      target: { name: I, checked: F }
    } = E;
    i({
      ...r,
      settings: r.settings.map(
        (A) => A.key === I ? { ...A, value: F } : A
      )
    });
  }, v = (E, I) => {
    if (!I)
      return;
    const { selectedValues: F } = I, A = F?.[0];
    if (A) {
      const K = r.settings.map(
        (Y) => Y.key === E ? { ...Y, value: A?.value } : Y
      );
      i({
        ...r,
        settings: K
      });
    } else {
      const K = r.settings.filter(
        (Y) => Y.key !== E
      );
      i({
        ...r,
        settings: K
      });
    }
  }, C = (E) => {
    i({
      ...r,
      enabled: E
    });
  }, _ = (E) => {
    if (!E)
      return;
    const {
      target: { value: I }
    } = E;
    a[Wa] && !l(I) && d(Wa), i({
      ...r,
      name: I
    });
  }, S = (E, I) => {
    const { settings: F } = r, A = F.map((K) => K.key === I ? {
      ...K,
      isEditing: E,
      ...!E && { value: "" }
    } : K);
    a[I] && !E && d(I), i({
      ...r,
      settings: A
    });
  }, j = (E) => r.settings.find(
    (I) => I.key === E
  ), k = async (E) => {
    E.preventDefault(), L() && n(m(r));
  }, L = () => {
    const E = {}, { name: I, settings: F } = r;
    return l(I) && (E[Wa] = u.input), F.forEach(
      ({ key: A, value: K, required: Y, isEditing: ie, type: G, customValidation: B }) => {
        if (Y && ie)
          if (B) {
            const O = B(K);
            typeof O == "string" && (E[A] = O);
          } else
            typeof K == "string" && l(K) && (E[A] = u[G]);
      }
    ), o(E), !Object.keys(E)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: C,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: v,
    handleEditSecret: S,
    handleChangeName: _,
    handleSubmit: k,
    getSettingValueByKey: j,
    initializeFormData: s,
    validate: L
  };
}, GM = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], Qk = "The configuration of the integration is not correct. Please check the settings.", YM = (e) => {
  const n = Dp()[e.type]?.WidgetSettings;
  return n ? /* @__PURE__ */ Ve.jsx(n, { ...e }) : /* @__PURE__ */ Ve.jsx(QM, { ...e });
}, QM = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const { track: l } = bn(), { deleteDixaApiToken: d, createDixaApiToken: m } = LM({
    type: n,
    baseUrl: a.baseUrl
  }), f = MS().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), h = !e && !!n && !!f, v = GM.includes(n), [C, _] = se(), [S, j] = se(!1), [k, L] = se(!1), [E, I] = se(!1), [F, A] = se(null), [K, Y] = se(), [ie, G] = se(h ? [] : null);
  qe(() => {
    G(h ? [] : null);
  }, [e, h]), qe(() => {
    K && ie === null && G(K.renderConditions ?? []);
  }, [K, ie]);
  const { isInboundOAuth: B } = hS(), O = B && h ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: z,
    isShopifyMarketplaceApp: Z,
    initialValuesForShopify: be
  } = OM({
    featureFlags: a.featureFlags,
    widgetConfiguration: K
  }), he = n === "YOTPO" && !!K?.additionalProperties?.isUsingOAuth, de = n === "KLAVIYO" && !!K?.additionalProperties?.isUsingOAuth, ye = h && n === "SHOPIFY", Ce = Dp({
    SHOPIFY: {
      hasShopifyOAuth: z,
      isShopifyMarketplaceApp: Z,
      isCreationMode: h
    },
    YOTPO: {
      hasOAuth: he,
      isCreationMode: h
    },
    KLAVIYO: {
      hasOAuth: de,
      isCreationMode: h
    }
  })[n].settingsConfiguration ?? [], H = Ce.filter(({ type: X }) => X !== "hidden").filter(({ hideOnCreate: X }) => h ? !X : !0), He = H.filter(
    ({ additionalProperties: X }) => X?.renderAboveForm === !0
  ), Be = H.filter(
    ({ additionalProperties: X }) => X?.renderAboveForm !== !0
  ), {
    error: Re,
    loading: Ue,
    refetch: Te
  } = VS(yS, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (X) => {
      if (Object.keys(X).length === 0)
        I(!0);
      else {
        I(!1);
        const re = X?.Management?.widgetConfigurations?.[0];
        re && Y({
          ...re,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${re.id}`,
          additionalProperties: re.additionalProperties ?? void 0
        });
      }
    }
  }), [Me, { error: De }] = Ap(
    h ? gS : vS,
    {
      onError: (X) => {
        _(X), j(!1), i({
          title: "Something went wrong",
          text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (X) => {
        if (j(!1), Object.keys(X).length !== 0) {
          if (h && r(
            X.Management?.createWidgetConfiguration?.id
          ), !h) {
            const V = X.Management?.updateWidgetConfiguration;
            V?.misconfigured ? A(
              V.misconfigurationCause ?? Qk
            ) : A(null);
          }
          if ((h || s) && ie) {
            const re = (K?.renderConditions?.length ?? 0) > 0;
            kS(
              l,
              h,
              ie,
              re
            );
          }
          i({
            title: `${h ? "Creating" : "Updating"} was successful`,
            text: `${h ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [on] = Ap(bS, {
    onError: (X) => {
      _(X), j(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      j(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Fe,
    handleIsEnabled: Ye,
    errors: Ze,
    handleChangeText: fe,
    handleChangeBoolean: ge,
    handleChangeSelect: $e,
    handleEditSecret: Le,
    handleChangeName: Pe,
    handleSubmit: mn,
    getSettingValueByKey: J,
    initializeFormData: T
  } = KM({
    onSubmit: async (X) => {
      h ? l("settings:create:submitted", { widgetType: n }) : e && l("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), j(!0);
      const re = X.settings.map(
        (ke) => typeof ke.value == "boolean" ? { ...ke, value: ke.value.toString() } : ke
      ), V = Kk(re) && h;
      let W = [];
      if (V) {
        const ke = await m().catch(
          (Ie) => {
            j(!1), console.warn("API-Token (creation) error resonse", Ie), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        ke?.data && (W = zM({
          token: ke.data,
          settings: re
        }));
      }
      const le = {
        ...X,
        settings: [
          ...W.length > 0 ? W : re
        ]
      };
      (V && W.length > 1 || !V && W.length === 0) && (Me({
        variables: {
          ...!h && { id: e },
          ...h && { type: n },
          ...le,
          ...(h || !!s) && ie !== null && { renderConditions: ie }
        }
      }), re.forEach(
        (Ie) => Ie.secret && Le(!1, Ie.key)
      ));
    },
    ...h && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: Yk({
          settingsFromBackend: be,
          settingsConfiguration: Ce,
          creating: !0
        })
      }
    }
  });
  qe(() => {
    if (K) {
      const X = Yk({
        settingsFromBackend: K.settings,
        settingsConfiguration: Ce
      });
      T({
        enabled: !!K.enabled,
        name: K.name,
        settings: X
      }), K.misconfigured ? A(
        K?.misconfigurationCause ?? Qk
      ) : A(null);
    }
  }, [K]);
  const U = Bn(() => o ? !o.isCoupled : !0, [o]);
  return Re || De || C ? /* @__PURE__ */ Ve.jsx(
    Cn,
    {
      error: Re || C,
      retry: Re ? Te : void 0
    }
  ) : S || Ue ? /* @__PURE__ */ Ve.jsx(ln, { "data-testid": "widget-settings-loading" }) : E ? /* @__PURE__ */ Ve.jsxs(D.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ Ve.jsx(An, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ Ve.jsxs("form", { children: [
    F && /* @__PURE__ */ Ve.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ve.jsx(
      _s,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ Ve.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ Ve.jsx(D.Paragraph, { children: F }),
          /* @__PURE__ */ Ve.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ Ve.jsx(D.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ Ve.jsx(D.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ Ve.jsxs(
      rt,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          He.map(
            ({ key: X, label: re, ...V }) => /* @__PURE__ */ Ve.jsx(
              Gk,
              {
                widgetSettingsKey: X,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: J,
                isSecret: !1,
                label: re,
                placeholder: "",
                required: !1,
                errors: Ze,
                type: "custom",
                isCreationMode: h,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: Ce,
                otherProps: V
              },
              X
            )
          ),
          !ye && /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
            /* @__PURE__ */ Ve.jsx(ue, { children: /* @__PURE__ */ Ve.jsx(nn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ve.jsx(
              ob,
              {
                input: {
                  name: "enabled",
                  checked: Fe.enabled,
                  value: "dummy",
                  onChange: (X) => Ye(X.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ Ve.jsx(ue, { span: 3, children: /* @__PURE__ */ Ve.jsx(
              ir,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: Wa,
                  value: Fe.name,
                  onChange: Pe
                },
                meta: {
                  error: Ze[Wa]
                }
              }
            ) }),
            /* @__PURE__ */ Ve.jsx(ue, { span: 3 })
          ] }),
          !ye && s && ie !== null && /* @__PURE__ */ Ve.jsx(ue, { children: s({
            value: ie,
            onChange: G,
            configurationKey: K?.id
          }) }),
          Be?.map(
            ({
              key: X,
              secret: re,
              label: V,
              placeholder: W = "",
              required: le = !1,
              type: ke,
              prefix: Ie,
              readOnly: en,
              ...hn
            }) => {
              const { settings: rn } = Fe, cn = rn.find(
                (pn) => pn.key === X
              );
              return /* @__PURE__ */ Ve.jsx(jS, { children: /* @__PURE__ */ Ve.jsx(
                Gk,
                {
                  widgetSettingsKey: X,
                  isEditingField: !!cn?.isEditing,
                  handleEditSecret: Le,
                  handleChangeText: fe,
                  handleChangeBoolean: ge,
                  handleChangeSelect: $e,
                  getValueByKey: J,
                  isSecret: re,
                  label: V,
                  placeholder: W,
                  required: le,
                  errors: Ze,
                  type: ke,
                  isCreationMode: h,
                  prefix: Ie,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: en,
                  settings: Ce,
                  otherProps: hn
                }
              ) }, X);
            }
          )
        ]
      }
    ),
    !ye && /* @__PURE__ */ Ve.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ Ve.jsx(Kn, { onClick: mn, children: O }),
      !h && /* @__PURE__ */ Ve.jsx(
        We,
        {
          content: "The widget is used in automations",
          disabled: U,
          children: /* @__PURE__ */ Ve.jsx(
            Kn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && l("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), L(!0);
              },
              disabled: !U,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Ve.jsx(
      rb,
      {
        isOpen: k,
        setIsOpen: L,
        confirmVariant: v ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && l("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && l("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), Kk(Fe.settings)) {
            const X = Fe.settings.find(
              ({ key: re }) => re === Rp
            )?.value;
            X && d(X).catch((re) => {
              console.warn("API-Token (deletion) error response", re), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          on({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ Ve.jsx(b, { children: v ? /* @__PURE__ */ Ve.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ Ve.jsx(
            me,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ Ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ Ve.jsxs(D.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ Ve.jsxs(D.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ Ve.jsxs(D.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Fe.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Fe.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, E4 = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => /* @__PURE__ */ Ve.jsx(
  ab.Provider,
  {
    value: {
      onError: (l, d) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        l,
        d
      )
    },
    children: /* @__PURE__ */ Ve.jsx(
      Vb,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ Ve.jsx(
          YM,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o,
            renderConditionsEditor: s
          }
        )
      }
    )
  }
), Jk = "__PairingContext__", J_ = globalThis[Jk] ?? (() => {
  const e = ib({});
  return globalThis[Jk] = e, e;
})(), T4 = () => _m(J_), $4 = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Ve.jsx(J_.Provider, { value: e, children: n });
var Mo = { exports: {} }, Xk;
function JM() {
  if (Xk) return Mo.exports;
  Xk = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(I, F, A) {
    return Function.prototype.apply.call(I, F, A);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(I) {
    return Object.getOwnPropertyNames(I).concat(Object.getOwnPropertySymbols(I));
  } : r = function(I) {
    return Object.getOwnPropertyNames(I);
  };
  function i(E) {
    console && console.warn && console.warn(E);
  }
  var a = Number.isNaN || function(I) {
    return I !== I;
  };
  function o() {
    o.init.call(this);
  }
  Mo.exports = o, Mo.exports.once = j, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(E) {
    if (typeof E != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof E);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(E) {
      if (typeof E != "number" || E < 0 || a(E))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + E + ".");
      s = E;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(I) {
    if (typeof I != "number" || I < 0 || a(I))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + I + ".");
    return this._maxListeners = I, this;
  };
  function d(E) {
    return E._maxListeners === void 0 ? o.defaultMaxListeners : E._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(I) {
    for (var F = [], A = 1; A < arguments.length; A++) F.push(arguments[A]);
    var K = I === "error", Y = this._events;
    if (Y !== void 0)
      K = K && Y.error === void 0;
    else if (!K)
      return !1;
    if (K) {
      var ie;
      if (F.length > 0 && (ie = F[0]), ie instanceof Error)
        throw ie;
      var G = new Error("Unhandled error." + (ie ? " (" + ie.message + ")" : ""));
      throw G.context = ie, G;
    }
    var B = Y[I];
    if (B === void 0)
      return !1;
    if (typeof B == "function")
      n(B, this, F);
    else
      for (var O = B.length, z = C(B, O), A = 0; A < O; ++A)
        n(z[A], this, F);
    return !0;
  };
  function m(E, I, F, A) {
    var K, Y, ie;
    if (l(F), Y = E._events, Y === void 0 ? (Y = E._events = /* @__PURE__ */ Object.create(null), E._eventsCount = 0) : (Y.newListener !== void 0 && (E.emit(
      "newListener",
      I,
      F.listener ? F.listener : F
    ), Y = E._events), ie = Y[I]), ie === void 0)
      ie = Y[I] = F, ++E._eventsCount;
    else if (typeof ie == "function" ? ie = Y[I] = A ? [F, ie] : [ie, F] : A ? ie.unshift(F) : ie.push(F), K = d(E), K > 0 && ie.length > K && !ie.warned) {
      ie.warned = !0;
      var G = new Error("Possible EventEmitter memory leak detected. " + ie.length + " " + String(I) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      G.name = "MaxListenersExceededWarning", G.emitter = E, G.type = I, G.count = ie.length, i(G);
    }
    return E;
  }
  o.prototype.addListener = function(I, F) {
    return m(this, I, F, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(I, F) {
    return m(this, I, F, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(E, I, F) {
    var A = { fired: !1, wrapFn: void 0, target: E, type: I, listener: F }, K = u.bind(A);
    return K.listener = F, A.wrapFn = K, K;
  }
  o.prototype.once = function(I, F) {
    return l(F), this.on(I, f(this, I, F)), this;
  }, o.prototype.prependOnceListener = function(I, F) {
    return l(F), this.prependListener(I, f(this, I, F)), this;
  }, o.prototype.removeListener = function(I, F) {
    var A, K, Y, ie, G;
    if (l(F), K = this._events, K === void 0)
      return this;
    if (A = K[I], A === void 0)
      return this;
    if (A === F || A.listener === F)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete K[I], K.removeListener && this.emit("removeListener", I, A.listener || F));
    else if (typeof A != "function") {
      for (Y = -1, ie = A.length - 1; ie >= 0; ie--)
        if (A[ie] === F || A[ie].listener === F) {
          G = A[ie].listener, Y = ie;
          break;
        }
      if (Y < 0)
        return this;
      Y === 0 ? A.shift() : _(A, Y), A.length === 1 && (K[I] = A[0]), K.removeListener !== void 0 && this.emit("removeListener", I, G || F);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(I) {
    var F, A, K;
    if (A = this._events, A === void 0)
      return this;
    if (A.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : A[I] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete A[I]), this;
    if (arguments.length === 0) {
      var Y = Object.keys(A), ie;
      for (K = 0; K < Y.length; ++K)
        ie = Y[K], ie !== "removeListener" && this.removeAllListeners(ie);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (F = A[I], typeof F == "function")
      this.removeListener(I, F);
    else if (F !== void 0)
      for (K = F.length - 1; K >= 0; K--)
        this.removeListener(I, F[K]);
    return this;
  };
  function h(E, I, F) {
    var A = E._events;
    if (A === void 0)
      return [];
    var K = A[I];
    return K === void 0 ? [] : typeof K == "function" ? F ? [K.listener || K] : [K] : F ? S(K) : C(K, K.length);
  }
  o.prototype.listeners = function(I) {
    return h(this, I, !0);
  }, o.prototype.rawListeners = function(I) {
    return h(this, I, !1);
  }, o.listenerCount = function(E, I) {
    return typeof E.listenerCount == "function" ? E.listenerCount(I) : v.call(E, I);
  }, o.prototype.listenerCount = v;
  function v(E) {
    var I = this._events;
    if (I !== void 0) {
      var F = I[E];
      if (typeof F == "function")
        return 1;
      if (F !== void 0)
        return F.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function C(E, I) {
    for (var F = new Array(I), A = 0; A < I; ++A)
      F[A] = E[A];
    return F;
  }
  function _(E, I) {
    for (; I + 1 < E.length; I++)
      E[I] = E[I + 1];
    E.pop();
  }
  function S(E) {
    for (var I = new Array(E.length), F = 0; F < I.length; ++F)
      I[F] = E[F].listener || E[F];
    return I;
  }
  function j(E, I) {
    return new Promise(function(F, A) {
      function K(ie) {
        E.removeListener(I, Y), A(ie);
      }
      function Y() {
        typeof E.removeListener == "function" && E.removeListener("error", K), F([].slice.call(arguments));
      }
      L(E, I, Y, { once: !0 }), I !== "error" && k(E, K, { once: !0 });
    });
  }
  function k(E, I, F) {
    typeof E.on == "function" && L(E, "error", I, F);
  }
  function L(E, I, F, A) {
    if (typeof E.on == "function")
      A.once ? E.once(I, F) : E.on(I, F);
    else if (typeof E.addEventListener == "function")
      E.addEventListener(I, function K(Y) {
        A.once && E.removeEventListener(I, K), F(Y);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof E);
  }
  return Mo.exports;
}
var XM = JM();
function D4() {
  const e = new XM.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  fj as GraphQLClientProvider,
  J_ as PairingContext,
  $4 as PairingProvider,
  I4 as PartnerIntegrations,
  E4 as PartnerIntegrationsSettings,
  Dp as getWidgetDefinitions,
  D4 as initializePartnerEventEmitter,
  T4 as usePairing,
  F4 as usePartnerIntegrationWidgetConfigurations,
  OM as useShopifyConfiguration
};
